// Auto-generated by scripts/generateVietnamAddresses.js
// Do not edit manually. Regenerate with: npm run generate:addresses

export interface ProvinceDataItem { code: string; name: string; }
export interface DistrictDataItem { code: string; name: string; province_code: string; }
export interface WardDataItem { code: string; name: string; district_code: string; }

export const provincesData: ProvinceDataItem[] = [
  { code: "1", name: "Thành phố Hà Nội" },
  { code: "2", name: "Tỉnh Hà Giang" },
  { code: "4", name: "Tỉnh Cao Bằng" },
  { code: "6", name: "Tỉnh Bắc Kạn" },
  { code: "8", name: "Tỉnh Tuyên Quang" },
  { code: "10", name: "Tỉnh Lào Cai" },
  { code: "11", name: "Tỉnh Điện Biên" },
  { code: "12", name: "Tỉnh Lai Châu" },
  { code: "14", name: "Tỉnh Sơn La" },
  { code: "15", name: "Tỉnh Yên Bái" },
  { code: "17", name: "Tỉnh Hoà Bình" },
  { code: "19", name: "Tỉnh Thái Nguyên" },
  { code: "20", name: "Tỉnh Lạng Sơn" },
  { code: "22", name: "Tỉnh Quảng Ninh" },
  { code: "24", name: "Tỉnh Bắc Giang" },
  { code: "25", name: "Tỉnh Phú Thọ" },
  { code: "26", name: "Tỉnh Vĩnh Phúc" },
  { code: "27", name: "Tỉnh Bắc Ninh" },
  { code: "30", name: "Tỉnh Hải Dương" },
  { code: "31", name: "Thành phố Hải Phòng" },
  { code: "33", name: "Tỉnh Hưng Yên" },
  { code: "34", name: "Tỉnh Thái Bình" },
  { code: "35", name: "Tỉnh Hà Nam" },
  { code: "36", name: "Tỉnh Nam Định" },
  { code: "37", name: "Tỉnh Ninh Bình" },
  { code: "38", name: "Tỉnh Thanh Hóa" },
  { code: "40", name: "Tỉnh Nghệ An" },
  { code: "42", name: "Tỉnh Hà Tĩnh" },
  { code: "44", name: "Tỉnh Quảng Bình" },
  { code: "45", name: "Tỉnh Quảng Trị" },
  { code: "46", name: "Thành phố Huế" },
  { code: "48", name: "Thành phố Đà Nẵng" },
  { code: "49", name: "Tỉnh Quảng Nam" },
  { code: "51", name: "Tỉnh Quảng Ngãi" },
  { code: "52", name: "Tỉnh Bình Định" },
  { code: "54", name: "Tỉnh Phú Yên" },
  { code: "56", name: "Tỉnh Khánh Hòa" },
  { code: "58", name: "Tỉnh Ninh Thuận" },
  { code: "60", name: "Tỉnh Bình Thuận" },
  { code: "62", name: "Tỉnh Kon Tum" },
  { code: "64", name: "Tỉnh Gia Lai" },
  { code: "66", name: "Tỉnh Đắk Lắk" },
  { code: "67", name: "Tỉnh Đắk Nông" },
  { code: "68", name: "Tỉnh Lâm Đồng" },
  { code: "70", name: "Tỉnh Bình Phước" },
  { code: "72", name: "Tỉnh Tây Ninh" },
  { code: "74", name: "Tỉnh Bình Dương" },
  { code: "75", name: "Tỉnh Đồng Nai" },
  { code: "77", name: "Tỉnh Bà Rịa - Vũng Tàu" },
  { code: "79", name: "Thành phố Hồ Chí Minh" },
  { code: "80", name: "Tỉnh Long An" },
  { code: "82", name: "Tỉnh Tiền Giang" },
  { code: "83", name: "Tỉnh Bến Tre" },
  { code: "84", name: "Tỉnh Trà Vinh" },
  { code: "86", name: "Tỉnh Vĩnh Long" },
  { code: "87", name: "Tỉnh Đồng Tháp" },
  { code: "89", name: "Tỉnh An Giang" },
  { code: "91", name: "Tỉnh Kiên Giang" },
  { code: "92", name: "Thành phố Cần Thơ" },
  { code: "93", name: "Tỉnh Hậu Giang" },
  { code: "94", name: "Tỉnh Sóc Trăng" },
  { code: "95", name: "Tỉnh Bạc Liêu" },
  { code: "96", name: "Tỉnh Cà Mau" },
];

export const districtsData: DistrictDataItem[] = [
  { code: "1", name: "Quận Ba Đình", province_code: "1" },
  { code: "2", name: "Quận Hoàn Kiếm", province_code: "1" },
  { code: "3", name: "Quận Tây Hồ", province_code: "1" },
  { code: "4", name: "Quận Long Biên", province_code: "1" },
  { code: "5", name: "Quận Cầu Giấy", province_code: "1" },
  { code: "6", name: "Quận Đống Đa", province_code: "1" },
  { code: "7", name: "Quận Hai Bà Trưng", province_code: "1" },
  { code: "8", name: "Quận Hoàng Mai", province_code: "1" },
  { code: "9", name: "Quận Thanh Xuân", province_code: "1" },
  { code: "16", name: "Huyện Sóc Sơn", province_code: "1" },
  { code: "17", name: "Huyện Đông Anh", province_code: "1" },
  { code: "18", name: "Huyện Gia Lâm", province_code: "1" },
  { code: "19", name: "Quận Nam Từ Liêm", province_code: "1" },
  { code: "20", name: "Huyện Thanh Trì", province_code: "1" },
  { code: "21", name: "Quận Bắc Từ Liêm", province_code: "1" },
  { code: "250", name: "Huyện Mê Linh", province_code: "1" },
  { code: "268", name: "Quận Hà Đông", province_code: "1" },
  { code: "269", name: "Thị xã Sơn Tây", province_code: "1" },
  { code: "271", name: "Huyện Ba Vì", province_code: "1" },
  { code: "272", name: "Huyện Phúc Thọ", province_code: "1" },
  { code: "273", name: "Huyện Đan Phượng", province_code: "1" },
  { code: "274", name: "Huyện Hoài Đức", province_code: "1" },
  { code: "275", name: "Huyện Quốc Oai", province_code: "1" },
  { code: "276", name: "Huyện Thạch Thất", province_code: "1" },
  { code: "277", name: "Huyện Chương Mỹ", province_code: "1" },
  { code: "278", name: "Huyện Thanh Oai", province_code: "1" },
  { code: "279", name: "Huyện Thường Tín", province_code: "1" },
  { code: "280", name: "Huyện Phú Xuyên", province_code: "1" },
  { code: "281", name: "Huyện Ứng Hòa", province_code: "1" },
  { code: "282", name: "Huyện Mỹ Đức", province_code: "1" },
  { code: "24", name: "Thành phố Hà Giang", province_code: "2" },
  { code: "26", name: "Huyện Đồng Văn", province_code: "2" },
  { code: "27", name: "Huyện Mèo Vạc", province_code: "2" },
  { code: "28", name: "Huyện Yên Minh", province_code: "2" },
  { code: "29", name: "Huyện Quản Bạ", province_code: "2" },
  { code: "30", name: "Huyện Vị Xuyên", province_code: "2" },
  { code: "31", name: "Huyện Bắc Mê", province_code: "2" },
  { code: "32", name: "Huyện Hoàng Su Phì", province_code: "2" },
  { code: "33", name: "Huyện Xín Mần", province_code: "2" },
  { code: "34", name: "Huyện Bắc Quang", province_code: "2" },
  { code: "35", name: "Huyện Quang Bình", province_code: "2" },
  { code: "40", name: "Thành phố Cao Bằng", province_code: "4" },
  { code: "42", name: "Huyện Bảo Lâm", province_code: "4" },
  { code: "43", name: "Huyện Bảo Lạc", province_code: "4" },
  { code: "45", name: "Huyện Hà Quảng", province_code: "4" },
  { code: "47", name: "Huyện Trùng Khánh", province_code: "4" },
  { code: "48", name: "Huyện Hạ Lang", province_code: "4" },
  { code: "49", name: "Huyện Quảng Hòa", province_code: "4" },
  { code: "51", name: "Huyện Hoà An", province_code: "4" },
  { code: "52", name: "Huyện Nguyên Bình", province_code: "4" },
  { code: "53", name: "Huyện Thạch An", province_code: "4" },
  { code: "58", name: "Thành Phố Bắc Kạn", province_code: "6" },
  { code: "60", name: "Huyện Pác Nặm", province_code: "6" },
  { code: "61", name: "Huyện Ba Bể", province_code: "6" },
  { code: "62", name: "Huyện Ngân Sơn", province_code: "6" },
  { code: "63", name: "Huyện Bạch Thông", province_code: "6" },
  { code: "64", name: "Huyện Chợ Đồn", province_code: "6" },
  { code: "65", name: "Huyện Chợ Mới", province_code: "6" },
  { code: "66", name: "Huyện Na Rì", province_code: "6" },
  { code: "70", name: "Thành phố Tuyên Quang", province_code: "8" },
  { code: "71", name: "Huyện Lâm Bình", province_code: "8" },
  { code: "72", name: "Huyện Na Hang", province_code: "8" },
  { code: "73", name: "Huyện Chiêm Hóa", province_code: "8" },
  { code: "74", name: "Huyện Hàm Yên", province_code: "8" },
  { code: "75", name: "Huyện Yên Sơn", province_code: "8" },
  { code: "76", name: "Huyện Sơn Dương", province_code: "8" },
  { code: "80", name: "Thành phố Lào Cai", province_code: "10" },
  { code: "82", name: "Huyện Bát Xát", province_code: "10" },
  { code: "83", name: "Huyện Mường Khương", province_code: "10" },
  { code: "84", name: "Huyện Si Ma Cai", province_code: "10" },
  { code: "85", name: "Huyện Bắc Hà", province_code: "10" },
  { code: "86", name: "Huyện Bảo Thắng", province_code: "10" },
  { code: "87", name: "Huyện Bảo Yên", province_code: "10" },
  { code: "88", name: "Thị xã Sa Pa", province_code: "10" },
  { code: "89", name: "Huyện Văn Bàn", province_code: "10" },
  { code: "94", name: "Thành phố Điện Biên Phủ", province_code: "11" },
  { code: "95", name: "Thị xã Mường Lay", province_code: "11" },
  { code: "96", name: "Huyện Mường Nhé", province_code: "11" },
  { code: "97", name: "Huyện Mường Chà", province_code: "11" },
  { code: "98", name: "Huyện Tủa Chùa", province_code: "11" },
  { code: "99", name: "Huyện Tuần Giáo", province_code: "11" },
  { code: "100", name: "Huyện Điện Biên", province_code: "11" },
  { code: "101", name: "Huyện Điện Biên Đông", province_code: "11" },
  { code: "102", name: "Huyện Mường Ảng", province_code: "11" },
  { code: "103", name: "Huyện Nậm Pồ", province_code: "11" },
  { code: "105", name: "Thành phố Lai Châu", province_code: "12" },
  { code: "106", name: "Huyện Tam Đường", province_code: "12" },
  { code: "107", name: "Huyện Mường Tè", province_code: "12" },
  { code: "108", name: "Huyện Sìn Hồ", province_code: "12" },
  { code: "109", name: "Huyện Phong Thổ", province_code: "12" },
  { code: "110", name: "Huyện Than Uyên", province_code: "12" },
  { code: "111", name: "Huyện Tân Uyên", province_code: "12" },
  { code: "112", name: "Huyện Nậm Nhùn", province_code: "12" },
  { code: "116", name: "Thành phố Sơn La", province_code: "14" },
  { code: "118", name: "Huyện Quỳnh Nhai", province_code: "14" },
  { code: "119", name: "Huyện Thuận Châu", province_code: "14" },
  { code: "120", name: "Huyện Mường La", province_code: "14" },
  { code: "121", name: "Huyện Bắc Yên", province_code: "14" },
  { code: "122", name: "Huyện Phù Yên", province_code: "14" },
  { code: "123", name: "Huyện Mộc Châu", province_code: "14" },
  { code: "124", name: "Huyện Yên Châu", province_code: "14" },
  { code: "125", name: "Huyện Mai Sơn", province_code: "14" },
  { code: "126", name: "Huyện Sông Mã", province_code: "14" },
  { code: "127", name: "Huyện Sốp Cộp", province_code: "14" },
  { code: "128", name: "Huyện Vân Hồ", province_code: "14" },
  { code: "132", name: "Thành phố Yên Bái", province_code: "15" },
  { code: "133", name: "Thị xã Nghĩa Lộ", province_code: "15" },
  { code: "135", name: "Huyện Lục Yên", province_code: "15" },
  { code: "136", name: "Huyện Văn Yên", province_code: "15" },
  { code: "137", name: "Huyện Mù Căng Chải", province_code: "15" },
  { code: "138", name: "Huyện Trấn Yên", province_code: "15" },
  { code: "139", name: "Huyện Trạm Tấu", province_code: "15" },
  { code: "140", name: "Huyện Văn Chấn", province_code: "15" },
  { code: "141", name: "Huyện Yên Bình", province_code: "15" },
  { code: "148", name: "Thành phố Hòa Bình", province_code: "17" },
  { code: "150", name: "Huyện Đà Bắc", province_code: "17" },
  { code: "152", name: "Huyện Lương Sơn", province_code: "17" },
  { code: "153", name: "Huyện Kim Bôi", province_code: "17" },
  { code: "154", name: "Huyện Cao Phong", province_code: "17" },
  { code: "155", name: "Huyện Tân Lạc", province_code: "17" },
  { code: "156", name: "Huyện Mai Châu", province_code: "17" },
  { code: "157", name: "Huyện Lạc Sơn", province_code: "17" },
  { code: "158", name: "Huyện Yên Thủy", province_code: "17" },
  { code: "159", name: "Huyện Lạc Thủy", province_code: "17" },
  { code: "164", name: "Thành phố Thái Nguyên", province_code: "19" },
  { code: "165", name: "Thành phố Sông Công", province_code: "19" },
  { code: "167", name: "Huyện Định Hóa", province_code: "19" },
  { code: "168", name: "Huyện Phú Lương", province_code: "19" },
  { code: "169", name: "Huyện Đồng Hỷ", province_code: "19" },
  { code: "170", name: "Huyện Võ Nhai", province_code: "19" },
  { code: "171", name: "Huyện Đại Từ", province_code: "19" },
  { code: "172", name: "Thành phố Phổ Yên", province_code: "19" },
  { code: "173", name: "Huyện Phú Bình", province_code: "19" },
  { code: "178", name: "Thành phố Lạng Sơn", province_code: "20" },
  { code: "180", name: "Huyện Tràng Định", province_code: "20" },
  { code: "181", name: "Huyện Bình Gia", province_code: "20" },
  { code: "182", name: "Huyện Văn Lãng", province_code: "20" },
  { code: "183", name: "Huyện Cao Lộc", province_code: "20" },
  { code: "184", name: "Huyện Văn Quan", province_code: "20" },
  { code: "185", name: "Huyện Bắc Sơn", province_code: "20" },
  { code: "186", name: "Huyện Hữu Lũng", province_code: "20" },
  { code: "187", name: "Huyện Chi Lăng", province_code: "20" },
  { code: "188", name: "Huyện Lộc Bình", province_code: "20" },
  { code: "189", name: "Huyện Đình Lập", province_code: "20" },
  { code: "193", name: "Thành phố Hạ Long", province_code: "22" },
  { code: "194", name: "Thành phố Móng Cái", province_code: "22" },
  { code: "195", name: "Thành phố Cẩm Phả", province_code: "22" },
  { code: "196", name: "Thành phố Uông Bí", province_code: "22" },
  { code: "198", name: "Huyện Bình Liêu", province_code: "22" },
  { code: "199", name: "Huyện Tiên Yên", province_code: "22" },
  { code: "200", name: "Huyện Đầm Hà", province_code: "22" },
  { code: "201", name: "Huyện Hải Hà", province_code: "22" },
  { code: "202", name: "Huyện Ba Chẽ", province_code: "22" },
  { code: "203", name: "Huyện Vân Đồn", province_code: "22" },
  { code: "205", name: "Thành phố Đông Triều", province_code: "22" },
  { code: "206", name: "Thị xã Quảng Yên", province_code: "22" },
  { code: "207", name: "Huyện Cô Tô", province_code: "22" },
  { code: "213", name: "Thành phố Bắc Giang", province_code: "24" },
  { code: "215", name: "Huyện Yên Thế", province_code: "24" },
  { code: "216", name: "Huyện Tân Yên", province_code: "24" },
  { code: "217", name: "Huyện Lạng Giang", province_code: "24" },
  { code: "218", name: "Huyện Lục Nam", province_code: "24" },
  { code: "219", name: "Huyện Lục Ngạn", province_code: "24" },
  { code: "220", name: "Huyện Sơn Động", province_code: "24" },
  { code: "222", name: "Thị xã Việt Yên", province_code: "24" },
  { code: "223", name: "Huyện Hiệp Hòa", province_code: "24" },
  { code: "224", name: "Thị xã Chũ", province_code: "24" },
  { code: "227", name: "Thành phố Việt Trì", province_code: "25" },
  { code: "228", name: "Thị xã Phú Thọ", province_code: "25" },
  { code: "230", name: "Huyện Đoan Hùng", province_code: "25" },
  { code: "231", name: "Huyện Hạ Hoà", province_code: "25" },
  { code: "232", name: "Huyện Thanh Ba", province_code: "25" },
  { code: "233", name: "Huyện Phù Ninh", province_code: "25" },
  { code: "234", name: "Huyện Yên Lập", province_code: "25" },
  { code: "235", name: "Huyện Cẩm Khê", province_code: "25" },
  { code: "236", name: "Huyện Tam Nông", province_code: "25" },
  { code: "237", name: "Huyện Lâm Thao", province_code: "25" },
  { code: "238", name: "Huyện Thanh Sơn", province_code: "25" },
  { code: "239", name: "Huyện Thanh Thuỷ", province_code: "25" },
  { code: "240", name: "Huyện Tân Sơn", province_code: "25" },
  { code: "243", name: "Thành phố Vĩnh Yên", province_code: "26" },
  { code: "244", name: "Thành phố Phúc Yên", province_code: "26" },
  { code: "246", name: "Huyện Lập Thạch", province_code: "26" },
  { code: "247", name: "Huyện Tam Dương", province_code: "26" },
  { code: "248", name: "Huyện Tam Đảo", province_code: "26" },
  { code: "249", name: "Huyện Bình Xuyên", province_code: "26" },
  { code: "251", name: "Huyện Yên Lạc", province_code: "26" },
  { code: "252", name: "Huyện Vĩnh Tường", province_code: "26" },
  { code: "253", name: "Huyện Sông Lô", province_code: "26" },
  { code: "256", name: "Thành phố Bắc Ninh", province_code: "27" },
  { code: "258", name: "Huyện Yên Phong", province_code: "27" },
  { code: "259", name: "Thị xã Quế Võ", province_code: "27" },
  { code: "260", name: "Huyện Tiên Du", province_code: "27" },
  { code: "261", name: "Thành phố Từ Sơn", province_code: "27" },
  { code: "262", name: "Thị xã Thuận Thành", province_code: "27" },
  { code: "263", name: "Huyện Gia Bình", province_code: "27" },
  { code: "264", name: "Huyện Lương Tài", province_code: "27" },
  { code: "288", name: "Thành phố Hải Dương", province_code: "30" },
  { code: "290", name: "Thành phố Chí Linh", province_code: "30" },
  { code: "291", name: "Huyện Nam Sách", province_code: "30" },
  { code: "292", name: "Thị xã Kinh Môn", province_code: "30" },
  { code: "293", name: "Huyện Kim Thành", province_code: "30" },
  { code: "294", name: "Huyện Thanh Hà", province_code: "30" },
  { code: "295", name: "Huyện Cẩm Giàng", province_code: "30" },
  { code: "296", name: "Huyện Bình Giang", province_code: "30" },
  { code: "297", name: "Huyện Gia Lộc", province_code: "30" },
  { code: "298", name: "Huyện Tứ Kỳ", province_code: "30" },
  { code: "299", name: "Huyện Ninh Giang", province_code: "30" },
  { code: "300", name: "Huyện Thanh Miện", province_code: "30" },
  { code: "303", name: "Quận Hồng Bàng", province_code: "31" },
  { code: "304", name: "Quận Ngô Quyền", province_code: "31" },
  { code: "305", name: "Quận Lê Chân", province_code: "31" },
  { code: "306", name: "Quận Hải An", province_code: "31" },
  { code: "307", name: "Quận Kiến An", province_code: "31" },
  { code: "308", name: "Quận Đồ Sơn", province_code: "31" },
  { code: "309", name: "Quận Dương Kinh", province_code: "31" },
  { code: "311", name: "Thành phố Thuỷ Nguyên", province_code: "31" },
  { code: "312", name: "Quận An Dương", province_code: "31" },
  { code: "313", name: "Huyện An Lão", province_code: "31" },
  { code: "314", name: "Huyện Kiến Thuỵ", province_code: "31" },
  { code: "315", name: "Huyện Tiên Lãng", province_code: "31" },
  { code: "316", name: "Huyện Vĩnh Bảo", province_code: "31" },
  { code: "317", name: "Huyện Cát Hải", province_code: "31" },
  { code: "323", name: "Thành phố Hưng Yên", province_code: "33" },
  { code: "325", name: "Huyện Văn Lâm", province_code: "33" },
  { code: "326", name: "Huyện Văn Giang", province_code: "33" },
  { code: "327", name: "Huyện Yên Mỹ", province_code: "33" },
  { code: "328", name: "Thị xã Mỹ Hào", province_code: "33" },
  { code: "329", name: "Huyện Ân Thi", province_code: "33" },
  { code: "330", name: "Huyện Khoái Châu", province_code: "33" },
  { code: "331", name: "Huyện Kim Động", province_code: "33" },
  { code: "332", name: "Huyện Tiên Lữ", province_code: "33" },
  { code: "333", name: "Huyện Phù Cừ", province_code: "33" },
  { code: "336", name: "Thành phố Thái Bình", province_code: "34" },
  { code: "338", name: "Huyện Quỳnh Phụ", province_code: "34" },
  { code: "339", name: "Huyện Hưng Hà", province_code: "34" },
  { code: "340", name: "Huyện Đông Hưng", province_code: "34" },
  { code: "341", name: "Huyện Thái Thụy", province_code: "34" },
  { code: "342", name: "Huyện Tiền Hải", province_code: "34" },
  { code: "343", name: "Huyện Kiến Xương", province_code: "34" },
  { code: "344", name: "Huyện Vũ Thư", province_code: "34" },
  { code: "347", name: "Thành phố Phủ Lý", province_code: "35" },
  { code: "349", name: "Thị xã Duy Tiên", province_code: "35" },
  { code: "350", name: "Thị xã Kim Bảng", province_code: "35" },
  { code: "351", name: "Huyện Thanh Liêm", province_code: "35" },
  { code: "352", name: "Huyện Bình Lục", province_code: "35" },
  { code: "353", name: "Huyện Lý Nhân", province_code: "35" },
  { code: "356", name: "Thành phố Nam Định", province_code: "36" },
  { code: "359", name: "Huyện Vụ Bản", province_code: "36" },
  { code: "360", name: "Huyện Ý Yên", province_code: "36" },
  { code: "361", name: "Huyện Nghĩa Hưng", province_code: "36" },
  { code: "362", name: "Huyện Nam Trực", province_code: "36" },
  { code: "363", name: "Huyện Trực Ninh", province_code: "36" },
  { code: "364", name: "Huyện Xuân Trường", province_code: "36" },
  { code: "365", name: "Huyện Giao Thủy", province_code: "36" },
  { code: "366", name: "Huyện Hải Hậu", province_code: "36" },
  { code: "370", name: "Thành phố Tam Điệp", province_code: "37" },
  { code: "372", name: "Huyện Nho Quan", province_code: "37" },
  { code: "373", name: "Huyện Gia Viễn", province_code: "37" },
  { code: "374", name: "Thành phố Hoa Lư", province_code: "37" },
  { code: "375", name: "Huyện Yên Khánh", province_code: "37" },
  { code: "376", name: "Huyện Kim Sơn", province_code: "37" },
  { code: "377", name: "Huyện Yên Mô", province_code: "37" },
  { code: "380", name: "Thành phố Thanh Hóa", province_code: "38" },
  { code: "381", name: "Thị xã Bỉm Sơn", province_code: "38" },
  { code: "382", name: "Thành phố Sầm Sơn", province_code: "38" },
  { code: "384", name: "Huyện Mường Lát", province_code: "38" },
  { code: "385", name: "Huyện Quan Hóa", province_code: "38" },
  { code: "386", name: "Huyện Bá Thước", province_code: "38" },
  { code: "387", name: "Huyện Quan Sơn", province_code: "38" },
  { code: "388", name: "Huyện Lang Chánh", province_code: "38" },
  { code: "389", name: "Huyện Ngọc Lặc", province_code: "38" },
  { code: "390", name: "Huyện Cẩm Thủy", province_code: "38" },
  { code: "391", name: "Huyện Thạch Thành", province_code: "38" },
  { code: "392", name: "Huyện Hà Trung", province_code: "38" },
  { code: "393", name: "Huyện Vĩnh Lộc", province_code: "38" },
  { code: "394", name: "Huyện Yên Định", province_code: "38" },
  { code: "395", name: "Huyện Thọ Xuân", province_code: "38" },
  { code: "396", name: "Huyện Thường Xuân", province_code: "38" },
  { code: "397", name: "Huyện Triệu Sơn", province_code: "38" },
  { code: "398", name: "Huyện Thiệu Hóa", province_code: "38" },
  { code: "399", name: "Huyện Hoằng Hóa", province_code: "38" },
  { code: "400", name: "Huyện Hậu Lộc", province_code: "38" },
  { code: "401", name: "Huyện Nga Sơn", province_code: "38" },
  { code: "402", name: "Huyện Như Xuân", province_code: "38" },
  { code: "403", name: "Huyện Như Thanh", province_code: "38" },
  { code: "404", name: "Huyện Nông Cống", province_code: "38" },
  { code: "406", name: "Huyện Quảng Xương", province_code: "38" },
  { code: "407", name: "Thị xã Nghi Sơn", province_code: "38" },
  { code: "412", name: "Thành phố Vinh", province_code: "40" },
  { code: "414", name: "Thị xã Thái Hoà", province_code: "40" },
  { code: "415", name: "Huyện Quế Phong", province_code: "40" },
  { code: "416", name: "Huyện Quỳ Châu", province_code: "40" },
  { code: "417", name: "Huyện Kỳ Sơn", province_code: "40" },
  { code: "418", name: "Huyện Tương Dương", province_code: "40" },
  { code: "419", name: "Huyện Nghĩa Đàn", province_code: "40" },
  { code: "420", name: "Huyện Quỳ Hợp", province_code: "40" },
  { code: "421", name: "Huyện Quỳnh Lưu", province_code: "40" },
  { code: "422", name: "Huyện Con Cuông", province_code: "40" },
  { code: "423", name: "Huyện Tân Kỳ", province_code: "40" },
  { code: "424", name: "Huyện Anh Sơn", province_code: "40" },
  { code: "425", name: "Huyện Diễn Châu", province_code: "40" },
  { code: "426", name: "Huyện Yên Thành", province_code: "40" },
  { code: "427", name: "Huyện Đô Lương", province_code: "40" },
  { code: "428", name: "Huyện Thanh Chương", province_code: "40" },
  { code: "429", name: "Huyện Nghi Lộc", province_code: "40" },
  { code: "430", name: "Huyện Nam Đàn", province_code: "40" },
  { code: "431", name: "Huyện Hưng Nguyên", province_code: "40" },
  { code: "432", name: "Thị xã Hoàng Mai", province_code: "40" },
  { code: "436", name: "Thành phố Hà Tĩnh", province_code: "42" },
  { code: "437", name: "Thị xã Hồng Lĩnh", province_code: "42" },
  { code: "439", name: "Huyện Hương Sơn", province_code: "42" },
  { code: "440", name: "Huyện Đức Thọ", province_code: "42" },
  { code: "441", name: "Huyện Vũ Quang", province_code: "42" },
  { code: "442", name: "Huyện Nghi Xuân", province_code: "42" },
  { code: "443", name: "Huyện Can Lộc", province_code: "42" },
  { code: "444", name: "Huyện Hương Khê", province_code: "42" },
  { code: "445", name: "Huyện Thạch Hà", province_code: "42" },
  { code: "446", name: "Huyện Cẩm Xuyên", province_code: "42" },
  { code: "447", name: "Huyện Kỳ Anh", province_code: "42" },
  { code: "449", name: "Thị xã Kỳ Anh", province_code: "42" },
  { code: "450", name: "Thành Phố Đồng Hới", province_code: "44" },
  { code: "452", name: "Huyện Minh Hóa", province_code: "44" },
  { code: "453", name: "Huyện Tuyên Hóa", province_code: "44" },
  { code: "454", name: "Huyện Quảng Trạch", province_code: "44" },
  { code: "455", name: "Huyện Bố Trạch", province_code: "44" },
  { code: "456", name: "Huyện Quảng Ninh", province_code: "44" },
  { code: "457", name: "Huyện Lệ Thủy", province_code: "44" },
  { code: "458", name: "Thị xã Ba Đồn", province_code: "44" },
  { code: "461", name: "Thành phố Đông Hà", province_code: "45" },
  { code: "462", name: "Thị xã Quảng Trị", province_code: "45" },
  { code: "464", name: "Huyện Vĩnh Linh", province_code: "45" },
  { code: "465", name: "Huyện Hướng Hóa", province_code: "45" },
  { code: "466", name: "Huyện Gio Linh", province_code: "45" },
  { code: "467", name: "Huyện Đa Krông", province_code: "45" },
  { code: "468", name: "Huyện Cam Lộ", province_code: "45" },
  { code: "469", name: "Huyện Triệu Phong", province_code: "45" },
  { code: "470", name: "Huyện Hải Lăng", province_code: "45" },
  { code: "474", name: "Quận Thuận Hóa", province_code: "46" },
  { code: "475", name: "Quận Phú Xuân", province_code: "46" },
  { code: "476", name: "Thị xã Phong Điền", province_code: "46" },
  { code: "477", name: "Huyện Quảng Điền", province_code: "46" },
  { code: "478", name: "Huyện Phú Vang", province_code: "46" },
  { code: "479", name: "Thị xã Hương Thủy", province_code: "46" },
  { code: "480", name: "Thị xã Hương Trà", province_code: "46" },
  { code: "481", name: "Huyện A Lưới", province_code: "46" },
  { code: "482", name: "Huyện Phú Lộc", province_code: "46" },
  { code: "490", name: "Quận Liên Chiểu", province_code: "48" },
  { code: "491", name: "Quận Thanh Khê", province_code: "48" },
  { code: "492", name: "Quận Hải Châu", province_code: "48" },
  { code: "493", name: "Quận Sơn Trà", province_code: "48" },
  { code: "494", name: "Quận Ngũ Hành Sơn", province_code: "48" },
  { code: "495", name: "Quận Cẩm Lệ", province_code: "48" },
  { code: "497", name: "Huyện Hòa Vang", province_code: "48" },
  { code: "502", name: "Thành phố Tam Kỳ", province_code: "49" },
  { code: "503", name: "Thành phố Hội An", province_code: "49" },
  { code: "504", name: "Huyện Tây Giang", province_code: "49" },
  { code: "505", name: "Huyện Đông Giang", province_code: "49" },
  { code: "506", name: "Huyện Đại Lộc", province_code: "49" },
  { code: "507", name: "Thị xã Điện Bàn", province_code: "49" },
  { code: "508", name: "Huyện Duy Xuyên", province_code: "49" },
  { code: "509", name: "Huyện Quế Sơn", province_code: "49" },
  { code: "510", name: "Huyện Nam Giang", province_code: "49" },
  { code: "511", name: "Huyện Phước Sơn", province_code: "49" },
  { code: "512", name: "Huyện Hiệp Đức", province_code: "49" },
  { code: "513", name: "Huyện Thăng Bình", province_code: "49" },
  { code: "514", name: "Huyện Tiên Phước", province_code: "49" },
  { code: "515", name: "Huyện Bắc Trà My", province_code: "49" },
  { code: "516", name: "Huyện Nam Trà My", province_code: "49" },
  { code: "517", name: "Huyện Núi Thành", province_code: "49" },
  { code: "518", name: "Huyện Phú Ninh", province_code: "49" },
  { code: "522", name: "Thành phố Quảng Ngãi", province_code: "51" },
  { code: "524", name: "Huyện Bình Sơn", province_code: "51" },
  { code: "525", name: "Huyện Trà Bồng", province_code: "51" },
  { code: "527", name: "Huyện Sơn Tịnh", province_code: "51" },
  { code: "528", name: "Huyện Tư Nghĩa", province_code: "51" },
  { code: "529", name: "Huyện Sơn Hà", province_code: "51" },
  { code: "530", name: "Huyện Sơn Tây", province_code: "51" },
  { code: "531", name: "Huyện Minh Long", province_code: "51" },
  { code: "532", name: "Huyện Nghĩa Hành", province_code: "51" },
  { code: "533", name: "Huyện Mộ Đức", province_code: "51" },
  { code: "534", name: "Thị xã Đức Phổ", province_code: "51" },
  { code: "535", name: "Huyện Ba Tơ", province_code: "51" },
  { code: "540", name: "Thành phố Quy Nhơn", province_code: "52" },
  { code: "542", name: "Huyện An Lão", province_code: "52" },
  { code: "543", name: "Thị xã Hoài Nhơn", province_code: "52" },
  { code: "544", name: "Huyện Hoài Ân", province_code: "52" },
  { code: "545", name: "Huyện Phù Mỹ", province_code: "52" },
  { code: "546", name: "Huyện Vĩnh Thạnh", province_code: "52" },
  { code: "547", name: "Huyện Tây Sơn", province_code: "52" },
  { code: "548", name: "Huyện Phù Cát", province_code: "52" },
  { code: "549", name: "Thị xã An Nhơn", province_code: "52" },
  { code: "550", name: "Huyện Tuy Phước", province_code: "52" },
  { code: "551", name: "Huyện Vân Canh", province_code: "52" },
  { code: "555", name: "Thành phố Tuy Hoà", province_code: "54" },
  { code: "557", name: "Thị xã Sông Cầu", province_code: "54" },
  { code: "558", name: "Huyện Đồng Xuân", province_code: "54" },
  { code: "559", name: "Huyện Tuy An", province_code: "54" },
  { code: "560", name: "Huyện Sơn Hòa", province_code: "54" },
  { code: "561", name: "Huyện Sông Hinh", province_code: "54" },
  { code: "562", name: "Huyện Tây Hoà", province_code: "54" },
  { code: "563", name: "Huyện Phú Hoà", province_code: "54" },
  { code: "564", name: "Thị xã Đông Hòa", province_code: "54" },
  { code: "568", name: "Thành phố Nha Trang", province_code: "56" },
  { code: "569", name: "Thành phố Cam Ranh", province_code: "56" },
  { code: "570", name: "Huyện Cam Lâm", province_code: "56" },
  { code: "571", name: "Huyện Vạn Ninh", province_code: "56" },
  { code: "572", name: "Thị xã Ninh Hòa", province_code: "56" },
  { code: "573", name: "Huyện Khánh Vĩnh", province_code: "56" },
  { code: "574", name: "Huyện Diên Khánh", province_code: "56" },
  { code: "575", name: "Huyện Khánh Sơn", province_code: "56" },
  { code: "576", name: "Huyện Trường Sa", province_code: "56" },
  { code: "582", name: "Thành phố Phan Rang-Tháp Chàm", province_code: "58" },
  { code: "584", name: "Huyện Bác Ái", province_code: "58" },
  { code: "585", name: "Huyện Ninh Sơn", province_code: "58" },
  { code: "586", name: "Huyện Ninh Hải", province_code: "58" },
  { code: "587", name: "Huyện Ninh Phước", province_code: "58" },
  { code: "588", name: "Huyện Thuận Bắc", province_code: "58" },
  { code: "589", name: "Huyện Thuận Nam", province_code: "58" },
  { code: "593", name: "Thành phố Phan Thiết", province_code: "60" },
  { code: "594", name: "Thị xã La Gi", province_code: "60" },
  { code: "595", name: "Huyện Tuy Phong", province_code: "60" },
  { code: "596", name: "Huyện Bắc Bình", province_code: "60" },
  { code: "597", name: "Huyện Hàm Thuận Bắc", province_code: "60" },
  { code: "598", name: "Huyện Hàm Thuận Nam", province_code: "60" },
  { code: "599", name: "Huyện Tánh Linh", province_code: "60" },
  { code: "600", name: "Huyện Đức Linh", province_code: "60" },
  { code: "601", name: "Huyện Hàm Tân", province_code: "60" },
  { code: "602", name: "Huyện Phú Quí", province_code: "60" },
  { code: "608", name: "Thành phố Kon Tum", province_code: "62" },
  { code: "610", name: "Huyện Đắk Glei", province_code: "62" },
  { code: "611", name: "Huyện Ngọc Hồi", province_code: "62" },
  { code: "612", name: "Huyện Đắk Tô", province_code: "62" },
  { code: "613", name: "Huyện Kon Plông", province_code: "62" },
  { code: "614", name: "Huyện Kon Rẫy", province_code: "62" },
  { code: "615", name: "Huyện Đắk Hà", province_code: "62" },
  { code: "616", name: "Huyện Sa Thầy", province_code: "62" },
  { code: "617", name: "Huyện Tu Mơ Rông", province_code: "62" },
  { code: "618", name: "Huyện Ia H' Drai", province_code: "62" },
  { code: "622", name: "Thành phố Pleiku", province_code: "64" },
  { code: "623", name: "Thị xã An Khê", province_code: "64" },
  { code: "624", name: "Thị xã Ayun Pa", province_code: "64" },
  { code: "625", name: "Huyện KBang", province_code: "64" },
  { code: "626", name: "Huyện Đăk Đoa", province_code: "64" },
  { code: "627", name: "Huyện Chư Păh", province_code: "64" },
  { code: "628", name: "Huyện Ia Grai", province_code: "64" },
  { code: "629", name: "Huyện Mang Yang", province_code: "64" },
  { code: "630", name: "Huyện Kông Chro", province_code: "64" },
  { code: "631", name: "Huyện Đức Cơ", province_code: "64" },
  { code: "632", name: "Huyện Chư Prông", province_code: "64" },
  { code: "633", name: "Huyện Chư Sê", province_code: "64" },
  { code: "634", name: "Huyện Đăk Pơ", province_code: "64" },
  { code: "635", name: "Huyện Ia Pa", province_code: "64" },
  { code: "637", name: "Huyện Krông Pa", province_code: "64" },
  { code: "638", name: "Huyện Phú Thiện", province_code: "64" },
  { code: "639", name: "Huyện Chư Pưh", province_code: "64" },
  { code: "643", name: "Thành phố Buôn Ma Thuột", province_code: "66" },
  { code: "644", name: "Thị xã Buôn Hồ", province_code: "66" },
  { code: "645", name: "Huyện Ea H'leo", province_code: "66" },
  { code: "646", name: "Huyện Ea Súp", province_code: "66" },
  { code: "647", name: "Huyện Buôn Đôn", province_code: "66" },
  { code: "648", name: "Huyện Cư M'gar", province_code: "66" },
  { code: "649", name: "Huyện Krông Búk", province_code: "66" },
  { code: "650", name: "Huyện Krông Năng", province_code: "66" },
  { code: "651", name: "Huyện Ea Kar", province_code: "66" },
  { code: "652", name: "Huyện M'Đrắk", province_code: "66" },
  { code: "653", name: "Huyện Krông Bông", province_code: "66" },
  { code: "654", name: "Huyện Krông Pắc", province_code: "66" },
  { code: "655", name: "Huyện Krông A Na", province_code: "66" },
  { code: "656", name: "Huyện Lắk", province_code: "66" },
  { code: "657", name: "Huyện Cư Kuin", province_code: "66" },
  { code: "660", name: "Thành phố Gia Nghĩa", province_code: "67" },
  { code: "661", name: "Huyện Đăk Glong", province_code: "67" },
  { code: "662", name: "Huyện Cư Jút", province_code: "67" },
  { code: "663", name: "Huyện Đắk Mil", province_code: "67" },
  { code: "664", name: "Huyện Krông Nô", province_code: "67" },
  { code: "665", name: "Huyện Đắk Song", province_code: "67" },
  { code: "666", name: "Huyện Đắk R'Lấp", province_code: "67" },
  { code: "667", name: "Huyện Tuy Đức", province_code: "67" },
  { code: "672", name: "Thành phố Đà Lạt", province_code: "68" },
  { code: "673", name: "Thành phố Bảo Lộc", province_code: "68" },
  { code: "674", name: "Huyện Đam Rông", province_code: "68" },
  { code: "675", name: "Huyện Lạc Dương", province_code: "68" },
  { code: "676", name: "Huyện Lâm Hà", province_code: "68" },
  { code: "677", name: "Huyện Đơn Dương", province_code: "68" },
  { code: "678", name: "Huyện Đức Trọng", province_code: "68" },
  { code: "679", name: "Huyện Di Linh", province_code: "68" },
  { code: "680", name: "Huyện Bảo Lâm", province_code: "68" },
  { code: "682", name: "Huyện Đạ Huoai", province_code: "68" },
  { code: "688", name: "Thị xã Phước Long", province_code: "70" },
  { code: "689", name: "Thành phố Đồng Xoài", province_code: "70" },
  { code: "690", name: "Thị xã Bình Long", province_code: "70" },
  { code: "691", name: "Huyện Bù Gia Mập", province_code: "70" },
  { code: "692", name: "Huyện Lộc Ninh", province_code: "70" },
  { code: "693", name: "Huyện Bù Đốp", province_code: "70" },
  { code: "694", name: "Huyện Hớn Quản", province_code: "70" },
  { code: "695", name: "Huyện Đồng Phú", province_code: "70" },
  { code: "696", name: "Huyện Bù Đăng", province_code: "70" },
  { code: "697", name: "Thị xã Chơn Thành", province_code: "70" },
  { code: "698", name: "Huyện Phú Riềng", province_code: "70" },
  { code: "703", name: "Thành phố Tây Ninh", province_code: "72" },
  { code: "705", name: "Huyện Tân Biên", province_code: "72" },
  { code: "706", name: "Huyện Tân Châu", province_code: "72" },
  { code: "707", name: "Huyện Dương Minh Châu", province_code: "72" },
  { code: "708", name: "Huyện Châu Thành", province_code: "72" },
  { code: "709", name: "Thị xã Hòa Thành", province_code: "72" },
  { code: "710", name: "Huyện Gò Dầu", province_code: "72" },
  { code: "711", name: "Huyện Bến Cầu", province_code: "72" },
  { code: "712", name: "Thị xã Trảng Bàng", province_code: "72" },
  { code: "718", name: "Thành phố Thủ Dầu Một", province_code: "74" },
  { code: "719", name: "Huyện Bàu Bàng", province_code: "74" },
  { code: "720", name: "Huyện Dầu Tiếng", province_code: "74" },
  { code: "721", name: "Thành phố Bến Cát", province_code: "74" },
  { code: "722", name: "Huyện Phú Giáo", province_code: "74" },
  { code: "723", name: "Thành phố Tân Uyên", province_code: "74" },
  { code: "724", name: "Thành phố Dĩ An", province_code: "74" },
  { code: "725", name: "Thành phố Thuận An", province_code: "74" },
  { code: "726", name: "Huyện Bắc Tân Uyên", province_code: "74" },
  { code: "731", name: "Thành phố Biên Hòa", province_code: "75" },
  { code: "732", name: "Thành phố Long Khánh", province_code: "75" },
  { code: "734", name: "Huyện Tân Phú", province_code: "75" },
  { code: "735", name: "Huyện Vĩnh Cửu", province_code: "75" },
  { code: "736", name: "Huyện Định Quán", province_code: "75" },
  { code: "737", name: "Huyện Trảng Bom", province_code: "75" },
  { code: "738", name: "Huyện Thống Nhất", province_code: "75" },
  { code: "739", name: "Huyện Cẩm Mỹ", province_code: "75" },
  { code: "740", name: "Huyện Long Thành", province_code: "75" },
  { code: "741", name: "Huyện Xuân Lộc", province_code: "75" },
  { code: "742", name: "Huyện Nhơn Trạch", province_code: "75" },
  { code: "747", name: "Thành phố Vũng Tàu", province_code: "77" },
  { code: "748", name: "Thành phố Bà Rịa", province_code: "77" },
  { code: "750", name: "Huyện Châu Đức", province_code: "77" },
  { code: "751", name: "Huyện Xuyên Mộc", province_code: "77" },
  { code: "753", name: "Huyện Long Đất", province_code: "77" },
  { code: "754", name: "Thị xã Phú Mỹ", province_code: "77" },
  { code: "760", name: "Quận 1", province_code: "79" },
  { code: "761", name: "Quận 12", province_code: "79" },
  { code: "764", name: "Quận Gò Vấp", province_code: "79" },
  { code: "765", name: "Quận Bình Thạnh", province_code: "79" },
  { code: "766", name: "Quận Tân Bình", province_code: "79" },
  { code: "767", name: "Quận Tân Phú", province_code: "79" },
  { code: "768", name: "Quận Phú Nhuận", province_code: "79" },
  { code: "769", name: "Thành phố Thủ Đức", province_code: "79" },
  { code: "770", name: "Quận 3", province_code: "79" },
  { code: "771", name: "Quận 10", province_code: "79" },
  { code: "772", name: "Quận 11", province_code: "79" },
  { code: "773", name: "Quận 4", province_code: "79" },
  { code: "774", name: "Quận 5", province_code: "79" },
  { code: "775", name: "Quận 6", province_code: "79" },
  { code: "776", name: "Quận 8", province_code: "79" },
  { code: "777", name: "Quận Bình Tân", province_code: "79" },
  { code: "778", name: "Quận 7", province_code: "79" },
  { code: "783", name: "Huyện Củ Chi", province_code: "79" },
  { code: "784", name: "Huyện Hóc Môn", province_code: "79" },
  { code: "785", name: "Huyện Bình Chánh", province_code: "79" },
  { code: "786", name: "Huyện Nhà Bè", province_code: "79" },
  { code: "787", name: "Huyện Cần Giờ", province_code: "79" },
  { code: "794", name: "Thành phố Tân An", province_code: "80" },
  { code: "795", name: "Thị xã Kiến Tường", province_code: "80" },
  { code: "796", name: "Huyện Tân Hưng", province_code: "80" },
  { code: "797", name: "Huyện Vĩnh Hưng", province_code: "80" },
  { code: "798", name: "Huyện Mộc Hóa", province_code: "80" },
  { code: "799", name: "Huyện Tân Thạnh", province_code: "80" },
  { code: "800", name: "Huyện Thạnh Hóa", province_code: "80" },
  { code: "801", name: "Huyện Đức Huệ", province_code: "80" },
  { code: "802", name: "Huyện Đức Hòa", province_code: "80" },
  { code: "803", name: "Huyện Bến Lức", province_code: "80" },
  { code: "804", name: "Huyện Thủ Thừa", province_code: "80" },
  { code: "805", name: "Huyện Tân Trụ", province_code: "80" },
  { code: "806", name: "Huyện Cần Đước", province_code: "80" },
  { code: "807", name: "Huyện Cần Giuộc", province_code: "80" },
  { code: "808", name: "Huyện Châu Thành", province_code: "80" },
  { code: "815", name: "Thành phố Mỹ Tho", province_code: "82" },
  { code: "816", name: "Thành phố Gò Công", province_code: "82" },
  { code: "817", name: "Thị xã Cai Lậy", province_code: "82" },
  { code: "818", name: "Huyện Tân Phước", province_code: "82" },
  { code: "819", name: "Huyện Cái Bè", province_code: "82" },
  { code: "820", name: "Huyện Cai Lậy", province_code: "82" },
  { code: "821", name: "Huyện Châu Thành", province_code: "82" },
  { code: "822", name: "Huyện Chợ Gạo", province_code: "82" },
  { code: "823", name: "Huyện Gò Công Tây", province_code: "82" },
  { code: "824", name: "Huyện Gò Công Đông", province_code: "82" },
  { code: "825", name: "Huyện Tân Phú Đông", province_code: "82" },
  { code: "829", name: "Thành phố Bến Tre", province_code: "83" },
  { code: "831", name: "Huyện Châu Thành", province_code: "83" },
  { code: "832", name: "Huyện Chợ Lách", province_code: "83" },
  { code: "833", name: "Huyện Mỏ Cày Nam", province_code: "83" },
  { code: "834", name: "Huyện Giồng Trôm", province_code: "83" },
  { code: "835", name: "Huyện Bình Đại", province_code: "83" },
  { code: "836", name: "Huyện Ba Tri", province_code: "83" },
  { code: "837", name: "Huyện Thạnh Phú", province_code: "83" },
  { code: "838", name: "Huyện Mỏ Cày Bắc", province_code: "83" },
  { code: "842", name: "Thành phố Trà Vinh", province_code: "84" },
  { code: "844", name: "Huyện Càng Long", province_code: "84" },
  { code: "845", name: "Huyện Cầu Kè", province_code: "84" },
  { code: "846", name: "Huyện Tiểu Cần", province_code: "84" },
  { code: "847", name: "Huyện Châu Thành", province_code: "84" },
  { code: "848", name: "Huyện Cầu Ngang", province_code: "84" },
  { code: "849", name: "Huyện Trà Cú", province_code: "84" },
  { code: "850", name: "Huyện Duyên Hải", province_code: "84" },
  { code: "851", name: "Thị xã Duyên Hải", province_code: "84" },
  { code: "855", name: "Thành phố Vĩnh Long", province_code: "86" },
  { code: "857", name: "Huyện Long Hồ", province_code: "86" },
  { code: "858", name: "Huyện Mang Thít", province_code: "86" },
  { code: "859", name: "Huyện Vũng Liêm", province_code: "86" },
  { code: "860", name: "Huyện Tam Bình", province_code: "86" },
  { code: "861", name: "Thị xã Bình Minh", province_code: "86" },
  { code: "862", name: "Huyện Trà Ôn", province_code: "86" },
  { code: "863", name: "Huyện Bình Tân", province_code: "86" },
  { code: "866", name: "Thành phố Cao Lãnh", province_code: "87" },
  { code: "867", name: "Thành phố Sa Đéc", province_code: "87" },
  { code: "868", name: "Thành phố Hồng Ngự", province_code: "87" },
  { code: "869", name: "Huyện Tân Hồng", province_code: "87" },
  { code: "870", name: "Huyện Hồng Ngự", province_code: "87" },
  { code: "871", name: "Huyện Tam Nông", province_code: "87" },
  { code: "872", name: "Huyện Tháp Mười", province_code: "87" },
  { code: "873", name: "Huyện Cao Lãnh", province_code: "87" },
  { code: "874", name: "Huyện Thanh Bình", province_code: "87" },
  { code: "875", name: "Huyện Lấp Vò", province_code: "87" },
  { code: "876", name: "Huyện Lai Vung", province_code: "87" },
  { code: "877", name: "Huyện Châu Thành", province_code: "87" },
  { code: "883", name: "Thành phố Long Xuyên", province_code: "89" },
  { code: "884", name: "Thành phố Châu Đốc", province_code: "89" },
  { code: "886", name: "Huyện An Phú", province_code: "89" },
  { code: "887", name: "Thị xã Tân Châu", province_code: "89" },
  { code: "888", name: "Huyện Phú Tân", province_code: "89" },
  { code: "889", name: "Huyện Châu Phú", province_code: "89" },
  { code: "890", name: "Thị xã Tịnh Biên", province_code: "89" },
  { code: "891", name: "Huyện Tri Tôn", province_code: "89" },
  { code: "892", name: "Huyện Châu Thành", province_code: "89" },
  { code: "893", name: "Huyện Chợ Mới", province_code: "89" },
  { code: "894", name: "Huyện Thoại Sơn", province_code: "89" },
  { code: "899", name: "Thành phố Rạch Giá", province_code: "91" },
  { code: "900", name: "Thành phố Hà Tiên", province_code: "91" },
  { code: "902", name: "Huyện Kiên Lương", province_code: "91" },
  { code: "903", name: "Huyện Hòn Đất", province_code: "91" },
  { code: "904", name: "Huyện Tân Hiệp", province_code: "91" },
  { code: "905", name: "Huyện Châu Thành", province_code: "91" },
  { code: "906", name: "Huyện Giồng Riềng", province_code: "91" },
  { code: "907", name: "Huyện Gò Quao", province_code: "91" },
  { code: "908", name: "Huyện An Biên", province_code: "91" },
  { code: "909", name: "Huyện An Minh", province_code: "91" },
  { code: "910", name: "Huyện Vĩnh Thuận", province_code: "91" },
  { code: "911", name: "Thành phố Phú Quốc", province_code: "91" },
  { code: "912", name: "Huyện Kiên Hải", province_code: "91" },
  { code: "913", name: "Huyện U Minh Thượng", province_code: "91" },
  { code: "914", name: "Huyện Giang Thành", province_code: "91" },
  { code: "916", name: "Quận Ninh Kiều", province_code: "92" },
  { code: "917", name: "Quận Ô Môn", province_code: "92" },
  { code: "918", name: "Quận Bình Thuỷ", province_code: "92" },
  { code: "919", name: "Quận Cái Răng", province_code: "92" },
  { code: "923", name: "Quận Thốt Nốt", province_code: "92" },
  { code: "924", name: "Huyện Vĩnh Thạnh", province_code: "92" },
  { code: "925", name: "Huyện Cờ Đỏ", province_code: "92" },
  { code: "926", name: "Huyện Phong Điền", province_code: "92" },
  { code: "927", name: "Huyện Thới Lai", province_code: "92" },
  { code: "930", name: "Thành phố Vị Thanh", province_code: "93" },
  { code: "931", name: "Thành phố Ngã Bảy", province_code: "93" },
  { code: "932", name: "Huyện Châu Thành A", province_code: "93" },
  { code: "933", name: "Huyện Châu Thành", province_code: "93" },
  { code: "934", name: "Huyện Phụng Hiệp", province_code: "93" },
  { code: "935", name: "Huyện Vị Thuỷ", province_code: "93" },
  { code: "936", name: "Huyện Long Mỹ", province_code: "93" },
  { code: "937", name: "Thị xã Long Mỹ", province_code: "93" },
  { code: "941", name: "Thành phố Sóc Trăng", province_code: "94" },
  { code: "942", name: "Huyện Châu Thành", province_code: "94" },
  { code: "943", name: "Huyện Kế Sách", province_code: "94" },
  { code: "944", name: "Huyện Mỹ Tú", province_code: "94" },
  { code: "945", name: "Huyện Cù Lao Dung", province_code: "94" },
  { code: "946", name: "Huyện Long Phú", province_code: "94" },
  { code: "947", name: "Huyện Mỹ Xuyên", province_code: "94" },
  { code: "948", name: "Thị xã Ngã Năm", province_code: "94" },
  { code: "949", name: "Huyện Thạnh Trị", province_code: "94" },
  { code: "950", name: "Thị xã Vĩnh Châu", province_code: "94" },
  { code: "951", name: "Huyện Trần Đề", province_code: "94" },
  { code: "954", name: "Thành phố Bạc Liêu", province_code: "95" },
  { code: "956", name: "Huyện Hồng Dân", province_code: "95" },
  { code: "957", name: "Huyện Phước Long", province_code: "95" },
  { code: "958", name: "Huyện Vĩnh Lợi", province_code: "95" },
  { code: "959", name: "Thị xã Giá Rai", province_code: "95" },
  { code: "960", name: "Huyện Đông Hải", province_code: "95" },
  { code: "961", name: "Huyện Hoà Bình", province_code: "95" },
  { code: "964", name: "Thành phố Cà Mau", province_code: "96" },
  { code: "966", name: "Huyện U Minh", province_code: "96" },
  { code: "967", name: "Huyện Thới Bình", province_code: "96" },
  { code: "968", name: "Huyện Trần Văn Thời", province_code: "96" },
  { code: "969", name: "Huyện Cái Nước", province_code: "96" },
  { code: "970", name: "Huyện Đầm Dơi", province_code: "96" },
  { code: "971", name: "Huyện Năm Căn", province_code: "96" },
  { code: "972", name: "Huyện Phú Tân", province_code: "96" },
  { code: "973", name: "Huyện Ngọc Hiển", province_code: "96" },
];

export const wardsData: WardDataItem[] = [
  { code: "1", name: "Phường Phúc Xá", district_code: "1" },
  { code: "4", name: "Phường Trúc Bạch", district_code: "1" },
  { code: "6", name: "Phường Vĩnh Phúc", district_code: "1" },
  { code: "7", name: "Phường Cống Vị", district_code: "1" },
  { code: "8", name: "Phường Liễu Giai", district_code: "1" },
  { code: "13", name: "Phường Quán Thánh", district_code: "1" },
  { code: "16", name: "Phường Ngọc Hà", district_code: "1" },
  { code: "19", name: "Phường Điện Biên", district_code: "1" },
  { code: "22", name: "Phường Đội Cấn", district_code: "1" },
  { code: "25", name: "Phường Ngọc Khánh", district_code: "1" },
  { code: "28", name: "Phường Kim Mã", district_code: "1" },
  { code: "31", name: "Phường Giảng Võ", district_code: "1" },
  { code: "34", name: "Phường Thành Công", district_code: "1" },
  { code: "37", name: "Phường Phúc Tân", district_code: "2" },
  { code: "40", name: "Phường Đồng Xuân", district_code: "2" },
  { code: "43", name: "Phường Hàng Mã", district_code: "2" },
  { code: "46", name: "Phường Hàng Buồm", district_code: "2" },
  { code: "49", name: "Phường Hàng Đào", district_code: "2" },
  { code: "52", name: "Phường Hàng Bồ", district_code: "2" },
  { code: "55", name: "Phường Cửa Đông", district_code: "2" },
  { code: "58", name: "Phường Lý Thái Tổ", district_code: "2" },
  { code: "61", name: "Phường Hàng Bạc", district_code: "2" },
  { code: "64", name: "Phường Hàng Gai", district_code: "2" },
  { code: "67", name: "Phường Chương Dương", district_code: "2" },
  { code: "70", name: "Phường Hàng Trống", district_code: "2" },
  { code: "73", name: "Phường Cửa Nam", district_code: "2" },
  { code: "76", name: "Phường Hàng Bông", district_code: "2" },
  { code: "79", name: "Phường Tràng Tiền", district_code: "2" },
  { code: "82", name: "Phường Trần Hưng Đạo", district_code: "2" },
  { code: "85", name: "Phường Phan Chu Trinh", district_code: "2" },
  { code: "88", name: "Phường Hàng Bài", district_code: "2" },
  { code: "91", name: "Phường Phú Thượng", district_code: "3" },
  { code: "94", name: "Phường Nhật Tân", district_code: "3" },
  { code: "97", name: "Phường Tứ Liên", district_code: "3" },
  { code: "100", name: "Phường Quảng An", district_code: "3" },
  { code: "103", name: "Phường Xuân La", district_code: "3" },
  { code: "106", name: "Phường Yên Phụ", district_code: "3" },
  { code: "109", name: "Phường Bưởi", district_code: "3" },
  { code: "112", name: "Phường Thụy Khuê", district_code: "3" },
  { code: "115", name: "Phường Thượng Thanh", district_code: "4" },
  { code: "118", name: "Phường Ngọc Thụy", district_code: "4" },
  { code: "121", name: "Phường Giang Biên", district_code: "4" },
  { code: "124", name: "Phường Đức Giang", district_code: "4" },
  { code: "127", name: "Phường Việt Hưng", district_code: "4" },
  { code: "130", name: "Phường Gia Thụy", district_code: "4" },
  { code: "133", name: "Phường Ngọc Lâm", district_code: "4" },
  { code: "136", name: "Phường Phúc Lợi", district_code: "4" },
  { code: "139", name: "Phường Bồ Đề", district_code: "4" },
  { code: "145", name: "Phường Long Biên", district_code: "4" },
  { code: "148", name: "Phường Thạch Bàn", district_code: "4" },
  { code: "151", name: "Phường Phúc Đồng", district_code: "4" },
  { code: "154", name: "Phường Cự Khối", district_code: "4" },
  { code: "157", name: "Phường Nghĩa Đô", district_code: "5" },
  { code: "160", name: "Phường Nghĩa Tân", district_code: "5" },
  { code: "163", name: "Phường Mai Dịch", district_code: "5" },
  { code: "166", name: "Phường Dịch Vọng", district_code: "5" },
  { code: "167", name: "Phường Dịch Vọng Hậu", district_code: "5" },
  { code: "169", name: "Phường Quan Hoa", district_code: "5" },
  { code: "172", name: "Phường Yên Hoà", district_code: "5" },
  { code: "175", name: "Phường Trung Hoà", district_code: "5" },
  { code: "178", name: "Phường Cát Linh", district_code: "6" },
  { code: "181", name: "Phường Văn Miếu - Quốc Tử Giám", district_code: "6" },
  { code: "187", name: "Phường Láng Thượng", district_code: "6" },
  { code: "190", name: "Phường Ô Chợ Dừa", district_code: "6" },
  { code: "193", name: "Phường Văn Chương", district_code: "6" },
  { code: "196", name: "Phường Hàng Bột", district_code: "6" },
  { code: "199", name: "Phường Láng Hạ", district_code: "6" },
  { code: "202", name: "Phường Khâm Thiên", district_code: "6" },
  { code: "205", name: "Phường Thổ Quan", district_code: "6" },
  { code: "208", name: "Phường Nam Đồng", district_code: "6" },
  { code: "214", name: "Phường Quang Trung", district_code: "6" },
  { code: "217", name: "Phường Trung Liệt", district_code: "6" },
  { code: "226", name: "Phường Phương Liên - Trung Tự", district_code: "6" },
  { code: "229", name: "Phường Kim Liên", district_code: "6" },
  { code: "232", name: "Phường Phương Mai", district_code: "6" },
  { code: "235", name: "Phường Thịnh Quang", district_code: "6" },
  { code: "238", name: "Phường Khương Thượng", district_code: "6" },
  { code: "241", name: "Phường Nguyễn Du", district_code: "7" },
  { code: "244", name: "Phường Bạch Đằng", district_code: "7" },
  { code: "247", name: "Phường Phạm Đình Hổ", district_code: "7" },
  { code: "256", name: "Phường Lê Đại Hành", district_code: "7" },
  { code: "259", name: "Phường Đồng Nhân", district_code: "7" },
  { code: "262", name: "Phường Phố Huế", district_code: "7" },
  { code: "268", name: "Phường Thanh Lương", district_code: "7" },
  { code: "271", name: "Phường Thanh Nhàn", district_code: "7" },
  { code: "277", name: "Phường Bách Khoa", district_code: "7" },
  { code: "280", name: "Phường Đồng Tâm", district_code: "7" },
  { code: "283", name: "Phường Vĩnh Tuy", district_code: "7" },
  { code: "289", name: "Phường Quỳnh Mai", district_code: "7" },
  { code: "292", name: "Phường Bạch Mai", district_code: "7" },
  { code: "295", name: "Phường Minh Khai", district_code: "7" },
  { code: "298", name: "Phường Trương Định", district_code: "7" },
  { code: "301", name: "Phường Thanh Trì", district_code: "8" },
  { code: "304", name: "Phường Vĩnh Hưng", district_code: "8" },
  { code: "307", name: "Phường Định Công", district_code: "8" },
  { code: "310", name: "Phường Mai Động", district_code: "8" },
  { code: "313", name: "Phường Tương Mai", district_code: "8" },
  { code: "316", name: "Phường Đại Kim", district_code: "8" },
  { code: "319", name: "Phường Tân Mai", district_code: "8" },
  { code: "322", name: "Phường Hoàng Văn Thụ", district_code: "8" },
  { code: "325", name: "Phường Giáp Bát", district_code: "8" },
  { code: "328", name: "Phường Lĩnh Nam", district_code: "8" },
  { code: "331", name: "Phường Thịnh Liệt", district_code: "8" },
  { code: "334", name: "Phường Trần Phú", district_code: "8" },
  { code: "337", name: "Phường Hoàng Liệt", district_code: "8" },
  { code: "340", name: "Phường Yên Sở", district_code: "8" },
  { code: "343", name: "Phường Nhân Chính", district_code: "9" },
  { code: "346", name: "Phường Thượng Đình", district_code: "9" },
  { code: "349", name: "Phường Khương Trung", district_code: "9" },
  { code: "352", name: "Phường Khương Mai", district_code: "9" },
  { code: "355", name: "Phường Thanh Xuân Trung", district_code: "9" },
  { code: "358", name: "Phường Phương Liệt", district_code: "9" },
  { code: "364", name: "Phường Khương Đình", district_code: "9" },
  { code: "367", name: "Phường Thanh Xuân Bắc", district_code: "9" },
  { code: "373", name: "Phường Hạ Đình", district_code: "9" },
  { code: "376", name: "Thị trấn Sóc Sơn", district_code: "16" },
  { code: "379", name: "Xã Bắc Sơn", district_code: "16" },
  { code: "382", name: "Xã Minh Trí", district_code: "16" },
  { code: "385", name: "Xã Hồng Kỳ", district_code: "16" },
  { code: "388", name: "Xã Nam Sơn", district_code: "16" },
  { code: "391", name: "Xã Trung Giã", district_code: "16" },
  { code: "394", name: "Xã Tân Hưng", district_code: "16" },
  { code: "397", name: "Xã Minh Phú", district_code: "16" },
  { code: "400", name: "Xã Phù Linh", district_code: "16" },
  { code: "403", name: "Xã Bắc Phú", district_code: "16" },
  { code: "406", name: "Xã Tân Minh", district_code: "16" },
  { code: "409", name: "Xã Quang Tiến", district_code: "16" },
  { code: "412", name: "Xã Hiền Ninh", district_code: "16" },
  { code: "415", name: "Xã Tân Dân", district_code: "16" },
  { code: "418", name: "Xã Tiên Dược", district_code: "16" },
  { code: "421", name: "Xã Việt Long", district_code: "16" },
  { code: "424", name: "Xã Xuân Giang", district_code: "16" },
  { code: "427", name: "Xã Mai Đình", district_code: "16" },
  { code: "430", name: "Xã Đức Hoà", district_code: "16" },
  { code: "433", name: "Xã Thanh Xuân", district_code: "16" },
  { code: "436", name: "Xã Đông Xuân", district_code: "16" },
  { code: "439", name: "Xã Kim Lũ", district_code: "16" },
  { code: "442", name: "Xã Phú Cường", district_code: "16" },
  { code: "445", name: "Xã Phú Minh", district_code: "16" },
  { code: "448", name: "Xã Phù Lỗ", district_code: "16" },
  { code: "451", name: "Xã Xuân Thu", district_code: "16" },
  { code: "454", name: "Thị trấn Đông Anh", district_code: "17" },
  { code: "457", name: "Xã Xuân Nộn", district_code: "17" },
  { code: "460", name: "Xã Thuỵ Lâm", district_code: "17" },
  { code: "463", name: "Xã Bắc Hồng", district_code: "17" },
  { code: "466", name: "Xã Nguyên Khê", district_code: "17" },
  { code: "469", name: "Xã Nam Hồng", district_code: "17" },
  { code: "472", name: "Xã Tiên Dương", district_code: "17" },
  { code: "475", name: "Xã Vân Hà", district_code: "17" },
  { code: "478", name: "Xã Uy Nỗ", district_code: "17" },
  { code: "481", name: "Xã Vân Nội", district_code: "17" },
  { code: "484", name: "Xã Liên Hà", district_code: "17" },
  { code: "487", name: "Xã Việt Hùng", district_code: "17" },
  { code: "490", name: "Xã Kim Nỗ", district_code: "17" },
  { code: "493", name: "Xã Kim Chung", district_code: "17" },
  { code: "496", name: "Xã Dục Tú", district_code: "17" },
  { code: "499", name: "Xã Đại Mạch", district_code: "17" },
  { code: "502", name: "Xã Vĩnh Ngọc", district_code: "17" },
  { code: "505", name: "Xã Cổ Loa", district_code: "17" },
  { code: "508", name: "Xã Hải Bối", district_code: "17" },
  { code: "511", name: "Xã Xuân Canh", district_code: "17" },
  { code: "514", name: "Xã Võng La", district_code: "17" },
  { code: "517", name: "Xã Tàm Xá", district_code: "17" },
  { code: "520", name: "Xã Mai Lâm", district_code: "17" },
  { code: "523", name: "Xã Đông Hội", district_code: "17" },
  { code: "526", name: "Thị trấn Yên Viên", district_code: "18" },
  { code: "529", name: "Xã Yên Thường", district_code: "18" },
  { code: "532", name: "Xã Yên Viên", district_code: "18" },
  { code: "535", name: "Xã Ninh Hiệp", district_code: "18" },
  { code: "541", name: "Xã Thiên Đức", district_code: "18" },
  { code: "544", name: "Xã Phù Đổng", district_code: "18" },
  { code: "550", name: "Xã Lệ Chi", district_code: "18" },
  { code: "553", name: "Xã Cổ Bi", district_code: "18" },
  { code: "556", name: "Xã Đặng Xá", district_code: "18" },
  { code: "562", name: "Xã Phú Sơn", district_code: "18" },
  { code: "565", name: "Thị trấn Trâu Quỳ", district_code: "18" },
  { code: "568", name: "Xã Dương Quang", district_code: "18" },
  { code: "571", name: "Xã Dương Xá", district_code: "18" },
  { code: "577", name: "Xã Đa Tốn", district_code: "18" },
  { code: "580", name: "Xã Kiêu Kỵ", district_code: "18" },
  { code: "583", name: "Xã Bát Tràng", district_code: "18" },
  { code: "589", name: "Xã Kim Đức", district_code: "18" },
  { code: "592", name: "Phường Cầu Diễn", district_code: "19" },
  { code: "622", name: "Phường Xuân Phương", district_code: "19" },
  { code: "623", name: "Phường Phương Canh", district_code: "19" },
  { code: "625", name: "Phường Mỹ Đình 1", district_code: "19" },
  { code: "626", name: "Phường Mỹ Đình 2", district_code: "19" },
  { code: "628", name: "Phường Tây Mỗ", district_code: "19" },
  { code: "631", name: "Phường Mễ Trì", district_code: "19" },
  { code: "632", name: "Phường Phú Đô", district_code: "19" },
  { code: "634", name: "Phường Đại Mỗ", district_code: "19" },
  { code: "637", name: "Phường Trung Văn", district_code: "19" },
  { code: "640", name: "Thị trấn Văn Điển", district_code: "20" },
  { code: "643", name: "Xã Tân Triều", district_code: "20" },
  { code: "646", name: "Xã Thanh Liệt", district_code: "20" },
  { code: "649", name: "Xã Tả Thanh Oai", district_code: "20" },
  { code: "652", name: "Xã Hữu Hoà", district_code: "20" },
  { code: "655", name: "Xã Tam Hiệp", district_code: "20" },
  { code: "658", name: "Xã Tứ Hiệp", district_code: "20" },
  { code: "661", name: "Xã Yên Mỹ", district_code: "20" },
  { code: "664", name: "Xã Vĩnh Quỳnh", district_code: "20" },
  { code: "667", name: "Xã Ngũ Hiệp", district_code: "20" },
  { code: "670", name: "Xã Duyên Hà", district_code: "20" },
  { code: "673", name: "Xã Ngọc Hồi", district_code: "20" },
  { code: "676", name: "Xã Vạn Phúc", district_code: "20" },
  { code: "679", name: "Xã Đại áng", district_code: "20" },
  { code: "682", name: "Xã Liên Ninh", district_code: "20" },
  { code: "685", name: "Xã Đông Mỹ", district_code: "20" },
  { code: "595", name: "Phường Thượng Cát", district_code: "21" },
  { code: "598", name: "Phường Liên Mạc", district_code: "21" },
  { code: "601", name: "Phường Đông Ngạc", district_code: "21" },
  { code: "602", name: "Phường Đức Thắng", district_code: "21" },
  { code: "604", name: "Phường Thụy Phương", district_code: "21" },
  { code: "607", name: "Phường Tây Tựu", district_code: "21" },
  { code: "610", name: "Phường Xuân Đỉnh", district_code: "21" },
  { code: "611", name: "Phường Xuân Tảo", district_code: "21" },
  { code: "613", name: "Phường Minh Khai", district_code: "21" },
  { code: "616", name: "Phường Cổ Nhuế 1", district_code: "21" },
  { code: "617", name: "Phường Cổ Nhuế 2", district_code: "21" },
  { code: "619", name: "Phường Phú Diễn", district_code: "21" },
  { code: "620", name: "Phường Phúc Diễn", district_code: "21" },
  { code: "8973", name: "Thị trấn Chi Đông", district_code: "250" },
  { code: "8974", name: "Xã Đại Thịnh", district_code: "250" },
  { code: "8977", name: "Xã Kim Hoa", district_code: "250" },
  { code: "8980", name: "Xã Thạch Đà", district_code: "250" },
  { code: "8983", name: "Xã Tiến Thắng", district_code: "250" },
  { code: "8986", name: "Xã Tự Lập", district_code: "250" },
  { code: "8989", name: "Thị trấn Quang Minh", district_code: "250" },
  { code: "8992", name: "Xã Thanh Lâm", district_code: "250" },
  { code: "8995", name: "Xã Tam Đồng", district_code: "250" },
  { code: "8998", name: "Xã Liên Mạc", district_code: "250" },
  { code: "9004", name: "Xã Chu Phan", district_code: "250" },
  { code: "9007", name: "Xã Tiến Thịnh", district_code: "250" },
  { code: "9010", name: "Xã Mê Linh", district_code: "250" },
  { code: "9013", name: "Xã Văn Khê", district_code: "250" },
  { code: "9016", name: "Xã Hoàng Kim", district_code: "250" },
  { code: "9019", name: "Xã Tiền Phong", district_code: "250" },
  { code: "9022", name: "Xã Tráng Việt", district_code: "250" },
  { code: "9538", name: "Phường Quang Trung", district_code: "268" },
  { code: "9541", name: "Phường Mộ Lao", district_code: "268" },
  { code: "9542", name: "Phường Văn Quán", district_code: "268" },
  { code: "9544", name: "Phường Vạn Phúc", district_code: "268" },
  { code: "9551", name: "Phường La Khê", district_code: "268" },
  { code: "9552", name: "Phường Phú La", district_code: "268" },
  { code: "9553", name: "Phường Phúc La", district_code: "268" },
  { code: "9556", name: "Phường Hà Cầu", district_code: "268" },
  { code: "9562", name: "Phường Yên Nghĩa", district_code: "268" },
  { code: "9565", name: "Phường Kiến Hưng", district_code: "268" },
  { code: "9568", name: "Phường Phú Lãm", district_code: "268" },
  { code: "9571", name: "Phường Phú Lương", district_code: "268" },
  { code: "9886", name: "Phường Dương Nội", district_code: "268" },
  { code: "10117", name: "Phường Đồng Mai", district_code: "268" },
  { code: "10123", name: "Phường Biên Giang", district_code: "268" },
  { code: "9574", name: "Phường Ngô Quyền", district_code: "269" },
  { code: "9577", name: "Phường Phú Thịnh", district_code: "269" },
  { code: "9586", name: "Phường Sơn Lộc", district_code: "269" },
  { code: "9589", name: "Phường Xuân Khanh", district_code: "269" },
  { code: "9592", name: "Xã Đường Lâm", district_code: "269" },
  { code: "9595", name: "Phường Viên Sơn", district_code: "269" },
  { code: "9598", name: "Xã Xuân Sơn", district_code: "269" },
  { code: "9601", name: "Phường Trung Hưng", district_code: "269" },
  { code: "9604", name: "Xã Thanh Mỹ", district_code: "269" },
  { code: "9607", name: "Phường Trung Sơn Trầm", district_code: "269" },
  { code: "9610", name: "Xã Kim Sơn", district_code: "269" },
  { code: "9613", name: "Xã Sơn Đông", district_code: "269" },
  { code: "9616", name: "Xã Cổ Đông", district_code: "269" },
  { code: "9619", name: "Thị trấn Tây Đằng", district_code: "271" },
  { code: "9625", name: "Xã Phú Cường", district_code: "271" },
  { code: "9628", name: "Xã Cổ Đô", district_code: "271" },
  { code: "9634", name: "Xã Vạn Thắng", district_code: "271" },
  { code: "9640", name: "Xã Phong Vân", district_code: "271" },
  { code: "9643", name: "Xã Phú Đông", district_code: "271" },
  { code: "9646", name: "Xã Phú Hồng", district_code: "271" },
  { code: "9649", name: "Xã Phú Châu", district_code: "271" },
  { code: "9652", name: "Xã Thái Hòa", district_code: "271" },
  { code: "9655", name: "Xã Đồng Thái", district_code: "271" },
  { code: "9658", name: "Xã Phú Sơn", district_code: "271" },
  { code: "9661", name: "Xã Minh Châu", district_code: "271" },
  { code: "9664", name: "Xã Vật Lại", district_code: "271" },
  { code: "9667", name: "Xã Chu Minh", district_code: "271" },
  { code: "9670", name: "Xã Tòng Bạt", district_code: "271" },
  { code: "9673", name: "Xã Cẩm Lĩnh", district_code: "271" },
  { code: "9676", name: "Xã Sơn Đà", district_code: "271" },
  { code: "9679", name: "Xã Đông Quang", district_code: "271" },
  { code: "9682", name: "Xã Tiên Phong", district_code: "271" },
  { code: "9685", name: "Xã Thụy An", district_code: "271" },
  { code: "9688", name: "Xã Cam Thượng", district_code: "271" },
  { code: "9691", name: "Xã Thuần Mỹ", district_code: "271" },
  { code: "9694", name: "Xã Tản Lĩnh", district_code: "271" },
  { code: "9697", name: "Xã Ba Trại", district_code: "271" },
  { code: "9700", name: "Xã Minh Quang", district_code: "271" },
  { code: "9703", name: "Xã Ba Vì", district_code: "271" },
  { code: "9706", name: "Xã Vân Hòa", district_code: "271" },
  { code: "9709", name: "Xã Yên Bài", district_code: "271" },
  { code: "9712", name: "Xã Khánh Thượng", district_code: "271" },
  { code: "9715", name: "Thị trấn Phúc Thọ", district_code: "272" },
  { code: "9721", name: "Xã Vân Phúc", district_code: "272" },
  { code: "9724", name: "Xã Nam Hà", district_code: "272" },
  { code: "9727", name: "Xã Xuân Đình", district_code: "272" },
  { code: "9733", name: "Xã Sen Phương", district_code: "272" },
  { code: "9739", name: "Xã Võng Xuyên", district_code: "272" },
  { code: "9742", name: "Xã Tích Lộc", district_code: "272" },
  { code: "9745", name: "Xã Long Thượng", district_code: "272" },
  { code: "9751", name: "Xã Hát Môn", district_code: "272" },
  { code: "9757", name: "Xã Thanh Đa", district_code: "272" },
  { code: "9760", name: "Xã Trạch Mỹ Lộc", district_code: "272" },
  { code: "9763", name: "Xã Phúc Hòa", district_code: "272" },
  { code: "9766", name: "Xã Ngọc Tảo", district_code: "272" },
  { code: "9769", name: "Xã Phụng Thượng", district_code: "272" },
  { code: "9772", name: "Xã Tam Thuấn", district_code: "272" },
  { code: "9775", name: "Xã Tam Hiệp", district_code: "272" },
  { code: "9778", name: "Xã Hiệp Thuận", district_code: "272" },
  { code: "9781", name: "Xã Liên Hiệp", district_code: "272" },
  { code: "9784", name: "Thị trấn Phùng", district_code: "273" },
  { code: "9787", name: "Xã Trung Châu", district_code: "273" },
  { code: "9790", name: "Xã Thọ An", district_code: "273" },
  { code: "9793", name: "Xã Thọ Xuân", district_code: "273" },
  { code: "9796", name: "Xã Hồng Hà", district_code: "273" },
  { code: "9799", name: "Xã Liên Hồng", district_code: "273" },
  { code: "9802", name: "Xã Liên Hà", district_code: "273" },
  { code: "9805", name: "Xã Hạ Mỗ", district_code: "273" },
  { code: "9808", name: "Xã Liên Trung", district_code: "273" },
  { code: "9811", name: "Xã Phương Đình", district_code: "273" },
  { code: "9814", name: "Xã Thượng Mỗ", district_code: "273" },
  { code: "9817", name: "Xã Tân Hội", district_code: "273" },
  { code: "9820", name: "Xã Tân Lập", district_code: "273" },
  { code: "9823", name: "Xã Đan Phượng", district_code: "273" },
  { code: "9826", name: "Xã Đồng Tháp", district_code: "273" },
  { code: "9829", name: "Xã Song Phượng", district_code: "273" },
  { code: "9832", name: "Thị trấn Trạm Trôi", district_code: "274" },
  { code: "9835", name: "Xã Đức Thượng", district_code: "274" },
  { code: "9838", name: "Xã Minh Khai", district_code: "274" },
  { code: "9841", name: "Xã Dương Liễu", district_code: "274" },
  { code: "9844", name: "Xã Di Trạch", district_code: "274" },
  { code: "9847", name: "Xã Đức Giang", district_code: "274" },
  { code: "9850", name: "Xã Cát Quế", district_code: "274" },
  { code: "9853", name: "Xã Kim Chung", district_code: "274" },
  { code: "9856", name: "Xã Yên Sở", district_code: "274" },
  { code: "9859", name: "Xã Sơn Đồng", district_code: "274" },
  { code: "9862", name: "Xã Vân Canh", district_code: "274" },
  { code: "9865", name: "Xã Đắc Sở", district_code: "274" },
  { code: "9868", name: "Xã Lại Yên", district_code: "274" },
  { code: "9871", name: "Xã Tiền Yên", district_code: "274" },
  { code: "9874", name: "Xã Song Phương", district_code: "274" },
  { code: "9877", name: "Xã An Khánh", district_code: "274" },
  { code: "9880", name: "Xã An Thượng", district_code: "274" },
  { code: "9883", name: "Xã Vân Côn", district_code: "274" },
  { code: "9889", name: "Xã La Phù", district_code: "274" },
  { code: "9892", name: "Xã Đông La", district_code: "274" },
  { code: "4939", name: "Xã Đông Xuân", district_code: "275" },
  { code: "9895", name: "Thị trấn Quốc Oai", district_code: "275" },
  { code: "9898", name: "Xã Sài Sơn", district_code: "275" },
  { code: "9904", name: "Xã Phượng Sơn", district_code: "275" },
  { code: "9907", name: "Xã Ngọc Liệp", district_code: "275" },
  { code: "9910", name: "Xã Ngọc Mỹ", district_code: "275" },
  { code: "9916", name: "Xã Thạch Thán", district_code: "275" },
  { code: "9919", name: "Xã Đồng Quang", district_code: "275" },
  { code: "9922", name: "Xã Phú Cát", district_code: "275" },
  { code: "9925", name: "Xã Tuyết Nghĩa", district_code: "275" },
  { code: "9928", name: "Xã Liệp Nghĩa", district_code: "275" },
  { code: "9931", name: "Xã Cộng Hòa", district_code: "275" },
  { code: "9934", name: "Xã Hưng Đạo", district_code: "275" },
  { code: "9940", name: "Xã Phú Mãn", district_code: "275" },
  { code: "9943", name: "Xã Cấn Hữu", district_code: "275" },
  { code: "9949", name: "Xã Hòa Thạch", district_code: "275" },
  { code: "9952", name: "Xã Đông Yên", district_code: "275" },
  { code: "4927", name: "Xã Yên Trung", district_code: "276" },
  { code: "4930", name: "Xã Yên Bình", district_code: "276" },
  { code: "4936", name: "Xã Tiến Xuân", district_code: "276" },
  { code: "9955", name: "Thị trấn Liên Quan", district_code: "276" },
  { code: "9958", name: "Xã Đại Đồng", district_code: "276" },
  { code: "9961", name: "Xã Cẩm Yên", district_code: "276" },
  { code: "9964", name: "Xã Lại Thượng", district_code: "276" },
  { code: "9967", name: "Xã Phú Kim", district_code: "276" },
  { code: "9970", name: "Xã Hương Ngải", district_code: "276" },
  { code: "9973", name: "Xã Lam Sơn", district_code: "276" },
  { code: "9976", name: "Xã Kim Quan", district_code: "276" },
  { code: "9982", name: "Xã Bình Yên", district_code: "276" },
  { code: "9988", name: "Xã Thạch Hoà", district_code: "276" },
  { code: "9991", name: "Xã Cần Kiệm", district_code: "276" },
  { code: "9997", name: "Xã Phùng Xá", district_code: "276" },
  { code: "10000", name: "Xã Tân Xã", district_code: "276" },
  { code: "10003", name: "Xã Thạch Xá", district_code: "276" },
  { code: "10006", name: "Xã Quang Trung", district_code: "276" },
  { code: "10009", name: "Xã Hạ Bằng", district_code: "276" },
  { code: "10012", name: "Xã Đồng Trúc", district_code: "276" },
  { code: "10015", name: "Thị trấn Chúc Sơn", district_code: "277" },
  { code: "10018", name: "Thị trấn Xuân Mai", district_code: "277" },
  { code: "10021", name: "Xã Phụng Châu", district_code: "277" },
  { code: "10024", name: "Xã Tiên Phương", district_code: "277" },
  { code: "10027", name: "Xã Đông Sơn", district_code: "277" },
  { code: "10030", name: "Xã Đông Phương Yên", district_code: "277" },
  { code: "10033", name: "Xã Phú Nghĩa", district_code: "277" },
  { code: "10039", name: "Xã Trường Yên", district_code: "277" },
  { code: "10042", name: "Xã Ngọc Hòa", district_code: "277" },
  { code: "10045", name: "Xã Thủy Xuân Tiên", district_code: "277" },
  { code: "10048", name: "Xã Thanh Bình", district_code: "277" },
  { code: "10051", name: "Xã Trung Hòa", district_code: "277" },
  { code: "10054", name: "Xã Đại Yên", district_code: "277" },
  { code: "10057", name: "Xã Thụy Hương", district_code: "277" },
  { code: "10060", name: "Xã Tốt Động", district_code: "277" },
  { code: "10063", name: "Xã Lam Điền", district_code: "277" },
  { code: "10066", name: "Xã Tân Tiến", district_code: "277" },
  { code: "10069", name: "Xã Nam Phương Tiến", district_code: "277" },
  { code: "10072", name: "Xã Hợp Đồng", district_code: "277" },
  { code: "10075", name: "Xã Hoàng Văn Thụ", district_code: "277" },
  { code: "10078", name: "Xã Hoàng Diệu", district_code: "277" },
  { code: "10081", name: "Xã Hữu Văn", district_code: "277" },
  { code: "10084", name: "Xã Quảng Bị", district_code: "277" },
  { code: "10087", name: "Xã Mỹ Lương", district_code: "277" },
  { code: "10090", name: "Xã Thượng Vực", district_code: "277" },
  { code: "10096", name: "Xã Hồng Phú", district_code: "277" },
  { code: "10099", name: "Xã Trần Phú", district_code: "277" },
  { code: "10102", name: "Xã Văn Võ", district_code: "277" },
  { code: "10105", name: "Xã Đồng Lạc", district_code: "277" },
  { code: "10108", name: "Xã Hòa Phú", district_code: "277" },
  { code: "10114", name: "Thị trấn Kim Bài", district_code: "278" },
  { code: "10120", name: "Xã Cự Khê", district_code: "278" },
  { code: "10126", name: "Xã Bích Hòa", district_code: "278" },
  { code: "10129", name: "Xã Mỹ Hưng", district_code: "278" },
  { code: "10132", name: "Xã Cao Viên", district_code: "278" },
  { code: "10135", name: "Xã Bình Minh", district_code: "278" },
  { code: "10138", name: "Xã Tam Hưng", district_code: "278" },
  { code: "10141", name: "Xã Thanh Cao", district_code: "278" },
  { code: "10144", name: "Xã Thanh Thùy", district_code: "278" },
  { code: "10147", name: "Xã Thanh Mai", district_code: "278" },
  { code: "10150", name: "Xã Thanh Văn", district_code: "278" },
  { code: "10153", name: "Xã Đỗ Động", district_code: "278" },
  { code: "10156", name: "Xã Kim An", district_code: "278" },
  { code: "10159", name: "Xã Kim Thư", district_code: "278" },
  { code: "10162", name: "Xã Phương Trung", district_code: "278" },
  { code: "10165", name: "Xã Tân Ước", district_code: "278" },
  { code: "10168", name: "Xã Dân Hòa", district_code: "278" },
  { code: "10171", name: "Xã Liên Châu", district_code: "278" },
  { code: "10174", name: "Xã Cao Xuân Dương", district_code: "278" },
  { code: "10180", name: "Xã Hồng Dương", district_code: "278" },
  { code: "10183", name: "Thị trấn Thường Tín", district_code: "279" },
  { code: "10186", name: "Xã Ninh Sở", district_code: "279" },
  { code: "10189", name: "Xã Nhị Khê", district_code: "279" },
  { code: "10192", name: "Xã Duyên Thái", district_code: "279" },
  { code: "10195", name: "Xã Khánh Hà", district_code: "279" },
  { code: "10198", name: "Xã Hòa Bình", district_code: "279" },
  { code: "10201", name: "Xã Văn Bình", district_code: "279" },
  { code: "10204", name: "Xã Hiền Giang", district_code: "279" },
  { code: "10207", name: "Xã Hồng Vân", district_code: "279" },
  { code: "10210", name: "Xã Vân Tảo", district_code: "279" },
  { code: "10213", name: "Xã Liên Phương", district_code: "279" },
  { code: "10216", name: "Xã Văn Phú", district_code: "279" },
  { code: "10219", name: "Xã Tự Nhiên", district_code: "279" },
  { code: "10222", name: "Xã Tiền Phong", district_code: "279" },
  { code: "10225", name: "Xã Hà Hồi", district_code: "279" },
  { code: "10231", name: "Xã Nguyễn Trãi", district_code: "279" },
  { code: "10234", name: "Xã Quất Động", district_code: "279" },
  { code: "10237", name: "Xã Chương Dương", district_code: "279" },
  { code: "10240", name: "Xã Tân Minh", district_code: "279" },
  { code: "10243", name: "Xã Lê Lợi", district_code: "279" },
  { code: "10246", name: "Xã Thắng Lợi", district_code: "279" },
  { code: "10249", name: "Xã Dũng Tiến", district_code: "279" },
  { code: "10255", name: "Xã Nghiêm Xuyên", district_code: "279" },
  { code: "10258", name: "Xã Tô Hiệu", district_code: "279" },
  { code: "10261", name: "Xã Văn Tự", district_code: "279" },
  { code: "10264", name: "Xã Vạn Nhất", district_code: "279" },
  { code: "10267", name: "Xã Minh Cường", district_code: "279" },
  { code: "10270", name: "Thị trấn Phú Minh", district_code: "280" },
  { code: "10273", name: "Thị trấn Phú Xuyên", district_code: "280" },
  { code: "10276", name: "Xã Hồng Minh", district_code: "280" },
  { code: "10279", name: "Xã Phượng Dực", district_code: "280" },
  { code: "10282", name: "Xã Nam Tiến", district_code: "280" },
  { code: "10291", name: "Xã Văn Hoàng", district_code: "280" },
  { code: "10294", name: "Xã Phú Túc", district_code: "280" },
  { code: "10300", name: "Xã Hồng Thái", district_code: "280" },
  { code: "10303", name: "Xã Hoàng Long", district_code: "280" },
  { code: "10312", name: "Xã Nam Phong", district_code: "280" },
  { code: "10315", name: "Xã Tân Dân", district_code: "280" },
  { code: "10318", name: "Xã Quang Hà", district_code: "280" },
  { code: "10321", name: "Xã Chuyên Mỹ", district_code: "280" },
  { code: "10324", name: "Xã Khai Thái", district_code: "280" },
  { code: "10327", name: "Xã Phúc Tiến", district_code: "280" },
  { code: "10330", name: "Xã Vân Từ", district_code: "280" },
  { code: "10333", name: "Xã Tri Thủy", district_code: "280" },
  { code: "10336", name: "Xã Đại Xuyên", district_code: "280" },
  { code: "10339", name: "Xã Phú Yên", district_code: "280" },
  { code: "10342", name: "Xã Bạch Hạ", district_code: "280" },
  { code: "10345", name: "Xã Quang Lãng", district_code: "280" },
  { code: "10348", name: "Xã Châu Can", district_code: "280" },
  { code: "10351", name: "Xã Minh Tân", district_code: "280" },
  { code: "10354", name: "Thị trấn Vân Đình", district_code: "281" },
  { code: "10363", name: "Xã Hoa Viên", district_code: "281" },
  { code: "10366", name: "Xã Quảng Phú Cầu", district_code: "281" },
  { code: "10369", name: "Xã Trường Thịnh", district_code: "281" },
  { code: "10375", name: "Xã Liên Bạt", district_code: "281" },
  { code: "10378", name: "Xã Cao Sơn Tiến", district_code: "281" },
  { code: "10384", name: "Xã Phương Tú", district_code: "281" },
  { code: "10387", name: "Xã Trung Tú", district_code: "281" },
  { code: "10390", name: "Xã Đồng Tân", district_code: "281" },
  { code: "10393", name: "Xã Tảo Dương Văn", district_code: "281" },
  { code: "10396", name: "Xã Thái Hòa", district_code: "281" },
  { code: "10399", name: "Xã Minh Đức", district_code: "281" },
  { code: "10402", name: "Xã Trầm Lộng", district_code: "281" },
  { code: "10411", name: "Xã Kim Đường", district_code: "281" },
  { code: "10417", name: "Xã Hòa Phú", district_code: "281" },
  { code: "10423", name: "Xã Đại Hùng", district_code: "281" },
  { code: "10426", name: "Xã Đông Lỗ", district_code: "281" },
  { code: "10429", name: "Xã Phù Lưu", district_code: "281" },
  { code: "10432", name: "Xã Đại Cường", district_code: "281" },
  { code: "10435", name: "Xã Bình Lưu Quang", district_code: "281" },
  { code: "10441", name: "Thị trấn Đại Nghĩa", district_code: "282" },
  { code: "10444", name: "Xã Đồng Tâm", district_code: "282" },
  { code: "10447", name: "Xã Thượng Lâm", district_code: "282" },
  { code: "10450", name: "Xã Tuy Lai", district_code: "282" },
  { code: "10453", name: "Xã Phúc Lâm", district_code: "282" },
  { code: "10459", name: "Xã Mỹ Xuyên", district_code: "282" },
  { code: "10462", name: "Xã An Mỹ", district_code: "282" },
  { code: "10465", name: "Xã Hồng Sơn", district_code: "282" },
  { code: "10468", name: "Xã Lê Thanh", district_code: "282" },
  { code: "10471", name: "Xã Xuy Xá", district_code: "282" },
  { code: "10474", name: "Xã Phùng Xá", district_code: "282" },
  { code: "10477", name: "Xã Phù Lưu Tế", district_code: "282" },
  { code: "10480", name: "Xã Đại Hưng", district_code: "282" },
  { code: "10483", name: "Xã Vạn Tín", district_code: "282" },
  { code: "10489", name: "Xã Hương Sơn", district_code: "282" },
  { code: "10492", name: "Xã Hùng Tiến", district_code: "282" },
  { code: "10495", name: "Xã An Tiến", district_code: "282" },
  { code: "10498", name: "Xã Hợp Tiến", district_code: "282" },
  { code: "10501", name: "Xã Hợp Thanh", district_code: "282" },
  { code: "10504", name: "Xã An Phú", district_code: "282" },
  { code: "688", name: "Phường Quang Trung", district_code: "24" },
  { code: "691", name: "Phường Trần Phú", district_code: "24" },
  { code: "692", name: "Phường Ngọc Hà", district_code: "24" },
  { code: "694", name: "Phường Nguyễn Trãi", district_code: "24" },
  { code: "697", name: "Phường Minh Khai", district_code: "24" },
  { code: "700", name: "Xã Ngọc Đường", district_code: "24" },
  { code: "946", name: "Xã Phương Độ", district_code: "24" },
  { code: "949", name: "Xã Phương Thiện", district_code: "24" },
  { code: "712", name: "Thị trấn Phó Bảng", district_code: "26" },
  { code: "715", name: "Xã Lũng Cú", district_code: "26" },
  { code: "718", name: "Xã Má Lé", district_code: "26" },
  { code: "721", name: "Thị trấn Đồng Văn", district_code: "26" },
  { code: "724", name: "Xã Lũng Táo", district_code: "26" },
  { code: "727", name: "Xã Phố Là", district_code: "26" },
  { code: "730", name: "Xã Thài Phìn Tủng", district_code: "26" },
  { code: "733", name: "Xã Sủng Là", district_code: "26" },
  { code: "736", name: "Xã Xà Phìn", district_code: "26" },
  { code: "739", name: "Xã Tả Phìn", district_code: "26" },
  { code: "742", name: "Xã Tả Lủng", district_code: "26" },
  { code: "745", name: "Xã Phố Cáo", district_code: "26" },
  { code: "748", name: "Xã Sính Lủng", district_code: "26" },
  { code: "751", name: "Xã Sảng Tủng", district_code: "26" },
  { code: "754", name: "Xã Lũng Thầu", district_code: "26" },
  { code: "757", name: "Xã Hố Quáng Phìn", district_code: "26" },
  { code: "760", name: "Xã Vần Chải", district_code: "26" },
  { code: "763", name: "Xã Lũng Phìn", district_code: "26" },
  { code: "766", name: "Xã Sủng Trái", district_code: "26" },
  { code: "769", name: "Thị trấn Mèo Vạc", district_code: "27" },
  { code: "772", name: "Xã Thượng Phùng", district_code: "27" },
  { code: "775", name: "Xã Pải Lủng", district_code: "27" },
  { code: "778", name: "Xã Xín Cái", district_code: "27" },
  { code: "781", name: "Xã Pả Vi", district_code: "27" },
  { code: "784", name: "Xã Giàng Chu Phìn", district_code: "27" },
  { code: "787", name: "Xã Sủng Trà", district_code: "27" },
  { code: "790", name: "Xã Sủng Máng", district_code: "27" },
  { code: "793", name: "Xã Sơn Vĩ", district_code: "27" },
  { code: "796", name: "Xã Tả Lủng", district_code: "27" },
  { code: "799", name: "Xã Cán Chu Phìn", district_code: "27" },
  { code: "802", name: "Xã Lũng Pù", district_code: "27" },
  { code: "805", name: "Xã Lũng Chinh", district_code: "27" },
  { code: "808", name: "Xã Tát Ngà", district_code: "27" },
  { code: "811", name: "Xã Nậm Ban", district_code: "27" },
  { code: "814", name: "Xã Khâu Vai", district_code: "27" },
  { code: "815", name: "Xã Niêm Tòng", district_code: "27" },
  { code: "817", name: "Xã Niêm Sơn", district_code: "27" },
  { code: "820", name: "Thị trấn Yên Minh", district_code: "28" },
  { code: "823", name: "Xã Thắng Mố", district_code: "28" },
  { code: "826", name: "Xã Phú Lũng", district_code: "28" },
  { code: "829", name: "Xã Sủng Tráng", district_code: "28" },
  { code: "832", name: "Xã Bạch Đích", district_code: "28" },
  { code: "835", name: "Xã Na Khê", district_code: "28" },
  { code: "838", name: "Xã Sủng Thài", district_code: "28" },
  { code: "841", name: "Xã Hữu Vinh", district_code: "28" },
  { code: "844", name: "Xã Lao Và Chải", district_code: "28" },
  { code: "847", name: "Xã Mậu Duệ", district_code: "28" },
  { code: "850", name: "Xã Đông Minh", district_code: "28" },
  { code: "853", name: "Xã Mậu Long", district_code: "28" },
  { code: "856", name: "Xã Ngam La", district_code: "28" },
  { code: "859", name: "Xã Ngọc Long", district_code: "28" },
  { code: "862", name: "Xã Đường Thượng", district_code: "28" },
  { code: "865", name: "Xã Lũng Hồ", district_code: "28" },
  { code: "868", name: "Xã Du Tiến", district_code: "28" },
  { code: "871", name: "Xã Du Già", district_code: "28" },
  { code: "874", name: "Thị trấn Tam Sơn", district_code: "29" },
  { code: "877", name: "Xã Bát Đại Sơn", district_code: "29" },
  { code: "880", name: "Xã Nghĩa Thuận", district_code: "29" },
  { code: "883", name: "Xã Cán Tỷ", district_code: "29" },
  { code: "886", name: "Xã Cao Mã Pờ", district_code: "29" },
  { code: "889", name: "Xã Thanh Vân", district_code: "29" },
  { code: "892", name: "Xã Tùng Vài", district_code: "29" },
  { code: "895", name: "Xã Đông Hà", district_code: "29" },
  { code: "898", name: "Xã Quản Bạ", district_code: "29" },
  { code: "901", name: "Xã Lùng Tám", district_code: "29" },
  { code: "904", name: "Xã Quyết Tiến", district_code: "29" },
  { code: "907", name: "Xã Tả Ván", district_code: "29" },
  { code: "910", name: "Xã Thái An", district_code: "29" },
  { code: "703", name: "Xã Kim Thạch", district_code: "30" },
  { code: "706", name: "Xã Phú Linh", district_code: "30" },
  { code: "709", name: "Xã Kim Linh", district_code: "30" },
  { code: "913", name: "Thị trấn Vị Xuyên", district_code: "30" },
  { code: "916", name: "Thị trấn Nông Trường Việt Lâm", district_code: "30" },
  { code: "919", name: "Xã Minh Tân", district_code: "30" },
  { code: "922", name: "Xã Thuận Hoà", district_code: "30" },
  { code: "925", name: "Xã Tùng Bá", district_code: "30" },
  { code: "928", name: "Xã Thanh Thủy", district_code: "30" },
  { code: "931", name: "Xã Thanh Đức", district_code: "30" },
  { code: "934", name: "Xã Phong Quang", district_code: "30" },
  { code: "937", name: "Xã Xín Chải", district_code: "30" },
  { code: "940", name: "Xã Phương Tiến", district_code: "30" },
  { code: "943", name: "Xã Lao Chải", district_code: "30" },
  { code: "952", name: "Xã Cao Bồ", district_code: "30" },
  { code: "955", name: "Xã Đạo Đức", district_code: "30" },
  { code: "958", name: "Xã Thượng Sơn", district_code: "30" },
  { code: "961", name: "Xã Linh Hồ", district_code: "30" },
  { code: "964", name: "Xã Quảng Ngần", district_code: "30" },
  { code: "967", name: "Xã Việt Lâm", district_code: "30" },
  { code: "970", name: "Xã Ngọc Linh", district_code: "30" },
  { code: "973", name: "Xã Ngọc Minh", district_code: "30" },
  { code: "976", name: "Xã Bạch Ngọc", district_code: "30" },
  { code: "979", name: "Xã Trung Thành", district_code: "30" },
  { code: "982", name: "Xã Minh Sơn", district_code: "31" },
  { code: "985", name: "Xã Giáp Trung", district_code: "31" },
  { code: "988", name: "Xã Yên Định", district_code: "31" },
  { code: "991", name: "Thị trấn Yên Phú", district_code: "31" },
  { code: "994", name: "Xã Minh Ngọc", district_code: "31" },
  { code: "997", name: "Xã Yên Phong", district_code: "31" },
  { code: "1000", name: "Xã Lạc Nông", district_code: "31" },
  { code: "1003", name: "Xã Phú Nam", district_code: "31" },
  { code: "1006", name: "Xã Yên Cường", district_code: "31" },
  { code: "1009", name: "Xã Thượng Tân", district_code: "31" },
  { code: "1012", name: "Xã Đường Âm", district_code: "31" },
  { code: "1015", name: "Xã Đường Hồng", district_code: "31" },
  { code: "1018", name: "Xã Phiêng Luông", district_code: "31" },
  { code: "1021", name: "Thị trấn Vinh Quang", district_code: "32" },
  { code: "1024", name: "Xã Bản Máy", district_code: "32" },
  { code: "1027", name: "Xã Thàng Tín", district_code: "32" },
  { code: "1030", name: "Xã Thèn Chu Phìn", district_code: "32" },
  { code: "1033", name: "Xã Pố Lồ", district_code: "32" },
  { code: "1036", name: "Xã Bản Phùng", district_code: "32" },
  { code: "1039", name: "Xã Túng Sán", district_code: "32" },
  { code: "1042", name: "Xã Chiến Phố", district_code: "32" },
  { code: "1045", name: "Xã Đản Ván", district_code: "32" },
  { code: "1048", name: "Xã Tụ Nhân", district_code: "32" },
  { code: "1051", name: "Xã Tân Tiến", district_code: "32" },
  { code: "1054", name: "Xã Nàng Đôn", district_code: "32" },
  { code: "1057", name: "Xã Pờ Ly Ngài", district_code: "32" },
  { code: "1060", name: "Xã Sán Xả Hồ", district_code: "32" },
  { code: "1063", name: "Xã Bản Luốc", district_code: "32" },
  { code: "1066", name: "Xã Ngàm Đăng Vài", district_code: "32" },
  { code: "1069", name: "Xã Bản Nhùng", district_code: "32" },
  { code: "1072", name: "Xã Tả Sử Choóng", district_code: "32" },
  { code: "1075", name: "Xã Nậm Dịch", district_code: "32" },
  { code: "1081", name: "Xã Hồ Thầu", district_code: "32" },
  { code: "1084", name: "Xã Nam Sơn", district_code: "32" },
  { code: "1087", name: "Xã Nậm Tỵ", district_code: "32" },
  { code: "1090", name: "Xã Thông Nguyên", district_code: "32" },
  { code: "1093", name: "Xã Nậm Khòa", district_code: "32" },
  { code: "1096", name: "Thị trấn Cốc Pài", district_code: "33" },
  { code: "1099", name: "Xã Nàn Xỉn", district_code: "33" },
  { code: "1102", name: "Xã Bản Díu", district_code: "33" },
  { code: "1105", name: "Xã Chí Cà", district_code: "33" },
  { code: "1108", name: "Xã Xín Mần", district_code: "33" },
  { code: "1114", name: "Xã Thèn Phàng", district_code: "33" },
  { code: "1117", name: "Xã Trung Thịnh", district_code: "33" },
  { code: "1120", name: "Xã Pà Vầy Sủ", district_code: "33" },
  { code: "1123", name: "Xã Cốc Rế", district_code: "33" },
  { code: "1126", name: "Xã Thu Tà", district_code: "33" },
  { code: "1129", name: "Xã Nàn Ma", district_code: "33" },
  { code: "1132", name: "Xã Tả Nhìu", district_code: "33" },
  { code: "1135", name: "Xã Bản Ngò", district_code: "33" },
  { code: "1138", name: "Xã Chế Là", district_code: "33" },
  { code: "1141", name: "Xã Nấm Dẩn", district_code: "33" },
  { code: "1144", name: "Xã Quảng Nguyên", district_code: "33" },
  { code: "1147", name: "Xã Nà Chì", district_code: "33" },
  { code: "1150", name: "Xã Khuôn Lùng", district_code: "33" },
  { code: "1153", name: "Thị trấn Việt Quang", district_code: "34" },
  { code: "1156", name: "Thị trấn Vĩnh Tuy", district_code: "34" },
  { code: "1159", name: "Xã Tân Lập", district_code: "34" },
  { code: "1162", name: "Xã Tân Thành", district_code: "34" },
  { code: "1165", name: "Xã Đồng Tiến", district_code: "34" },
  { code: "1168", name: "Xã Đồng Tâm", district_code: "34" },
  { code: "1171", name: "Xã Tân Quang", district_code: "34" },
  { code: "1174", name: "Xã Thượng Bình", district_code: "34" },
  { code: "1177", name: "Xã Hữu Sản", district_code: "34" },
  { code: "1180", name: "Xã Kim Ngọc", district_code: "34" },
  { code: "1183", name: "Xã Việt Vinh", district_code: "34" },
  { code: "1186", name: "Xã Bằng Hành", district_code: "34" },
  { code: "1189", name: "Xã Quang Minh", district_code: "34" },
  { code: "1192", name: "Xã Liên Hiệp", district_code: "34" },
  { code: "1195", name: "Xã Vô Điếm", district_code: "34" },
  { code: "1198", name: "Xã Việt Hồng", district_code: "34" },
  { code: "1201", name: "Xã Hùng An", district_code: "34" },
  { code: "1204", name: "Xã Đức Xuân", district_code: "34" },
  { code: "1207", name: "Xã Tiên Kiều", district_code: "34" },
  { code: "1210", name: "Xã Vĩnh Hảo", district_code: "34" },
  { code: "1213", name: "Xã Vĩnh Phúc", district_code: "34" },
  { code: "1216", name: "Xã Đồng Yên", district_code: "34" },
  { code: "1219", name: "Xã Đông Thành", district_code: "34" },
  { code: "1222", name: "Xã Xuân Minh", district_code: "35" },
  { code: "1225", name: "Xã Tiên Nguyên", district_code: "35" },
  { code: "1228", name: "Xã Tân Nam", district_code: "35" },
  { code: "1231", name: "Xã Bản Rịa", district_code: "35" },
  { code: "1234", name: "Xã Yên Thành", district_code: "35" },
  { code: "1237", name: "Thị trấn Yên Bình", district_code: "35" },
  { code: "1240", name: "Xã Tân Trịnh", district_code: "35" },
  { code: "1243", name: "Xã Tân Bắc", district_code: "35" },
  { code: "1246", name: "Xã Bằng Lang", district_code: "35" },
  { code: "1249", name: "Xã Yên Hà", district_code: "35" },
  { code: "1252", name: "Xã Hương Sơn", district_code: "35" },
  { code: "1255", name: "Xã Xuân Giang", district_code: "35" },
  { code: "1258", name: "Xã Nà Khương", district_code: "35" },
  { code: "1261", name: "Xã Tiên Yên", district_code: "35" },
  { code: "1264", name: "Xã Vĩ Thượng", district_code: "35" },
  { code: "1267", name: "Phường Sông Hiến", district_code: "40" },
  { code: "1270", name: "Phường Sông Bằng", district_code: "40" },
  { code: "1273", name: "Phường Hợp Giang", district_code: "40" },
  { code: "1276", name: "Phường Tân Giang", district_code: "40" },
  { code: "1279", name: "Phường Ngọc Xuân", district_code: "40" },
  { code: "1282", name: "Phường Đề Thám", district_code: "40" },
  { code: "1285", name: "Phường Hoà Chung", district_code: "40" },
  { code: "1288", name: "Phường Duyệt Trung", district_code: "40" },
  { code: "1693", name: "Xã Vĩnh Quang", district_code: "40" },
  { code: "1705", name: "Xã Hưng Đạo", district_code: "40" },
  { code: "1720", name: "Xã Chu Trinh", district_code: "40" },
  { code: "1290", name: "Thị trấn Pác Miầu", district_code: "42" },
  { code: "1291", name: "Xã Đức Hạnh", district_code: "42" },
  { code: "1294", name: "Xã Lý Bôn", district_code: "42" },
  { code: "1296", name: "Xã Nam Cao", district_code: "42" },
  { code: "1297", name: "Xã Nam Quang", district_code: "42" },
  { code: "1300", name: "Xã Vĩnh Quang", district_code: "42" },
  { code: "1303", name: "Xã Quảng Lâm", district_code: "42" },
  { code: "1304", name: "Xã Thạch Lâm", district_code: "42" },
  { code: "1309", name: "Xã Vĩnh Phong", district_code: "42" },
  { code: "1312", name: "Xã Mông Ân", district_code: "42" },
  { code: "1315", name: "Xã Thái Học", district_code: "42" },
  { code: "1316", name: "Xã Thái Sơn", district_code: "42" },
  { code: "1318", name: "Xã Yên Thổ", district_code: "42" },
  { code: "1321", name: "Thị trấn Bảo Lạc", district_code: "43" },
  { code: "1324", name: "Xã Cốc Pàng", district_code: "43" },
  { code: "1327", name: "Xã Thượng Hà", district_code: "43" },
  { code: "1330", name: "Xã Cô Ba", district_code: "43" },
  { code: "1333", name: "Xã Bảo Toàn", district_code: "43" },
  { code: "1336", name: "Xã Khánh Xuân", district_code: "43" },
  { code: "1339", name: "Xã Xuân Trường", district_code: "43" },
  { code: "1342", name: "Xã Hồng Trị", district_code: "43" },
  { code: "1343", name: "Xã Kim Cúc", district_code: "43" },
  { code: "1345", name: "Xã Phan Thanh", district_code: "43" },
  { code: "1348", name: "Xã Hồng An", district_code: "43" },
  { code: "1351", name: "Xã Hưng Đạo", district_code: "43" },
  { code: "1352", name: "Xã Hưng Thịnh", district_code: "43" },
  { code: "1354", name: "Xã Huy Giáp", district_code: "43" },
  { code: "1357", name: "Xã Đình Phùng", district_code: "43" },
  { code: "1359", name: "Xã Sơn Lập", district_code: "43" },
  { code: "1360", name: "Xã Sơn Lộ", district_code: "43" },
  { code: "1363", name: "Thị trấn Thông Nông", district_code: "45" },
  { code: "1366", name: "Xã Cần Yên", district_code: "45" },
  { code: "1367", name: "Xã Cần Nông", district_code: "45" },
  { code: "1372", name: "Xã Lương Thông", district_code: "45" },
  { code: "1375", name: "Xã Đa Thông", district_code: "45" },
  { code: "1378", name: "Xã Ngọc Động", district_code: "45" },
  { code: "1381", name: "Xã Yên Sơn", district_code: "45" },
  { code: "1384", name: "Xã Lương Can", district_code: "45" },
  { code: "1387", name: "Xã Thanh Long", district_code: "45" },
  { code: "1392", name: "Thị trấn Xuân Hòa", district_code: "45" },
  { code: "1393", name: "Xã Lũng Nặm", district_code: "45" },
  { code: "1399", name: "Xã Trường Hà", district_code: "45" },
  { code: "1402", name: "Xã Cải Viên", district_code: "45" },
  { code: "1411", name: "Xã Nội Thôn", district_code: "45" },
  { code: "1414", name: "Xã Tổng Cọt", district_code: "45" },
  { code: "1417", name: "Xã Sóc Hà", district_code: "45" },
  { code: "1420", name: "Xã Thượng Thôn", district_code: "45" },
  { code: "1429", name: "Xã Hồng Sỹ", district_code: "45" },
  { code: "1432", name: "Xã Quý Quân", district_code: "45" },
  { code: "1435", name: "Xã Mã Ba", district_code: "45" },
  { code: "1438", name: "Xã Ngọc Đào", district_code: "45" },
  { code: "1447", name: "Thị trấn Trà Lĩnh", district_code: "47" },
  { code: "1453", name: "Xã Tri Phương", district_code: "47" },
  { code: "1456", name: "Xã Quang Hán", district_code: "47" },
  { code: "1462", name: "Xã Xuân Nội", district_code: "47" },
  { code: "1465", name: "Xã Quang Trung", district_code: "47" },
  { code: "1468", name: "Xã Quang Vinh", district_code: "47" },
  { code: "1471", name: "Xã Cao Chương", district_code: "47" },
  { code: "1477", name: "Thị trấn Trùng Khánh", district_code: "47" },
  { code: "1480", name: "Xã Ngọc Khê", district_code: "47" },
  { code: "1481", name: "Xã Ngọc Côn", district_code: "47" },
  { code: "1483", name: "Xã Phong Nậm", district_code: "47" },
  { code: "1489", name: "Xã Đình Phong", district_code: "47" },
  { code: "1495", name: "Xã Đàm Thuỷ", district_code: "47" },
  { code: "1498", name: "Xã Khâm Thành", district_code: "47" },
  { code: "1501", name: "Xã Chí Viễn", district_code: "47" },
  { code: "1504", name: "Xã Lăng Hiếu", district_code: "47" },
  { code: "1507", name: "Xã Phong Châu", district_code: "47" },
  { code: "1516", name: "Xã Trung Phúc", district_code: "47" },
  { code: "1519", name: "Xã Cao Thăng", district_code: "47" },
  { code: "1522", name: "Xã Đức Hồng", district_code: "47" },
  { code: "1525", name: "Xã Đoài Dương", district_code: "47" },
  { code: "1534", name: "Xã Minh Long", district_code: "48" },
  { code: "1537", name: "Xã Lý Quốc", district_code: "48" },
  { code: "1540", name: "Xã Thắng Lợi", district_code: "48" },
  { code: "1543", name: "Xã Đồng Loan", district_code: "48" },
  { code: "1546", name: "Xã Đức Quang", district_code: "48" },
  { code: "1549", name: "Xã Kim Loan", district_code: "48" },
  { code: "1552", name: "Xã Quang Long", district_code: "48" },
  { code: "1555", name: "Xã An Lạc", district_code: "48" },
  { code: "1558", name: "Thị trấn Thanh Nhật", district_code: "48" },
  { code: "1561", name: "Xã Vinh Quý", district_code: "48" },
  { code: "1564", name: "Xã Thống Nhất", district_code: "48" },
  { code: "1567", name: "Xã Cô Ngân", district_code: "48" },
  { code: "1573", name: "Xã Thị Hoa", district_code: "48" },
  { code: "1474", name: "Xã Quốc Toản", district_code: "49" },
  { code: "1576", name: "Thị trấn Quảng Uyên", district_code: "49" },
  { code: "1579", name: "Xã Phi Hải", district_code: "49" },
  { code: "1582", name: "Xã Quảng Hưng", district_code: "49" },
  { code: "1594", name: "Xã Độc Lập", district_code: "49" },
  { code: "1597", name: "Xã Cai Bộ", district_code: "49" },
  { code: "1603", name: "Xã Phúc Sen", district_code: "49" },
  { code: "1606", name: "Xã Chí Thảo", district_code: "49" },
  { code: "1609", name: "Xã Tự Do", district_code: "49" },
  { code: "1615", name: "Xã Hồng Quang", district_code: "49" },
  { code: "1618", name: "Xã Ngọc Động", district_code: "49" },
  { code: "1624", name: "Xã Hạnh Phúc", district_code: "49" },
  { code: "1627", name: "Thị trấn Tà Lùng", district_code: "49" },
  { code: "1630", name: "Xã Bế Văn Đàn", district_code: "49" },
  { code: "1636", name: "Xã Cách Linh", district_code: "49" },
  { code: "1639", name: "Xã Đại Sơn", district_code: "49" },
  { code: "1645", name: "Xã Tiên Thành", district_code: "49" },
  { code: "1648", name: "Thị trấn Hoà Thuận", district_code: "49" },
  { code: "1651", name: "Xã Mỹ Hưng", district_code: "49" },
  { code: "1654", name: "Thị trấn Nước Hai", district_code: "51" },
  { code: "1657", name: "Xã Dân Chủ", district_code: "51" },
  { code: "1660", name: "Xã Nam Tuấn", district_code: "51" },
  { code: "1666", name: "Xã Đại Tiến", district_code: "51" },
  { code: "1669", name: "Xã Đức Long", district_code: "51" },
  { code: "1672", name: "Xã Ngũ Lão", district_code: "51" },
  { code: "1675", name: "Xã Trương Lương", district_code: "51" },
  { code: "1687", name: "Xã Hồng Việt", district_code: "51" },
  { code: "1696", name: "Xã Hoàng Tung", district_code: "51" },
  { code: "1699", name: "Xã Nguyễn Huệ", district_code: "51" },
  { code: "1702", name: "Xã Quang Trung", district_code: "51" },
  { code: "1708", name: "Xã Bạch Đằng", district_code: "51" },
  { code: "1711", name: "Xã Bình Dương", district_code: "51" },
  { code: "1714", name: "Xã Lê Chung", district_code: "51" },
  { code: "1723", name: "Xã Hồng Nam", district_code: "51" },
  { code: "1726", name: "Thị trấn Nguyên Bình", district_code: "52" },
  { code: "1729", name: "Thị trấn Tĩnh Túc", district_code: "52" },
  { code: "1732", name: "Xã Yên Lạc", district_code: "52" },
  { code: "1735", name: "Xã Triệu Nguyên", district_code: "52" },
  { code: "1738", name: "Xã Ca Thành", district_code: "52" },
  { code: "1744", name: "Xã Vũ Nông", district_code: "52" },
  { code: "1747", name: "Xã Minh Tâm", district_code: "52" },
  { code: "1750", name: "Xã Thể Dục", district_code: "52" },
  { code: "1756", name: "Xã Mai Long", district_code: "52" },
  { code: "1762", name: "Xã Vũ Minh", district_code: "52" },
  { code: "1765", name: "Xã Hoa Thám", district_code: "52" },
  { code: "1768", name: "Xã Phan Thanh", district_code: "52" },
  { code: "1771", name: "Xã Quang Thành", district_code: "52" },
  { code: "1774", name: "Xã Tam Kim", district_code: "52" },
  { code: "1777", name: "Xã Thành Công", district_code: "52" },
  { code: "1780", name: "Xã Thịnh Vượng", district_code: "52" },
  { code: "1783", name: "Xã Hưng Đạo", district_code: "52" },
  { code: "1786", name: "Thị trấn Đông Khê", district_code: "53" },
  { code: "1789", name: "Xã Canh Tân", district_code: "53" },
  { code: "1792", name: "Xã Kim Đồng", district_code: "53" },
  { code: "1795", name: "Xã Minh Khai", district_code: "53" },
  { code: "1801", name: "Xã Đức Thông", district_code: "53" },
  { code: "1804", name: "Xã Thái Cường", district_code: "53" },
  { code: "1807", name: "Xã Vân Trình", district_code: "53" },
  { code: "1810", name: "Xã Thụy Hùng", district_code: "53" },
  { code: "1813", name: "Xã Quang Trọng", district_code: "53" },
  { code: "1816", name: "Xã Trọng Con", district_code: "53" },
  { code: "1819", name: "Xã Lê Lai", district_code: "53" },
  { code: "1822", name: "Xã Đức Long", district_code: "53" },
  { code: "1828", name: "Xã Lê Lợi", district_code: "53" },
  { code: "1831", name: "Xã Đức Xuân", district_code: "53" },
  { code: "1834", name: "Phường Nguyễn Thị Minh Khai", district_code: "58" },
  { code: "1837", name: "Phường Sông Cầu", district_code: "58" },
  { code: "1840", name: "Phường Đức Xuân", district_code: "58" },
  { code: "1843", name: "Phường Phùng Chí Kiên", district_code: "58" },
  { code: "1846", name: "Phường Huyền Tụng", district_code: "58" },
  { code: "1849", name: "Xã Dương Quang", district_code: "58" },
  { code: "1852", name: "Xã Nông Thượng", district_code: "58" },
  { code: "1855", name: "Phường Xuất Hóa", district_code: "58" },
  { code: "1858", name: "Xã Bằng Thành", district_code: "60" },
  { code: "1861", name: "Xã Nhạn Môn", district_code: "60" },
  { code: "1864", name: "Xã Bộc Bố", district_code: "60" },
  { code: "1867", name: "Xã Công Bằng", district_code: "60" },
  { code: "1870", name: "Xã Giáo Hiệu", district_code: "60" },
  { code: "1873", name: "Xã Xuân La", district_code: "60" },
  { code: "1876", name: "Xã An Thắng", district_code: "60" },
  { code: "1879", name: "Xã Cổ Linh", district_code: "60" },
  { code: "1882", name: "Xã Nghiên Loan", district_code: "60" },
  { code: "1885", name: "Xã Cao Tân", district_code: "60" },
  { code: "1888", name: "Thị trấn Chợ Rã", district_code: "61" },
  { code: "1891", name: "Xã Bành Trạch", district_code: "61" },
  { code: "1894", name: "Xã Phúc Lộc", district_code: "61" },
  { code: "1897", name: "Xã Hà Hiệu", district_code: "61" },
  { code: "1900", name: "Xã Cao Thượng", district_code: "61" },
  { code: "1906", name: "Xã Khang Ninh", district_code: "61" },
  { code: "1909", name: "Xã Nam Mẫu", district_code: "61" },
  { code: "1912", name: "Xã Thượng Giáo", district_code: "61" },
  { code: "1915", name: "Xã Địa Linh", district_code: "61" },
  { code: "1918", name: "Xã Yến Dương", district_code: "61" },
  { code: "1921", name: "Xã Chu Hương", district_code: "61" },
  { code: "1924", name: "Xã Quảng Khê", district_code: "61" },
  { code: "1927", name: "Xã Mỹ Phương", district_code: "61" },
  { code: "1930", name: "Xã Hoàng Trĩ", district_code: "61" },
  { code: "1933", name: "Xã Đồng Phúc", district_code: "61" },
  { code: "1936", name: "Thị trấn Nà Phặc", district_code: "62" },
  { code: "1939", name: "Xã Thượng Ân", district_code: "62" },
  { code: "1942", name: "Xã Bằng Vân", district_code: "62" },
  { code: "1945", name: "Xã Cốc Đán", district_code: "62" },
  { code: "1948", name: "Xã Trung Hoà", district_code: "62" },
  { code: "1951", name: "Xã Đức Vân", district_code: "62" },
  { code: "1954", name: "Thị trấn Vân Tùng", district_code: "62" },
  { code: "1957", name: "Xã Thượng Quan", district_code: "62" },
  { code: "1960", name: "Xã Hiệp Lực", district_code: "62" },
  { code: "1963", name: "Xã Thuần Mang", district_code: "62" },
  { code: "1969", name: "Thị trấn Phủ Thông", district_code: "63" },
  { code: "1975", name: "Xã Vi Hương", district_code: "63" },
  { code: "1978", name: "Xã Sĩ Bình", district_code: "63" },
  { code: "1981", name: "Xã Vũ Muộn", district_code: "63" },
  { code: "1984", name: "Xã Đôn Phong", district_code: "63" },
  { code: "1990", name: "Xã Lục Bình", district_code: "63" },
  { code: "1993", name: "Xã Tân Tú", district_code: "63" },
  { code: "1999", name: "Xã Nguyên Phúc", district_code: "63" },
  { code: "2002", name: "Xã Cao Sơn", district_code: "63" },
  { code: "2005", name: "Xã Quân Hà", district_code: "63" },
  { code: "2008", name: "Xã Cẩm Giàng", district_code: "63" },
  { code: "2011", name: "Xã Mỹ Thanh", district_code: "63" },
  { code: "2014", name: "Xã Dương Phong", district_code: "63" },
  { code: "2017", name: "Xã Quang Thuận", district_code: "63" },
  { code: "2020", name: "Thị trấn Bằng Lũng", district_code: "64" },
  { code: "2023", name: "Xã Xuân Lạc", district_code: "64" },
  { code: "2026", name: "Xã Nam Cường", district_code: "64" },
  { code: "2029", name: "Xã Đồng Lạc", district_code: "64" },
  { code: "2032", name: "Xã Tân Lập", district_code: "64" },
  { code: "2035", name: "Xã Bản Thi", district_code: "64" },
  { code: "2038", name: "Xã Quảng Bạch", district_code: "64" },
  { code: "2041", name: "Xã Bằng Phúc", district_code: "64" },
  { code: "2044", name: "Xã Yên Thịnh", district_code: "64" },
  { code: "2047", name: "Xã Yên Thượng", district_code: "64" },
  { code: "2050", name: "Xã Phương Viên", district_code: "64" },
  { code: "2053", name: "Xã Ngọc Phái", district_code: "64" },
  { code: "2059", name: "Xã Đồng Thắng", district_code: "64" },
  { code: "2062", name: "Xã Lương Bằng", district_code: "64" },
  { code: "2065", name: "Xã Bằng Lãng", district_code: "64" },
  { code: "2068", name: "Xã Đại Sảo", district_code: "64" },
  { code: "2071", name: "Xã Nghĩa Tá", district_code: "64" },
  { code: "2077", name: "Xã Yên Mỹ", district_code: "64" },
  { code: "2080", name: "Xã Bình Trung", district_code: "64" },
  { code: "2083", name: "Xã Yên Phong", district_code: "64" },
  { code: "2086", name: "Thị trấn Đồng Tâm", district_code: "65" },
  { code: "2089", name: "Xã Tân Sơn", district_code: "65" },
  { code: "2092", name: "Xã Thanh Vận", district_code: "65" },
  { code: "2095", name: "Xã Mai Lạp", district_code: "65" },
  { code: "2098", name: "Xã Hoà Mục", district_code: "65" },
  { code: "2101", name: "Xã Thanh Mai", district_code: "65" },
  { code: "2104", name: "Xã Cao Kỳ", district_code: "65" },
  { code: "2107", name: "Xã Nông Hạ", district_code: "65" },
  { code: "2110", name: "Xã Yên Cư", district_code: "65" },
  { code: "2113", name: "Xã Thanh Thịnh", district_code: "65" },
  { code: "2116", name: "Xã Yên Hân", district_code: "65" },
  { code: "2122", name: "Xã Như Cố", district_code: "65" },
  { code: "2125", name: "Xã Bình Văn", district_code: "65" },
  { code: "2131", name: "Xã Quảng Chu", district_code: "65" },
  { code: "2137", name: "Xã Văn Vũ", district_code: "66" },
  { code: "2140", name: "Xã Văn Lang", district_code: "66" },
  { code: "2143", name: "Xã Lương Thượng", district_code: "66" },
  { code: "2146", name: "Xã Kim Hỷ", district_code: "66" },
  { code: "2152", name: "Xã Cường Lợi", district_code: "66" },
  { code: "2155", name: "Thị trấn Yến Lạc", district_code: "66" },
  { code: "2158", name: "Xã Kim Lư", district_code: "66" },
  { code: "2161", name: "Xã Sơn Thành", district_code: "66" },
  { code: "2170", name: "Xã Văn Minh", district_code: "66" },
  { code: "2173", name: "Xã Côn Minh", district_code: "66" },
  { code: "2176", name: "Xã Cư Lễ", district_code: "66" },
  { code: "2179", name: "Xã Trần Phú", district_code: "66" },
  { code: "2185", name: "Xã Quang Phong", district_code: "66" },
  { code: "2188", name: "Xã Dương Sơn", district_code: "66" },
  { code: "2191", name: "Xã Xuân Dương", district_code: "66" },
  { code: "2194", name: "Xã Đổng Xá", district_code: "66" },
  { code: "2197", name: "Xã Liêm Thuỷ", district_code: "66" },
  { code: "2200", name: "Phường Phan Thiết", district_code: "70" },
  { code: "2203", name: "Phường Minh Xuân", district_code: "70" },
  { code: "2206", name: "Phường Tân Quang", district_code: "70" },
  { code: "2209", name: "Xã Tràng Đà", district_code: "70" },
  { code: "2212", name: "Phường Nông Tiến", district_code: "70" },
  { code: "2215", name: "Phường Ỷ La", district_code: "70" },
  { code: "2216", name: "Phường Tân Hà", district_code: "70" },
  { code: "2218", name: "Phường Hưng Thành", district_code: "70" },
  { code: "2497", name: "Xã Kim Phú", district_code: "70" },
  { code: "2503", name: "Xã An Khang", district_code: "70" },
  { code: "2509", name: "Phường Mỹ Lâm", district_code: "70" },
  { code: "2512", name: "Phường An Tường", district_code: "70" },
  { code: "2515", name: "Xã Lưỡng Vượng", district_code: "70" },
  { code: "2521", name: "Xã Thái Long", district_code: "70" },
  { code: "2524", name: "Phường Đội Cấn", district_code: "70" },
  { code: "2233", name: "Xã Phúc Yên", district_code: "71" },
  { code: "2242", name: "Xã Xuân Lập", district_code: "71" },
  { code: "2251", name: "Xã Khuôn Hà", district_code: "71" },
  { code: "2266", name: "Thị trấn Lăng Can", district_code: "71" },
  { code: "2269", name: "Xã Thượng Lâm", district_code: "71" },
  { code: "2290", name: "Xã Bình An", district_code: "71" },
  { code: "2293", name: "Xã Hồng Quang", district_code: "71" },
  { code: "2296", name: "Xã Thổ Bình", district_code: "71" },
  { code: "2299", name: "Xã Phúc Sơn", district_code: "71" },
  { code: "2302", name: "Xã Minh Quang", district_code: "71" },
  { code: "2221", name: "Thị trấn Na Hang", district_code: "72" },
  { code: "2227", name: "Xã Sinh Long", district_code: "72" },
  { code: "2230", name: "Xã Thượng Giáp", district_code: "72" },
  { code: "2239", name: "Xã Thượng Nông", district_code: "72" },
  { code: "2245", name: "Xã Côn Lôn", district_code: "72" },
  { code: "2248", name: "Xã Yên Hoa", district_code: "72" },
  { code: "2254", name: "Xã Hồng Thái", district_code: "72" },
  { code: "2260", name: "Xã Đà Vị", district_code: "72" },
  { code: "2263", name: "Xã Khau Tinh", district_code: "72" },
  { code: "2275", name: "Xã Sơn Phú", district_code: "72" },
  { code: "2281", name: "Xã Năng Khả", district_code: "72" },
  { code: "2284", name: "Xã Thanh Tương", district_code: "72" },
  { code: "2287", name: "Thị trấn Vĩnh Lộc", district_code: "73" },
  { code: "2305", name: "Xã Trung Hà", district_code: "73" },
  { code: "2308", name: "Xã Tân Mỹ", district_code: "73" },
  { code: "2311", name: "Xã Hà Lang", district_code: "73" },
  { code: "2314", name: "Xã Hùng Mỹ", district_code: "73" },
  { code: "2317", name: "Xã Yên Lập", district_code: "73" },
  { code: "2320", name: "Xã Tân An", district_code: "73" },
  { code: "2323", name: "Xã Bình Phú", district_code: "73" },
  { code: "2326", name: "Xã Xuân Quang", district_code: "73" },
  { code: "2329", name: "Xã Ngọc Hội", district_code: "73" },
  { code: "2332", name: "Xã Phú Bình", district_code: "73" },
  { code: "2335", name: "Xã Hòa Phú", district_code: "73" },
  { code: "2338", name: "Xã Phúc Thịnh", district_code: "73" },
  { code: "2341", name: "Xã Kiên Đài", district_code: "73" },
  { code: "2344", name: "Xã Tân Thịnh", district_code: "73" },
  { code: "2347", name: "Xã Trung Hòa", district_code: "73" },
  { code: "2350", name: "Xã Kim Bình", district_code: "73" },
  { code: "2353", name: "Xã Hòa An", district_code: "73" },
  { code: "2356", name: "Xã Vinh Quang", district_code: "73" },
  { code: "2359", name: "Xã Tri Phú", district_code: "73" },
  { code: "2362", name: "Xã Nhân Lý", district_code: "73" },
  { code: "2365", name: "Xã Yên Nguyên", district_code: "73" },
  { code: "2368", name: "Xã Linh Phú", district_code: "73" },
  { code: "2371", name: "Xã Bình Nhân", district_code: "73" },
  { code: "2374", name: "Thị trấn Tân Yên", district_code: "74" },
  { code: "2377", name: "Xã Yên Thuận", district_code: "74" },
  { code: "2380", name: "Xã Bạch Xa", district_code: "74" },
  { code: "2383", name: "Xã Minh Khương", district_code: "74" },
  { code: "2386", name: "Xã Yên Lâm", district_code: "74" },
  { code: "2389", name: "Xã Minh Dân", district_code: "74" },
  { code: "2392", name: "Xã Phù Lưu", district_code: "74" },
  { code: "2395", name: "Xã Minh Hương", district_code: "74" },
  { code: "2398", name: "Xã Yên Phú", district_code: "74" },
  { code: "2401", name: "Xã Tân Thành", district_code: "74" },
  { code: "2404", name: "Xã Bình Xa", district_code: "74" },
  { code: "2407", name: "Xã Thái Sơn", district_code: "74" },
  { code: "2410", name: "Xã Nhân Mục", district_code: "74" },
  { code: "2413", name: "Xã Thành Long", district_code: "74" },
  { code: "2416", name: "Xã Bằng Cốc", district_code: "74" },
  { code: "2419", name: "Xã Thái Hòa", district_code: "74" },
  { code: "2422", name: "Xã Đức Ninh", district_code: "74" },
  { code: "2425", name: "Xã Hùng Đức", district_code: "74" },
  { code: "2431", name: "Xã Quí Quân", district_code: "75" },
  { code: "2434", name: "Xã Lực Hành", district_code: "75" },
  { code: "2437", name: "Xã Kiến Thiết", district_code: "75" },
  { code: "2440", name: "Xã Trung Minh", district_code: "75" },
  { code: "2443", name: "Xã Chiêu Yên", district_code: "75" },
  { code: "2446", name: "Xã Trung Trực", district_code: "75" },
  { code: "2449", name: "Xã Xuân Vân", district_code: "75" },
  { code: "2452", name: "Xã Phúc Ninh", district_code: "75" },
  { code: "2455", name: "Xã Hùng Lợi", district_code: "75" },
  { code: "2458", name: "Xã Trung Sơn", district_code: "75" },
  { code: "2461", name: "Xã Tân Tiến", district_code: "75" },
  { code: "2464", name: "Xã Tứ Quận", district_code: "75" },
  { code: "2467", name: "Xã Đạo Viện", district_code: "75" },
  { code: "2470", name: "Xã Tân Long", district_code: "75" },
  { code: "2473", name: "Thị trấn Yên Sơn", district_code: "75" },
  { code: "2476", name: "Xã Kim Quan", district_code: "75" },
  { code: "2479", name: "Xã Lang Quán", district_code: "75" },
  { code: "2482", name: "Xã Phú Thịnh", district_code: "75" },
  { code: "2485", name: "Xã Công Đa", district_code: "75" },
  { code: "2488", name: "Xã Trung Môn", district_code: "75" },
  { code: "2491", name: "Xã Chân Sơn", district_code: "75" },
  { code: "2494", name: "Xã Thái Bình", district_code: "75" },
  { code: "2500", name: "Xã Tiến Bộ", district_code: "75" },
  { code: "2506", name: "Xã Mỹ Bằng", district_code: "75" },
  { code: "2518", name: "Xã Hoàng Khai", district_code: "75" },
  { code: "2527", name: "Xã Nhữ Hán", district_code: "75" },
  { code: "2530", name: "Xã Nhữ Khê", district_code: "75" },
  { code: "2533", name: "Xã Đội Bình", district_code: "75" },
  { code: "2536", name: "Thị trấn Sơn Dương", district_code: "76" },
  { code: "2539", name: "Xã Trung Yên", district_code: "76" },
  { code: "2542", name: "Xã Minh Thanh", district_code: "76" },
  { code: "2545", name: "Xã Tân Trào", district_code: "76" },
  { code: "2548", name: "Xã Vĩnh Lợi", district_code: "76" },
  { code: "2551", name: "Xã Thượng Ấm", district_code: "76" },
  { code: "2554", name: "Xã Bình Yên", district_code: "76" },
  { code: "2557", name: "Xã Lương Thiện", district_code: "76" },
  { code: "2560", name: "Xã Tú Thịnh", district_code: "76" },
  { code: "2563", name: "Xã Cấp Tiến", district_code: "76" },
  { code: "2566", name: "Xã Hợp Thành", district_code: "76" },
  { code: "2569", name: "Xã Phúc Ứng", district_code: "76" },
  { code: "2572", name: "Xã Đông Thọ", district_code: "76" },
  { code: "2575", name: "Xã Kháng Nhật", district_code: "76" },
  { code: "2578", name: "Xã Hợp Hòa", district_code: "76" },
  { code: "2584", name: "Xã Quyết Thắng", district_code: "76" },
  { code: "2587", name: "Xã Đồng Quý", district_code: "76" },
  { code: "2590", name: "Xã Tân Thanh", district_code: "76" },
  { code: "2596", name: "Xã Văn Phú", district_code: "76" },
  { code: "2599", name: "Xã Chi Thiết", district_code: "76" },
  { code: "2602", name: "Xã Đông Lợi", district_code: "76" },
  { code: "2605", name: "Xã Thiện Kế", district_code: "76" },
  { code: "2608", name: "Xã Hồng Sơn", district_code: "76" },
  { code: "2611", name: "Xã Phú Lương", district_code: "76" },
  { code: "2614", name: "Xã Ninh Lai", district_code: "76" },
  { code: "2617", name: "Xã Đại Phú", district_code: "76" },
  { code: "2620", name: "Xã Sơn Nam", district_code: "76" },
  { code: "2623", name: "Xã Hào Phú", district_code: "76" },
  { code: "2626", name: "Xã Tam Đa", district_code: "76" },
  { code: "2632", name: "Xã Trường Sinh", district_code: "76" },
  { code: "2635", name: "Phường Duyên Hải", district_code: "80" },
  { code: "2641", name: "Phường Lào Cai", district_code: "80" },
  { code: "2644", name: "Phường Cốc Lếu", district_code: "80" },
  { code: "2647", name: "Phường Kim Tân", district_code: "80" },
  { code: "2650", name: "Phường Bắc Lệnh", district_code: "80" },
  { code: "2653", name: "Phường Pom Hán", district_code: "80" },
  { code: "2656", name: "Phường Xuân Tăng", district_code: "80" },
  { code: "2658", name: "Phường Bình Minh", district_code: "80" },
  { code: "2659", name: "Xã Thống Nhất", district_code: "80" },
  { code: "2662", name: "Xã Đồng Tuyển", district_code: "80" },
  { code: "2665", name: "Xã Vạn Hoà", district_code: "80" },
  { code: "2668", name: "Phường Bắc Cường", district_code: "80" },
  { code: "2671", name: "Phường Nam Cường", district_code: "80" },
  { code: "2674", name: "Xã Cam Đường", district_code: "80" },
  { code: "2677", name: "Xã Tả Phời", district_code: "80" },
  { code: "2680", name: "Xã Hợp Thành", district_code: "80" },
  { code: "2746", name: "Xã Cốc San", district_code: "80" },
  { code: "2683", name: "Thị trấn Bát Xát", district_code: "82" },
  { code: "2686", name: "Xã A Mú Sung", district_code: "82" },
  { code: "2689", name: "Xã Nậm Chạc", district_code: "82" },
  { code: "2692", name: "Xã A Lù", district_code: "82" },
  { code: "2695", name: "Xã Trịnh Tường", district_code: "82" },
  { code: "2701", name: "Xã Y Tý", district_code: "82" },
  { code: "2704", name: "Xã Cốc Mỳ", district_code: "82" },
  { code: "2707", name: "Xã Dền Sáng", district_code: "82" },
  { code: "2710", name: "Xã Bản Vược", district_code: "82" },
  { code: "2713", name: "Xã Sàng Ma Sáo", district_code: "82" },
  { code: "2716", name: "Xã Bản Qua", district_code: "82" },
  { code: "2719", name: "Xã Mường Vi", district_code: "82" },
  { code: "2722", name: "Xã Dền Thàng", district_code: "82" },
  { code: "2725", name: "Xã Bản Xèo", district_code: "82" },
  { code: "2728", name: "Xã Mường Hum", district_code: "82" },
  { code: "2731", name: "Xã Trung Lèng Hồ", district_code: "82" },
  { code: "2734", name: "Xã Quang Kim", district_code: "82" },
  { code: "2737", name: "Xã Pa Cheo", district_code: "82" },
  { code: "2740", name: "Xã Nậm Pung", district_code: "82" },
  { code: "2743", name: "Xã Phìn Ngan", district_code: "82" },
  { code: "2749", name: "Xã Tòng Sành", district_code: "82" },
  { code: "2752", name: "Xã Pha Long", district_code: "83" },
  { code: "2755", name: "Xã Tả Ngải Chồ", district_code: "83" },
  { code: "2758", name: "Xã Tung Chung Phố", district_code: "83" },
  { code: "2761", name: "Thị trấn Mường Khương", district_code: "83" },
  { code: "2764", name: "Xã Dìn Chin", district_code: "83" },
  { code: "2767", name: "Xã Tả Gia Khâu", district_code: "83" },
  { code: "2770", name: "Xã Nậm Chảy", district_code: "83" },
  { code: "2773", name: "Xã Nấm Lư", district_code: "83" },
  { code: "2776", name: "Xã Lùng Khấu Nhin", district_code: "83" },
  { code: "2779", name: "Xã Thanh Bình", district_code: "83" },
  { code: "2782", name: "Xã Cao Sơn", district_code: "83" },
  { code: "2785", name: "Xã Lùng Vai", district_code: "83" },
  { code: "2788", name: "Xã Bản Lầu", district_code: "83" },
  { code: "2791", name: "Xã La Pan Tẩn", district_code: "83" },
  { code: "2794", name: "Xã Tả Thàng", district_code: "83" },
  { code: "2797", name: "Xã Bản Sen", district_code: "83" },
  { code: "2800", name: "Xã Nàn Sán", district_code: "84" },
  { code: "2803", name: "Xã Thào Chư Phìn", district_code: "84" },
  { code: "2806", name: "Xã Bản Mế", district_code: "84" },
  { code: "2809", name: "Thị trấn Si Ma Cai", district_code: "84" },
  { code: "2812", name: "Xã Sán Chải", district_code: "84" },
  { code: "2818", name: "Xã Lùng Thẩn", district_code: "84" },
  { code: "2821", name: "Xã Cán Cấu", district_code: "84" },
  { code: "2824", name: "Xã Sín Chéng", district_code: "84" },
  { code: "2827", name: "Xã Quan Hồ Thẩn", district_code: "84" },
  { code: "2836", name: "Xã Nàn Xín", district_code: "84" },
  { code: "2839", name: "Thị trấn Bắc Hà", district_code: "85" },
  { code: "2842", name: "Xã Lùng Cải", district_code: "85" },
  { code: "2848", name: "Xã Lùng Phình", district_code: "85" },
  { code: "2851", name: "Xã Tả Van Chư", district_code: "85" },
  { code: "2854", name: "Xã Tả Củ Tỷ", district_code: "85" },
  { code: "2857", name: "Xã Thải Giàng Phố", district_code: "85" },
  { code: "2863", name: "Xã Hoàng Thu Phố", district_code: "85" },
  { code: "2866", name: "Xã Bản Phố", district_code: "85" },
  { code: "2869", name: "Xã Bản Liền", district_code: "85" },
  { code: "2875", name: "Xã Na Hối", district_code: "85" },
  { code: "2878", name: "Xã Cốc Ly", district_code: "85" },
  { code: "2881", name: "Xã Nậm Mòn", district_code: "85" },
  { code: "2884", name: "Xã Nậm Đét", district_code: "85" },
  { code: "2887", name: "Xã Nậm Khánh", district_code: "85" },
  { code: "2890", name: "Xã Bảo Nhai", district_code: "85" },
  { code: "2893", name: "Xã Nậm Lúc", district_code: "85" },
  { code: "2896", name: "Xã Cốc Lầu", district_code: "85" },
  { code: "2899", name: "Xã Bản Cái", district_code: "85" },
  { code: "2902", name: "Thị trấn N.T Phong Hải", district_code: "86" },
  { code: "2905", name: "Thị trấn Phố Lu", district_code: "86" },
  { code: "2908", name: "Thị trấn Tằng Loỏng", district_code: "86" },
  { code: "2911", name: "Xã Bản Phiệt", district_code: "86" },
  { code: "2914", name: "Xã Bản Cầm", district_code: "86" },
  { code: "2917", name: "Xã Thái Niên", district_code: "86" },
  { code: "2920", name: "Xã Phong Niên", district_code: "86" },
  { code: "2923", name: "Xã Gia Phú", district_code: "86" },
  { code: "2926", name: "Xã Xuân Quang", district_code: "86" },
  { code: "2929", name: "Xã Sơn Hải", district_code: "86" },
  { code: "2932", name: "Xã Xuân Giao", district_code: "86" },
  { code: "2935", name: "Xã Trì Quang", district_code: "86" },
  { code: "2938", name: "Xã Sơn Hà", district_code: "86" },
  { code: "2944", name: "Xã Phú Nhuận", district_code: "86" },
  { code: "2947", name: "Thị trấn Phố Ràng", district_code: "87" },
  { code: "2950", name: "Xã Tân Tiến", district_code: "87" },
  { code: "2953", name: "Xã Nghĩa Đô", district_code: "87" },
  { code: "2956", name: "Xã Vĩnh Yên", district_code: "87" },
  { code: "2959", name: "Xã Điện Quan", district_code: "87" },
  { code: "2962", name: "Xã Xuân Hoà", district_code: "87" },
  { code: "2965", name: "Xã Tân Dương", district_code: "87" },
  { code: "2968", name: "Xã Thượng Hà", district_code: "87" },
  { code: "2971", name: "Xã Kim Sơn", district_code: "87" },
  { code: "2974", name: "Xã Cam Cọn", district_code: "87" },
  { code: "2977", name: "Xã Minh Tân", district_code: "87" },
  { code: "2980", name: "Xã Xuân Thượng", district_code: "87" },
  { code: "2983", name: "Xã Việt Tiến", district_code: "87" },
  { code: "2986", name: "Xã Yên Sơn", district_code: "87" },
  { code: "2989", name: "Xã Bảo Hà", district_code: "87" },
  { code: "2992", name: "Xã Lương Sơn", district_code: "87" },
  { code: "2998", name: "Xã Phúc Khánh", district_code: "87" },
  { code: "3001", name: "Phường Sa Pa", district_code: "88" },
  { code: "3002", name: "Phường Sa Pả", district_code: "88" },
  { code: "3003", name: "Phường Ô Quý Hồ", district_code: "88" },
  { code: "3004", name: "Xã Ngũ Chỉ Sơn", district_code: "88" },
  { code: "3006", name: "Phường Phan Si Păng", district_code: "88" },
  { code: "3010", name: "Xã Trung Chải", district_code: "88" },
  { code: "3013", name: "Xã Tả Phìn", district_code: "88" },
  { code: "3016", name: "Phường Hàm Rồng", district_code: "88" },
  { code: "3019", name: "Xã Hoàng Liên", district_code: "88" },
  { code: "3022", name: "Xã Thanh Bình", district_code: "88" },
  { code: "3028", name: "Phường Cầu Mây", district_code: "88" },
  { code: "3037", name: "Xã Mường Hoa", district_code: "88" },
  { code: "3040", name: "Xã Tả Van", district_code: "88" },
  { code: "3043", name: "Xã Mường Bo", district_code: "88" },
  { code: "3046", name: "Xã Bản Hồ", district_code: "88" },
  { code: "3052", name: "Xã Liên Minh", district_code: "88" },
  { code: "3055", name: "Thị trấn Khánh Yên", district_code: "89" },
  { code: "3061", name: "Xã Võ Lao", district_code: "89" },
  { code: "3064", name: "Xã Sơn Thuỷ", district_code: "89" },
  { code: "3067", name: "Xã Nậm Mả", district_code: "89" },
  { code: "3070", name: "Xã Tân Thượng", district_code: "89" },
  { code: "3073", name: "Xã Nậm Rạng", district_code: "89" },
  { code: "3076", name: "Xã Nậm Chầy", district_code: "89" },
  { code: "3079", name: "Xã Tân An", district_code: "89" },
  { code: "3082", name: "Xã Khánh Yên Thượng", district_code: "89" },
  { code: "3085", name: "Xã Nậm Xé", district_code: "89" },
  { code: "3088", name: "Xã Dần Thàng", district_code: "89" },
  { code: "3091", name: "Xã Chiềng Ken", district_code: "89" },
  { code: "3094", name: "Xã Làng Giàng", district_code: "89" },
  { code: "3097", name: "Xã Hoà Mạc", district_code: "89" },
  { code: "3100", name: "Xã Khánh Yên Trung", district_code: "89" },
  { code: "3103", name: "Xã Khánh Yên Hạ", district_code: "89" },
  { code: "3106", name: "Xã Dương Quỳ", district_code: "89" },
  { code: "3109", name: "Xã Nậm Tha", district_code: "89" },
  { code: "3112", name: "Xã Minh Lương", district_code: "89" },
  { code: "3115", name: "Xã Thẩm Dương", district_code: "89" },
  { code: "3118", name: "Xã Liêm Phú", district_code: "89" },
  { code: "3121", name: "Xã Nậm Xây", district_code: "89" },
  { code: "3124", name: "Phường Noong Bua", district_code: "94" },
  { code: "3127", name: "Phường Him Lam", district_code: "94" },
  { code: "3130", name: "Phường Thanh Bình", district_code: "94" },
  { code: "3133", name: "Phường Tân Thanh", district_code: "94" },
  { code: "3136", name: "Phường Mường Thanh", district_code: "94" },
  { code: "3139", name: "Phường Nam Thanh", district_code: "94" },
  { code: "3142", name: "Phường Thanh Trường", district_code: "94" },
  { code: "3145", name: "Xã Thanh Minh", district_code: "94" },
  { code: "3316", name: "Xã Nà Tấu", district_code: "94" },
  { code: "3317", name: "Xã Nà Nhạn", district_code: "94" },
  { code: "3325", name: "Xã Mường Phăng", district_code: "94" },
  { code: "3326", name: "Xã Pá Khoang", district_code: "94" },
  { code: "3148", name: "Phường Sông Đà", district_code: "95" },
  { code: "3151", name: "Phường Na Lay", district_code: "95" },
  { code: "3184", name: "Xã Lay Nưa", district_code: "95" },
  { code: "3154", name: "Xã Sín Thầu", district_code: "96" },
  { code: "3155", name: "Xã Sen Thượng", district_code: "96" },
  { code: "3157", name: "Xã Chung Chải", district_code: "96" },
  { code: "3158", name: "Xã Leng Su Sìn", district_code: "96" },
  { code: "3159", name: "Xã Pá Mỳ", district_code: "96" },
  { code: "3160", name: "Xã Mường Nhé", district_code: "96" },
  { code: "3161", name: "Xã Nậm Vì", district_code: "96" },
  { code: "3162", name: "Xã Nậm Kè", district_code: "96" },
  { code: "3163", name: "Xã Mường Toong", district_code: "96" },
  { code: "3164", name: "Xã Quảng Lâm", district_code: "96" },
  { code: "3177", name: "Xã Huổi Lếnh", district_code: "96" },
  { code: "3172", name: "Thị trấn Mường Chà", district_code: "97" },
  { code: "3178", name: "Xã Xá Tổng", district_code: "97" },
  { code: "3181", name: "Xã Mường Tùng", district_code: "97" },
  { code: "3190", name: "Xã Hừa Ngài", district_code: "97" },
  { code: "3191", name: "Xã Huổi Mí", district_code: "97" },
  { code: "3193", name: "Xã Pa Ham", district_code: "97" },
  { code: "3194", name: "Xã Nậm Nèn", district_code: "97" },
  { code: "3196", name: "Xã Huổi Lèng", district_code: "97" },
  { code: "3197", name: "Xã Sa Lông", district_code: "97" },
  { code: "3200", name: "Xã Ma Thì Hồ", district_code: "97" },
  { code: "3201", name: "Xã Na Sang", district_code: "97" },
  { code: "3202", name: "Xã Mường Mươn", district_code: "97" },
  { code: "3217", name: "Thị trấn Tủa Chùa", district_code: "98" },
  { code: "3220", name: "Xã Huổi Só", district_code: "98" },
  { code: "3223", name: "Xã Xín Chải", district_code: "98" },
  { code: "3226", name: "Xã Tả Sìn Thàng", district_code: "98" },
  { code: "3229", name: "Xã Lao Xả Phình", district_code: "98" },
  { code: "3232", name: "Xã Tả Phìn", district_code: "98" },
  { code: "3235", name: "Xã Tủa Thàng", district_code: "98" },
  { code: "3238", name: "Xã Trung Thu", district_code: "98" },
  { code: "3241", name: "Xã Sính Phình", district_code: "98" },
  { code: "3244", name: "Xã Sáng Nhè", district_code: "98" },
  { code: "3247", name: "Xã Mường Đun", district_code: "98" },
  { code: "3250", name: "Xã Mường Báng", district_code: "98" },
  { code: "3253", name: "Thị trấn Tuần Giáo", district_code: "99" },
  { code: "3259", name: "Xã Phình Sáng", district_code: "99" },
  { code: "3260", name: "Xã Rạng Đông", district_code: "99" },
  { code: "3262", name: "Xã Mùn Chung", district_code: "99" },
  { code: "3263", name: "Xã Nà Tòng", district_code: "99" },
  { code: "3265", name: "Xã Ta Ma", district_code: "99" },
  { code: "3268", name: "Xã Mường Mùn", district_code: "99" },
  { code: "3269", name: "Xã Pú Xi", district_code: "99" },
  { code: "3271", name: "Xã Pú Nhung", district_code: "99" },
  { code: "3274", name: "Xã Quài Nưa", district_code: "99" },
  { code: "3277", name: "Xã Mường Thín", district_code: "99" },
  { code: "3280", name: "Xã Tỏa Tình", district_code: "99" },
  { code: "3283", name: "Xã Nà Sáy", district_code: "99" },
  { code: "3284", name: "Xã Mường Khong", district_code: "99" },
  { code: "3289", name: "Xã Quài Cang", district_code: "99" },
  { code: "3295", name: "Xã Quài Tở", district_code: "99" },
  { code: "3298", name: "Xã Chiềng Sinh", district_code: "99" },
  { code: "3299", name: "Xã Chiềng Đông", district_code: "99" },
  { code: "3304", name: "Xã Tênh Phông", district_code: "99" },
  { code: "3319", name: "Xã Mường Pồn", district_code: "100" },
  { code: "3322", name: "Xã Thanh Nưa", district_code: "100" },
  { code: "3323", name: "Xã Hua Thanh", district_code: "100" },
  { code: "3328", name: "Xã Thanh Luông", district_code: "100" },
  { code: "3331", name: "Xã Thanh Hưng", district_code: "100" },
  { code: "3334", name: "Xã Thanh Xương", district_code: "100" },
  { code: "3337", name: "Xã Thanh Chăn", district_code: "100" },
  { code: "3340", name: "Xã Pa Thơm", district_code: "100" },
  { code: "3343", name: "Xã Thanh An", district_code: "100" },
  { code: "3346", name: "Xã Thanh Yên", district_code: "100" },
  { code: "3349", name: "Xã Noong Luống", district_code: "100" },
  { code: "3352", name: "Xã Noọng Hẹt", district_code: "100" },
  { code: "3355", name: "Xã Sam Mứn", district_code: "100" },
  { code: "3356", name: "Xã Pom Lót", district_code: "100" },
  { code: "3358", name: "Xã Núa Ngam", district_code: "100" },
  { code: "3359", name: "Xã Hẹ Muông", district_code: "100" },
  { code: "3361", name: "Xã Na Ư", district_code: "100" },
  { code: "3364", name: "Xã Mường Nhà", district_code: "100" },
  { code: "3365", name: "Xã Na Tông", district_code: "100" },
  { code: "3367", name: "Xã Mường Lói", district_code: "100" },
  { code: "3368", name: "Xã Phu Luông", district_code: "100" },
  { code: "3203", name: "Thị trấn Điện Biên Đông", district_code: "101" },
  { code: "3205", name: "Xã Na Son", district_code: "101" },
  { code: "3208", name: "Xã Phì Nhừ", district_code: "101" },
  { code: "3211", name: "Xã Chiềng Sơ", district_code: "101" },
  { code: "3214", name: "Xã Mường Luân", district_code: "101" },
  { code: "3370", name: "Xã Pú Nhi", district_code: "101" },
  { code: "3371", name: "Xã Nong U", district_code: "101" },
  { code: "3373", name: "Xã Xa Dung", district_code: "101" },
  { code: "3376", name: "Xã Keo Lôm", district_code: "101" },
  { code: "3379", name: "Xã Luân Giới", district_code: "101" },
  { code: "3382", name: "Xã Phình Giàng", district_code: "101" },
  { code: "3383", name: "Xã Pú Hồng", district_code: "101" },
  { code: "3384", name: "Xã Tìa Dình", district_code: "101" },
  { code: "3385", name: "Xã Háng Lìa", district_code: "101" },
  { code: "3256", name: "Thị trấn Mường Ảng", district_code: "102" },
  { code: "3286", name: "Xã Mường Đăng", district_code: "102" },
  { code: "3287", name: "Xã Ngối Cáy", district_code: "102" },
  { code: "3292", name: "Xã Ẳng Tở", district_code: "102" },
  { code: "3301", name: "Xã Búng Lao", district_code: "102" },
  { code: "3302", name: "Xã Xuân Lao", district_code: "102" },
  { code: "3307", name: "Xã Ẳng Nưa", district_code: "102" },
  { code: "3310", name: "Xã Ẳng Cang", district_code: "102" },
  { code: "3312", name: "Xã Nặm Lịch", district_code: "102" },
  { code: "3313", name: "Xã Mường Lạn", district_code: "102" },
  { code: "3156", name: "Xã Nậm Tin", district_code: "103" },
  { code: "3165", name: "Xã Pa Tần", district_code: "103" },
  { code: "3166", name: "Xã Chà Cang", district_code: "103" },
  { code: "3167", name: "Xã Na Cô Sa", district_code: "103" },
  { code: "3168", name: "Xã Nà Khoa", district_code: "103" },
  { code: "3169", name: "Xã Nà Hỳ", district_code: "103" },
  { code: "3170", name: "Xã Nà Bủng", district_code: "103" },
  { code: "3171", name: "Xã Nậm Nhừ", district_code: "103" },
  { code: "3173", name: "Xã Nậm Chua", district_code: "103" },
  { code: "3174", name: "Xã Nậm Khăn", district_code: "103" },
  { code: "3175", name: "Xã Chà Tở", district_code: "103" },
  { code: "3176", name: "Xã Vàng Đán", district_code: "103" },
  { code: "3187", name: "Xã Chà Nưa", district_code: "103" },
  { code: "3198", name: "Xã Phìn Hồ", district_code: "103" },
  { code: "3199", name: "Xã Si Pa Phìn", district_code: "103" },
  { code: "3386", name: "Phường Quyết Thắng", district_code: "105" },
  { code: "3387", name: "Phường Tân Phong", district_code: "105" },
  { code: "3388", name: "Phường Quyết Tiến", district_code: "105" },
  { code: "3389", name: "Phường Đoàn Kết", district_code: "105" },
  { code: "3403", name: "Xã Sùng Phài", district_code: "105" },
  { code: "3408", name: "Phường Đông Phong", district_code: "105" },
  { code: "3409", name: "Xã San Thàng", district_code: "105" },
  { code: "3390", name: "Thị trấn Tam Đường", district_code: "106" },
  { code: "3394", name: "Xã Thèn Sin", district_code: "106" },
  { code: "3400", name: "Xã Tả Lèng", district_code: "106" },
  { code: "3405", name: "Xã Giang Ma", district_code: "106" },
  { code: "3406", name: "Xã Hồ Thầu", district_code: "106" },
  { code: "3412", name: "Xã Bình Lư", district_code: "106" },
  { code: "3413", name: "Xã Sơn Bình", district_code: "106" },
  { code: "3415", name: "Xã Nùng Nàng", district_code: "106" },
  { code: "3418", name: "Xã Bản Giang", district_code: "106" },
  { code: "3421", name: "Xã Bản Hon", district_code: "106" },
  { code: "3424", name: "Xã Bản Bo", district_code: "106" },
  { code: "3427", name: "Xã Nà Tăm", district_code: "106" },
  { code: "3430", name: "Xã Khun Há", district_code: "106" },
  { code: "3433", name: "Thị trấn Mường Tè", district_code: "107" },
  { code: "3436", name: "Xã Thu Lũm", district_code: "107" },
  { code: "3439", name: "Xã Ka Lăng", district_code: "107" },
  { code: "3440", name: "Xã Tá Bạ", district_code: "107" },
  { code: "3442", name: "Xã Pa ủ", district_code: "107" },
  { code: "3445", name: "Xã Mường Tè", district_code: "107" },
  { code: "3448", name: "Xã Pa Vệ Sử", district_code: "107" },
  { code: "3451", name: "Xã Mù Cả", district_code: "107" },
  { code: "3454", name: "Xã Bum Tở", district_code: "107" },
  { code: "3457", name: "Xã Nậm Khao", district_code: "107" },
  { code: "3463", name: "Xã Tà Tổng", district_code: "107" },
  { code: "3466", name: "Xã Bum Nưa", district_code: "107" },
  { code: "3467", name: "Xã Vàng San", district_code: "107" },
  { code: "3469", name: "Xã Kan Hồ", district_code: "107" },
  { code: "3478", name: "Thị trấn Sìn Hồ", district_code: "108" },
  { code: "3487", name: "Xã Chăn Nưa", district_code: "108" },
  { code: "3493", name: "Xã Pa Tần", district_code: "108" },
  { code: "3496", name: "Xã Phìn Hồ", district_code: "108" },
  { code: "3499", name: "Xã Hồng Thu", district_code: "108" },
  { code: "3505", name: "Xã Phăng Sô Lin", district_code: "108" },
  { code: "3508", name: "Xã Ma Quai", district_code: "108" },
  { code: "3509", name: "Xã Lùng Thàng", district_code: "108" },
  { code: "3511", name: "Xã Tả Phìn", district_code: "108" },
  { code: "3514", name: "Xã Sà Dề Phìn", district_code: "108" },
  { code: "3517", name: "Xã Nậm Tăm", district_code: "108" },
  { code: "3520", name: "Xã Tả Ngảo", district_code: "108" },
  { code: "3523", name: "Xã Pu Sam Cáp", district_code: "108" },
  { code: "3526", name: "Xã Nậm Cha", district_code: "108" },
  { code: "3527", name: "Xã Pa Khoá", district_code: "108" },
  { code: "3529", name: "Xã Làng Mô", district_code: "108" },
  { code: "3532", name: "Xã Noong Hẻo", district_code: "108" },
  { code: "3535", name: "Xã Nậm Mạ", district_code: "108" },
  { code: "3538", name: "Xã Căn Co", district_code: "108" },
  { code: "3541", name: "Xã Tủa Sín Chải", district_code: "108" },
  { code: "3544", name: "Xã Nậm Cuổi", district_code: "108" },
  { code: "3547", name: "Xã Nậm Hăn", district_code: "108" },
  { code: "3391", name: "Xã Lả Nhì Thàng", district_code: "109" },
  { code: "3490", name: "Xã Huổi Luông", district_code: "109" },
  { code: "3549", name: "Thị trấn Phong Thổ", district_code: "109" },
  { code: "3550", name: "Xã Sì Lở Lầu", district_code: "109" },
  { code: "3553", name: "Xã Mồ Sì San", district_code: "109" },
  { code: "3559", name: "Xã Pa Vây Sử", district_code: "109" },
  { code: "3562", name: "Xã Vàng Ma Chải", district_code: "109" },
  { code: "3565", name: "Xã Tông Qua Lìn", district_code: "109" },
  { code: "3568", name: "Xã Mù Sang", district_code: "109" },
  { code: "3571", name: "Xã Dào San", district_code: "109" },
  { code: "3574", name: "Xã Ma Ly Pho", district_code: "109" },
  { code: "3577", name: "Xã Bản Lang", district_code: "109" },
  { code: "3580", name: "Xã Hoang Thèn", district_code: "109" },
  { code: "3583", name: "Xã Khổng Lào", district_code: "109" },
  { code: "3586", name: "Xã Nậm Xe", district_code: "109" },
  { code: "3589", name: "Xã Mường So", district_code: "109" },
  { code: "3592", name: "Xã Sin Suối Hồ", district_code: "109" },
  { code: "3595", name: "Thị trấn Than Uyên", district_code: "110" },
  { code: "3618", name: "Xã Phúc Than", district_code: "110" },
  { code: "3619", name: "Xã Mường Than", district_code: "110" },
  { code: "3625", name: "Xã Mường Mít", district_code: "110" },
  { code: "3628", name: "Xã Pha Mu", district_code: "110" },
  { code: "3631", name: "Xã Mường Cang", district_code: "110" },
  { code: "3632", name: "Xã Hua Nà", district_code: "110" },
  { code: "3634", name: "Xã Tà Hừa", district_code: "110" },
  { code: "3637", name: "Xã Mường Kim", district_code: "110" },
  { code: "3638", name: "Xã Tà Mung", district_code: "110" },
  { code: "3640", name: "Xã Tà Gia", district_code: "110" },
  { code: "3643", name: "Xã Khoen On", district_code: "110" },
  { code: "3598", name: "Thị trấn Tân Uyên", district_code: "111" },
  { code: "3601", name: "Xã Mường Khoa", district_code: "111" },
  { code: "3602", name: "Xã Phúc Khoa", district_code: "111" },
  { code: "3604", name: "Xã Thân Thuộc", district_code: "111" },
  { code: "3605", name: "Xã Trung Đồng", district_code: "111" },
  { code: "3607", name: "Xã Hố Mít", district_code: "111" },
  { code: "3610", name: "Xã Nậm Cần", district_code: "111" },
  { code: "3613", name: "Xã Nậm Sỏ", district_code: "111" },
  { code: "3616", name: "Xã Pắc Ta", district_code: "111" },
  { code: "3622", name: "Xã Tà Mít", district_code: "111" },
  { code: "3434", name: "Thị trấn Nậm Nhùn", district_code: "112" },
  { code: "3460", name: "Xã Hua Bun", district_code: "112" },
  { code: "3472", name: "Xã Mường Mô", district_code: "112" },
  { code: "3473", name: "Xã Nậm Chà", district_code: "112" },
  { code: "3474", name: "Xã Nậm Manh", district_code: "112" },
  { code: "3475", name: "Xã Nậm Hàng", district_code: "112" },
  { code: "3481", name: "Xã Lê Lợi", district_code: "112" },
  { code: "3484", name: "Xã Pú Đao", district_code: "112" },
  { code: "3488", name: "Xã Nậm Pì", district_code: "112" },
  { code: "3502", name: "Xã Nậm Ban", district_code: "112" },
  { code: "3503", name: "Xã Trung Chải", district_code: "112" },
  { code: "3646", name: "Phường Chiềng Lề", district_code: "116" },
  { code: "3649", name: "Phường Tô Hiệu", district_code: "116" },
  { code: "3652", name: "Phường Quyết Thắng", district_code: "116" },
  { code: "3655", name: "Phường Quyết Tâm", district_code: "116" },
  { code: "3658", name: "Xã Chiềng Cọ", district_code: "116" },
  { code: "3661", name: "Xã Chiềng Đen", district_code: "116" },
  { code: "3664", name: "Xã Chiềng Xôm", district_code: "116" },
  { code: "3667", name: "Phường Chiềng An", district_code: "116" },
  { code: "3670", name: "Phường Chiềng Cơi", district_code: "116" },
  { code: "3673", name: "Xã Chiềng Ngần", district_code: "116" },
  { code: "3676", name: "Xã Hua La", district_code: "116" },
  { code: "3679", name: "Phường Chiềng Sinh", district_code: "116" },
  { code: "3682", name: "Xã Mường Chiên", district_code: "118" },
  { code: "3685", name: "Xã Cà Nàng", district_code: "118" },
  { code: "3688", name: "Xã Chiềng Khay", district_code: "118" },
  { code: "3694", name: "Xã Mường Giôn", district_code: "118" },
  { code: "3697", name: "Xã Pá Ma Pha Khinh", district_code: "118" },
  { code: "3700", name: "Xã Chiềng Ơn", district_code: "118" },
  { code: "3703", name: "Xã Mường Giàng", district_code: "118" },
  { code: "3706", name: "Xã Chiềng Bằng", district_code: "118" },
  { code: "3709", name: "Xã Mường Sại", district_code: "118" },
  { code: "3712", name: "Xã Nậm ét", district_code: "118" },
  { code: "3718", name: "Xã Chiềng Khoang", district_code: "118" },
  { code: "3721", name: "Thị trấn Thuận Châu", district_code: "119" },
  { code: "3724", name: "Xã Phổng Lái", district_code: "119" },
  { code: "3727", name: "Xã Mường é", district_code: "119" },
  { code: "3730", name: "Xã Chiềng Pha", district_code: "119" },
  { code: "3733", name: "Xã Chiềng La", district_code: "119" },
  { code: "3736", name: "Xã Chiềng Ngàm", district_code: "119" },
  { code: "3739", name: "Xã Liệp Tè", district_code: "119" },
  { code: "3742", name: "Xã é Tòng", district_code: "119" },
  { code: "3745", name: "Xã Phổng Lập", district_code: "119" },
  { code: "3748", name: "Xã Phổng Lăng", district_code: "119" },
  { code: "3751", name: "Xã Chiềng Ly", district_code: "119" },
  { code: "3754", name: "Xã Noong Lay", district_code: "119" },
  { code: "3757", name: "Xã Mường Khiêng", district_code: "119" },
  { code: "3760", name: "Xã Mường Bám", district_code: "119" },
  { code: "3763", name: "Xã Long Hẹ", district_code: "119" },
  { code: "3766", name: "Xã Chiềng Bôm", district_code: "119" },
  { code: "3769", name: "Xã Thôm Mòn", district_code: "119" },
  { code: "3772", name: "Xã Tông Lạnh", district_code: "119" },
  { code: "3775", name: "Xã Tông Cọ", district_code: "119" },
  { code: "3778", name: "Xã Bó Mười", district_code: "119" },
  { code: "3781", name: "Xã Co Mạ", district_code: "119" },
  { code: "3784", name: "Xã Púng Tra", district_code: "119" },
  { code: "3787", name: "Xã Chiềng Pấc", district_code: "119" },
  { code: "3790", name: "Xã Nậm Lầu", district_code: "119" },
  { code: "3793", name: "Xã Bon Phặng", district_code: "119" },
  { code: "3796", name: "Xã Co Tòng", district_code: "119" },
  { code: "3799", name: "Xã Muổi Nọi", district_code: "119" },
  { code: "3802", name: "Xã Pá Lông", district_code: "119" },
  { code: "3805", name: "Xã Bản Lầm", district_code: "119" },
  { code: "3808", name: "Thị trấn Ít Ong", district_code: "120" },
  { code: "3811", name: "Xã Nậm Giôn", district_code: "120" },
  { code: "3814", name: "Xã Chiềng Lao", district_code: "120" },
  { code: "3817", name: "Xã Hua Trai", district_code: "120" },
  { code: "3820", name: "Xã Ngọc Chiến", district_code: "120" },
  { code: "3823", name: "Xã Mường Trai", district_code: "120" },
  { code: "3826", name: "Xã Nậm Păm", district_code: "120" },
  { code: "3829", name: "Xã Chiềng Muôn", district_code: "120" },
  { code: "3832", name: "Xã Chiềng Ân", district_code: "120" },
  { code: "3835", name: "Xã Pi Toong", district_code: "120" },
  { code: "3838", name: "Xã Chiềng Công", district_code: "120" },
  { code: "3841", name: "Xã Tạ Bú", district_code: "120" },
  { code: "3844", name: "Xã Chiềng San", district_code: "120" },
  { code: "3847", name: "Xã Mường Bú", district_code: "120" },
  { code: "3850", name: "Xã Chiềng Hoa", district_code: "120" },
  { code: "3853", name: "Xã Mường Chùm", district_code: "120" },
  { code: "3856", name: "Thị trấn Bắc Yên", district_code: "121" },
  { code: "3859", name: "Xã Phiêng Ban", district_code: "121" },
  { code: "3862", name: "Xã Hang Chú", district_code: "121" },
  { code: "3865", name: "Xã Xím Vàng", district_code: "121" },
  { code: "3868", name: "Xã Tà Xùa", district_code: "121" },
  { code: "3869", name: "Xã Háng Đồng", district_code: "121" },
  { code: "3871", name: "Xã Pắc Ngà", district_code: "121" },
  { code: "3874", name: "Xã Làng Chếu", district_code: "121" },
  { code: "3877", name: "Xã Chim Vàn", district_code: "121" },
  { code: "3880", name: "Xã Mường Khoa", district_code: "121" },
  { code: "3883", name: "Xã Song Pe", district_code: "121" },
  { code: "3886", name: "Xã Hồng Ngài", district_code: "121" },
  { code: "3889", name: "Xã Tạ Khoa", district_code: "121" },
  { code: "3890", name: "Xã Hua Nhàn", district_code: "121" },
  { code: "3892", name: "Xã Phiêng Côn", district_code: "121" },
  { code: "3895", name: "Xã Chiềng Sại", district_code: "121" },
  { code: "3898", name: "Thị trấn Phù Yên", district_code: "122" },
  { code: "3901", name: "Xã Suối Tọ", district_code: "122" },
  { code: "3904", name: "Xã Mường Thải", district_code: "122" },
  { code: "3907", name: "Xã Mường Cơi", district_code: "122" },
  { code: "3910", name: "Xã Quang Huy", district_code: "122" },
  { code: "3913", name: "Xã Huy Bắc", district_code: "122" },
  { code: "3916", name: "Xã Huy Thượng", district_code: "122" },
  { code: "3919", name: "Xã Tân Lang", district_code: "122" },
  { code: "3922", name: "Xã Gia Phù", district_code: "122" },
  { code: "3925", name: "Xã Tường Phù", district_code: "122" },
  { code: "3928", name: "Xã Huy Hạ", district_code: "122" },
  { code: "3931", name: "Xã Huy Tân", district_code: "122" },
  { code: "3934", name: "Xã Mường Lang", district_code: "122" },
  { code: "3937", name: "Xã Suối Bau", district_code: "122" },
  { code: "3940", name: "Xã Huy Tường", district_code: "122" },
  { code: "3943", name: "Xã Mường Do", district_code: "122" },
  { code: "3946", name: "Xã Sập Xa", district_code: "122" },
  { code: "3949", name: "Xã Tường Thượng", district_code: "122" },
  { code: "3952", name: "Xã Tường Tiến", district_code: "122" },
  { code: "3955", name: "Xã Tường Phong", district_code: "122" },
  { code: "3958", name: "Xã Tường Hạ", district_code: "122" },
  { code: "3961", name: "Xã Kim Bon", district_code: "122" },
  { code: "3964", name: "Xã Mường Bang", district_code: "122" },
  { code: "3967", name: "Xã Đá Đỏ", district_code: "122" },
  { code: "3970", name: "Xã Tân Phong", district_code: "122" },
  { code: "3973", name: "Xã Nam Phong", district_code: "122" },
  { code: "3976", name: "Xã Bắc Phong", district_code: "122" },
  { code: "3979", name: "Thị trấn Mộc Châu", district_code: "123" },
  { code: "3982", name: "Thị trấn NT Mộc Châu", district_code: "123" },
  { code: "3985", name: "Xã Chiềng Sơn", district_code: "123" },
  { code: "3988", name: "Xã Tân Hợp", district_code: "123" },
  { code: "3991", name: "Xã Qui Hướng", district_code: "123" },
  { code: "3997", name: "Xã Tân Lập", district_code: "123" },
  { code: "4000", name: "Xã Nà Mường", district_code: "123" },
  { code: "4003", name: "Xã Tà Lai", district_code: "123" },
  { code: "4012", name: "Xã Chiềng Hắc", district_code: "123" },
  { code: "4015", name: "Xã Hua Păng", district_code: "123" },
  { code: "4024", name: "Xã Chiềng Khừa", district_code: "123" },
  { code: "4027", name: "Xã Mường Sang", district_code: "123" },
  { code: "4030", name: "Xã Đông Sang", district_code: "123" },
  { code: "4033", name: "Xã Phiêng Luông", district_code: "123" },
  { code: "4045", name: "Xã Lóng Sập", district_code: "123" },
  { code: "4060", name: "Thị trấn Yên Châu", district_code: "124" },
  { code: "4063", name: "Xã Chiềng Đông", district_code: "124" },
  { code: "4066", name: "Xã Sập Vạt", district_code: "124" },
  { code: "4069", name: "Xã Chiềng Sàng", district_code: "124" },
  { code: "4072", name: "Xã Chiềng Pằn", district_code: "124" },
  { code: "4075", name: "Xã Viêng Lán", district_code: "124" },
  { code: "4078", name: "Xã Chiềng Hặc", district_code: "124" },
  { code: "4081", name: "Xã Mường Lựm", district_code: "124" },
  { code: "4084", name: "Xã Chiềng On", district_code: "124" },
  { code: "4087", name: "Xã Yên Sơn", district_code: "124" },
  { code: "4090", name: "Xã Chiềng Khoi", district_code: "124" },
  { code: "4093", name: "Xã Tú Nang", district_code: "124" },
  { code: "4096", name: "Xã Lóng Phiêng", district_code: "124" },
  { code: "4099", name: "Xã Phiêng Khoài", district_code: "124" },
  { code: "4102", name: "Xã Chiềng Tương", district_code: "124" },
  { code: "4105", name: "Thị trấn Hát Lót", district_code: "125" },
  { code: "4108", name: "Xã Chiềng Sung", district_code: "125" },
  { code: "4111", name: "Xã Mường Bằng", district_code: "125" },
  { code: "4114", name: "Xã Chiềng Chăn", district_code: "125" },
  { code: "4117", name: "Xã Mương Chanh", district_code: "125" },
  { code: "4120", name: "Xã Chiềng Ban", district_code: "125" },
  { code: "4123", name: "Xã Chiềng Mung", district_code: "125" },
  { code: "4126", name: "Xã Mường Bon", district_code: "125" },
  { code: "4129", name: "Xã Chiềng Chung", district_code: "125" },
  { code: "4132", name: "Xã Chiềng Mai", district_code: "125" },
  { code: "4135", name: "Xã Hát Lót", district_code: "125" },
  { code: "4136", name: "Xã Nà Pó", district_code: "125" },
  { code: "4138", name: "Xã Cò Nòi", district_code: "125" },
  { code: "4141", name: "Xã Chiềng Nơi", district_code: "125" },
  { code: "4144", name: "Xã Phiêng Cằm", district_code: "125" },
  { code: "4147", name: "Xã Chiềng Dong", district_code: "125" },
  { code: "4150", name: "Xã Chiềng Kheo", district_code: "125" },
  { code: "4153", name: "Xã Chiềng Ve", district_code: "125" },
  { code: "4156", name: "Xã Chiềng Lương", district_code: "125" },
  { code: "4159", name: "Xã Phiêng Pằn", district_code: "125" },
  { code: "4162", name: "Xã Nà Ơt", district_code: "125" },
  { code: "4165", name: "Xã Tà Hộc", district_code: "125" },
  { code: "4168", name: "Thị trấn Sông Mã", district_code: "126" },
  { code: "4171", name: "Xã Bó Sinh", district_code: "126" },
  { code: "4174", name: "Xã Pú Pẩu", district_code: "126" },
  { code: "4177", name: "Xã Chiềng Phung", district_code: "126" },
  { code: "4180", name: "Xã Chiềng En", district_code: "126" },
  { code: "4183", name: "Xã Mường Lầm", district_code: "126" },
  { code: "4186", name: "Xã Nậm Ty", district_code: "126" },
  { code: "4189", name: "Xã Đứa Mòn", district_code: "126" },
  { code: "4192", name: "Xã Yên Hưng", district_code: "126" },
  { code: "4195", name: "Xã Chiềng Sơ", district_code: "126" },
  { code: "4198", name: "Xã Nà Nghịu", district_code: "126" },
  { code: "4201", name: "Xã Nậm Mằn", district_code: "126" },
  { code: "4204", name: "Xã Chiềng Khoong", district_code: "126" },
  { code: "4207", name: "Xã Chiềng Cang", district_code: "126" },
  { code: "4210", name: "Xã Huổi Một", district_code: "126" },
  { code: "4213", name: "Xã Mường Sai", district_code: "126" },
  { code: "4216", name: "Xã Mường Cai", district_code: "126" },
  { code: "4219", name: "Xã Mường Hung", district_code: "126" },
  { code: "4222", name: "Xã Chiềng Khương", district_code: "126" },
  { code: "4225", name: "Xã Sam Kha", district_code: "127" },
  { code: "4228", name: "Xã Púng Bánh", district_code: "127" },
  { code: "4231", name: "Xã Sốp Cộp", district_code: "127" },
  { code: "4234", name: "Xã Dồm Cang", district_code: "127" },
  { code: "4237", name: "Xã Nậm Lạnh", district_code: "127" },
  { code: "4240", name: "Xã Mường Lèo", district_code: "127" },
  { code: "4243", name: "Xã Mường Và", district_code: "127" },
  { code: "4246", name: "Xã Mường Lạn", district_code: "127" },
  { code: "3994", name: "Xã Suối Bàng", district_code: "128" },
  { code: "4006", name: "Xã Song Khủa", district_code: "128" },
  { code: "4009", name: "Xã Liên Hoà", district_code: "128" },
  { code: "4018", name: "Xã Tô Múa", district_code: "128" },
  { code: "4021", name: "Xã Mường Tè", district_code: "128" },
  { code: "4036", name: "Xã Chiềng Khoa", district_code: "128" },
  { code: "4039", name: "Xã Mường Men", district_code: "128" },
  { code: "4042", name: "Xã Quang Minh", district_code: "128" },
  { code: "4048", name: "Xã Vân Hồ", district_code: "128" },
  { code: "4051", name: "Xã Lóng Luông", district_code: "128" },
  { code: "4054", name: "Xã Chiềng Yên", district_code: "128" },
  { code: "4056", name: "Xã Chiềng Xuân", district_code: "128" },
  { code: "4057", name: "Xã Xuân Nha", district_code: "128" },
  { code: "4058", name: "Xã Tân Xuân", district_code: "128" },
  { code: "4249", name: "Phường Yên Thịnh", district_code: "132" },
  { code: "4252", name: "Phường Yên Ninh", district_code: "132" },
  { code: "4255", name: "Phường Minh Tân", district_code: "132" },
  { code: "4258", name: "Phường Nguyễn Thái Học", district_code: "132" },
  { code: "4261", name: "Phường Đồng Tâm", district_code: "132" },
  { code: "4264", name: "Phường Hồng Hà", district_code: "132" },
  { code: "4270", name: "Xã Minh Bảo", district_code: "132" },
  { code: "4273", name: "Phường Nam Cường", district_code: "132" },
  { code: "4276", name: "Xã Tuy Lộc", district_code: "132" },
  { code: "4279", name: "Xã Tân Thịnh", district_code: "132" },
  { code: "4540", name: "Xã Âu Lâu", district_code: "132" },
  { code: "4543", name: "Xã Giới Phiên", district_code: "132" },
  { code: "4546", name: "Phường Hợp Minh", district_code: "132" },
  { code: "4558", name: "Xã Văn Phú", district_code: "132" },
  { code: "4282", name: "Phường Pú Trạng", district_code: "133" },
  { code: "4285", name: "Phường Trung Tâm", district_code: "133" },
  { code: "4288", name: "Phường Tân An", district_code: "133" },
  { code: "4291", name: "Phường Cầu Thia", district_code: "133" },
  { code: "4294", name: "Xã Nghĩa Lợi", district_code: "133" },
  { code: "4297", name: "Xã Nghĩa Phúc", district_code: "133" },
  { code: "4300", name: "Xã Nghĩa An", district_code: "133" },
  { code: "4624", name: "Xã Nghĩa Lộ", district_code: "133" },
  { code: "4660", name: "Xã Sơn A", district_code: "133" },
  { code: "4663", name: "Xã Phù Nham", district_code: "133" },
  { code: "4675", name: "Xã Thanh Lương", district_code: "133" },
  { code: "4678", name: "Xã Hạnh Sơn", district_code: "133" },
  { code: "4681", name: "Xã Phúc Sơn", district_code: "133" },
  { code: "4684", name: "Xã Thạch Lương", district_code: "133" },
  { code: "4303", name: "Thị trấn Yên Thế", district_code: "135" },
  { code: "4306", name: "Xã Tân Phượng", district_code: "135" },
  { code: "4309", name: "Xã Lâm Thượng", district_code: "135" },
  { code: "4312", name: "Xã Khánh Thiện", district_code: "135" },
  { code: "4315", name: "Xã Minh Chuẩn", district_code: "135" },
  { code: "4318", name: "Xã Mai Sơn", district_code: "135" },
  { code: "4321", name: "Xã Khai Trung", district_code: "135" },
  { code: "4324", name: "Xã Mường Lai", district_code: "135" },
  { code: "4327", name: "Xã An Lạc", district_code: "135" },
  { code: "4330", name: "Xã Minh Xuân", district_code: "135" },
  { code: "4333", name: "Xã Tô Mậu", district_code: "135" },
  { code: "4336", name: "Xã Tân Lĩnh", district_code: "135" },
  { code: "4339", name: "Xã Yên Thắng", district_code: "135" },
  { code: "4342", name: "Xã Khánh Hoà", district_code: "135" },
  { code: "4345", name: "Xã Vĩnh Lạc", district_code: "135" },
  { code: "4348", name: "Xã Liễu Đô", district_code: "135" },
  { code: "4351", name: "Xã Động Quan", district_code: "135" },
  { code: "4354", name: "Xã Tân Lập", district_code: "135" },
  { code: "4357", name: "Xã Minh Tiến", district_code: "135" },
  { code: "4360", name: "Xã Trúc Lâu", district_code: "135" },
  { code: "4363", name: "Xã Phúc Lợi", district_code: "135" },
  { code: "4366", name: "Xã Phan Thanh", district_code: "135" },
  { code: "4369", name: "Xã An Phú", district_code: "135" },
  { code: "4372", name: "Xã Trung Tâm", district_code: "135" },
  { code: "4375", name: "Thị trấn Mậu A", district_code: "136" },
  { code: "4378", name: "Xã Lang Thíp", district_code: "136" },
  { code: "4381", name: "Xã Lâm Giang", district_code: "136" },
  { code: "4384", name: "Xã Châu Quế Thượng", district_code: "136" },
  { code: "4387", name: "Xã Châu Quế Hạ", district_code: "136" },
  { code: "4390", name: "Xã An Bình", district_code: "136" },
  { code: "4393", name: "Xã Quang Minh", district_code: "136" },
  { code: "4396", name: "Xã Đông An", district_code: "136" },
  { code: "4399", name: "Xã Đông Cuông", district_code: "136" },
  { code: "4402", name: "Xã Phong Dụ Hạ", district_code: "136" },
  { code: "4405", name: "Xã Mậu Đông", district_code: "136" },
  { code: "4408", name: "Xã Ngòi A", district_code: "136" },
  { code: "4411", name: "Xã Xuân Tầm", district_code: "136" },
  { code: "4414", name: "Xã Tân Hợp", district_code: "136" },
  { code: "4417", name: "Xã An Thịnh", district_code: "136" },
  { code: "4420", name: "Xã Yên Thái", district_code: "136" },
  { code: "4423", name: "Xã Phong Dụ Thượng", district_code: "136" },
  { code: "4426", name: "Xã Yên Hợp", district_code: "136" },
  { code: "4429", name: "Xã Đại Sơn", district_code: "136" },
  { code: "4435", name: "Xã Đại Phác", district_code: "136" },
  { code: "4438", name: "Xã Yên Phú", district_code: "136" },
  { code: "4441", name: "Xã Xuân Ái", district_code: "136" },
  { code: "4447", name: "Xã Viễn Sơn", district_code: "136" },
  { code: "4450", name: "Xã Mỏ Vàng", district_code: "136" },
  { code: "4453", name: "Xã Nà Hẩu", district_code: "136" },
  { code: "4456", name: "Thị trấn Mù Căng Chải", district_code: "137" },
  { code: "4459", name: "Xã Hồ Bốn", district_code: "137" },
  { code: "4462", name: "Xã Nậm Có", district_code: "137" },
  { code: "4465", name: "Xã Khao Mang", district_code: "137" },
  { code: "4468", name: "Xã Mồ Dề", district_code: "137" },
  { code: "4471", name: "Xã Chế Cu Nha", district_code: "137" },
  { code: "4474", name: "Xã Lao Chải", district_code: "137" },
  { code: "4477", name: "Xã Kim Nọi", district_code: "137" },
  { code: "4480", name: "Xã Cao Phạ", district_code: "137" },
  { code: "4483", name: "Xã La Pán Tẩn", district_code: "137" },
  { code: "4486", name: "Xã Dế Su Phình", district_code: "137" },
  { code: "4489", name: "Xã Chế Tạo", district_code: "137" },
  { code: "4492", name: "Xã Púng Luông", district_code: "137" },
  { code: "4495", name: "Xã Nậm Khắt", district_code: "137" },
  { code: "4498", name: "Thị trấn Cổ Phúc", district_code: "138" },
  { code: "4501", name: "Xã Tân Đồng", district_code: "138" },
  { code: "4504", name: "Xã Báo Đáp", district_code: "138" },
  { code: "4510", name: "Xã Thành Thịnh", district_code: "138" },
  { code: "4513", name: "Xã Hòa Cuông", district_code: "138" },
  { code: "4516", name: "Xã Minh Quán", district_code: "138" },
  { code: "4519", name: "Xã Quy Mông", district_code: "138" },
  { code: "4522", name: "Xã Cường Thịnh", district_code: "138" },
  { code: "4525", name: "Xã Kiên Thành", district_code: "138" },
  { code: "4531", name: "Xã Y Can", district_code: "138" },
  { code: "4537", name: "Xã Lương Thịnh", district_code: "138" },
  { code: "4564", name: "Xã Việt Cường", district_code: "138" },
  { code: "4567", name: "Xã Minh Quân", district_code: "138" },
  { code: "4570", name: "Xã Hồng Ca", district_code: "138" },
  { code: "4573", name: "Xã Hưng Thịnh", district_code: "138" },
  { code: "4576", name: "Xã Hưng Khánh", district_code: "138" },
  { code: "4579", name: "Xã Việt Hồng", district_code: "138" },
  { code: "4582", name: "Xã Vân Hội", district_code: "138" },
  { code: "4585", name: "Thị trấn Trạm Tấu", district_code: "139" },
  { code: "4588", name: "Xã Túc Đán", district_code: "139" },
  { code: "4591", name: "Xã Pá Lau", district_code: "139" },
  { code: "4594", name: "Xã Xà Hồ", district_code: "139" },
  { code: "4597", name: "Xã Phình Hồ", district_code: "139" },
  { code: "4600", name: "Xã Trạm Tấu", district_code: "139" },
  { code: "4603", name: "Xã Tà Si Láng", district_code: "139" },
  { code: "4606", name: "Xã Pá Hu", district_code: "139" },
  { code: "4609", name: "Xã Làng Nhì", district_code: "139" },
  { code: "4612", name: "Xã Bản Công", district_code: "139" },
  { code: "4615", name: "Xã Bản Mù", district_code: "139" },
  { code: "4618", name: "Xã Hát Lìu", district_code: "139" },
  { code: "4621", name: "Thị trấn NT Liên Sơn", district_code: "140" },
  { code: "4627", name: "Thị trấn NT Trần Phú", district_code: "140" },
  { code: "4630", name: "Xã Tú Lệ", district_code: "140" },
  { code: "4633", name: "Xã Nậm Búng", district_code: "140" },
  { code: "4636", name: "Xã Gia Hội", district_code: "140" },
  { code: "4639", name: "Xã Sùng Đô", district_code: "140" },
  { code: "4642", name: "Xã Nậm Mười", district_code: "140" },
  { code: "4645", name: "Xã An Lương", district_code: "140" },
  { code: "4648", name: "Xã Nậm Lành", district_code: "140" },
  { code: "4651", name: "Xã Sơn Lương", district_code: "140" },
  { code: "4654", name: "Xã Suối Quyền", district_code: "140" },
  { code: "4657", name: "Xã Suối Giàng", district_code: "140" },
  { code: "4666", name: "Xã Nghĩa Sơn", district_code: "140" },
  { code: "4669", name: "Xã Suối Bu", district_code: "140" },
  { code: "4672", name: "Thị trấn Sơn Thịnh", district_code: "140" },
  { code: "4687", name: "Xã Đại Lịch", district_code: "140" },
  { code: "4690", name: "Xã Đồng Khê", district_code: "140" },
  { code: "4693", name: "Xã Cát Thịnh", district_code: "140" },
  { code: "4696", name: "Xã Tân Thịnh", district_code: "140" },
  { code: "4699", name: "Xã Chấn Thịnh", district_code: "140" },
  { code: "4702", name: "Xã Bình Thuận", district_code: "140" },
  { code: "4705", name: "Xã Thượng Bằng La", district_code: "140" },
  { code: "4708", name: "Xã Minh An", district_code: "140" },
  { code: "4711", name: "Xã Nghĩa Tâm", district_code: "140" },
  { code: "4714", name: "Thị trấn Yên Bình", district_code: "141" },
  { code: "4717", name: "Thị trấn Thác Bà", district_code: "141" },
  { code: "4720", name: "Xã Xuân Long", district_code: "141" },
  { code: "4726", name: "Xã Cảm Nhân", district_code: "141" },
  { code: "4729", name: "Xã Ngọc Chấn", district_code: "141" },
  { code: "4732", name: "Xã Tân Nguyên", district_code: "141" },
  { code: "4735", name: "Xã Phúc Ninh", district_code: "141" },
  { code: "4738", name: "Xã Bảo Ái", district_code: "141" },
  { code: "4741", name: "Xã Mỹ Gia", district_code: "141" },
  { code: "4744", name: "Xã Xuân Lai", district_code: "141" },
  { code: "4747", name: "Xã Mông Sơn", district_code: "141" },
  { code: "4750", name: "Xã Cảm Ân", district_code: "141" },
  { code: "4753", name: "Xã Yên Thành", district_code: "141" },
  { code: "4756", name: "Xã Tân Hương", district_code: "141" },
  { code: "4759", name: "Xã Phúc An", district_code: "141" },
  { code: "4762", name: "Xã Bạch Hà", district_code: "141" },
  { code: "4765", name: "Xã Vũ Linh", district_code: "141" },
  { code: "4768", name: "Xã Đại Đồng", district_code: "141" },
  { code: "4771", name: "Xã Vĩnh Kiên", district_code: "141" },
  { code: "4777", name: "Xã Thịnh Hưng", district_code: "141" },
  { code: "4780", name: "Xã Hán Đà", district_code: "141" },
  { code: "4783", name: "Xã Phú Thịnh", district_code: "141" },
  { code: "4786", name: "Xã Đại Minh", district_code: "141" },
  { code: "4789", name: "Phường Thái Bình", district_code: "148" },
  { code: "4792", name: "Phường Tân Hòa", district_code: "148" },
  { code: "4795", name: "Phường Thịnh Lang", district_code: "148" },
  { code: "4798", name: "Phường Hữu Nghị", district_code: "148" },
  { code: "4801", name: "Phường Tân Thịnh", district_code: "148" },
  { code: "4804", name: "Phường Đồng Tiến", district_code: "148" },
  { code: "4807", name: "Phường Phương Lâm", district_code: "148" },
  { code: "4813", name: "Xã Yên Mông", district_code: "148" },
  { code: "4816", name: "Phường Quỳnh Lâm", district_code: "148" },
  { code: "4819", name: "Phường Dân Chủ", district_code: "148" },
  { code: "4825", name: "Xã Hòa Bình", district_code: "148" },
  { code: "4828", name: "Phường Thống Nhất", district_code: "148" },
  { code: "4894", name: "Phường Kỳ Sơn", district_code: "148" },
  { code: "4897", name: "Xã Thịnh Minh", district_code: "148" },
  { code: "4903", name: "Xã Hợp Thành", district_code: "148" },
  { code: "4906", name: "Xã Quang Tiến", district_code: "148" },
  { code: "4912", name: "Xã Mông Hóa", district_code: "148" },
  { code: "4918", name: "Phường Trung Minh", district_code: "148" },
  { code: "4921", name: "Xã Độc Lập", district_code: "148" },
  { code: "4831", name: "Thị trấn Đà Bắc", district_code: "150" },
  { code: "4834", name: "Xã Nánh Nghê", district_code: "150" },
  { code: "4840", name: "Xã Giáp Đắt", district_code: "150" },
  { code: "4846", name: "Xã Mường Chiềng", district_code: "150" },
  { code: "4849", name: "Xã Tân Pheo", district_code: "150" },
  { code: "4852", name: "Xã Đồng Chum", district_code: "150" },
  { code: "4855", name: "Xã Tân Minh", district_code: "150" },
  { code: "4858", name: "Xã Đoàn Kết", district_code: "150" },
  { code: "4861", name: "Xã Đồng Ruộng", district_code: "150" },
  { code: "4867", name: "Xã Tú Lý", district_code: "150" },
  { code: "4870", name: "Xã Trung Thành", district_code: "150" },
  { code: "4873", name: "Xã Yên Hòa", district_code: "150" },
  { code: "4876", name: "Xã Cao Sơn", district_code: "150" },
  { code: "4879", name: "Xã Toàn Sơn", district_code: "150" },
  { code: "4885", name: "Xã Hiền Lương", district_code: "150" },
  { code: "4888", name: "Xã Tiền Phong", district_code: "150" },
  { code: "4891", name: "Xã Vầy Nưa", district_code: "150" },
  { code: "4924", name: "Thị trấn Lương Sơn", district_code: "152" },
  { code: "4942", name: "Xã Lâm Sơn", district_code: "152" },
  { code: "4945", name: "Xã Hòa Sơn", district_code: "152" },
  { code: "4951", name: "Xã Tân Vinh", district_code: "152" },
  { code: "4954", name: "Xã Nhuận Trạch", district_code: "152" },
  { code: "4957", name: "Xã Cao Sơn", district_code: "152" },
  { code: "4960", name: "Xã Cư Yên", district_code: "152" },
  { code: "4969", name: "Xã Liên Sơn", district_code: "152" },
  { code: "5008", name: "Xã Cao Dương", district_code: "152" },
  { code: "5041", name: "Xã Thanh Sơn", district_code: "152" },
  { code: "5047", name: "Xã Thanh Cao", district_code: "152" },
  { code: "4978", name: "Thị trấn Bo", district_code: "153" },
  { code: "4984", name: "Xã Đú Sáng", district_code: "153" },
  { code: "4987", name: "Xã Hùng Sơn", district_code: "153" },
  { code: "4990", name: "Xã Bình Sơn", district_code: "153" },
  { code: "4999", name: "Xã Tú Sơn", district_code: "153" },
  { code: "5005", name: "Xã Vĩnh Tiến", district_code: "153" },
  { code: "5014", name: "Xã Đông Bắc", district_code: "153" },
  { code: "5017", name: "Xã Xuân Thủy", district_code: "153" },
  { code: "5026", name: "Xã Vĩnh Đồng", district_code: "153" },
  { code: "5035", name: "Xã Kim Lập", district_code: "153" },
  { code: "5038", name: "Xã Hợp Tiến", district_code: "153" },
  { code: "5065", name: "Xã Kim Bôi", district_code: "153" },
  { code: "5068", name: "Xã Nam Thượng", district_code: "153" },
  { code: "5077", name: "Xã Cuối Hạ", district_code: "153" },
  { code: "5080", name: "Xã Sào Báy", district_code: "153" },
  { code: "5083", name: "Xã Mi Hòa", district_code: "153" },
  { code: "5086", name: "Xã Nuông Dăm", district_code: "153" },
  { code: "5089", name: "Thị trấn Cao Phong", district_code: "154" },
  { code: "5092", name: "Xã Bình Thanh", district_code: "154" },
  { code: "5095", name: "Xã Thung Nai", district_code: "154" },
  { code: "5098", name: "Xã Bắc Phong", district_code: "154" },
  { code: "5101", name: "Xã Thu Phong", district_code: "154" },
  { code: "5104", name: "Xã Hợp Phong", district_code: "154" },
  { code: "5110", name: "Xã Tây Phong", district_code: "154" },
  { code: "5116", name: "Xã Dũng Phong", district_code: "154" },
  { code: "5119", name: "Xã Nam Phong", district_code: "154" },
  { code: "5125", name: "Xã Thạch Yên", district_code: "154" },
  { code: "5128", name: "Thị trấn Mãn Đức", district_code: "155" },
  { code: "5134", name: "Xã Suối Hoa", district_code: "155" },
  { code: "5137", name: "Xã Phú Vinh", district_code: "155" },
  { code: "5140", name: "Xã Phú Cường", district_code: "155" },
  { code: "5143", name: "Xã Mỹ Hòa", district_code: "155" },
  { code: "5152", name: "Xã Quyết Chiến", district_code: "155" },
  { code: "5158", name: "Xã Phong Phú", district_code: "155" },
  { code: "5164", name: "Xã Tử Nê", district_code: "155" },
  { code: "5167", name: "Xã Thanh Hối", district_code: "155" },
  { code: "5170", name: "Xã Ngọc Mỹ", district_code: "155" },
  { code: "5173", name: "Xã Đông Lai", district_code: "155" },
  { code: "5176", name: "Xã Vân Sơn", district_code: "155" },
  { code: "5182", name: "Xã Nhân Mỹ", district_code: "155" },
  { code: "5191", name: "Xã Lỗ Sơn", district_code: "155" },
  { code: "5194", name: "Xã Ngổ Luông", district_code: "155" },
  { code: "5197", name: "Xã Gia Mô", district_code: "155" },
  { code: "4882", name: "Xã Tân Thành", district_code: "156" },
  { code: "5200", name: "Thị trấn Mai Châu", district_code: "156" },
  { code: "5206", name: "Xã Sơn Thủy", district_code: "156" },
  { code: "5209", name: "Xã Pà Cò", district_code: "156" },
  { code: "5212", name: "Xã Hang Kia", district_code: "156" },
  { code: "5221", name: "Xã Đồng Tân", district_code: "156" },
  { code: "5224", name: "Xã Cun Pheo", district_code: "156" },
  { code: "5227", name: "Xã Bao La", district_code: "156" },
  { code: "5233", name: "Xã Tòng Đậu", district_code: "156" },
  { code: "5242", name: "Xã Nà Phòn", district_code: "156" },
  { code: "5245", name: "Xã Săm Khóe", district_code: "156" },
  { code: "5248", name: "Xã Chiềng Châu", district_code: "156" },
  { code: "5251", name: "Xã Mai Hạ", district_code: "156" },
  { code: "5254", name: "Xã Thành Sơn", district_code: "156" },
  { code: "5257", name: "Xã Mai Hịch", district_code: "156" },
  { code: "5263", name: "Xã Vạn Mai", district_code: "156" },
  { code: "5266", name: "Thị trấn Vụ Bản", district_code: "157" },
  { code: "5269", name: "Xã Quý Hòa", district_code: "157" },
  { code: "5272", name: "Xã Miền Đồi", district_code: "157" },
  { code: "5275", name: "Xã Mỹ Thành", district_code: "157" },
  { code: "5278", name: "Xã Tuân Đạo", district_code: "157" },
  { code: "5281", name: "Xã Văn Nghĩa", district_code: "157" },
  { code: "5284", name: "Xã Văn Sơn", district_code: "157" },
  { code: "5287", name: "Xã Tân Lập", district_code: "157" },
  { code: "5290", name: "Xã Nhân Nghĩa", district_code: "157" },
  { code: "5293", name: "Xã Thượng Cốc", district_code: "157" },
  { code: "5299", name: "Xã Quyết Thắng", district_code: "157" },
  { code: "5302", name: "Xã Xuất Hóa", district_code: "157" },
  { code: "5305", name: "Xã Yên Phú", district_code: "157" },
  { code: "5308", name: "Xã Bình Hẻm", district_code: "157" },
  { code: "5320", name: "Xã Định Cư", district_code: "157" },
  { code: "5323", name: "Xã Chí Đạo", district_code: "157" },
  { code: "5329", name: "Xã Ngọc Sơn", district_code: "157" },
  { code: "5332", name: "Xã Hương Nhượng", district_code: "157" },
  { code: "5335", name: "Xã Vũ Bình", district_code: "157" },
  { code: "5338", name: "Xã Tự Do", district_code: "157" },
  { code: "5341", name: "Xã Yên Nghiệp", district_code: "157" },
  { code: "5344", name: "Xã Tân Mỹ", district_code: "157" },
  { code: "5347", name: "Xã Ân Nghĩa", district_code: "157" },
  { code: "5350", name: "Xã Ngọc Lâu", district_code: "157" },
  { code: "5353", name: "Thị trấn Hàng Trạm", district_code: "158" },
  { code: "5356", name: "Xã Lạc Sỹ", district_code: "158" },
  { code: "5362", name: "Xã Lạc Lương", district_code: "158" },
  { code: "5365", name: "Xã Bảo Hiệu", district_code: "158" },
  { code: "5368", name: "Xã Đa Phúc", district_code: "158" },
  { code: "5371", name: "Xã Hữu Lợi", district_code: "158" },
  { code: "5374", name: "Xã Lạc Thịnh", district_code: "158" },
  { code: "5380", name: "Xã Đoàn Kết", district_code: "158" },
  { code: "5383", name: "Xã Phú Lai", district_code: "158" },
  { code: "5386", name: "Xã Yên Trị", district_code: "158" },
  { code: "5389", name: "Xã Ngọc Lương", district_code: "158" },
  { code: "4981", name: "Thị trấn Ba Hàng Đồi", district_code: "159" },
  { code: "5392", name: "Thị trấn Chi Nê", district_code: "159" },
  { code: "5395", name: "Xã Phú Nghĩa", district_code: "159" },
  { code: "5398", name: "Xã Phú Thành", district_code: "159" },
  { code: "5404", name: "Xã Hưng Thi", district_code: "159" },
  { code: "5413", name: "Xã Khoan Dụ", district_code: "159" },
  { code: "5419", name: "Xã Đồng Tâm", district_code: "159" },
  { code: "5422", name: "Xã Yên Bồng", district_code: "159" },
  { code: "5425", name: "Xã Thống Nhất", district_code: "159" },
  { code: "5428", name: "Xã An Bình", district_code: "159" },
  { code: "5431", name: "Phường Quán Triều", district_code: "164" },
  { code: "5434", name: "Phường Quang Vinh", district_code: "164" },
  { code: "5437", name: "Phường Túc Duyên", district_code: "164" },
  { code: "5440", name: "Phường Hoàng Văn Thụ", district_code: "164" },
  { code: "5443", name: "Phường Trưng Vương", district_code: "164" },
  { code: "5446", name: "Phường Quang Trung", district_code: "164" },
  { code: "5449", name: "Phường Phan Đình Phùng", district_code: "164" },
  { code: "5452", name: "Phường Tân Thịnh", district_code: "164" },
  { code: "5455", name: "Phường Thịnh Đán", district_code: "164" },
  { code: "5458", name: "Phường Đồng Quang", district_code: "164" },
  { code: "5461", name: "Phường Gia Sàng", district_code: "164" },
  { code: "5464", name: "Phường Tân Lập", district_code: "164" },
  { code: "5467", name: "Phường Cam Giá", district_code: "164" },
  { code: "5470", name: "Phường Phú Xá", district_code: "164" },
  { code: "5473", name: "Phường Hương Sơn", district_code: "164" },
  { code: "5476", name: "Phường Trung Thành", district_code: "164" },
  { code: "5479", name: "Phường Tân Thành", district_code: "164" },
  { code: "5482", name: "Phường Tân Long", district_code: "164" },
  { code: "5485", name: "Xã Phúc Hà", district_code: "164" },
  { code: "5488", name: "Xã Phúc Xuân", district_code: "164" },
  { code: "5491", name: "Xã Quyết Thắng", district_code: "164" },
  { code: "5494", name: "Xã Phúc Trìu", district_code: "164" },
  { code: "5497", name: "Xã Thịnh Đức", district_code: "164" },
  { code: "5500", name: "Phường Tích Lương", district_code: "164" },
  { code: "5503", name: "Xã Tân Cương", district_code: "164" },
  { code: "5653", name: "Xã Sơn Cẩm", district_code: "164" },
  { code: "5659", name: "Phường Chùa Hang", district_code: "164" },
  { code: "5695", name: "Xã Cao Ngạn", district_code: "164" },
  { code: "5701", name: "Xã Linh Sơn", district_code: "164" },
  { code: "5710", name: "Phường Đồng Bẩm", district_code: "164" },
  { code: "5713", name: "Xã Huống Thượng", district_code: "164" },
  { code: "5914", name: "Xã Đồng Liên", district_code: "164" },
  { code: "5506", name: "Phường Lương Sơn", district_code: "165" },
  { code: "5509", name: "Phường Châu Sơn", district_code: "165" },
  { code: "5512", name: "Phường Mỏ Chè", district_code: "165" },
  { code: "5515", name: "Phường Cải Đan", district_code: "165" },
  { code: "5518", name: "Phường Thắng Lợi", district_code: "165" },
  { code: "5521", name: "Phường Phố Cò", district_code: "165" },
  { code: "5527", name: "Xã Tân Quang", district_code: "165" },
  { code: "5528", name: "Phường Bách Quang", district_code: "165" },
  { code: "5530", name: "Xã Bình Sơn", district_code: "165" },
  { code: "5533", name: "Xã Bá Xuyên", district_code: "165" },
  { code: "5539", name: "Xã Linh Thông", district_code: "167" },
  { code: "5542", name: "Xã Lam Vỹ", district_code: "167" },
  { code: "5545", name: "Xã Quy Kỳ", district_code: "167" },
  { code: "5548", name: "Xã Tân Thịnh", district_code: "167" },
  { code: "5551", name: "Xã Kim Phượng", district_code: "167" },
  { code: "5554", name: "Xã Bảo Linh", district_code: "167" },
  { code: "5560", name: "Xã Phúc Chu", district_code: "167" },
  { code: "5563", name: "Xã Tân Dương", district_code: "167" },
  { code: "5566", name: "Xã Phượng Tiến", district_code: "167" },
  { code: "5569", name: "Thị trấn Chợ Chu", district_code: "167" },
  { code: "5572", name: "Xã Đồng Thịnh", district_code: "167" },
  { code: "5575", name: "Xã Định Biên", district_code: "167" },
  { code: "5578", name: "Xã Thanh Định", district_code: "167" },
  { code: "5581", name: "Xã Trung Hội", district_code: "167" },
  { code: "5584", name: "Xã Trung Lương", district_code: "167" },
  { code: "5587", name: "Xã Bình Yên", district_code: "167" },
  { code: "5590", name: "Xã Điềm Mặc", district_code: "167" },
  { code: "5593", name: "Xã Phú Tiến", district_code: "167" },
  { code: "5596", name: "Xã Bộc Nhiêu", district_code: "167" },
  { code: "5599", name: "Xã Sơn Phú", district_code: "167" },
  { code: "5602", name: "Xã Phú Đình", district_code: "167" },
  { code: "5605", name: "Xã Bình Thành", district_code: "167" },
  { code: "5611", name: "Thị trấn Đu", district_code: "168" },
  { code: "5614", name: "Xã Yên Ninh", district_code: "168" },
  { code: "5617", name: "Xã Yên Trạch", district_code: "168" },
  { code: "5620", name: "Xã Yên Đổ", district_code: "168" },
  { code: "5623", name: "Xã Yên Lạc", district_code: "168" },
  { code: "5626", name: "Xã Ôn Lương", district_code: "168" },
  { code: "5629", name: "Xã Động Đạt", district_code: "168" },
  { code: "5632", name: "Xã Phủ Lý", district_code: "168" },
  { code: "5635", name: "Xã Phú Đô", district_code: "168" },
  { code: "5638", name: "Xã Hợp Thành", district_code: "168" },
  { code: "5641", name: "Xã Tức Tranh", district_code: "168" },
  { code: "5644", name: "Thị trấn Giang Tiên", district_code: "168" },
  { code: "5647", name: "Xã Vô Tranh", district_code: "168" },
  { code: "5650", name: "Xã Cổ Lũng", district_code: "168" },
  { code: "5656", name: "Thị trấn Sông Cầu", district_code: "169" },
  { code: "5662", name: "Thị trấn Trại Cau", district_code: "169" },
  { code: "5665", name: "Xã Văn Lăng", district_code: "169" },
  { code: "5668", name: "Xã Tân Long", district_code: "169" },
  { code: "5671", name: "Xã Hòa Bình", district_code: "169" },
  { code: "5674", name: "Xã Quang Sơn", district_code: "169" },
  { code: "5677", name: "Xã Minh Lập", district_code: "169" },
  { code: "5680", name: "Xã Văn Hán", district_code: "169" },
  { code: "5683", name: "Xã Hóa Trung", district_code: "169" },
  { code: "5686", name: "Xã Khe Mo", district_code: "169" },
  { code: "5689", name: "Xã Cây Thị", district_code: "169" },
  { code: "5692", name: "Thị trấn Hóa Thượng", district_code: "169" },
  { code: "5698", name: "Xã Hợp Tiến", district_code: "169" },
  { code: "5707", name: "Xã Nam Hòa", district_code: "169" },
  { code: "5716", name: "Thị trấn Đình Cả", district_code: "170" },
  { code: "5719", name: "Xã Sảng Mộc", district_code: "170" },
  { code: "5722", name: "Xã Nghinh Tường", district_code: "170" },
  { code: "5725", name: "Xã Thần Xa", district_code: "170" },
  { code: "5728", name: "Xã Vũ Chấn", district_code: "170" },
  { code: "5731", name: "Xã Thượng Nung", district_code: "170" },
  { code: "5734", name: "Xã Phú Thượng", district_code: "170" },
  { code: "5737", name: "Xã Cúc Đường", district_code: "170" },
  { code: "5740", name: "Xã La Hiên", district_code: "170" },
  { code: "5743", name: "Xã Lâu Thượng", district_code: "170" },
  { code: "5746", name: "Xã Tràng Xá", district_code: "170" },
  { code: "5749", name: "Xã Phương Giao", district_code: "170" },
  { code: "5752", name: "Xã Liên Minh", district_code: "170" },
  { code: "5755", name: "Xã Dân Tiến", district_code: "170" },
  { code: "5758", name: "Xã Bình Long", district_code: "170" },
  { code: "5761", name: "Thị trấn Hùng Sơn", district_code: "171" },
  { code: "5767", name: "Xã Phúc Lương", district_code: "171" },
  { code: "5770", name: "Xã Minh Tiến", district_code: "171" },
  { code: "5773", name: "Xã Yên Lãng", district_code: "171" },
  { code: "5776", name: "Xã Đức Lương", district_code: "171" },
  { code: "5779", name: "Xã Phú Cường", district_code: "171" },
  { code: "5785", name: "Xã Phú Lạc", district_code: "171" },
  { code: "5788", name: "Xã Tân Linh", district_code: "171" },
  { code: "5791", name: "Xã Phú Thịnh", district_code: "171" },
  { code: "5794", name: "Xã Phục Linh", district_code: "171" },
  { code: "5797", name: "Xã Phú Xuyên", district_code: "171" },
  { code: "5800", name: "Xã Bản Ngoại", district_code: "171" },
  { code: "5803", name: "Xã Tiên Hội", district_code: "171" },
  { code: "5809", name: "Xã Cù Vân", district_code: "171" },
  { code: "5812", name: "Xã Hà Thượng", district_code: "171" },
  { code: "5815", name: "Xã La Bằng", district_code: "171" },
  { code: "5818", name: "Xã Hoàng Nông", district_code: "171" },
  { code: "5821", name: "Xã Khôi Kỳ", district_code: "171" },
  { code: "5824", name: "Xã An Khánh", district_code: "171" },
  { code: "5827", name: "Xã Tân Thái", district_code: "171" },
  { code: "5830", name: "Xã Bình Thuận", district_code: "171" },
  { code: "5833", name: "Xã Lục Ba", district_code: "171" },
  { code: "5836", name: "Xã Mỹ Yên", district_code: "171" },
  { code: "5842", name: "Xã Văn Yên", district_code: "171" },
  { code: "5845", name: "Xã Vạn Phú", district_code: "171" },
  { code: "5848", name: "Xã Cát Nê", district_code: "171" },
  { code: "5851", name: "Thị trấn Quân Chu", district_code: "171" },
  { code: "5854", name: "Phường Bãi Bông", district_code: "172" },
  { code: "5857", name: "Phường Bắc Sơn", district_code: "172" },
  { code: "5860", name: "Phường Ba Hàng", district_code: "172" },
  { code: "5863", name: "Xã Phúc Tân", district_code: "172" },
  { code: "5866", name: "Xã Phúc Thuận", district_code: "172" },
  { code: "5869", name: "Phường Hồng Tiến", district_code: "172" },
  { code: "5872", name: "Xã Minh Đức", district_code: "172" },
  { code: "5875", name: "Phường Đắc Sơn", district_code: "172" },
  { code: "5878", name: "Phường Đồng Tiến", district_code: "172" },
  { code: "5881", name: "Xã Thành Công", district_code: "172" },
  { code: "5884", name: "Phường Tiên Phong", district_code: "172" },
  { code: "5887", name: "Xã Vạn Phái", district_code: "172" },
  { code: "5890", name: "Phường Nam Tiến", district_code: "172" },
  { code: "5893", name: "Phường Tân Hương", district_code: "172" },
  { code: "5896", name: "Phường Đông Cao", district_code: "172" },
  { code: "5899", name: "Phường Trung Thành", district_code: "172" },
  { code: "5902", name: "Phường Tân Phú", district_code: "172" },
  { code: "5905", name: "Phường Thuận Thành", district_code: "172" },
  { code: "5908", name: "Thị trấn Hương Sơn", district_code: "173" },
  { code: "5911", name: "Xã Bàn Đạt", district_code: "173" },
  { code: "5917", name: "Xã Tân Khánh", district_code: "173" },
  { code: "5920", name: "Xã Tân Kim", district_code: "173" },
  { code: "5923", name: "Xã Tân Thành", district_code: "173" },
  { code: "5926", name: "Xã Đào Xá", district_code: "173" },
  { code: "5929", name: "Xã Bảo Lý", district_code: "173" },
  { code: "5932", name: "Xã Thượng Đình", district_code: "173" },
  { code: "5935", name: "Xã Tân Hòa", district_code: "173" },
  { code: "5938", name: "Xã Nhã Lộng", district_code: "173" },
  { code: "5941", name: "Xã Điềm Thụy", district_code: "173" },
  { code: "5944", name: "Xã Xuân Phương", district_code: "173" },
  { code: "5947", name: "Xã Tân Đức", district_code: "173" },
  { code: "5950", name: "Xã Úc Kỳ", district_code: "173" },
  { code: "5953", name: "Xã Lương Phú", district_code: "173" },
  { code: "5956", name: "Xã Nga My", district_code: "173" },
  { code: "5959", name: "Xã Kha Sơn", district_code: "173" },
  { code: "5962", name: "Xã Thanh Ninh", district_code: "173" },
  { code: "5965", name: "Xã Dương Thành", district_code: "173" },
  { code: "5968", name: "Xã Hà Châu", district_code: "173" },
  { code: "5971", name: "Phường Hoàng Văn Thụ", district_code: "178" },
  { code: "5974", name: "Phường Tam Thanh", district_code: "178" },
  { code: "5977", name: "Phường Vĩnh Trại", district_code: "178" },
  { code: "5980", name: "Phường Đông Kinh", district_code: "178" },
  { code: "5983", name: "Phường Chi Lăng", district_code: "178" },
  { code: "5986", name: "Xã Hoàng Đồng", district_code: "178" },
  { code: "5989", name: "Xã Quảng Lạc", district_code: "178" },
  { code: "5992", name: "Xã Mai Pha", district_code: "178" },
  { code: "5998", name: "Xã Khánh Long", district_code: "180" },
  { code: "6001", name: "Xã Đoàn Kết", district_code: "180" },
  { code: "6004", name: "Xã Quốc Khánh", district_code: "180" },
  { code: "6010", name: "Xã Cao Minh", district_code: "180" },
  { code: "6013", name: "Xã Chí Minh", district_code: "180" },
  { code: "6016", name: "Xã Tri Phương", district_code: "180" },
  { code: "6019", name: "Xã Tân Tiến", district_code: "180" },
  { code: "6022", name: "Xã Tân Yên", district_code: "180" },
  { code: "6025", name: "Xã Đội Cấn", district_code: "180" },
  { code: "6028", name: "Xã Tân Minh", district_code: "180" },
  { code: "6031", name: "Xã Kim Đồng", district_code: "180" },
  { code: "6034", name: "Xã Chi Lăng", district_code: "180" },
  { code: "6037", name: "Xã Trung Thành", district_code: "180" },
  { code: "6040", name: "Thị trấn Thất Khê", district_code: "180" },
  { code: "6043", name: "Xã Đào Viên", district_code: "180" },
  { code: "6046", name: "Xã Đề Thám", district_code: "180" },
  { code: "6049", name: "Xã Kháng Chiến", district_code: "180" },
  { code: "6055", name: "Xã Hùng Sơn", district_code: "180" },
  { code: "6058", name: "Xã Quốc Việt", district_code: "180" },
  { code: "6061", name: "Xã Hùng Việt", district_code: "180" },
  { code: "6067", name: "Xã Hưng Đạo", district_code: "181" },
  { code: "6070", name: "Xã Vĩnh Yên", district_code: "181" },
  { code: "6073", name: "Xã Hoa Thám", district_code: "181" },
  { code: "6076", name: "Xã Quý Hòa", district_code: "181" },
  { code: "6079", name: "Xã Hồng Phong", district_code: "181" },
  { code: "6082", name: "Xã Yên Lỗ", district_code: "181" },
  { code: "6085", name: "Xã Thiện Hòa", district_code: "181" },
  { code: "6088", name: "Xã Quang Trung", district_code: "181" },
  { code: "6091", name: "Xã Thiện Thuật", district_code: "181" },
  { code: "6094", name: "Xã Minh Khai", district_code: "181" },
  { code: "6097", name: "Xã Thiện Long", district_code: "181" },
  { code: "6100", name: "Xã Hoàng Văn Thụ", district_code: "181" },
  { code: "6103", name: "Xã Hòa Bình", district_code: "181" },
  { code: "6106", name: "Xã Mông Ân", district_code: "181" },
  { code: "6109", name: "Xã Tân Hòa", district_code: "181" },
  { code: "6112", name: "Thị trấn Bình Gia", district_code: "181" },
  { code: "6115", name: "Xã Hồng Thái", district_code: "181" },
  { code: "6118", name: "Xã Bình La", district_code: "181" },
  { code: "6121", name: "Xã Tân Văn", district_code: "181" },
  { code: "6124", name: "Thị trấn Na Sầm", district_code: "182" },
  { code: "6127", name: "Xã Trùng Khánh", district_code: "182" },
  { code: "6133", name: "Xã Bắc La", district_code: "182" },
  { code: "6136", name: "Xã Thụy Hùng", district_code: "182" },
  { code: "6139", name: "Xã Bắc Hùng", district_code: "182" },
  { code: "6142", name: "Xã Tân Tác", district_code: "182" },
  { code: "6148", name: "Xã Thanh Long", district_code: "182" },
  { code: "6151", name: "Xã Hội Hoan", district_code: "182" },
  { code: "6154", name: "Xã Bắc Việt", district_code: "182" },
  { code: "6157", name: "Xã Hoàng Việt", district_code: "182" },
  { code: "6160", name: "Xã Gia Miễn", district_code: "182" },
  { code: "6163", name: "Xã Thành Hòa", district_code: "182" },
  { code: "6166", name: "Xã Tân Thanh", district_code: "182" },
  { code: "6172", name: "Xã Tân Mỹ", district_code: "182" },
  { code: "6175", name: "Xã Hồng Thái", district_code: "182" },
  { code: "6178", name: "Xã Hoàng Văn Thụ", district_code: "182" },
  { code: "6181", name: "Xã Nhạc Kỳ", district_code: "182" },
  { code: "6184", name: "Thị trấn Đồng Đăng", district_code: "183" },
  { code: "6187", name: "Thị trấn Cao Lộc", district_code: "183" },
  { code: "6190", name: "Xã Bảo Lâm", district_code: "183" },
  { code: "6193", name: "Xã Thanh Lòa", district_code: "183" },
  { code: "6196", name: "Xã Cao Lâu", district_code: "183" },
  { code: "6199", name: "Xã Thạch Đạn", district_code: "183" },
  { code: "6202", name: "Xã Xuất Lễ", district_code: "183" },
  { code: "6205", name: "Xã Hồng Phong", district_code: "183" },
  { code: "6208", name: "Xã Thụy Hùng", district_code: "183" },
  { code: "6211", name: "Xã Lộc Yên", district_code: "183" },
  { code: "6214", name: "Xã Phú Xá", district_code: "183" },
  { code: "6217", name: "Xã Bình Trung", district_code: "183" },
  { code: "6220", name: "Xã Hải Yến", district_code: "183" },
  { code: "6223", name: "Xã Hòa Cư", district_code: "183" },
  { code: "6226", name: "Xã Hợp Thành", district_code: "183" },
  { code: "6232", name: "Xã Công Sơn", district_code: "183" },
  { code: "6235", name: "Xã Gia Cát", district_code: "183" },
  { code: "6238", name: "Xã Mẫu Sơn", district_code: "183" },
  { code: "6241", name: "Xã Xuân Long", district_code: "183" },
  { code: "6244", name: "Xã Tân Liên", district_code: "183" },
  { code: "6247", name: "Xã Yên Trạch", district_code: "183" },
  { code: "6250", name: "Xã Tân Thành", district_code: "183" },
  { code: "6253", name: "Thị trấn Văn Quan", district_code: "184" },
  { code: "6256", name: "Xã Trấn Ninh", district_code: "184" },
  { code: "6268", name: "Xã Liên Hội", district_code: "184" },
  { code: "6274", name: "Xã Hòa Bình", district_code: "184" },
  { code: "6277", name: "Xã Tú Xuyên", district_code: "184" },
  { code: "6280", name: "Xã Điềm He", district_code: "184" },
  { code: "6283", name: "Xã An Sơn", district_code: "184" },
  { code: "6286", name: "Xã Khánh Khê", district_code: "184" },
  { code: "6292", name: "Xã Lương Năng", district_code: "184" },
  { code: "6298", name: "Xã Bình Phúc", district_code: "184" },
  { code: "6307", name: "Xã Tân Đoàn", district_code: "184" },
  { code: "6313", name: "Xã Tri Lễ", district_code: "184" },
  { code: "6316", name: "Xã Tràng Phái", district_code: "184" },
  { code: "6319", name: "Xã Yên Phúc", district_code: "184" },
  { code: "6322", name: "Xã Hữu Lễ", district_code: "184" },
  { code: "6325", name: "Thị trấn Bắc Sơn", district_code: "185" },
  { code: "6328", name: "Xã Long Đống", district_code: "185" },
  { code: "6331", name: "Xã Vạn Thủy", district_code: "185" },
  { code: "6337", name: "Xã Đồng ý", district_code: "185" },
  { code: "6340", name: "Xã Tân Tri", district_code: "185" },
  { code: "6343", name: "Xã Bắc Quỳnh", district_code: "185" },
  { code: "6349", name: "Xã Hưng Vũ", district_code: "185" },
  { code: "6352", name: "Xã Tân Lập", district_code: "185" },
  { code: "6355", name: "Xã Vũ Sơn", district_code: "185" },
  { code: "6358", name: "Xã Chiêu Vũ", district_code: "185" },
  { code: "6361", name: "Xã Tân Hương", district_code: "185" },
  { code: "6364", name: "Xã Chiến Thắng", district_code: "185" },
  { code: "6367", name: "Xã Vũ Lăng", district_code: "185" },
  { code: "6370", name: "Xã Trấn Yên", district_code: "185" },
  { code: "6373", name: "Xã Vũ Lễ", district_code: "185" },
  { code: "6376", name: "Xã Nhất Hòa", district_code: "185" },
  { code: "6379", name: "Xã Tân Thành", district_code: "185" },
  { code: "6382", name: "Xã Nhất Tiến", district_code: "185" },
  { code: "6385", name: "Thị trấn Hữu Lũng", district_code: "186" },
  { code: "6388", name: "Xã Hữu Liên", district_code: "186" },
  { code: "6391", name: "Xã Yên Bình", district_code: "186" },
  { code: "6394", name: "Xã Quyết Thắng", district_code: "186" },
  { code: "6397", name: "Xã Hòa Bình", district_code: "186" },
  { code: "6400", name: "Xã Yên Thịnh", district_code: "186" },
  { code: "6403", name: "Xã Yên Sơn", district_code: "186" },
  { code: "6406", name: "Xã Thiện Tân", district_code: "186" },
  { code: "6412", name: "Xã Yên Vượng", district_code: "186" },
  { code: "6415", name: "Xã Minh Tiến", district_code: "186" },
  { code: "6418", name: "Xã Nhật Tiến", district_code: "186" },
  { code: "6421", name: "Xã Thanh Sơn", district_code: "186" },
  { code: "6424", name: "Xã Đồng Tân", district_code: "186" },
  { code: "6427", name: "Xã Cai Kinh", district_code: "186" },
  { code: "6430", name: "Xã Hòa Lạc", district_code: "186" },
  { code: "6433", name: "Xã Vân Nham", district_code: "186" },
  { code: "6436", name: "Xã Đồng Tiến", district_code: "186" },
  { code: "6442", name: "Xã Tân Thành", district_code: "186" },
  { code: "6445", name: "Xã Hòa Sơn", district_code: "186" },
  { code: "6448", name: "Xã Minh Sơn", district_code: "186" },
  { code: "6451", name: "Xã Hồ Sơn", district_code: "186" },
  { code: "6457", name: "Xã Minh Hòa", district_code: "186" },
  { code: "6460", name: "Xã Hòa Thắng", district_code: "186" },
  { code: "6463", name: "Thị trấn Đồng Mỏ", district_code: "187" },
  { code: "6466", name: "Thị trấn Chi Lăng", district_code: "187" },
  { code: "6469", name: "Xã Vân An", district_code: "187" },
  { code: "6472", name: "Xã Vân Thủy", district_code: "187" },
  { code: "6475", name: "Xã Gia Lộc", district_code: "187" },
  { code: "6478", name: "Xã Bắc Thủy", district_code: "187" },
  { code: "6481", name: "Xã Chiến Thắng", district_code: "187" },
  { code: "6484", name: "Xã Mai Sao", district_code: "187" },
  { code: "6487", name: "Xã Bằng Hữu", district_code: "187" },
  { code: "6490", name: "Xã Thượng Cường", district_code: "187" },
  { code: "6493", name: "Xã Bằng Mạc", district_code: "187" },
  { code: "6496", name: "Xã Nhân Lý", district_code: "187" },
  { code: "6499", name: "Xã Lâm Sơn", district_code: "187" },
  { code: "6502", name: "Xã Liên Sơn", district_code: "187" },
  { code: "6505", name: "Xã Vạn Linh", district_code: "187" },
  { code: "6508", name: "Xã Hòa Bình", district_code: "187" },
  { code: "6514", name: "Xã Hữu Kiên", district_code: "187" },
  { code: "6517", name: "Xã Quan Sơn", district_code: "187" },
  { code: "6520", name: "Xã Y Tịch", district_code: "187" },
  { code: "6523", name: "Xã Chi Lăng", district_code: "187" },
  { code: "6526", name: "Thị trấn Na Dương", district_code: "188" },
  { code: "6529", name: "Thị trấn Lộc Bình", district_code: "188" },
  { code: "6532", name: "Xã Mẫu Sơn", district_code: "188" },
  { code: "6541", name: "Xã Yên Khoái", district_code: "188" },
  { code: "6544", name: "Xã Khánh Xuân", district_code: "188" },
  { code: "6547", name: "Xã Tú Mịch", district_code: "188" },
  { code: "6550", name: "Xã Hữu Khánh", district_code: "188" },
  { code: "6553", name: "Xã Đồng Bục", district_code: "188" },
  { code: "6559", name: "Xã Tam Gia", district_code: "188" },
  { code: "6562", name: "Xã Tú Đoạn", district_code: "188" },
  { code: "6565", name: "Xã Khuất Xá", district_code: "188" },
  { code: "6577", name: "Xã Thống Nhất", district_code: "188" },
  { code: "6589", name: "Xã Sàn Viên", district_code: "188" },
  { code: "6592", name: "Xã Đông Quan", district_code: "188" },
  { code: "6595", name: "Xã Minh Hiệp", district_code: "188" },
  { code: "6598", name: "Xã Hữu Lân", district_code: "188" },
  { code: "6601", name: "Xã Lợi Bác", district_code: "188" },
  { code: "6604", name: "Xã Nam Quan", district_code: "188" },
  { code: "6607", name: "Xã Xuân Dương", district_code: "188" },
  { code: "6610", name: "Xã Ái Quốc", district_code: "188" },
  { code: "6613", name: "Thị trấn Đình Lập", district_code: "189" },
  { code: "6616", name: "Thị trấn NT Thái Bình", district_code: "189" },
  { code: "6619", name: "Xã Bắc Xa", district_code: "189" },
  { code: "6622", name: "Xã Bính Xá", district_code: "189" },
  { code: "6625", name: "Xã Kiên Mộc", district_code: "189" },
  { code: "6628", name: "Xã Đình Lập", district_code: "189" },
  { code: "6631", name: "Xã Thái Bình", district_code: "189" },
  { code: "6634", name: "Xã Cường Lợi", district_code: "189" },
  { code: "6637", name: "Xã Châu Sơn", district_code: "189" },
  { code: "6640", name: "Xã Lâm Ca", district_code: "189" },
  { code: "6643", name: "Xã Đồng Thắng", district_code: "189" },
  { code: "6646", name: "Xã Bắc Lãng", district_code: "189" },
  { code: "6649", name: "Phường Hà Khánh", district_code: "193" },
  { code: "6652", name: "Phường Hà Phong", district_code: "193" },
  { code: "6655", name: "Phường Hà Khẩu", district_code: "193" },
  { code: "6658", name: "Phường Cao Xanh", district_code: "193" },
  { code: "6661", name: "Phường Giếng Đáy", district_code: "193" },
  { code: "6664", name: "Phường Hà Tu", district_code: "193" },
  { code: "6667", name: "Phường Hà Trung", district_code: "193" },
  { code: "6670", name: "Phường Hà Lầm", district_code: "193" },
  { code: "6673", name: "Phường Bãi Cháy", district_code: "193" },
  { code: "6676", name: "Phường Cao Thắng", district_code: "193" },
  { code: "6679", name: "Phường Hùng Thắng", district_code: "193" },
  { code: "6685", name: "Phường Trần Hưng Đạo", district_code: "193" },
  { code: "6688", name: "Phường Hồng Hải", district_code: "193" },
  { code: "6691", name: "Phường Hồng Gai", district_code: "193" },
  { code: "6694", name: "Phường Bạch Đằng", district_code: "193" },
  { code: "6697", name: "Phường Hồng Hà", district_code: "193" },
  { code: "6700", name: "Phường Tuần Châu", district_code: "193" },
  { code: "6703", name: "Phường Việt Hưng", district_code: "193" },
  { code: "6706", name: "Phường Đại Yên", district_code: "193" },
  { code: "7030", name: "Phường Hoành Bồ", district_code: "193" },
  { code: "7033", name: "Xã Kỳ Thượng", district_code: "193" },
  { code: "7036", name: "Xã Đồng Sơn", district_code: "193" },
  { code: "7039", name: "Xã Tân Dân", district_code: "193" },
  { code: "7042", name: "Xã Đồng Lâm", district_code: "193" },
  { code: "7045", name: "Xã Hòa Bình", district_code: "193" },
  { code: "7048", name: "Xã Vũ Oai", district_code: "193" },
  { code: "7051", name: "Xã Dân Chủ", district_code: "193" },
  { code: "7054", name: "Xã Quảng La", district_code: "193" },
  { code: "7057", name: "Xã Bằng Cả", district_code: "193" },
  { code: "7060", name: "Xã Thống Nhất", district_code: "193" },
  { code: "7063", name: "Xã Sơn Dương", district_code: "193" },
  { code: "7066", name: "Xã Lê Lợi", district_code: "193" },
  { code: "6709", name: "Phường Ka Long", district_code: "194" },
  { code: "6712", name: "Phường Trần Phú", district_code: "194" },
  { code: "6715", name: "Phường Ninh Dương", district_code: "194" },
  { code: "6721", name: "Phường Trà Cổ", district_code: "194" },
  { code: "6724", name: "Xã Hải Sơn", district_code: "194" },
  { code: "6727", name: "Xã Bắc Sơn", district_code: "194" },
  { code: "6730", name: "Xã Hải Đông", district_code: "194" },
  { code: "6733", name: "Xã Hải Tiến", district_code: "194" },
  { code: "6736", name: "Phường Hải Yên", district_code: "194" },
  { code: "6739", name: "Xã Quảng Nghĩa", district_code: "194" },
  { code: "6742", name: "Phường Hải Hoà", district_code: "194" },
  { code: "6745", name: "Xã Hải Xuân", district_code: "194" },
  { code: "6748", name: "Xã Vạn Ninh", district_code: "194" },
  { code: "6751", name: "Phường Bình Ngọc", district_code: "194" },
  { code: "6754", name: "Xã Vĩnh Trung", district_code: "194" },
  { code: "6757", name: "Xã Vĩnh Thực", district_code: "194" },
  { code: "6760", name: "Phường Mông Dương", district_code: "195" },
  { code: "6763", name: "Phường Cửa Ông", district_code: "195" },
  { code: "6766", name: "Phường Cẩm Sơn", district_code: "195" },
  { code: "6769", name: "Phường Cẩm Đông", district_code: "195" },
  { code: "6772", name: "Phường Cẩm Phú", district_code: "195" },
  { code: "6775", name: "Phường Cẩm Tây", district_code: "195" },
  { code: "6778", name: "Phường Quang Hanh", district_code: "195" },
  { code: "6781", name: "Phường Cẩm Thịnh", district_code: "195" },
  { code: "6784", name: "Phường Cẩm Thủy", district_code: "195" },
  { code: "6787", name: "Phường Cẩm Thạch", district_code: "195" },
  { code: "6790", name: "Phường Cẩm Thành", district_code: "195" },
  { code: "6793", name: "Phường Cẩm Trung", district_code: "195" },
  { code: "6796", name: "Phường Cẩm Bình", district_code: "195" },
  { code: "6799", name: "Xã Hải Hòa", district_code: "195" },
  { code: "6805", name: "Xã Dương Huy", district_code: "195" },
  { code: "6808", name: "Phường Vàng Danh", district_code: "196" },
  { code: "6811", name: "Phường Thanh Sơn", district_code: "196" },
  { code: "6814", name: "Phường Bắc Sơn", district_code: "196" },
  { code: "6817", name: "Phường Quang Trung", district_code: "196" },
  { code: "6820", name: "Phường Trưng Vương", district_code: "196" },
  { code: "6823", name: "Phường Nam Khê", district_code: "196" },
  { code: "6826", name: "Phường Yên Thanh", district_code: "196" },
  { code: "6829", name: "Xã Thượng Yên Công", district_code: "196" },
  { code: "6832", name: "Phường Phương Đông", district_code: "196" },
  { code: "6835", name: "Phường Phương Nam", district_code: "196" },
  { code: "6838", name: "Thị trấn Bình Liêu", district_code: "198" },
  { code: "6841", name: "Xã Hoành Mô", district_code: "198" },
  { code: "6844", name: "Xã Đồng Tâm", district_code: "198" },
  { code: "6847", name: "Xã Đồng Văn", district_code: "198" },
  { code: "6853", name: "Xã Vô Ngại", district_code: "198" },
  { code: "6856", name: "Xã Lục Hồn", district_code: "198" },
  { code: "6859", name: "Xã Húc Động", district_code: "198" },
  { code: "6862", name: "Thị trấn Tiên Yên", district_code: "199" },
  { code: "6865", name: "Xã Hà Lâu", district_code: "199" },
  { code: "6868", name: "Xã Đại Dực", district_code: "199" },
  { code: "6871", name: "Xã Phong Dụ", district_code: "199" },
  { code: "6874", name: "Xã Điền Xá", district_code: "199" },
  { code: "6877", name: "Xã Đông Ngũ", district_code: "199" },
  { code: "6880", name: "Xã Yên Than", district_code: "199" },
  { code: "6883", name: "Xã Đông Hải", district_code: "199" },
  { code: "6886", name: "Xã Hải Lạng", district_code: "199" },
  { code: "6889", name: "Xã Tiên Lãng", district_code: "199" },
  { code: "6892", name: "Xã Đồng Rui", district_code: "199" },
  { code: "6895", name: "Thị trấn Đầm Hà", district_code: "200" },
  { code: "6898", name: "Xã Quảng Lâm", district_code: "200" },
  { code: "6901", name: "Xã Quảng An", district_code: "200" },
  { code: "6904", name: "Xã Tân Bình", district_code: "200" },
  { code: "6910", name: "Xã Dực Yên", district_code: "200" },
  { code: "6913", name: "Xã Quảng Tân", district_code: "200" },
  { code: "6916", name: "Xã Đầm Hà", district_code: "200" },
  { code: "6917", name: "Xã Tân Lập", district_code: "200" },
  { code: "6919", name: "Xã Đại Bình", district_code: "200" },
  { code: "6922", name: "Thị trấn Quảng Hà", district_code: "201" },
  { code: "6925", name: "Xã Quảng Đức", district_code: "201" },
  { code: "6928", name: "Xã Quảng Sơn", district_code: "201" },
  { code: "6931", name: "Xã Quảng Thành", district_code: "201" },
  { code: "6937", name: "Xã Quảng Thịnh", district_code: "201" },
  { code: "6940", name: "Xã Quảng Minh", district_code: "201" },
  { code: "6943", name: "Xã Quảng Chính", district_code: "201" },
  { code: "6946", name: "Xã Quảng Long", district_code: "201" },
  { code: "6949", name: "Xã Đường Hoa", district_code: "201" },
  { code: "6952", name: "Xã Quảng Phong", district_code: "201" },
  { code: "6967", name: "Xã Cái Chiên", district_code: "201" },
  { code: "6970", name: "Thị trấn Ba Chẽ", district_code: "202" },
  { code: "6973", name: "Xã Thanh Sơn", district_code: "202" },
  { code: "6976", name: "Xã Thanh Lâm", district_code: "202" },
  { code: "6979", name: "Xã Đạp Thanh", district_code: "202" },
  { code: "6982", name: "Xã Nam Sơn", district_code: "202" },
  { code: "6985", name: "Xã Lương Minh", district_code: "202" },
  { code: "6988", name: "Xã Đồn Đạc", district_code: "202" },
  { code: "6994", name: "Thị trấn Cái Rồng", district_code: "203" },
  { code: "6997", name: "Xã Đài Xuyên", district_code: "203" },
  { code: "7000", name: "Xã Bình Dân", district_code: "203" },
  { code: "7003", name: "Xã Vạn Yên", district_code: "203" },
  { code: "7006", name: "Xã Minh Châu", district_code: "203" },
  { code: "7009", name: "Xã Đoàn Kết", district_code: "203" },
  { code: "7012", name: "Xã Hạ Long", district_code: "203" },
  { code: "7015", name: "Xã Đông Xá", district_code: "203" },
  { code: "7018", name: "Xã Bản Sen", district_code: "203" },
  { code: "7021", name: "Xã Thắng Lợi", district_code: "203" },
  { code: "7024", name: "Xã Quan Lạn", district_code: "203" },
  { code: "7027", name: "Xã Ngọc Vừng", district_code: "203" },
  { code: "7069", name: "Phường Mạo Khê", district_code: "205" },
  { code: "7075", name: "Xã An Sinh", district_code: "205" },
  { code: "7078", name: "Xã Tràng Lương", district_code: "205" },
  { code: "7081", name: "Phường Bình Khê", district_code: "205" },
  { code: "7084", name: "Xã Việt Dân", district_code: "205" },
  { code: "7090", name: "Phường Bình Dương", district_code: "205" },
  { code: "7093", name: "Phường Đức Chính", district_code: "205" },
  { code: "7096", name: "Phường Tràng An", district_code: "205" },
  { code: "7099", name: "Xã Nguyễn Huệ", district_code: "205" },
  { code: "7102", name: "Phường Thủy An", district_code: "205" },
  { code: "7105", name: "Phường Xuân Sơn", district_code: "205" },
  { code: "7108", name: "Xã Hồng Thái Tây", district_code: "205" },
  { code: "7111", name: "Xã Hồng Thái Đông", district_code: "205" },
  { code: "7114", name: "Phường Hoàng Quế", district_code: "205" },
  { code: "7117", name: "Phường Yên Thọ", district_code: "205" },
  { code: "7120", name: "Phường Hồng Phong", district_code: "205" },
  { code: "7123", name: "Phường Kim Sơn", district_code: "205" },
  { code: "7126", name: "Phường Hưng Đạo", district_code: "205" },
  { code: "7129", name: "Phường Yên Đức", district_code: "205" },
  { code: "7132", name: "Phường Quảng Yên", district_code: "206" },
  { code: "7135", name: "Phường Đông Mai", district_code: "206" },
  { code: "7138", name: "Phường Minh Thành", district_code: "206" },
  { code: "7144", name: "Xã Sông Khoai", district_code: "206" },
  { code: "7147", name: "Xã Hiệp Hòa", district_code: "206" },
  { code: "7150", name: "Phường Cộng Hòa", district_code: "206" },
  { code: "7153", name: "Xã Tiền An", district_code: "206" },
  { code: "7156", name: "Xã Hoàng Tân", district_code: "206" },
  { code: "7159", name: "Phường Tân An", district_code: "206" },
  { code: "7162", name: "Phường Yên Giang", district_code: "206" },
  { code: "7165", name: "Phường Nam Hoà", district_code: "206" },
  { code: "7168", name: "Phường Hà An", district_code: "206" },
  { code: "7171", name: "Xã Cẩm La", district_code: "206" },
  { code: "7174", name: "Phường Phong Hải", district_code: "206" },
  { code: "7177", name: "Phường Yên Hải", district_code: "206" },
  { code: "7180", name: "Xã Liên Hòa", district_code: "206" },
  { code: "7183", name: "Phường Phong Cốc", district_code: "206" },
  { code: "7186", name: "Xã Liên Vị", district_code: "206" },
  { code: "7189", name: "Xã Tiền Phong", district_code: "206" },
  { code: "7192", name: "Thị trấn Cô Tô", district_code: "207" },
  { code: "7195", name: "Xã Đồng Tiến", district_code: "207" },
  { code: "7198", name: "Xã Thanh Lân", district_code: "207" },
  { code: "7201", name: "Phường Thọ Xương", district_code: "213" },
  { code: "7207", name: "Phường Ngô Quyền", district_code: "213" },
  { code: "7210", name: "Phường Hoàng Văn Thụ", district_code: "213" },
  { code: "7213", name: "Phường Trần Phú", district_code: "213" },
  { code: "7216", name: "Phường Mỹ Độ", district_code: "213" },
  { code: "7222", name: "Phường Song Mai", district_code: "213" },
  { code: "7225", name: "Phường Xương Giang", district_code: "213" },
  { code: "7228", name: "Phường Đa Mai", district_code: "213" },
  { code: "7231", name: "Phường Dĩnh Kế", district_code: "213" },
  { code: "7441", name: "Phường Dĩnh Trì", district_code: "213" },
  { code: "7681", name: "Phường Nham Biền", district_code: "213" },
  { code: "7682", name: "Phường Tân An", district_code: "213" },
  { code: "7687", name: "Phường Tân Mỹ", district_code: "213" },
  { code: "7690", name: "Phường Hương Gián", district_code: "213" },
  { code: "7693", name: "Xã Tân An", district_code: "213" },
  { code: "7696", name: "Phường Đồng Sơn", district_code: "213" },
  { code: "7699", name: "Phường Tân Tiến", district_code: "213" },
  { code: "7702", name: "Xã Quỳnh Sơn", district_code: "213" },
  { code: "7705", name: "Phường Song Khê", district_code: "213" },
  { code: "7708", name: "Phường Nội Hoàng", district_code: "213" },
  { code: "7711", name: "Phường Tiền Phong", district_code: "213" },
  { code: "7714", name: "Xã Xuân Phú", district_code: "213" },
  { code: "7717", name: "Phường Tân Liễu", district_code: "213" },
  { code: "7720", name: "Xã Trí Yên", district_code: "213" },
  { code: "7723", name: "Xã Lãng Sơn", district_code: "213" },
  { code: "7726", name: "Xã Yên Lư", district_code: "213" },
  { code: "7729", name: "Xã Tiến Dũng", district_code: "213" },
  { code: "7732", name: "Xã Nham Sơn", district_code: "213" },
  { code: "7735", name: "Xã Đức Giang", district_code: "213" },
  { code: "7738", name: "Phường Cảnh Thụy", district_code: "213" },
  { code: "7741", name: "Xã Tư Mại", district_code: "213" },
  { code: "7744", name: "Xã Thắng Cương", district_code: "213" },
  { code: "7747", name: "Xã Đồng Việt", district_code: "213" },
  { code: "7750", name: "Xã Đồng Phúc", district_code: "213" },
  { code: "7243", name: "Xã Đồng Tiến", district_code: "215" },
  { code: "7246", name: "Xã Canh Nậu", district_code: "215" },
  { code: "7249", name: "Xã Xuân Lương", district_code: "215" },
  { code: "7252", name: "Xã Tam Tiến", district_code: "215" },
  { code: "7255", name: "Xã Đồng Vương", district_code: "215" },
  { code: "7258", name: "Xã Đồng Hưu", district_code: "215" },
  { code: "7260", name: "Xã Đồng Tâm", district_code: "215" },
  { code: "7261", name: "Xã Tân Hiệp", district_code: "215" },
  { code: "7264", name: "Xã Tiến Thắng", district_code: "215" },
  { code: "7270", name: "Xã Đồng Lạc", district_code: "215" },
  { code: "7273", name: "Xã Đông Sơn", district_code: "215" },
  { code: "7279", name: "Xã Hương Vĩ", district_code: "215" },
  { code: "7282", name: "Xã Đồng Kỳ", district_code: "215" },
  { code: "7285", name: "Xã An Thượng", district_code: "215" },
  { code: "7288", name: "Thị trấn Phồn Xương", district_code: "215" },
  { code: "7291", name: "Xã Tân Sỏi", district_code: "215" },
  { code: "7294", name: "Thị trấn Bố Hạ", district_code: "215" },
  { code: "7306", name: "Thị trấn Nhã Nam", district_code: "216" },
  { code: "7309", name: "Xã Tân Trung", district_code: "216" },
  { code: "7315", name: "Xã Quang Trung", district_code: "216" },
  { code: "7321", name: "Xã An Dương", district_code: "216" },
  { code: "7324", name: "Xã Phúc Hòa", district_code: "216" },
  { code: "7327", name: "Xã Liên Sơn", district_code: "216" },
  { code: "7330", name: "Xã Hợp Đức", district_code: "216" },
  { code: "7333", name: "Xã Lam Sơn", district_code: "216" },
  { code: "7336", name: "Xã Cao Xá", district_code: "216" },
  { code: "7339", name: "Thị trấn Cao Thượng", district_code: "216" },
  { code: "7342", name: "Xã Việt Ngọc", district_code: "216" },
  { code: "7345", name: "Xã Song Vân", district_code: "216" },
  { code: "7348", name: "Xã Ngọc Châu", district_code: "216" },
  { code: "7351", name: "Xã Ngọc Vân", district_code: "216" },
  { code: "7354", name: "Xã Việt Lập", district_code: "216" },
  { code: "7357", name: "Xã Liên Chung", district_code: "216" },
  { code: "7360", name: "Xã Ngọc Thiện", district_code: "216" },
  { code: "7363", name: "Xã Ngọc Lý", district_code: "216" },
  { code: "7366", name: "Xã Quế Nham", district_code: "216" },
  { code: "7375", name: "Thị trấn Vôi", district_code: "217" },
  { code: "7378", name: "Xã Nghĩa Hòa", district_code: "217" },
  { code: "7381", name: "Xã Nghĩa Hưng", district_code: "217" },
  { code: "7384", name: "Xã Quang Thịnh", district_code: "217" },
  { code: "7387", name: "Xã Hương Sơn", district_code: "217" },
  { code: "7390", name: "Xã Đào Mỹ", district_code: "217" },
  { code: "7393", name: "Xã Tiên Lục", district_code: "217" },
  { code: "7396", name: "Xã An Hà", district_code: "217" },
  { code: "7399", name: "Thị trấn Kép", district_code: "217" },
  { code: "7405", name: "Xã Hương Lạc", district_code: "217" },
  { code: "7408", name: "Xã Dương Đức", district_code: "217" },
  { code: "7411", name: "Xã Tân Thanh", district_code: "217" },
  { code: "7417", name: "Xã Tân Hưng", district_code: "217" },
  { code: "7420", name: "Xã Mỹ Thái", district_code: "217" },
  { code: "7426", name: "Xã Xương Lâm", district_code: "217" },
  { code: "7429", name: "Xã Xuân Hương", district_code: "217" },
  { code: "7432", name: "Xã Tân Dĩnh", district_code: "217" },
  { code: "7435", name: "Xã Đại Lâm", district_code: "217" },
  { code: "7438", name: "Xã Thái Đào", district_code: "217" },
  { code: "7444", name: "Thị trấn Đồi Ngô", district_code: "218" },
  { code: "7450", name: "Xã Đông Hưng", district_code: "218" },
  { code: "7453", name: "Xã Đông Phú", district_code: "218" },
  { code: "7456", name: "Xã Tam Dị", district_code: "218" },
  { code: "7459", name: "Xã Bảo Sơn", district_code: "218" },
  { code: "7462", name: "Xã Bảo Đài", district_code: "218" },
  { code: "7465", name: "Xã Thanh Lâm", district_code: "218" },
  { code: "7468", name: "Xã Tiên Nha", district_code: "218" },
  { code: "7471", name: "Xã Trường Giang", district_code: "218" },
  { code: "7477", name: "Thị trấn Phương Sơn", district_code: "218" },
  { code: "7480", name: "Xã Chu Điện", district_code: "218" },
  { code: "7483", name: "Xã Cương Sơn", district_code: "218" },
  { code: "7486", name: "Xã Nghĩa Phương", district_code: "218" },
  { code: "7489", name: "Xã Vô Tranh", district_code: "218" },
  { code: "7492", name: "Xã Bình Sơn", district_code: "218" },
  { code: "7495", name: "Xã Lan Mẫu", district_code: "218" },
  { code: "7498", name: "Xã Yên Sơn", district_code: "218" },
  { code: "7501", name: "Xã Khám Lạng", district_code: "218" },
  { code: "7504", name: "Xã Huyền Sơn", district_code: "218" },
  { code: "7507", name: "Xã Trường Sơn", district_code: "218" },
  { code: "7510", name: "Xã Lục Sơn", district_code: "218" },
  { code: "7513", name: "Xã Bắc Lũng", district_code: "218" },
  { code: "7519", name: "Xã Cẩm Lý", district_code: "218" },
  { code: "7522", name: "Xã Đan Hội", district_code: "218" },
  { code: "7528", name: "Xã Cấm Sơn", district_code: "219" },
  { code: "7531", name: "Xã Tân Sơn", district_code: "219" },
  { code: "7534", name: "Xã Phong Minh", district_code: "219" },
  { code: "7537", name: "Xã Phong Vân", district_code: "219" },
  { code: "7540", name: "Xã Xa Lý", district_code: "219" },
  { code: "7543", name: "Xã Hộ Đáp", district_code: "219" },
  { code: "7546", name: "Xã Sơn Hải", district_code: "219" },
  { code: "7555", name: "Xã Biên Sơn", district_code: "219" },
  { code: "7564", name: "Xã Kim Sơn", district_code: "219" },
  { code: "7567", name: "Xã Tân Hoa", district_code: "219" },
  { code: "7570", name: "Xã Giáp Sơn", district_code: "219" },
  { code: "7573", name: "Thị trấn Biển Động", district_code: "219" },
  { code: "7582", name: "Thị trấn Phì Điền", district_code: "219" },
  { code: "7588", name: "Xã Tân Quang", district_code: "219" },
  { code: "7591", name: "Xã Đồng Cốc", district_code: "219" },
  { code: "7594", name: "Xã Tân Lập", district_code: "219" },
  { code: "7597", name: "Xã Phú Nhuận", district_code: "219" },
  { code: "7606", name: "Xã Tân Mộc", district_code: "219" },
  { code: "7609", name: "Xã Đèo Gia", district_code: "219" },
  { code: "7615", name: "Thị trấn An Châu", district_code: "220" },
  { code: "7616", name: "Thị trấn Tây Yên Tử", district_code: "220" },
  { code: "7621", name: "Xã Vân Sơn", district_code: "220" },
  { code: "7624", name: "Xã Hữu Sản", district_code: "220" },
  { code: "7627", name: "Xã Đại Sơn", district_code: "220" },
  { code: "7630", name: "Xã Phúc Sơn", district_code: "220" },
  { code: "7636", name: "Xã Giáo Liêm", district_code: "220" },
  { code: "7642", name: "Xã Cẩm Đàn", district_code: "220" },
  { code: "7645", name: "Xã An Lạc", district_code: "220" },
  { code: "7648", name: "Xã Vĩnh An", district_code: "220" },
  { code: "7651", name: "Xã Yên Định", district_code: "220" },
  { code: "7654", name: "Xã Lệ Viễn", district_code: "220" },
  { code: "7660", name: "Xã An Bá", district_code: "220" },
  { code: "7663", name: "Xã Tuấn Đạo", district_code: "220" },
  { code: "7666", name: "Xã Dương Hưu", district_code: "220" },
  { code: "7672", name: "Xã Long Sơn", district_code: "220" },
  { code: "7678", name: "Xã Thanh Luận", district_code: "220" },
  { code: "7759", name: "Xã Thượng Lan", district_code: "222" },
  { code: "7762", name: "Xã Việt Tiến", district_code: "222" },
  { code: "7765", name: "Xã Nghĩa Trung", district_code: "222" },
  { code: "7768", name: "Xã Minh Đức", district_code: "222" },
  { code: "7771", name: "Xã Hương Mai", district_code: "222" },
  { code: "7774", name: "Phường Tự Lạn", district_code: "222" },
  { code: "7777", name: "Phường Bích Động", district_code: "222" },
  { code: "7780", name: "Xã Trung Sơn", district_code: "222" },
  { code: "7783", name: "Phường Hồng Thái", district_code: "222" },
  { code: "7786", name: "Xã Tiên Sơn", district_code: "222" },
  { code: "7789", name: "Phường Tăng Tiến", district_code: "222" },
  { code: "7792", name: "Phường Quảng Minh", district_code: "222" },
  { code: "7795", name: "Phường Nếnh", district_code: "222" },
  { code: "7798", name: "Phường Ninh Sơn", district_code: "222" },
  { code: "7801", name: "Phường Vân Trung", district_code: "222" },
  { code: "7804", name: "Xã Vân Hà", district_code: "222" },
  { code: "7807", name: "Phường Quang Châu", district_code: "222" },
  { code: "7816", name: "Xã Đồng Tiến", district_code: "223" },
  { code: "7822", name: "Xã Hoàng Vân", district_code: "223" },
  { code: "7825", name: "Xã Toàn Thắng", district_code: "223" },
  { code: "7831", name: "Xã Ngọc Sơn", district_code: "223" },
  { code: "7840", name: "Thị trấn Thắng", district_code: "223" },
  { code: "7843", name: "Xã Sơn Thịnh", district_code: "223" },
  { code: "7846", name: "Xã Lương Phong", district_code: "223" },
  { code: "7849", name: "Xã Hùng Thái", district_code: "223" },
  { code: "7855", name: "Xã Thường Thắng", district_code: "223" },
  { code: "7858", name: "Xã Hợp Thịnh", district_code: "223" },
  { code: "7861", name: "Xã Danh Thắng", district_code: "223" },
  { code: "7864", name: "Xã Mai Trung", district_code: "223" },
  { code: "7867", name: "Xã Đoan Bái", district_code: "223" },
  { code: "7870", name: "Thị trấn Bắc Lý", district_code: "223" },
  { code: "7873", name: "Xã Xuân Cẩm", district_code: "223" },
  { code: "7876", name: "Xã Hương Lâm", district_code: "223" },
  { code: "7879", name: "Xã Đông Lỗ", district_code: "223" },
  { code: "7882", name: "Xã Châu Minh", district_code: "223" },
  { code: "7885", name: "Xã Mai Đình", district_code: "223" },
  { code: "7525", name: "Phường Chũ", district_code: "224" },
  { code: "7549", name: "Phường Thanh Hải", district_code: "224" },
  { code: "7552", name: "Xã Kiên Lao", district_code: "224" },
  { code: "7558", name: "Xã Kiên Thành", district_code: "224" },
  { code: "7561", name: "Phường Hồng Giang", district_code: "224" },
  { code: "7576", name: "Xã Quý Sơn", district_code: "224" },
  { code: "7579", name: "Phường Trù Hựu", district_code: "224" },
  { code: "7600", name: "Xã Mỹ An", district_code: "224" },
  { code: "7603", name: "Xã Nam Dương", district_code: "224" },
  { code: "7612", name: "Phường Phượng Sơn", district_code: "224" },
  { code: "7888", name: "Phường Dữu Lâu", district_code: "227" },
  { code: "7894", name: "Phường Nông Trang", district_code: "227" },
  { code: "7897", name: "Phường Tân Dân", district_code: "227" },
  { code: "7900", name: "Phường Gia Cẩm", district_code: "227" },
  { code: "7903", name: "Phường Tiên Cát", district_code: "227" },
  { code: "7906", name: "Phường Thọ Sơn", district_code: "227" },
  { code: "7909", name: "Phường Thanh Miếu", district_code: "227" },
  { code: "7912", name: "Phường Bạch Hạc", district_code: "227" },
  { code: "7918", name: "Phường Vân Phú", district_code: "227" },
  { code: "7921", name: "Xã Phượng Lâu", district_code: "227" },
  { code: "7924", name: "Xã Thụy Vân", district_code: "227" },
  { code: "7927", name: "Phường Minh Phương", district_code: "227" },
  { code: "7930", name: "Xã Trưng Vương", district_code: "227" },
  { code: "7933", name: "Phường Minh Nông", district_code: "227" },
  { code: "7936", name: "Xã Sông Lô", district_code: "227" },
  { code: "8281", name: "Xã Kim Đức", district_code: "227" },
  { code: "8287", name: "Xã Hùng Lô", district_code: "227" },
  { code: "8503", name: "Xã Hy Cương", district_code: "227" },
  { code: "8506", name: "Xã Chu Hóa", district_code: "227" },
  { code: "8515", name: "Xã Thanh Đình", district_code: "227" },
  { code: "7942", name: "Phường Hùng Vương", district_code: "228" },
  { code: "7945", name: "Phường Phong Châu", district_code: "228" },
  { code: "7948", name: "Phường Âu Cơ", district_code: "228" },
  { code: "7951", name: "Xã Hà Lộc", district_code: "228" },
  { code: "7954", name: "Xã Phú Hộ", district_code: "228" },
  { code: "7957", name: "Xã Văn Lung", district_code: "228" },
  { code: "7960", name: "Xã Thanh Minh", district_code: "228" },
  { code: "7963", name: "Xã Hà Thạch", district_code: "228" },
  { code: "7966", name: "Phường Thanh Vinh", district_code: "228" },
  { code: "7969", name: "Thị trấn Đoan Hùng", district_code: "230" },
  { code: "7975", name: "Xã Hùng Xuyên", district_code: "230" },
  { code: "7981", name: "Xã Bằng Luân", district_code: "230" },
  { code: "7987", name: "Xã Phú Lâm", district_code: "230" },
  { code: "7996", name: "Xã Bằng Doãn", district_code: "230" },
  { code: "7999", name: "Xã Chí Đám", district_code: "230" },
  { code: "8005", name: "Xã Phúc Lai", district_code: "230" },
  { code: "8008", name: "Xã Ngọc Quan", district_code: "230" },
  { code: "8014", name: "Xã Hợp Nhất", district_code: "230" },
  { code: "8023", name: "Xã Tây Cốc", district_code: "230" },
  { code: "8035", name: "Xã Hùng Long", district_code: "230" },
  { code: "8038", name: "Xã Yên Kiện", district_code: "230" },
  { code: "8044", name: "Xã Chân Mộng", district_code: "230" },
  { code: "8050", name: "Xã Ca Đình", district_code: "230" },
  { code: "8053", name: "Thị trấn Hạ Hoà", district_code: "231" },
  { code: "8056", name: "Xã Đại Phạm", district_code: "231" },
  { code: "8062", name: "Xã Đan Thượng", district_code: "231" },
  { code: "8065", name: "Xã Hà Lương", district_code: "231" },
  { code: "8071", name: "Xã Tứ Hiệp", district_code: "231" },
  { code: "8080", name: "Xã Hiền Lương", district_code: "231" },
  { code: "8089", name: "Xã Phương Viên", district_code: "231" },
  { code: "8092", name: "Xã Gia Điền", district_code: "231" },
  { code: "8095", name: "Xã Ấm Hạ", district_code: "231" },
  { code: "8104", name: "Xã Hương Xạ", district_code: "231" },
  { code: "8110", name: "Xã Xuân Áng", district_code: "231" },
  { code: "8113", name: "Xã Yên Kỳ", district_code: "231" },
  { code: "8119", name: "Xã Minh Hạc", district_code: "231" },
  { code: "8122", name: "Xã Lang Sơn", district_code: "231" },
  { code: "8125", name: "Xã Bằng Giã", district_code: "231" },
  { code: "8128", name: "Xã Yên Luật", district_code: "231" },
  { code: "8131", name: "Xã Vô Tranh", district_code: "231" },
  { code: "8134", name: "Xã Văn Lang", district_code: "231" },
  { code: "8140", name: "Xã Minh Côi", district_code: "231" },
  { code: "8143", name: "Xã Vĩnh Chân", district_code: "231" },
  { code: "8152", name: "Thị trấn Thanh Ba", district_code: "232" },
  { code: "8156", name: "Xã Vân Lĩnh", district_code: "232" },
  { code: "8158", name: "Xã Đông Lĩnh", district_code: "232" },
  { code: "8161", name: "Xã Đại An", district_code: "232" },
  { code: "8164", name: "Xã Hanh Cù", district_code: "232" },
  { code: "8170", name: "Xã Đồng Xuân", district_code: "232" },
  { code: "8173", name: "Xã Quảng Yên", district_code: "232" },
  { code: "8179", name: "Xã Ninh Dân", district_code: "232" },
  { code: "8194", name: "Xã Võ Lao", district_code: "232" },
  { code: "8197", name: "Xã Khải Xuân", district_code: "232" },
  { code: "8200", name: "Xã Mạn Lạn", district_code: "232" },
  { code: "8203", name: "Xã Hoàng Cương", district_code: "232" },
  { code: "8206", name: "Xã Chí Tiên", district_code: "232" },
  { code: "8209", name: "Xã Đông Thành", district_code: "232" },
  { code: "8215", name: "Xã Sơn Cương", district_code: "232" },
  { code: "8218", name: "Xã Thanh Hà", district_code: "232" },
  { code: "8221", name: "Xã Đỗ Sơn", district_code: "232" },
  { code: "8224", name: "Xã Đỗ Xuyên", district_code: "232" },
  { code: "8227", name: "Xã Lương Lỗ", district_code: "232" },
  { code: "8230", name: "Thị trấn Phong Châu", district_code: "233" },
  { code: "8233", name: "Xã Phú Mỹ", district_code: "233" },
  { code: "8234", name: "Xã Lệ Mỹ", district_code: "233" },
  { code: "8236", name: "Xã Liên Hoa", district_code: "233" },
  { code: "8239", name: "Xã Trạm Thản", district_code: "233" },
  { code: "8242", name: "Xã Trị Quận", district_code: "233" },
  { code: "8245", name: "Xã Trung Giáp", district_code: "233" },
  { code: "8248", name: "Xã Tiên Phú", district_code: "233" },
  { code: "8251", name: "Xã Hạ Giáp", district_code: "233" },
  { code: "8254", name: "Xã Bảo Thanh", district_code: "233" },
  { code: "8257", name: "Xã Phú Lộc", district_code: "233" },
  { code: "8260", name: "Xã Gia Thanh", district_code: "233" },
  { code: "8263", name: "Xã Tiên Du", district_code: "233" },
  { code: "8266", name: "Xã Phú Nham", district_code: "233" },
  { code: "8272", name: "Xã An Đạo", district_code: "233" },
  { code: "8275", name: "Xã Bình Phú", district_code: "233" },
  { code: "8278", name: "Xã Phù Ninh", district_code: "233" },
  { code: "8290", name: "Thị trấn Yên Lập", district_code: "234" },
  { code: "8293", name: "Xã Mỹ Lung", district_code: "234" },
  { code: "8296", name: "Xã Mỹ Lương", district_code: "234" },
  { code: "8299", name: "Xã Lương Sơn", district_code: "234" },
  { code: "8302", name: "Xã Xuân An", district_code: "234" },
  { code: "8305", name: "Xã Xuân Viên", district_code: "234" },
  { code: "8308", name: "Xã Xuân Thủy", district_code: "234" },
  { code: "8311", name: "Xã Trung Sơn", district_code: "234" },
  { code: "8314", name: "Xã Hưng Long", district_code: "234" },
  { code: "8317", name: "Xã Nga Hoàng", district_code: "234" },
  { code: "8320", name: "Xã Đồng Lạc", district_code: "234" },
  { code: "8323", name: "Xã Thượng Long", district_code: "234" },
  { code: "8326", name: "Xã Đồng Thịnh", district_code: "234" },
  { code: "8329", name: "Xã Phúc Khánh", district_code: "234" },
  { code: "8332", name: "Xã Minh Hòa", district_code: "234" },
  { code: "8335", name: "Xã Ngọc Lập", district_code: "234" },
  { code: "8338", name: "Xã Ngọc Đồng", district_code: "234" },
  { code: "8341", name: "Thị trấn Cẩm Khê", district_code: "235" },
  { code: "8344", name: "Xã Tiên Lương", district_code: "235" },
  { code: "8350", name: "Xã Minh Thắng", district_code: "235" },
  { code: "8353", name: "Xã Minh Tân", district_code: "235" },
  { code: "8356", name: "Xã Phượng Vĩ", district_code: "235" },
  { code: "8374", name: "Xã Tùng Khê", district_code: "235" },
  { code: "8377", name: "Xã Tam Sơn", district_code: "235" },
  { code: "8380", name: "Xã Văn Bán", district_code: "235" },
  { code: "8389", name: "Xã Phong Thịnh", district_code: "235" },
  { code: "8398", name: "Xã Phú Khê", district_code: "235" },
  { code: "8401", name: "Xã Hương Lung", district_code: "235" },
  { code: "8413", name: "Xã Nhật Tiến", district_code: "235" },
  { code: "8416", name: "Xã Hùng Việt", district_code: "235" },
  { code: "8422", name: "Xã Yên Dưỡng", district_code: "235" },
  { code: "8428", name: "Xã Điêu Lương", district_code: "235" },
  { code: "8431", name: "Xã Đồng Lương", district_code: "235" },
  { code: "8434", name: "Thị trấn Hưng Hoá", district_code: "236" },
  { code: "8440", name: "Xã Hiền Quan", district_code: "236" },
  { code: "8443", name: "Xã Bắc Sơn", district_code: "236" },
  { code: "8446", name: "Xã Thanh Uyên", district_code: "236" },
  { code: "8461", name: "Xã Lam Sơn", district_code: "236" },
  { code: "8467", name: "Xã Vạn Xuân", district_code: "236" },
  { code: "8470", name: "Xã Quang Húc", district_code: "236" },
  { code: "8473", name: "Xã Hương Nộn", district_code: "236" },
  { code: "8476", name: "Xã Tề Lễ", district_code: "236" },
  { code: "8479", name: "Xã Thọ Văn", district_code: "236" },
  { code: "8482", name: "Xã Dị Nậu", district_code: "236" },
  { code: "8491", name: "Xã Dân Quyền", district_code: "236" },
  { code: "8494", name: "Thị trấn Lâm Thao", district_code: "237" },
  { code: "8497", name: "Xã Tiên Kiên", district_code: "237" },
  { code: "8498", name: "Thị trấn Hùng Sơn", district_code: "237" },
  { code: "8500", name: "Xã Xuân Lũng", district_code: "237" },
  { code: "8509", name: "Xã Xuân Huy", district_code: "237" },
  { code: "8512", name: "Xã Thạch Sơn", district_code: "237" },
  { code: "8518", name: "Xã Sơn Vi", district_code: "237" },
  { code: "8521", name: "Xã Phùng Nguyên", district_code: "237" },
  { code: "8527", name: "Xã Cao Xá", district_code: "237" },
  { code: "8533", name: "Xã Vĩnh Lại", district_code: "237" },
  { code: "8536", name: "Xã Tứ Xã", district_code: "237" },
  { code: "8539", name: "Xã Bản Nguyên", district_code: "237" },
  { code: "8542", name: "Thị trấn Thanh Sơn", district_code: "238" },
  { code: "8563", name: "Xã Sơn Hùng", district_code: "238" },
  { code: "8572", name: "Xã Địch Quả", district_code: "238" },
  { code: "8575", name: "Xã Giáp Lai", district_code: "238" },
  { code: "8581", name: "Xã Thục Luyện", district_code: "238" },
  { code: "8584", name: "Xã Võ Miếu", district_code: "238" },
  { code: "8587", name: "Xã Thạch Khoán", district_code: "238" },
  { code: "8602", name: "Xã Cự Thắng", district_code: "238" },
  { code: "8605", name: "Xã Tất Thắng", district_code: "238" },
  { code: "8611", name: "Xã Văn Miếu", district_code: "238" },
  { code: "8614", name: "Xã Cự Đồng", district_code: "238" },
  { code: "8623", name: "Xã Thắng Sơn", district_code: "238" },
  { code: "8629", name: "Xã Tân Minh", district_code: "238" },
  { code: "8632", name: "Xã Hương Cần", district_code: "238" },
  { code: "8635", name: "Xã Khả Cửu", district_code: "238" },
  { code: "8638", name: "Xã Đông Cửu", district_code: "238" },
  { code: "8641", name: "Xã Tân Lập", district_code: "238" },
  { code: "8644", name: "Xã Yên Lãng", district_code: "238" },
  { code: "8647", name: "Xã Yên Lương", district_code: "238" },
  { code: "8650", name: "Xã Thượng Cửu", district_code: "238" },
  { code: "8653", name: "Xã Lương Nha", district_code: "238" },
  { code: "8656", name: "Xã Yên Sơn", district_code: "238" },
  { code: "8659", name: "Xã Tinh Nhuệ", district_code: "238" },
  { code: "8662", name: "Xã Đào Xá", district_code: "239" },
  { code: "8665", name: "Xã Thạch Đồng", district_code: "239" },
  { code: "8668", name: "Xã Xuân Lộc", district_code: "239" },
  { code: "8671", name: "Xã Tân Phương", district_code: "239" },
  { code: "8674", name: "Thị trấn Thanh Thủy", district_code: "239" },
  { code: "8677", name: "Xã Sơn Thủy", district_code: "239" },
  { code: "8680", name: "Xã Bảo Yên", district_code: "239" },
  { code: "8683", name: "Xã Đoan Hạ", district_code: "239" },
  { code: "8686", name: "Xã Đồng Trung", district_code: "239" },
  { code: "8689", name: "Xã Hoàng Xá", district_code: "239" },
  { code: "8701", name: "Xã Tu Vũ", district_code: "239" },
  { code: "8545", name: "Xã Thu Cúc", district_code: "240" },
  { code: "8548", name: "Xã Thạch Kiệt", district_code: "240" },
  { code: "8551", name: "Xã Thu Ngạc", district_code: "240" },
  { code: "8554", name: "Xã Kiệt Sơn", district_code: "240" },
  { code: "8557", name: "Xã Đồng Sơn", district_code: "240" },
  { code: "8560", name: "Xã Lai Đồng", district_code: "240" },
  { code: "8566", name: "Thị trấn Tân Phú", district_code: "240" },
  { code: "8569", name: "Xã Mỹ Thuận", district_code: "240" },
  { code: "8578", name: "Xã Tân Sơn", district_code: "240" },
  { code: "8590", name: "Xã Xuân Đài", district_code: "240" },
  { code: "8593", name: "Xã Minh Đài", district_code: "240" },
  { code: "8596", name: "Xã Văn Luông", district_code: "240" },
  { code: "8599", name: "Xã Xuân Sơn", district_code: "240" },
  { code: "8608", name: "Xã Long Cốc", district_code: "240" },
  { code: "8617", name: "Xã Kim Thượng", district_code: "240" },
  { code: "8620", name: "Xã Tam Thanh", district_code: "240" },
  { code: "8626", name: "Xã Vinh Tiền", district_code: "240" },
  { code: "8707", name: "Phường Tích Sơn", district_code: "243" },
  { code: "8710", name: "Phường Liên Bảo", district_code: "243" },
  { code: "8713", name: "Phường Hội Hợp", district_code: "243" },
  { code: "8716", name: "Phường Đống Đa", district_code: "243" },
  { code: "8719", name: "Phường Ngô Quyền", district_code: "243" },
  { code: "8722", name: "Phường Đồng Tâm", district_code: "243" },
  { code: "8725", name: "Phường Định Trung", district_code: "243" },
  { code: "8728", name: "Phường Khai Quang", district_code: "243" },
  { code: "8731", name: "Xã Thanh Trù", district_code: "243" },
  { code: "8737", name: "Phường Hùng Vương", district_code: "244" },
  { code: "8740", name: "Phường Hai Bà Trưng", district_code: "244" },
  { code: "8743", name: "Phường Phúc Thắng", district_code: "244" },
  { code: "8746", name: "Phường Xuân Hoà", district_code: "244" },
  { code: "8747", name: "Phường Đồng Xuân", district_code: "244" },
  { code: "8749", name: "Xã Ngọc Thanh", district_code: "244" },
  { code: "8752", name: "Xã Cao Minh", district_code: "244" },
  { code: "8755", name: "Phường Nam Viêm", district_code: "244" },
  { code: "8758", name: "Phường Tiền Châu", district_code: "244" },
  { code: "8761", name: "Thị trấn Lập Thạch", district_code: "246" },
  { code: "8764", name: "Xã Quang Sơn", district_code: "246" },
  { code: "8767", name: "Xã Ngọc Mỹ", district_code: "246" },
  { code: "8770", name: "Xã Hợp Lý", district_code: "246" },
  { code: "8785", name: "Xã Bắc Bình", district_code: "246" },
  { code: "8788", name: "Xã Thái Hòa", district_code: "246" },
  { code: "8789", name: "Thị trấn Hoa Sơn", district_code: "246" },
  { code: "8791", name: "Xã Liễn Sơn", district_code: "246" },
  { code: "8794", name: "Xã Xuân Hòa", district_code: "246" },
  { code: "8797", name: "Xã Vân Trục", district_code: "246" },
  { code: "8812", name: "Xã Liên Hòa", district_code: "246" },
  { code: "8815", name: "Xã Tử Du", district_code: "246" },
  { code: "8833", name: "Xã Bàn Giản", district_code: "246" },
  { code: "8836", name: "Xã Xuân Lôi", district_code: "246" },
  { code: "8839", name: "Xã Đồng Ích", district_code: "246" },
  { code: "8842", name: "Xã Tiên Lữ", district_code: "246" },
  { code: "8845", name: "Xã Văn Quán", district_code: "246" },
  { code: "8863", name: "Xã Tây Sơn", district_code: "246" },
  { code: "8866", name: "Xã Sơn Đông", district_code: "246" },
  { code: "8869", name: "Thị trấn Hợp Hòa", district_code: "247" },
  { code: "8872", name: "Xã Hoàng Hoa", district_code: "247" },
  { code: "8875", name: "Xã Đồng Tĩnh", district_code: "247" },
  { code: "8878", name: "Thị trấn Kim Long", district_code: "247" },
  { code: "8881", name: "Xã Hướng Đạo", district_code: "247" },
  { code: "8884", name: "Xã Đạo Tú", district_code: "247" },
  { code: "8887", name: "Xã An Hòa", district_code: "247" },
  { code: "8890", name: "Xã Thanh Vân", district_code: "247" },
  { code: "8893", name: "Xã Duy Phiên", district_code: "247" },
  { code: "8896", name: "Xã Hoàng Đan", district_code: "247" },
  { code: "8899", name: "Xã Hoàng Lâu", district_code: "247" },
  { code: "8905", name: "Xã Hội Thịnh", district_code: "247" },
  { code: "8908", name: "Thị trấn Tam Đảo", district_code: "248" },
  { code: "8911", name: "Thị trấn Hợp Châu", district_code: "248" },
  { code: "8914", name: "Xã Đạo Trù", district_code: "248" },
  { code: "8917", name: "Xã Yên Dương", district_code: "248" },
  { code: "8920", name: "Xã Bồ Lý", district_code: "248" },
  { code: "8923", name: "Thị trấn Đại Đình", district_code: "248" },
  { code: "8926", name: "Xã Tam Quan", district_code: "248" },
  { code: "8929", name: "Xã Hồ Sơn", district_code: "248" },
  { code: "8932", name: "Xã Minh Quang", district_code: "248" },
  { code: "8935", name: "Thị trấn Hương Canh", district_code: "249" },
  { code: "8936", name: "Thị trấn Gia Khánh", district_code: "249" },
  { code: "8938", name: "Xã Trung Mỹ", district_code: "249" },
  { code: "8944", name: "Thị trấn Bá Hiến", district_code: "249" },
  { code: "8947", name: "Xã Thiện Kế", district_code: "249" },
  { code: "8950", name: "Xã Hương Sơn", district_code: "249" },
  { code: "8953", name: "Xã Tam Hợp", district_code: "249" },
  { code: "8956", name: "Xã Quất Lưu", district_code: "249" },
  { code: "8959", name: "Xã Sơn Lôi", district_code: "249" },
  { code: "8962", name: "Thị trấn Đạo Đức", district_code: "249" },
  { code: "8965", name: "Xã Tân Phong", district_code: "249" },
  { code: "8968", name: "Thị trấn Thanh Lãng", district_code: "249" },
  { code: "8971", name: "Xã Phú Xuân", district_code: "249" },
  { code: "9025", name: "Thị trấn Yên Lạc", district_code: "251" },
  { code: "9028", name: "Xã Đồng Cương", district_code: "251" },
  { code: "9031", name: "Xã Đồng Văn", district_code: "251" },
  { code: "9034", name: "Xã Bình Định", district_code: "251" },
  { code: "9037", name: "Xã Trung Nguyên", district_code: "251" },
  { code: "9040", name: "Xã Tề Lỗ", district_code: "251" },
  { code: "9043", name: "Thị trấn Tam Hồng", district_code: "251" },
  { code: "9046", name: "Xã Yên Đồng", district_code: "251" },
  { code: "9049", name: "Xã Văn Tiến", district_code: "251" },
  { code: "9052", name: "Xã Nguyệt Đức", district_code: "251" },
  { code: "9055", name: "Xã Yên Phương", district_code: "251" },
  { code: "9061", name: "Xã Trung Kiên", district_code: "251" },
  { code: "9064", name: "Xã Liên Châu", district_code: "251" },
  { code: "9067", name: "Xã Đại Tự", district_code: "251" },
  { code: "9070", name: "Xã Hồng Châu", district_code: "251" },
  { code: "9073", name: "Xã Trung Hà", district_code: "251" },
  { code: "9076", name: "Thị trấn Vĩnh Tường", district_code: "252" },
  { code: "9079", name: "Xã Kim Xá", district_code: "252" },
  { code: "9082", name: "Xã Yên Bình", district_code: "252" },
  { code: "9085", name: "Xã Chấn Hưng", district_code: "252" },
  { code: "9088", name: "Xã Nghĩa Hưng", district_code: "252" },
  { code: "9091", name: "Xã Yên Lập", district_code: "252" },
  { code: "9097", name: "Xã Sao Đại Việt", district_code: "252" },
  { code: "9100", name: "Xã Đại Đồng", district_code: "252" },
  { code: "9106", name: "Xã Lũng Hoà", district_code: "252" },
  { code: "9112", name: "Thị trấn Thổ Tang", district_code: "252" },
  { code: "9118", name: "Xã Lương Điền", district_code: "252" },
  { code: "9124", name: "Xã Tân Phú", district_code: "252" },
  { code: "9127", name: "Xã Thượng Trưng", district_code: "252" },
  { code: "9130", name: "Xã Vũ Di", district_code: "252" },
  { code: "9136", name: "Xã Tuân Chính", district_code: "252" },
  { code: "9145", name: "Thị trấn Tứ Trưng", district_code: "252" },
  { code: "9148", name: "Xã Ngũ Kiên", district_code: "252" },
  { code: "9151", name: "Xã An Nhân", district_code: "252" },
  { code: "9154", name: "Xã Vĩnh Thịnh", district_code: "252" },
  { code: "9157", name: "Xã Vĩnh Phú", district_code: "252" },
  { code: "8773", name: "Xã Lãng Công", district_code: "253" },
  { code: "8776", name: "Xã Quang Yên", district_code: "253" },
  { code: "8782", name: "Xã Hải Lựu", district_code: "253" },
  { code: "8800", name: "Xã Đồng Quế", district_code: "253" },
  { code: "8803", name: "Xã Nhân Đạo", district_code: "253" },
  { code: "8806", name: "Xã Đôn Nhân", district_code: "253" },
  { code: "8809", name: "Xã Phương Khoan", district_code: "253" },
  { code: "8818", name: "Xã Tân Lập", district_code: "253" },
  { code: "8824", name: "Thị trấn Tam Sơn", district_code: "253" },
  { code: "8830", name: "Xã Yên Thạch", district_code: "253" },
  { code: "8848", name: "Xã Đồng Thịnh", district_code: "253" },
  { code: "8851", name: "Xã Tứ Yên", district_code: "253" },
  { code: "8854", name: "Xã Đức Bác", district_code: "253" },
  { code: "8860", name: "Xã Cao Phong", district_code: "253" },
  { code: "9163", name: "Phường Vũ Ninh", district_code: "256" },
  { code: "9166", name: "Phường Đáp Cầu", district_code: "256" },
  { code: "9169", name: "Phường Thị Cầu", district_code: "256" },
  { code: "9172", name: "Phường Kinh Bắc", district_code: "256" },
  { code: "9181", name: "Phường Đại Phúc", district_code: "256" },
  { code: "9184", name: "Phường Tiền Ninh Vệ", district_code: "256" },
  { code: "9187", name: "Phường Suối Hoa", district_code: "256" },
  { code: "9190", name: "Phường Võ Cường", district_code: "256" },
  { code: "9214", name: "Phường Hòa Long", district_code: "256" },
  { code: "9226", name: "Phường Vạn An", district_code: "256" },
  { code: "9235", name: "Phường Khúc Xuyên", district_code: "256" },
  { code: "9244", name: "Phường Phong Khê", district_code: "256" },
  { code: "9256", name: "Phường Kim Chân", district_code: "256" },
  { code: "9271", name: "Phường Vân Dương", district_code: "256" },
  { code: "9286", name: "Phường Nam Sơn", district_code: "256" },
  { code: "9325", name: "Phường Khắc Niệm", district_code: "256" },
  { code: "9331", name: "Phường Hạp Lĩnh", district_code: "256" },
  { code: "9193", name: "Thị trấn Chờ", district_code: "258" },
  { code: "9196", name: "Xã Dũng Liệt", district_code: "258" },
  { code: "9199", name: "Xã Tam Đa", district_code: "258" },
  { code: "9202", name: "Xã Tam Giang", district_code: "258" },
  { code: "9205", name: "Xã Yên Trung", district_code: "258" },
  { code: "9208", name: "Xã Thụy Hòa", district_code: "258" },
  { code: "9211", name: "Xã Hòa Tiến", district_code: "258" },
  { code: "9217", name: "Xã Đông Tiến", district_code: "258" },
  { code: "9220", name: "Xã Yên Phụ", district_code: "258" },
  { code: "9223", name: "Xã Trung Nghĩa", district_code: "258" },
  { code: "9229", name: "Xã Đông Phong", district_code: "258" },
  { code: "9232", name: "Xã Long Châu", district_code: "258" },
  { code: "9238", name: "Xã Văn Môn", district_code: "258" },
  { code: "9241", name: "Xã Đông Thọ", district_code: "258" },
  { code: "9247", name: "Phường Phố Mới", district_code: "259" },
  { code: "9250", name: "Xã Việt Thống", district_code: "259" },
  { code: "9253", name: "Phường Đại Xuân", district_code: "259" },
  { code: "9259", name: "Phường Nhân Hòa", district_code: "259" },
  { code: "9262", name: "Phường Bằng An", district_code: "259" },
  { code: "9265", name: "Phường Phương Liễu", district_code: "259" },
  { code: "9268", name: "Phường Quế Tân", district_code: "259" },
  { code: "9274", name: "Phường Phù Lương", district_code: "259" },
  { code: "9277", name: "Xã Phù Lãng", district_code: "259" },
  { code: "9280", name: "Phường Phượng Mao", district_code: "259" },
  { code: "9283", name: "Phường Việt Hùng", district_code: "259" },
  { code: "9289", name: "Xã Ngọc Xá", district_code: "259" },
  { code: "9292", name: "Xã Châu Phong", district_code: "259" },
  { code: "9295", name: "Phường Bồng Lai", district_code: "259" },
  { code: "9298", name: "Phường Cách Bi", district_code: "259" },
  { code: "9301", name: "Xã Đào Viên", district_code: "259" },
  { code: "9304", name: "Xã Yên Giả", district_code: "259" },
  { code: "9307", name: "Xã Mộ Đạo", district_code: "259" },
  { code: "9310", name: "Xã Đức Long", district_code: "259" },
  { code: "9313", name: "Xã Chi Lăng", district_code: "259" },
  { code: "9319", name: "Thị trấn Lim", district_code: "260" },
  { code: "9322", name: "Xã Phú Lâm", district_code: "260" },
  { code: "9328", name: "Xã Nội Duệ", district_code: "260" },
  { code: "9334", name: "Xã Liên Bão", district_code: "260" },
  { code: "9337", name: "Xã Hiên Vân", district_code: "260" },
  { code: "9340", name: "Xã Hoàn Sơn", district_code: "260" },
  { code: "9343", name: "Xã Lạc Vệ", district_code: "260" },
  { code: "9346", name: "Xã Việt Đoàn", district_code: "260" },
  { code: "9349", name: "Xã Phật Tích", district_code: "260" },
  { code: "9352", name: "Xã Tân Chi", district_code: "260" },
  { code: "9355", name: "Xã Đại Đồng", district_code: "260" },
  { code: "9358", name: "Xã Tri Phương", district_code: "260" },
  { code: "9361", name: "Xã Minh Đạo", district_code: "260" },
  { code: "9364", name: "Xã Cảnh Hưng", district_code: "260" },
  { code: "9367", name: "Phường Đông Ngàn", district_code: "261" },
  { code: "9370", name: "Phường Tam Sơn", district_code: "261" },
  { code: "9373", name: "Phường Hương Mạc", district_code: "261" },
  { code: "9376", name: "Phường Tương Giang", district_code: "261" },
  { code: "9379", name: "Phường Phù Khê", district_code: "261" },
  { code: "9382", name: "Phường Đồng Kỵ", district_code: "261" },
  { code: "9383", name: "Phường Trang Hạ", district_code: "261" },
  { code: "9385", name: "Phường Đồng Nguyên", district_code: "261" },
  { code: "9388", name: "Phường Châu Khê", district_code: "261" },
  { code: "9391", name: "Phường Tân Hồng", district_code: "261" },
  { code: "9394", name: "Phường Đình Bảng", district_code: "261" },
  { code: "9397", name: "Phường Phù Chẩn", district_code: "261" },
  { code: "9400", name: "Phường Hồ", district_code: "262" },
  { code: "9403", name: "Xã Hoài Thượng", district_code: "262" },
  { code: "9406", name: "Xã Đại Đồng Thành", district_code: "262" },
  { code: "9409", name: "Xã Mão Điền", district_code: "262" },
  { code: "9412", name: "Phường Song Hồ", district_code: "262" },
  { code: "9415", name: "Xã Đình Tổ", district_code: "262" },
  { code: "9418", name: "Phường An Bình", district_code: "262" },
  { code: "9421", name: "Phường Trí Quả", district_code: "262" },
  { code: "9424", name: "Phường Gia Đông", district_code: "262" },
  { code: "9427", name: "Phường Thanh Khương", district_code: "262" },
  { code: "9430", name: "Phường Trạm Lộ", district_code: "262" },
  { code: "9433", name: "Phường Xuân Lâm", district_code: "262" },
  { code: "9436", name: "Phường Hà Mãn", district_code: "262" },
  { code: "9439", name: "Xã Ngũ Thái", district_code: "262" },
  { code: "9442", name: "Xã Nguyệt Đức", district_code: "262" },
  { code: "9445", name: "Phường Ninh Xá", district_code: "262" },
  { code: "9448", name: "Xã Nghĩa Đạo", district_code: "262" },
  { code: "9451", name: "Xã Song Liễu", district_code: "262" },
  { code: "9454", name: "Thị trấn Gia Bình", district_code: "263" },
  { code: "9457", name: "Xã Vạn Ninh", district_code: "263" },
  { code: "9460", name: "Xã Thái Bảo", district_code: "263" },
  { code: "9463", name: "Xã Giang Sơn", district_code: "263" },
  { code: "9466", name: "Xã Cao Đức", district_code: "263" },
  { code: "9469", name: "Xã Đại Lai", district_code: "263" },
  { code: "9472", name: "Xã Song Giang", district_code: "263" },
  { code: "9475", name: "Xã Bình Dương", district_code: "263" },
  { code: "9478", name: "Xã Lãng Ngâm", district_code: "263" },
  { code: "9481", name: "Thị trấn Nhân Thắng", district_code: "263" },
  { code: "9484", name: "Xã Xuân Lai", district_code: "263" },
  { code: "9487", name: "Xã Đông Cứu", district_code: "263" },
  { code: "9490", name: "Xã Đại Bái", district_code: "263" },
  { code: "9493", name: "Xã Quỳnh Phú", district_code: "263" },
  { code: "9496", name: "Thị trấn Thứa", district_code: "264" },
  { code: "9499", name: "Xã An Thịnh", district_code: "264" },
  { code: "9502", name: "Xã Trung Kênh", district_code: "264" },
  { code: "9505", name: "Xã Phú Hòa", district_code: "264" },
  { code: "9508", name: "Xã An Tập", district_code: "264" },
  { code: "9511", name: "Xã Tân Lãng", district_code: "264" },
  { code: "9514", name: "Xã Quảng Phú", district_code: "264" },
  { code: "9517", name: "Xã Quang Minh", district_code: "264" },
  { code: "9523", name: "Xã Trung Chính", district_code: "264" },
  { code: "9529", name: "Xã Bình Định", district_code: "264" },
  { code: "9532", name: "Xã Phú Lương", district_code: "264" },
  { code: "9535", name: "Xã Lâm Thao", district_code: "264" },
  { code: "10507", name: "Phường Cẩm Thượng", district_code: "288" },
  { code: "10510", name: "Phường Bình Hàn", district_code: "288" },
  { code: "10513", name: "Phường Ngọc Châu", district_code: "288" },
  { code: "10514", name: "Phường Nhị Châu", district_code: "288" },
  { code: "10516", name: "Phường Quang Trung", district_code: "288" },
  { code: "10519", name: "Phường Nguyễn Trãi", district_code: "288" },
  { code: "10525", name: "Phường Trần Hưng Đạo", district_code: "288" },
  { code: "10528", name: "Phường Trần Phú", district_code: "288" },
  { code: "10531", name: "Phường Thanh Bình", district_code: "288" },
  { code: "10532", name: "Phường Tân Bình", district_code: "288" },
  { code: "10534", name: "Phường Lê Thanh Nghị", district_code: "288" },
  { code: "10537", name: "Phường Hải Tân", district_code: "288" },
  { code: "10540", name: "Phường Tứ Minh", district_code: "288" },
  { code: "10543", name: "Phường Việt Hoà", district_code: "288" },
  { code: "10660", name: "Phường Ái Quốc", district_code: "288" },
  { code: "10663", name: "Xã An Thượng", district_code: "288" },
  { code: "10672", name: "Phường Nam Đồng", district_code: "288" },
  { code: "10822", name: "Xã Quyết Thắng", district_code: "288" },
  { code: "10837", name: "Xã Tiền Tiến", district_code: "288" },
  { code: "11002", name: "Phường Thạch Khôi", district_code: "288" },
  { code: "11005", name: "Xã Liên Hồng", district_code: "288" },
  { code: "11011", name: "Phường Tân Hưng", district_code: "288" },
  { code: "11017", name: "Xã Gia Xuyên", district_code: "288" },
  { code: "11077", name: "Xã Ngọc Sơn", district_code: "288" },
  { code: "10546", name: "Phường Phả Lại", district_code: "290" },
  { code: "10549", name: "Phường Sao Đỏ", district_code: "290" },
  { code: "10552", name: "Phường Bến Tắm", district_code: "290" },
  { code: "10555", name: "Xã Hoàng Hoa Thám", district_code: "290" },
  { code: "10558", name: "Xã Bắc An", district_code: "290" },
  { code: "10561", name: "Xã Hưng Đạo", district_code: "290" },
  { code: "10564", name: "Xã Lê Lợi", district_code: "290" },
  { code: "10567", name: "Phường Hoàng Tiến", district_code: "290" },
  { code: "10570", name: "Phường Cộng Hoà", district_code: "290" },
  { code: "10573", name: "Phường Hoàng Tân", district_code: "290" },
  { code: "10576", name: "Phường Cổ Thành", district_code: "290" },
  { code: "10579", name: "Phường Văn An", district_code: "290" },
  { code: "10582", name: "Phường Chí Minh", district_code: "290" },
  { code: "10585", name: "Phường Văn Đức", district_code: "290" },
  { code: "10588", name: "Phường Thái Học", district_code: "290" },
  { code: "10591", name: "Xã Nhân Huệ", district_code: "290" },
  { code: "10594", name: "Phường An Lạc", district_code: "290" },
  { code: "10600", name: "Phường Đồng Lạc", district_code: "290" },
  { code: "10603", name: "Phường Tân Dân", district_code: "290" },
  { code: "10606", name: "Thị trấn Nam Sách", district_code: "291" },
  { code: "10609", name: "Xã Nam Hưng", district_code: "291" },
  { code: "10612", name: "Xã Nam Tân", district_code: "291" },
  { code: "10615", name: "Xã Hợp Tiến", district_code: "291" },
  { code: "10618", name: "Xã Hiệp Cát", district_code: "291" },
  { code: "10621", name: "Xã Quốc Tuấn", district_code: "291" },
  { code: "10630", name: "Xã An Bình", district_code: "291" },
  { code: "10633", name: "Xã Trần Phú", district_code: "291" },
  { code: "10636", name: "Xã An Sơn", district_code: "291" },
  { code: "10639", name: "Xã Cộng Hòa", district_code: "291" },
  { code: "10642", name: "Xã Thái Tân", district_code: "291" },
  { code: "10645", name: "Xã An Phú", district_code: "291" },
  { code: "10654", name: "Xã Hồng Phong", district_code: "291" },
  { code: "10657", name: "Xã Đồng Lạc", district_code: "291" },
  { code: "10666", name: "Xã Minh Tân", district_code: "291" },
  { code: "10675", name: "Phường An Lưu", district_code: "292" },
  { code: "10678", name: "Xã Bạch Đằng", district_code: "292" },
  { code: "10681", name: "Phường Thất Hùng", district_code: "292" },
  { code: "10684", name: "Xã Lê Ninh", district_code: "292" },
  { code: "10693", name: "Phường Phạm Thái", district_code: "292" },
  { code: "10696", name: "Phường Duy Tân", district_code: "292" },
  { code: "10699", name: "Phường Tân Dân", district_code: "292" },
  { code: "10702", name: "Phường Minh Tân", district_code: "292" },
  { code: "10705", name: "Xã Quang Thành", district_code: "292" },
  { code: "10708", name: "Xã Hiệp Hòa", district_code: "292" },
  { code: "10714", name: "Phường Phú Thứ", district_code: "292" },
  { code: "10717", name: "Xã Thăng Long", district_code: "292" },
  { code: "10720", name: "Xã Lạc Long", district_code: "292" },
  { code: "10723", name: "Phường An Sinh", district_code: "292" },
  { code: "10726", name: "Phường Hiệp Sơn", district_code: "292" },
  { code: "10729", name: "Xã Thượng Quận", district_code: "292" },
  { code: "10732", name: "Phường An Phụ", district_code: "292" },
  { code: "10735", name: "Phường Hiệp An", district_code: "292" },
  { code: "10738", name: "Phường Long Xuyên", district_code: "292" },
  { code: "10741", name: "Phường Thái Thịnh", district_code: "292" },
  { code: "10744", name: "Phường Hiến Thành", district_code: "292" },
  { code: "10747", name: "Xã Minh Hòa", district_code: "292" },
  { code: "10750", name: "Thị trấn Phú Thái", district_code: "293" },
  { code: "10756", name: "Xã Lai Khê", district_code: "293" },
  { code: "10762", name: "Xã Vũ Dũng", district_code: "293" },
  { code: "10768", name: "Xã Tuấn Việt", district_code: "293" },
  { code: "10771", name: "Xã Kim Xuyên", district_code: "293" },
  { code: "10777", name: "Xã Ngũ Phúc", district_code: "293" },
  { code: "10780", name: "Xã Kim Anh", district_code: "293" },
  { code: "10783", name: "Xã Kim Liên", district_code: "293" },
  { code: "10786", name: "Xã Kim Tân", district_code: "293" },
  { code: "10792", name: "Xã Kim Đính", district_code: "293" },
  { code: "10798", name: "Xã Hòa Bình", district_code: "293" },
  { code: "10801", name: "Xã Tam Kỳ", district_code: "293" },
  { code: "10804", name: "Xã Đồng Cẩm", district_code: "293" },
  { code: "10810", name: "Xã Đại Đức", district_code: "293" },
  { code: "10813", name: "Thị trấn Thanh Hà", district_code: "294" },
  { code: "10816", name: "Xã Hồng Lạc", district_code: "294" },
  { code: "10825", name: "Xã Tân Việt", district_code: "294" },
  { code: "10828", name: "Xã Cẩm Việt", district_code: "294" },
  { code: "10831", name: "Xã Thanh An", district_code: "294" },
  { code: "10834", name: "Xã Thanh Lang", district_code: "294" },
  { code: "10840", name: "Xã Tân An", district_code: "294" },
  { code: "10843", name: "Xã Liên Mạc", district_code: "294" },
  { code: "10846", name: "Xã Thanh Hải", district_code: "294" },
  { code: "10855", name: "Xã Thanh Xuân", district_code: "294" },
  { code: "10861", name: "Xã Thanh Tân", district_code: "294" },
  { code: "10864", name: "Xã An Phượng", district_code: "294" },
  { code: "10867", name: "Xã Thanh Sơn", district_code: "294" },
  { code: "10876", name: "Xã Thanh Quang", district_code: "294" },
  { code: "10879", name: "Xã Thanh Hồng", district_code: "294" },
  { code: "10882", name: "Xã Vĩnh Cường", district_code: "294" },
  { code: "10888", name: "Thị trấn Cẩm Giang", district_code: "295" },
  { code: "10891", name: "Thị trấn Lai Cách", district_code: "295" },
  { code: "10894", name: "Xã Cẩm Hưng", district_code: "295" },
  { code: "10897", name: "Xã Cẩm Hoàng", district_code: "295" },
  { code: "10900", name: "Xã Cẩm Văn", district_code: "295" },
  { code: "10903", name: "Xã Ngọc Liên", district_code: "295" },
  { code: "10909", name: "Xã Cẩm Vũ", district_code: "295" },
  { code: "10912", name: "Xã Đức Chính", district_code: "295" },
  { code: "10918", name: "Xã Định Sơn", district_code: "295" },
  { code: "10924", name: "Xã Lương Điền", district_code: "295" },
  { code: "10927", name: "Xã Cao An", district_code: "295" },
  { code: "10930", name: "Xã Tân Trường", district_code: "295" },
  { code: "10933", name: "Xã Phúc Điền", district_code: "295" },
  { code: "10939", name: "Xã Cẩm Đông", district_code: "295" },
  { code: "10942", name: "Xã Cẩm Đoài", district_code: "295" },
  { code: "10945", name: "Thị trấn Kẻ Sặt", district_code: "296" },
  { code: "10951", name: "Xã Vĩnh Hưng", district_code: "296" },
  { code: "10954", name: "Xã Hùng Thắng", district_code: "296" },
  { code: "10960", name: "Xã Vĩnh Hồng", district_code: "296" },
  { code: "10963", name: "Xã Long Xuyên", district_code: "296" },
  { code: "10966", name: "Xã Tân Việt", district_code: "296" },
  { code: "10969", name: "Xã Thúc Kháng", district_code: "296" },
  { code: "10972", name: "Xã Tân Hồng", district_code: "296" },
  { code: "10978", name: "Xã Hồng Khê", district_code: "296" },
  { code: "10981", name: "Xã Thái Minh", district_code: "296" },
  { code: "10984", name: "Xã Cổ Bì", district_code: "296" },
  { code: "10987", name: "Xã Nhân Quyền", district_code: "296" },
  { code: "10990", name: "Xã Thái Dương", district_code: "296" },
  { code: "10993", name: "Xã Thái Hòa", district_code: "296" },
  { code: "10996", name: "Xã Bình Xuyên", district_code: "296" },
  { code: "10999", name: "Thị trấn Gia Lộc", district_code: "297" },
  { code: "11008", name: "Xã Thống Nhất", district_code: "297" },
  { code: "11020", name: "Xã Yết Kiêu", district_code: "297" },
  { code: "11035", name: "Xã Gia Phúc", district_code: "297" },
  { code: "11038", name: "Xã Gia Tiến", district_code: "297" },
  { code: "11041", name: "Xã Lê Lợi", district_code: "297" },
  { code: "11044", name: "Xã Toàn Thắng", district_code: "297" },
  { code: "11047", name: "Xã Hoàng Diệu", district_code: "297" },
  { code: "11050", name: "Xã Hồng Hưng", district_code: "297" },
  { code: "11053", name: "Xã Phạm Trấn", district_code: "297" },
  { code: "11056", name: "Xã Đoàn Thượng", district_code: "297" },
  { code: "11059", name: "Xã Thống Kênh", district_code: "297" },
  { code: "11065", name: "Xã Nhật Quang", district_code: "297" },
  { code: "11071", name: "Xã Quang Đức", district_code: "297" },
  { code: "11074", name: "Thị trấn Tứ Kỳ", district_code: "298" },
  { code: "11083", name: "Xã Đại Sơn", district_code: "298" },
  { code: "11086", name: "Xã Hưng Đạo", district_code: "298" },
  { code: "11092", name: "Xã Bình Lăng", district_code: "298" },
  { code: "11095", name: "Xã Chí Minh", district_code: "298" },
  { code: "11098", name: "Xã Kỳ Sơn", district_code: "298" },
  { code: "11101", name: "Xã Quang Phục", district_code: "298" },
  { code: "11113", name: "Xã Tân Kỳ", district_code: "298" },
  { code: "11116", name: "Xã Quang Khải", district_code: "298" },
  { code: "11119", name: "Xã Đại Hợp", district_code: "298" },
  { code: "11122", name: "Xã Dân An", district_code: "298" },
  { code: "11125", name: "Xã An Thanh", district_code: "298" },
  { code: "11128", name: "Xã Minh Đức", district_code: "298" },
  { code: "11131", name: "Xã Văn Tố", district_code: "298" },
  { code: "11134", name: "Xã Quang Trung", district_code: "298" },
  { code: "11140", name: "Xã Lạc Phượng", district_code: "298" },
  { code: "11143", name: "Xã Tiên Động", district_code: "298" },
  { code: "11146", name: "Xã Nguyên Giáp", district_code: "298" },
  { code: "11149", name: "Xã Hà Kỳ", district_code: "298" },
  { code: "11152", name: "Xã Hà Thanh", district_code: "298" },
  { code: "11161", name: "Xã Ứng Hoè", district_code: "299" },
  { code: "11164", name: "Xã Nghĩa An", district_code: "299" },
  { code: "11167", name: "Xã Đức Phúc", district_code: "299" },
  { code: "11173", name: "Xã An Đức", district_code: "299" },
  { code: "11179", name: "Xã Tân Hương", district_code: "299" },
  { code: "11185", name: "Xã Vĩnh Hòa", district_code: "299" },
  { code: "11188", name: "Xã Bình Xuyên", district_code: "299" },
  { code: "11197", name: "Xã Tân Phong", district_code: "299" },
  { code: "11203", name: "Thị trấn Ninh Giang", district_code: "299" },
  { code: "11206", name: "Xã Tân Quang", district_code: "299" },
  { code: "11215", name: "Xã Hồng Dụ", district_code: "299" },
  { code: "11218", name: "Xã Văn Hội", district_code: "299" },
  { code: "11224", name: "Xã Hồng Phong", district_code: "299" },
  { code: "11227", name: "Xã Hiệp Lực", district_code: "299" },
  { code: "11230", name: "Xã Kiến Phúc", district_code: "299" },
  { code: "11233", name: "Xã Hưng Long", district_code: "299" },
  { code: "11239", name: "Thị trấn Thanh Miện", district_code: "300" },
  { code: "11242", name: "Xã Thanh Tùng", district_code: "300" },
  { code: "11245", name: "Xã Phạm Kha", district_code: "300" },
  { code: "11248", name: "Xã Ngô Quyền", district_code: "300" },
  { code: "11251", name: "Xã Đoàn Tùng", district_code: "300" },
  { code: "11254", name: "Xã Hồng Quang", district_code: "300" },
  { code: "11257", name: "Xã Tân Trào", district_code: "300" },
  { code: "11260", name: "Xã Lam Sơn", district_code: "300" },
  { code: "11263", name: "Xã Đoàn Kết", district_code: "300" },
  { code: "11266", name: "Xã Lê Hồng", district_code: "300" },
  { code: "11269", name: "Xã Tứ Cường", district_code: "300" },
  { code: "11275", name: "Xã Ngũ Hùng", district_code: "300" },
  { code: "11278", name: "Xã Cao Thắng", district_code: "300" },
  { code: "11281", name: "Xã Chi Lăng Bắc", district_code: "300" },
  { code: "11284", name: "Xã Chi Lăng Nam", district_code: "300" },
  { code: "11287", name: "Xã Thanh Giang", district_code: "300" },
  { code: "11293", name: "Xã Hồng Phong", district_code: "300" },
  { code: "11296", name: "Phường Quán Toan", district_code: "303" },
  { code: "11299", name: "Phường Hùng Vương", district_code: "303" },
  { code: "11302", name: "Phường Sở Dầu", district_code: "303" },
  { code: "11305", name: "Phường Thượng Lý", district_code: "303" },
  { code: "11311", name: "Phường Minh Khai", district_code: "303" },
  { code: "11320", name: "Phường Hoàng Văn Thụ", district_code: "303" },
  { code: "11323", name: "Phường Phan Bội Châu", district_code: "303" },
  { code: "11587", name: "Phường Đại Bản", district_code: "303" },
  { code: "11599", name: "Phường An Hưng", district_code: "303" },
  { code: "11602", name: "Phường An Hồng", district_code: "303" },
  { code: "11329", name: "Phường Máy Chai", district_code: "304" },
  { code: "11335", name: "Phường Vạn Mỹ", district_code: "304" },
  { code: "11338", name: "Phường Cầu Tre", district_code: "304" },
  { code: "11341", name: "Phường Gia Viên", district_code: "304" },
  { code: "11344", name: "Phường Cầu Đất", district_code: "304" },
  { code: "11350", name: "Phường Đông Khê", district_code: "304" },
  { code: "11359", name: "Phường Đằng Giang", district_code: "304" },
  { code: "11365", name: "Phường Lạch Tray", district_code: "304" },
  { code: "11371", name: "Phường An Biên", district_code: "305" },
  { code: "11383", name: "Phường Trần Nguyên Hãn", district_code: "305" },
  { code: "11395", name: "Phường Hàng Kênh", district_code: "305" },
  { code: "11401", name: "Phường An Dương", district_code: "305" },
  { code: "11404", name: "Phường Dư Hàng Kênh", district_code: "305" },
  { code: "11405", name: "Phường Kênh Dương", district_code: "305" },
  { code: "11407", name: "Phường Vĩnh Niệm", district_code: "305" },
  { code: "11410", name: "Phường Đông Hải 1", district_code: "306" },
  { code: "11411", name: "Phường Đông Hải 2", district_code: "306" },
  { code: "11413", name: "Phường Đằng Lâm", district_code: "306" },
  { code: "11414", name: "Phường Thành Tô", district_code: "306" },
  { code: "11416", name: "Phường Đằng Hải", district_code: "306" },
  { code: "11419", name: "Phường Nam Hải", district_code: "306" },
  { code: "11422", name: "Phường Cát Bi", district_code: "306" },
  { code: "11425", name: "Phường Tràng Cát", district_code: "306" },
  { code: "11431", name: "Phường Đồng Hoà", district_code: "307" },
  { code: "11434", name: "Phường Bắc Sơn", district_code: "307" },
  { code: "11437", name: "Phường Nam Sơn", district_code: "307" },
  { code: "11440", name: "Phường Ngọc Sơn", district_code: "307" },
  { code: "11443", name: "Phường Trần Thành Ngọ", district_code: "307" },
  { code: "11446", name: "Phường Văn Đẩu", district_code: "307" },
  { code: "11449", name: "Phường Bắc Hà", district_code: "307" },
  { code: "11455", name: "Phường Ngọc Xuyên", district_code: "308" },
  { code: "11458", name: "Phường Hải Sơn", district_code: "308" },
  { code: "11461", name: "Phường Vạn Hương", district_code: "308" },
  { code: "11465", name: "Phường Minh Đức", district_code: "308" },
  { code: "11467", name: "Phường Bàng La", district_code: "308" },
  { code: "11737", name: "Phường Hợp Đức", district_code: "308" },
  { code: "11683", name: "Phường Đa Phúc", district_code: "309" },
  { code: "11686", name: "Phường Hưng Đạo", district_code: "309" },
  { code: "11689", name: "Phường Anh Dũng", district_code: "309" },
  { code: "11692", name: "Phường Hải Thành", district_code: "309" },
  { code: "11707", name: "Phường Hoà Nghĩa", district_code: "309" },
  { code: "11740", name: "Phường Tân Thành", district_code: "309" },
  { code: "11473", name: "Phường Minh Đức", district_code: "311" },
  { code: "11485", name: "Xã Liên Xuân", district_code: "311" },
  { code: "11488", name: "Phường Lưu Kiếm", district_code: "311" },
  { code: "11500", name: "Xã Bạch Đằng", district_code: "311" },
  { code: "11503", name: "Xã Ninh Sơn", district_code: "311" },
  { code: "11506", name: "Phường Quảng Thanh", district_code: "311" },
  { code: "11512", name: "Phường Trần Hưng Đạo", district_code: "311" },
  { code: "11518", name: "Xã Quang Trung", district_code: "311" },
  { code: "11521", name: "Phường Lê Hồng Phong", district_code: "311" },
  { code: "11527", name: "Phường Hoà Bình", district_code: "311" },
  { code: "11530", name: "Phường Thủy Hà", district_code: "311" },
  { code: "11533", name: "Phường An Lư", district_code: "311" },
  { code: "11539", name: "Phường Phạm Ngũ Lão", district_code: "311" },
  { code: "11542", name: "Phường Nam Triệu Giang", district_code: "311" },
  { code: "11545", name: "Phường Tam Hưng", district_code: "311" },
  { code: "11551", name: "Phường Lập Lễ", district_code: "311" },
  { code: "11557", name: "Phường Thiên Hương", district_code: "311" },
  { code: "11560", name: "Phường Thuỷ Đường", district_code: "311" },
  { code: "11569", name: "Phường Hoàng Lâm", district_code: "311" },
  { code: "11572", name: "Phường Hoa Động", district_code: "311" },
  { code: "11578", name: "Phường Dương Quan", district_code: "311" },
  { code: "11581", name: "Phường Lê Lợi", district_code: "312" },
  { code: "11584", name: "Phường Lê Thiện", district_code: "312" },
  { code: "11590", name: "Phường An Hoà", district_code: "312" },
  { code: "11593", name: "Phường Hồng Phong", district_code: "312" },
  { code: "11596", name: "Phường Tân Tiến", district_code: "312" },
  { code: "11608", name: "Phường Nam Sơn", district_code: "312" },
  { code: "11614", name: "Phường An Hải", district_code: "312" },
  { code: "11617", name: "Phường Đồng Thái", district_code: "312" },
  { code: "11623", name: "Phường An Đồng", district_code: "312" },
  { code: "11626", name: "Phường Hồng Thái", district_code: "312" },
  { code: "11629", name: "Thị trấn An Lão", district_code: "313" },
  { code: "11632", name: "Xã Bát Trang", district_code: "313" },
  { code: "11635", name: "Xã Trường Thọ", district_code: "313" },
  { code: "11638", name: "Xã Trường Thành", district_code: "313" },
  { code: "11641", name: "Xã An Tiến", district_code: "313" },
  { code: "11644", name: "Xã Quang Hưng", district_code: "313" },
  { code: "11647", name: "Xã Quang Trung", district_code: "313" },
  { code: "11650", name: "Xã Quốc Tuấn", district_code: "313" },
  { code: "11653", name: "Xã An Thắng", district_code: "313" },
  { code: "11656", name: "Thị trấn Trường Sơn", district_code: "313" },
  { code: "11659", name: "Xã Tân Dân", district_code: "313" },
  { code: "11662", name: "Xã Thái Sơn", district_code: "313" },
  { code: "11665", name: "Xã Tân Viên", district_code: "313" },
  { code: "11668", name: "Xã Mỹ Đức", district_code: "313" },
  { code: "11671", name: "Xã Chiến Thắng", district_code: "313" },
  { code: "11674", name: "Xã An Thọ", district_code: "313" },
  { code: "11677", name: "Xã An Thái", district_code: "313" },
  { code: "11680", name: "Thị trấn Núi Đối", district_code: "314" },
  { code: "11695", name: "Xã Đông Phương", district_code: "314" },
  { code: "11698", name: "Xã Thuận Thiên", district_code: "314" },
  { code: "11701", name: "Xã Hữu Bằng", district_code: "314" },
  { code: "11704", name: "Xã Đại Đồng", district_code: "314" },
  { code: "11710", name: "Xã Ngũ Phúc", district_code: "314" },
  { code: "11713", name: "Xã Kiến Quốc", district_code: "314" },
  { code: "11716", name: "Xã Du Lễ", district_code: "314" },
  { code: "11722", name: "Xã Thanh Sơn", district_code: "314" },
  { code: "11725", name: "Xã Minh Tân", district_code: "314" },
  { code: "11728", name: "Xã Kiến Hưng", district_code: "314" },
  { code: "11734", name: "Xã Tân Phong", district_code: "314" },
  { code: "11743", name: "Xã Tân Trào", district_code: "314" },
  { code: "11746", name: "Xã Đoàn Xá", district_code: "314" },
  { code: "11749", name: "Xã Tú Sơn", district_code: "314" },
  { code: "11752", name: "Xã Đại Hợp", district_code: "314" },
  { code: "11755", name: "Thị trấn Tiên Lãng", district_code: "315" },
  { code: "11758", name: "Xã Đại Thắng", district_code: "315" },
  { code: "11761", name: "Xã Tiên Cường", district_code: "315" },
  { code: "11764", name: "Xã Tự Cường", district_code: "315" },
  { code: "11770", name: "Xã Quyết Tiến", district_code: "315" },
  { code: "11773", name: "Xã Khởi Nghĩa", district_code: "315" },
  { code: "11776", name: "Xã Tiên Thanh", district_code: "315" },
  { code: "11779", name: "Xã Cấp Tiến", district_code: "315" },
  { code: "11782", name: "Xã Kiến Thiết", district_code: "315" },
  { code: "11785", name: "Xã Đoàn Lập", district_code: "315" },
  { code: "11791", name: "Xã Tân Minh", district_code: "315" },
  { code: "11797", name: "Xã Tiên Thắng", district_code: "315" },
  { code: "11800", name: "Xã Tiên Minh", district_code: "315" },
  { code: "11803", name: "Xã Bắc Hưng", district_code: "315" },
  { code: "11806", name: "Xã Nam Hưng", district_code: "315" },
  { code: "11809", name: "Xã Hùng Thắng", district_code: "315" },
  { code: "11812", name: "Xã Tây Hưng", district_code: "315" },
  { code: "11815", name: "Xã Đông Hưng", district_code: "315" },
  { code: "11821", name: "Xã Vinh Quang", district_code: "315" },
  { code: "11824", name: "Thị trấn Vĩnh Bảo", district_code: "316" },
  { code: "11827", name: "Xã Dũng Tiến", district_code: "316" },
  { code: "11830", name: "Xã Giang Biên", district_code: "316" },
  { code: "11833", name: "Xã Thắng Thuỷ", district_code: "316" },
  { code: "11836", name: "Xã Trung Lập", district_code: "316" },
  { code: "11839", name: "Xã Việt Tiến", district_code: "316" },
  { code: "11842", name: "Xã Vĩnh An", district_code: "316" },
  { code: "11848", name: "Xã Vĩnh Hoà", district_code: "316" },
  { code: "11851", name: "Xã Hùng Tiến", district_code: "316" },
  { code: "11857", name: "Xã Tân Hưng", district_code: "316" },
  { code: "11860", name: "Xã Tân Liên", district_code: "316" },
  { code: "11866", name: "Xã Vĩnh Hưng", district_code: "316" },
  { code: "11875", name: "Xã Vĩnh Hải", district_code: "316" },
  { code: "11881", name: "Xã Liên Am", district_code: "316" },
  { code: "11884", name: "Xã Lý Học", district_code: "316" },
  { code: "11887", name: "Xã Tam Cường", district_code: "316" },
  { code: "11890", name: "Xã Hoà Bình", district_code: "316" },
  { code: "11893", name: "Xã Tiền Phong", district_code: "316" },
  { code: "11902", name: "Xã Cao Minh", district_code: "316" },
  { code: "11911", name: "Xã Trấn Dương", district_code: "316" },
  { code: "11914", name: "Thị trấn Cát Bà", district_code: "317" },
  { code: "11917", name: "Thị trấn Cát Hải", district_code: "317" },
  { code: "11920", name: "Xã Nghĩa Lộ", district_code: "317" },
  { code: "11923", name: "Xã Đồng Bài", district_code: "317" },
  { code: "11926", name: "Xã Hoàng Châu", district_code: "317" },
  { code: "11929", name: "Xã Văn Phong", district_code: "317" },
  { code: "11932", name: "Xã Phù Long", district_code: "317" },
  { code: "11935", name: "Xã Gia Luận", district_code: "317" },
  { code: "11938", name: "Xã Hiền Hào", district_code: "317" },
  { code: "11941", name: "Xã Trân Châu", district_code: "317" },
  { code: "11944", name: "Xã Việt Hải", district_code: "317" },
  { code: "11947", name: "Xã Xuân Đám", district_code: "317" },
  { code: "11950", name: "Phường Lam Sơn", district_code: "323" },
  { code: "11953", name: "Phường Hiến Nam", district_code: "323" },
  { code: "11956", name: "Phường An Tảo", district_code: "323" },
  { code: "11959", name: "Phường Lê Lợi", district_code: "323" },
  { code: "11962", name: "Phường Minh Khai", district_code: "323" },
  { code: "11968", name: "Phường Hồng Châu", district_code: "323" },
  { code: "11971", name: "Xã Trung Nghĩa", district_code: "323" },
  { code: "11974", name: "Xã Liên Phương", district_code: "323" },
  { code: "11977", name: "Xã Phương Nam", district_code: "323" },
  { code: "11980", name: "Xã Quảng Châu", district_code: "323" },
  { code: "11983", name: "Xã Bảo Khê", district_code: "323" },
  { code: "12331", name: "Xã Phú Cường", district_code: "323" },
  { code: "12334", name: "Xã Hùng Cường", district_code: "323" },
  { code: "12385", name: "Xã Tân Hưng", district_code: "323" },
  { code: "12388", name: "Xã Hoàng Hanh", district_code: "323" },
  { code: "11986", name: "Thị trấn Như Quỳnh", district_code: "325" },
  { code: "11989", name: "Xã Lạc Đạo", district_code: "325" },
  { code: "11992", name: "Xã Chỉ Đạo", district_code: "325" },
  { code: "11995", name: "Xã Đại Đồng", district_code: "325" },
  { code: "11998", name: "Xã Việt Hưng", district_code: "325" },
  { code: "12001", name: "Xã Tân Quang", district_code: "325" },
  { code: "12004", name: "Xã Đình Dù", district_code: "325" },
  { code: "12007", name: "Xã Minh Hải", district_code: "325" },
  { code: "12010", name: "Xã Lương Tài", district_code: "325" },
  { code: "12013", name: "Xã Trưng Trắc", district_code: "325" },
  { code: "12016", name: "Xã Lạc Hồng", district_code: "325" },
  { code: "12019", name: "Thị trấn Văn Giang", district_code: "326" },
  { code: "12022", name: "Xã Xuân Quan", district_code: "326" },
  { code: "12025", name: "Xã Cửu Cao", district_code: "326" },
  { code: "12028", name: "Xã Phụng Công", district_code: "326" },
  { code: "12031", name: "Xã Nghĩa Trụ", district_code: "326" },
  { code: "12034", name: "Xã Long Hưng", district_code: "326" },
  { code: "12037", name: "Xã Vĩnh Khúc", district_code: "326" },
  { code: "12040", name: "Xã Liên Nghĩa", district_code: "326" },
  { code: "12043", name: "Xã Tân Tiến", district_code: "326" },
  { code: "12046", name: "Xã Thắng Lợi", district_code: "326" },
  { code: "12049", name: "Xã Mễ Sở", district_code: "326" },
  { code: "12052", name: "Thị trấn Yên Mỹ", district_code: "327" },
  { code: "12055", name: "Xã Nguyễn Văn Linh", district_code: "327" },
  { code: "12061", name: "Xã Đồng Than", district_code: "327" },
  { code: "12064", name: "Xã Ngọc Long", district_code: "327" },
  { code: "12067", name: "Xã Liêu Xá", district_code: "327" },
  { code: "12070", name: "Xã Hoàn Long", district_code: "327" },
  { code: "12073", name: "Xã Tân Lập", district_code: "327" },
  { code: "12076", name: "Xã Thanh Long", district_code: "327" },
  { code: "12079", name: "Xã Yên Phú", district_code: "327" },
  { code: "12085", name: "Xã Trung Hòa", district_code: "327" },
  { code: "12091", name: "Xã Việt Yên", district_code: "327" },
  { code: "12100", name: "Xã Tân Minh", district_code: "327" },
  { code: "12103", name: "Phường Bần Yên Nhân", district_code: "328" },
  { code: "12106", name: "Phường Phan Đình Phùng", district_code: "328" },
  { code: "12109", name: "Xã Cẩm Xá", district_code: "328" },
  { code: "12112", name: "Xã Dương Quang", district_code: "328" },
  { code: "12115", name: "Xã Hòa Phong", district_code: "328" },
  { code: "12118", name: "Phường Nhân Hòa", district_code: "328" },
  { code: "12121", name: "Phường Dị Sử", district_code: "328" },
  { code: "12124", name: "Phường Bạch Sam", district_code: "328" },
  { code: "12127", name: "Phường Minh Đức", district_code: "328" },
  { code: "12130", name: "Phường Phùng Chí Kiên", district_code: "328" },
  { code: "12133", name: "Xã Xuân Dục", district_code: "328" },
  { code: "12136", name: "Xã Ngọc Lâm", district_code: "328" },
  { code: "12139", name: "Xã Hưng Long", district_code: "328" },
  { code: "12142", name: "Thị trấn Ân Thi", district_code: "329" },
  { code: "12145", name: "Xã Phù Ủng", district_code: "329" },
  { code: "12148", name: "Xã Bắc Sơn", district_code: "329" },
  { code: "12151", name: "Xã Bãi Sậy", district_code: "329" },
  { code: "12154", name: "Xã Đào Dương", district_code: "329" },
  { code: "12157", name: "Xã Quang Vinh", district_code: "329" },
  { code: "12160", name: "Xã Vân Du", district_code: "329" },
  { code: "12166", name: "Xã Xuân Trúc", district_code: "329" },
  { code: "12169", name: "Xã Hoàng Hoa Thám", district_code: "329" },
  { code: "12172", name: "Xã Quảng Lãng", district_code: "329" },
  { code: "12175", name: "Xã Đa Lộc", district_code: "329" },
  { code: "12178", name: "Xã Đặng Lễ", district_code: "329" },
  { code: "12181", name: "Xã Cẩm Ninh", district_code: "329" },
  { code: "12184", name: "Xã Nguyễn Trãi", district_code: "329" },
  { code: "12190", name: "Xã Hồ Tùng Mậu", district_code: "329" },
  { code: "12193", name: "Xã Tiền Phong", district_code: "329" },
  { code: "12196", name: "Xã Hồng Quang", district_code: "329" },
  { code: "12202", name: "Xã Hạ Lễ", district_code: "329" },
  { code: "12205", name: "Thị trấn Khoái Châu", district_code: "330" },
  { code: "12208", name: "Xã Đông Tảo", district_code: "330" },
  { code: "12211", name: "Xã Bình Minh", district_code: "330" },
  { code: "12214", name: "Xã Phạm Hồng Thái", district_code: "330" },
  { code: "12220", name: "Xã Ông Đình", district_code: "330" },
  { code: "12223", name: "Xã Tân Dân", district_code: "330" },
  { code: "12226", name: "Xã Tứ Dân", district_code: "330" },
  { code: "12229", name: "Xã An Vĩ", district_code: "330" },
  { code: "12232", name: "Xã Đông Kết", district_code: "330" },
  { code: "12238", name: "Xã Dân Tiến", district_code: "330" },
  { code: "12244", name: "Xã Đồng Tiến", district_code: "330" },
  { code: "12247", name: "Xã Tân Châu", district_code: "330" },
  { code: "12250", name: "Xã Liên Khê", district_code: "330" },
  { code: "12253", name: "Xã Phùng Hưng", district_code: "330" },
  { code: "12256", name: "Xã Việt Hòa", district_code: "330" },
  { code: "12259", name: "Xã Đông Ninh", district_code: "330" },
  { code: "12262", name: "Xã Đại Tập", district_code: "330" },
  { code: "12265", name: "Xã Chí Minh", district_code: "330" },
  { code: "12271", name: "Xã Thuần Hưng", district_code: "330" },
  { code: "12274", name: "Xã Nguyễn Huệ", district_code: "330" },
  { code: "12280", name: "Thị trấn Lương Bằng", district_code: "331" },
  { code: "12283", name: "Xã Nghĩa Dân", district_code: "331" },
  { code: "12286", name: "Xã Toàn Thắng", district_code: "331" },
  { code: "12289", name: "Xã Vĩnh Xá", district_code: "331" },
  { code: "12292", name: "Xã Phạm Ngũ Lão", district_code: "331" },
  { code: "12295", name: "Xã Phú Thọ", district_code: "331" },
  { code: "12298", name: "Xã Đồng Thanh", district_code: "331" },
  { code: "12301", name: "Xã Song Mai", district_code: "331" },
  { code: "12304", name: "Xã Chính Nghĩa", district_code: "331" },
  { code: "12313", name: "Xã Mai Động", district_code: "331" },
  { code: "12316", name: "Xã Đức Hợp", district_code: "331" },
  { code: "12319", name: "Xã Hùng An", district_code: "331" },
  { code: "12322", name: "Xã Ngọc Thanh", district_code: "331" },
  { code: "12325", name: "Xã Diên Hồng", district_code: "331" },
  { code: "12328", name: "Xã Hiệp Cường", district_code: "331" },
  { code: "12337", name: "Thị trấn Vương", district_code: "332" },
  { code: "12340", name: "Xã Hưng Đạo", district_code: "332" },
  { code: "12346", name: "Xã Nhật Tân", district_code: "332" },
  { code: "12352", name: "Xã Lệ Xá", district_code: "332" },
  { code: "12355", name: "Xã An Viên", district_code: "332" },
  { code: "12361", name: "Xã Trung Dũng", district_code: "332" },
  { code: "12364", name: "Xã Hải Thắng", district_code: "332" },
  { code: "12367", name: "Xã Thủ Sỹ", district_code: "332" },
  { code: "12370", name: "Xã Thiện Phiến", district_code: "332" },
  { code: "12373", name: "Xã Thụy Lôi", district_code: "332" },
  { code: "12376", name: "Xã Cương Chính", district_code: "332" },
  { code: "12391", name: "Thị trấn Trần Cao", district_code: "333" },
  { code: "12394", name: "Xã Minh Tân", district_code: "333" },
  { code: "12397", name: "Xã Phan Sào Nam", district_code: "333" },
  { code: "12400", name: "Xã Quang Hưng", district_code: "333" },
  { code: "12403", name: "Xã Minh Hoàng", district_code: "333" },
  { code: "12406", name: "Xã Đoàn Đào", district_code: "333" },
  { code: "12409", name: "Xã Tống Phan", district_code: "333" },
  { code: "12412", name: "Xã Đình Cao", district_code: "333" },
  { code: "12415", name: "Xã Nhật Quang", district_code: "333" },
  { code: "12421", name: "Xã Tam Đa", district_code: "333" },
  { code: "12424", name: "Xã Tiên Tiến", district_code: "333" },
  { code: "12427", name: "Xã Nguyên Hòa", district_code: "333" },
  { code: "12430", name: "Xã Tống Trân", district_code: "333" },
  { code: "12433", name: "Phường Lê Hồng Phong", district_code: "336" },
  { code: "12436", name: "Phường Bồ Xuyên", district_code: "336" },
  { code: "12439", name: "Phường Đề Thám", district_code: "336" },
  { code: "12442", name: "Phường Kỳ Bá", district_code: "336" },
  { code: "12445", name: "Phường Quang Trung", district_code: "336" },
  { code: "12448", name: "Phường Phú Khánh", district_code: "336" },
  { code: "12451", name: "Phường Tiền Phong", district_code: "336" },
  { code: "12452", name: "Phường Trần Hưng Đạo", district_code: "336" },
  { code: "12454", name: "Phường Trần Lãm", district_code: "336" },
  { code: "12457", name: "Xã Đông Hòa", district_code: "336" },
  { code: "12460", name: "Phường Hoàng Diệu", district_code: "336" },
  { code: "12463", name: "Xã Phú Xuân", district_code: "336" },
  { code: "12466", name: "Xã Vũ Phúc", district_code: "336" },
  { code: "12469", name: "Xã Vũ Chính", district_code: "336" },
  { code: "12817", name: "Xã Đông Mỹ", district_code: "336" },
  { code: "12820", name: "Xã Đông Thọ", district_code: "336" },
  { code: "13084", name: "Xã Vũ Đông", district_code: "336" },
  { code: "13108", name: "Xã Vũ Lạc", district_code: "336" },
  { code: "13225", name: "Xã Tân Bình", district_code: "336" },
  { code: "12472", name: "Thị trấn Quỳnh Côi", district_code: "338" },
  { code: "12475", name: "Xã An Khê", district_code: "338" },
  { code: "12478", name: "Xã An Đồng", district_code: "338" },
  { code: "12481", name: "Xã Quỳnh Hoa", district_code: "338" },
  { code: "12484", name: "Xã Quỳnh Lâm", district_code: "338" },
  { code: "12487", name: "Xã Quỳnh Thọ", district_code: "338" },
  { code: "12490", name: "Xã An Hiệp", district_code: "338" },
  { code: "12493", name: "Xã Quỳnh Hoàng", district_code: "338" },
  { code: "12496", name: "Xã Quỳnh Giao", district_code: "338" },
  { code: "12499", name: "Xã An Thái", district_code: "338" },
  { code: "12502", name: "Xã An Cầu", district_code: "338" },
  { code: "12505", name: "Xã Quỳnh Hồng", district_code: "338" },
  { code: "12508", name: "Xã Quỳnh Khê", district_code: "338" },
  { code: "12511", name: "Xã Quỳnh Minh", district_code: "338" },
  { code: "12514", name: "Xã An Ninh", district_code: "338" },
  { code: "12517", name: "Xã Quỳnh Ngọc", district_code: "338" },
  { code: "12520", name: "Xã Quỳnh Hải", district_code: "338" },
  { code: "12523", name: "Thị trấn An Bài", district_code: "338" },
  { code: "12526", name: "Xã An Ấp", district_code: "338" },
  { code: "12529", name: "Xã Quỳnh Hội", district_code: "338" },
  { code: "12532", name: "Xã Châu Sơn", district_code: "338" },
  { code: "12535", name: "Xã Quỳnh Mỹ", district_code: "338" },
  { code: "12538", name: "Xã An Quí", district_code: "338" },
  { code: "12541", name: "Xã An Thanh", district_code: "338" },
  { code: "12547", name: "Xã An Vũ", district_code: "338" },
  { code: "12550", name: "Xã An Lễ", district_code: "338" },
  { code: "12553", name: "Xã Quỳnh Hưng", district_code: "338" },
  { code: "12559", name: "Xã An Mỹ", district_code: "338" },
  { code: "12562", name: "Xã Quỳnh Nguyên", district_code: "338" },
  { code: "12565", name: "Xã An Vinh", district_code: "338" },
  { code: "12571", name: "Xã An Dục", district_code: "338" },
  { code: "12574", name: "Xã Đông Hải", district_code: "338" },
  { code: "12577", name: "Xã Trang Bảo Xá", district_code: "338" },
  { code: "12580", name: "Xã An Tràng", district_code: "338" },
  { code: "12583", name: "Xã Đồng Tiến", district_code: "338" },
  { code: "12586", name: "Thị trấn Hưng Hà", district_code: "339" },
  { code: "12589", name: "Xã Quang Trung", district_code: "339" },
  { code: "12592", name: "Xã Tân Lễ", district_code: "339" },
  { code: "12595", name: "Xã Cộng Hòa", district_code: "339" },
  { code: "12601", name: "Xã Canh Tân", district_code: "339" },
  { code: "12604", name: "Xã Hòa Tiến", district_code: "339" },
  { code: "12610", name: "Xã Tân Tiến", district_code: "339" },
  { code: "12613", name: "Thị trấn Hưng Nhân", district_code: "339" },
  { code: "12616", name: "Xã Đoan Hùng", district_code: "339" },
  { code: "12619", name: "Xã Duyên Hải", district_code: "339" },
  { code: "12622", name: "Xã Tân Hòa", district_code: "339" },
  { code: "12625", name: "Xã Văn Cẩm", district_code: "339" },
  { code: "12628", name: "Xã Bắc Sơn", district_code: "339" },
  { code: "12631", name: "Xã Đông Đô", district_code: "339" },
  { code: "12634", name: "Xã Phúc Khánh", district_code: "339" },
  { code: "12637", name: "Xã Liên Hiệp", district_code: "339" },
  { code: "12640", name: "Xã Tây Đô", district_code: "339" },
  { code: "12643", name: "Xã Thống Nhất", district_code: "339" },
  { code: "12646", name: "Xã Tiến Đức", district_code: "339" },
  { code: "12649", name: "Xã Thái Hưng", district_code: "339" },
  { code: "12652", name: "Xã Thái Phương", district_code: "339" },
  { code: "12655", name: "Xã Hòa Bình", district_code: "339" },
  { code: "12656", name: "Xã Chi Lăng", district_code: "339" },
  { code: "12658", name: "Xã Minh Khai", district_code: "339" },
  { code: "12661", name: "Xã Hồng An", district_code: "339" },
  { code: "12664", name: "Xã Kim Chung", district_code: "339" },
  { code: "12667", name: "Xã Hồng Lĩnh", district_code: "339" },
  { code: "12670", name: "Xã Minh Tân", district_code: "339" },
  { code: "12673", name: "Xã Văn Lang", district_code: "339" },
  { code: "12676", name: "Xã Độc Lập", district_code: "339" },
  { code: "12679", name: "Xã Chí Hòa", district_code: "339" },
  { code: "12682", name: "Xã Minh Hòa", district_code: "339" },
  { code: "12685", name: "Xã Hồng Minh", district_code: "339" },
  { code: "12688", name: "Thị trấn Đông Hưng", district_code: "340" },
  { code: "12694", name: "Xã Đông Phương", district_code: "340" },
  { code: "12700", name: "Xã Liên An Đô", district_code: "340" },
  { code: "12703", name: "Xã Đông Sơn", district_code: "340" },
  { code: "12706", name: "Xã Đông Cường", district_code: "340" },
  { code: "12709", name: "Xã Phú Lương", district_code: "340" },
  { code: "12712", name: "Xã Mê Linh", district_code: "340" },
  { code: "12715", name: "Xã Lô Giang", district_code: "340" },
  { code: "12718", name: "Xã Đông La", district_code: "340" },
  { code: "12721", name: "Xã Minh Tân", district_code: "340" },
  { code: "12724", name: "Xã Đông Xá", district_code: "340" },
  { code: "12730", name: "Xã Nguyên Xá", district_code: "340" },
  { code: "12736", name: "Xã Phong Dương Tiến", district_code: "340" },
  { code: "12739", name: "Xã Hồng Việt", district_code: "340" },
  { code: "12745", name: "Xã Hà Giang", district_code: "340" },
  { code: "12748", name: "Xã Đông Kinh", district_code: "340" },
  { code: "12751", name: "Xã Đông Hợp", district_code: "340" },
  { code: "12754", name: "Xã Thăng Long", district_code: "340" },
  { code: "12757", name: "Xã Đông Các", district_code: "340" },
  { code: "12760", name: "Xã Phú Châu", district_code: "340" },
  { code: "12763", name: "Xã Liên Hoa", district_code: "340" },
  { code: "12769", name: "Xã Đông Tân", district_code: "340" },
  { code: "12772", name: "Xã Đông Vinh", district_code: "340" },
  { code: "12775", name: "Xã Xuân Quang Động", district_code: "340" },
  { code: "12778", name: "Xã Hồng Bạch", district_code: "340" },
  { code: "12784", name: "Xã Trọng Quan", district_code: "340" },
  { code: "12790", name: "Xã Hồng Giang", district_code: "340" },
  { code: "12793", name: "Xã Đông Quan", district_code: "340" },
  { code: "12802", name: "Xã Đông Á", district_code: "340" },
  { code: "12808", name: "Xã Đông Hoàng", district_code: "340" },
  { code: "12811", name: "Xã Đông Dương", district_code: "340" },
  { code: "12823", name: "Xã Minh Phú", district_code: "340" },
  { code: "12826", name: "Thị trấn Diêm Điền", district_code: "341" },
  { code: "12832", name: "Xã Thụy Trường", district_code: "341" },
  { code: "12841", name: "Xã Hồng Dũng", district_code: "341" },
  { code: "12844", name: "Xã Thụy Quỳnh", district_code: "341" },
  { code: "12847", name: "Xã An Tân", district_code: "341" },
  { code: "12850", name: "Xã Thụy Ninh", district_code: "341" },
  { code: "12853", name: "Xã Thụy Hưng", district_code: "341" },
  { code: "12856", name: "Xã Thụy Việt", district_code: "341" },
  { code: "12859", name: "Xã Thụy Văn", district_code: "341" },
  { code: "12862", name: "Xã Thụy Xuân", district_code: "341" },
  { code: "12865", name: "Xã Dương Phúc", district_code: "341" },
  { code: "12868", name: "Xã Thụy Trình", district_code: "341" },
  { code: "12871", name: "Xã Thụy Bình", district_code: "341" },
  { code: "12874", name: "Xã Thụy Chính", district_code: "341" },
  { code: "12877", name: "Xã Thụy Dân", district_code: "341" },
  { code: "12880", name: "Xã Thụy Hải", district_code: "341" },
  { code: "12889", name: "Xã Thụy Liên", district_code: "341" },
  { code: "12892", name: "Xã Thụy Duyên", district_code: "341" },
  { code: "12898", name: "Xã Thụy Thanh", district_code: "341" },
  { code: "12901", name: "Xã Thụy Sơn", district_code: "341" },
  { code: "12904", name: "Xã Thụy Phong", district_code: "341" },
  { code: "12907", name: "Xã Thái Thượng", district_code: "341" },
  { code: "12910", name: "Xã Thái Nguyên", district_code: "341" },
  { code: "12916", name: "Xã Dương Hồng Thủy", district_code: "341" },
  { code: "12919", name: "Xã Thái Giang", district_code: "341" },
  { code: "12922", name: "Xã Hòa An", district_code: "341" },
  { code: "12925", name: "Xã Sơn Hà", district_code: "341" },
  { code: "12934", name: "Xã Thái Phúc", district_code: "341" },
  { code: "12937", name: "Xã Thái Hưng", district_code: "341" },
  { code: "12940", name: "Xã Thái Đô", district_code: "341" },
  { code: "12943", name: "Xã Thái Xuyên", district_code: "341" },
  { code: "12949", name: "Xã Mỹ Lộc", district_code: "341" },
  { code: "12958", name: "Xã Tân Học", district_code: "341" },
  { code: "12961", name: "Xã Thái Thịnh", district_code: "341" },
  { code: "12964", name: "Xã Thuần Thành", district_code: "341" },
  { code: "12967", name: "Xã Thái Thọ", district_code: "341" },
  { code: "12970", name: "Thị trấn Tiền Hải", district_code: "342" },
  { code: "12976", name: "Xã Đông Trà", district_code: "342" },
  { code: "12979", name: "Xã Đông Long", district_code: "342" },
  { code: "12985", name: "Xã Vũ Lăng", district_code: "342" },
  { code: "12988", name: "Xã Đông Xuyên", district_code: "342" },
  { code: "12991", name: "Xã Tây Lương", district_code: "342" },
  { code: "12994", name: "Xã Tây Ninh", district_code: "342" },
  { code: "12997", name: "Xã Đông Quang", district_code: "342" },
  { code: "13000", name: "Xã Đông Hoàng", district_code: "342" },
  { code: "13003", name: "Xã Đông Minh", district_code: "342" },
  { code: "13012", name: "Xã An Ninh", district_code: "342" },
  { code: "13018", name: "Xã Đông Cơ", district_code: "342" },
  { code: "13021", name: "Xã Tây Giang", district_code: "342" },
  { code: "13024", name: "Xã Đông Lâm", district_code: "342" },
  { code: "13027", name: "Xã Phương Công", district_code: "342" },
  { code: "13030", name: "Xã Ái Quốc", district_code: "342" },
  { code: "13036", name: "Xã Nam Cường", district_code: "342" },
  { code: "13039", name: "Xã Vân Trường", district_code: "342" },
  { code: "13045", name: "Xã Nam Chính", district_code: "342" },
  { code: "13048", name: "Xã Bắc Hải", district_code: "342" },
  { code: "13051", name: "Xã Nam Thịnh", district_code: "342" },
  { code: "13054", name: "Xã Nam Hà", district_code: "342" },
  { code: "13057", name: "Xã Nam Tiến", district_code: "342" },
  { code: "13060", name: "Xã Nam Trung", district_code: "342" },
  { code: "13063", name: "Xã Nam Hồng", district_code: "342" },
  { code: "13066", name: "Xã Nam Hưng", district_code: "342" },
  { code: "13069", name: "Xã Nam Hải", district_code: "342" },
  { code: "13072", name: "Xã Nam Phú", district_code: "342" },
  { code: "13075", name: "Thị trấn Kiến Xương", district_code: "343" },
  { code: "13078", name: "Xã Trà Giang", district_code: "343" },
  { code: "13081", name: "Xã Quốc Tuấn", district_code: "343" },
  { code: "13087", name: "Xã An Bình", district_code: "343" },
  { code: "13090", name: "Xã Tây Sơn", district_code: "343" },
  { code: "13093", name: "Xã Hồng Thái", district_code: "343" },
  { code: "13096", name: "Xã Bình Nguyên", district_code: "343" },
  { code: "13102", name: "Xã Lê Lợi", district_code: "343" },
  { code: "13111", name: "Xã Vũ Lễ", district_code: "343" },
  { code: "13114", name: "Xã Thanh Tân", district_code: "343" },
  { code: "13120", name: "Xã Thống Nhất", district_code: "343" },
  { code: "13126", name: "Xã Vũ Ninh", district_code: "343" },
  { code: "13129", name: "Xã Vũ An", district_code: "343" },
  { code: "13132", name: "Xã Quang Lịch", district_code: "343" },
  { code: "13135", name: "Xã Hòa Bình", district_code: "343" },
  { code: "13138", name: "Xã Bình Minh", district_code: "343" },
  { code: "13141", name: "Xã Vũ Quí", district_code: "343" },
  { code: "13144", name: "Xã Quang Bình", district_code: "343" },
  { code: "13150", name: "Xã Vũ Trung", district_code: "343" },
  { code: "13156", name: "Xã Vũ Công", district_code: "343" },
  { code: "13159", name: "Xã Hồng Vũ", district_code: "343" },
  { code: "13162", name: "Xã Quang Minh", district_code: "343" },
  { code: "13165", name: "Xã Quang Trung", district_code: "343" },
  { code: "13171", name: "Xã Minh Quang", district_code: "343" },
  { code: "13177", name: "Xã Minh Tân", district_code: "343" },
  { code: "13180", name: "Xã Nam Bình", district_code: "343" },
  { code: "13183", name: "Xã Bình Thanh", district_code: "343" },
  { code: "13186", name: "Xã Bình Định", district_code: "343" },
  { code: "13189", name: "Xã Hồng Tiến", district_code: "343" },
  { code: "13192", name: "Thị trấn Vũ Thư", district_code: "344" },
  { code: "13195", name: "Xã Hồng Lý", district_code: "344" },
  { code: "13198", name: "Xã Đồng Thanh", district_code: "344" },
  { code: "13201", name: "Xã Xuân Hòa", district_code: "344" },
  { code: "13204", name: "Xã Hiệp Hòa", district_code: "344" },
  { code: "13207", name: "Xã Phúc Thành", district_code: "344" },
  { code: "13210", name: "Xã Tân Phong", district_code: "344" },
  { code: "13213", name: "Xã Song Lãng", district_code: "344" },
  { code: "13216", name: "Xã Tân Hòa", district_code: "344" },
  { code: "13219", name: "Xã Việt Hùng", district_code: "344" },
  { code: "13222", name: "Xã Minh Lãng", district_code: "344" },
  { code: "13228", name: "Xã Minh Khai", district_code: "344" },
  { code: "13231", name: "Xã Dũng Nghĩa", district_code: "344" },
  { code: "13234", name: "Xã Minh Quang", district_code: "344" },
  { code: "13237", name: "Xã Tam Quang", district_code: "344" },
  { code: "13240", name: "Xã Tân Lập", district_code: "344" },
  { code: "13243", name: "Xã Bách Thuận", district_code: "344" },
  { code: "13246", name: "Xã Tự Tân", district_code: "344" },
  { code: "13249", name: "Xã Song An", district_code: "344" },
  { code: "13252", name: "Xã Trung An", district_code: "344" },
  { code: "13255", name: "Xã Vũ Hội", district_code: "344" },
  { code: "13258", name: "Xã Hòa Bình", district_code: "344" },
  { code: "13261", name: "Xã Nguyên Xá", district_code: "344" },
  { code: "13264", name: "Xã Việt Thuận", district_code: "344" },
  { code: "13267", name: "Xã Vũ Vinh", district_code: "344" },
  { code: "13270", name: "Xã Vũ Đoài", district_code: "344" },
  { code: "13273", name: "Xã Vũ Tiến", district_code: "344" },
  { code: "13276", name: "Xã Vũ Vân", district_code: "344" },
  { code: "13279", name: "Xã Duy Nhất", district_code: "344" },
  { code: "13282", name: "Xã Hồng Phong", district_code: "344" },
  { code: "13285", name: "Phường Quang Trung", district_code: "347" },
  { code: "13291", name: "Phường Lê Hồng Phong", district_code: "347" },
  { code: "13294", name: "Phường Châu Cầu", district_code: "347" },
  { code: "13303", name: "Phường Lam Hạ", district_code: "347" },
  { code: "13306", name: "Xã Phù Vân", district_code: "347" },
  { code: "13309", name: "Phường Liêm Chính", district_code: "347" },
  { code: "13315", name: "Phường Thanh Châu", district_code: "347" },
  { code: "13318", name: "Phường Châu Sơn", district_code: "347" },
  { code: "13366", name: "Phường Tân Hiệp", district_code: "347" },
  { code: "13426", name: "Xã Kim Bình", district_code: "347" },
  { code: "13444", name: "Phường Tân Liêm", district_code: "347" },
  { code: "13459", name: "Phường Thanh Tuyền", district_code: "347" },
  { code: "13507", name: "Xã Đinh Xá", district_code: "347" },
  { code: "13513", name: "Xã Trịnh Xá", district_code: "347" },
  { code: "13321", name: "Phường Đồng Văn", district_code: "349" },
  { code: "13324", name: "Phường Hòa Mạc", district_code: "349" },
  { code: "13327", name: "Xã Mộc Hoàn", district_code: "349" },
  { code: "13330", name: "Phường Châu Giang", district_code: "349" },
  { code: "13333", name: "Phường Bạch Thượng", district_code: "349" },
  { code: "13336", name: "Phường Duy Minh", district_code: "349" },
  { code: "13342", name: "Phường Duy Hải", district_code: "349" },
  { code: "13345", name: "Xã Chuyên Ngoại", district_code: "349" },
  { code: "13348", name: "Phường Yên Bắc", district_code: "349" },
  { code: "13351", name: "Xã Trác Văn", district_code: "349" },
  { code: "13354", name: "Phường Tiên Nội", district_code: "349" },
  { code: "13357", name: "Phường Hoàng Đông", district_code: "349" },
  { code: "13360", name: "Xã Yên Nam", district_code: "349" },
  { code: "13363", name: "Xã Tiên Ngoại", district_code: "349" },
  { code: "13369", name: "Xã Tiên Sơn", district_code: "349" },
  { code: "13384", name: "Phường Quế", district_code: "350" },
  { code: "13387", name: "Xã Nguyễn Úy", district_code: "350" },
  { code: "13390", name: "Phường Đại Cương", district_code: "350" },
  { code: "13393", name: "Phường Lê Hồ", district_code: "350" },
  { code: "13396", name: "Phường Tượng Lĩnh", district_code: "350" },
  { code: "13402", name: "Phường Tân Tựu", district_code: "350" },
  { code: "13405", name: "Phường Đồng Hóa", district_code: "350" },
  { code: "13408", name: "Xã Hoàng Tây", district_code: "350" },
  { code: "13411", name: "Phường Tân Sơn", district_code: "350" },
  { code: "13414", name: "Xã Thụy Lôi", district_code: "350" },
  { code: "13417", name: "Xã Văn Xá", district_code: "350" },
  { code: "13420", name: "Xã Khả Phong", district_code: "350" },
  { code: "13423", name: "Phường Ngọc Sơn", district_code: "350" },
  { code: "13429", name: "Phường Ba Sao", district_code: "350" },
  { code: "13432", name: "Xã Liên Sơn", district_code: "350" },
  { code: "13435", name: "Phường Thi Sơn", district_code: "350" },
  { code: "13438", name: "Xã Thanh Sơn", district_code: "350" },
  { code: "13441", name: "Thị trấn Kiện Khê", district_code: "351" },
  { code: "13450", name: "Xã Liêm Phong", district_code: "351" },
  { code: "13453", name: "Xã Thanh Hà", district_code: "351" },
  { code: "13456", name: "Xã Liêm Cần", district_code: "351" },
  { code: "13465", name: "Xã Liêm Thuận", district_code: "351" },
  { code: "13468", name: "Xã Thanh Thủy", district_code: "351" },
  { code: "13471", name: "Xã Thanh Phong", district_code: "351" },
  { code: "13474", name: "Thị trấn Tân Thanh", district_code: "351" },
  { code: "13477", name: "Xã Thanh Tân", district_code: "351" },
  { code: "13480", name: "Xã Liêm Túc", district_code: "351" },
  { code: "13483", name: "Xã Liêm Sơn", district_code: "351" },
  { code: "13486", name: "Xã Thanh Hương", district_code: "351" },
  { code: "13489", name: "Xã Thanh Nghị", district_code: "351" },
  { code: "13492", name: "Xã Thanh Tâm", district_code: "351" },
  { code: "13495", name: "Xã Thanh Nguyên", district_code: "351" },
  { code: "13498", name: "Xã Thanh Hải", district_code: "351" },
  { code: "13501", name: "Thị trấn Bình Mỹ", district_code: "352" },
  { code: "13504", name: "Xã Bình Nghĩa", district_code: "352" },
  { code: "13510", name: "Xã Tràng An", district_code: "352" },
  { code: "13516", name: "Xã Đồng Du", district_code: "352" },
  { code: "13519", name: "Xã Ngọc Lũ", district_code: "352" },
  { code: "13525", name: "Xã Đồn Xá", district_code: "352" },
  { code: "13528", name: "Xã An Ninh", district_code: "352" },
  { code: "13531", name: "Xã Bồ Đề", district_code: "352" },
  { code: "13540", name: "Xã Bình An", district_code: "352" },
  { code: "13543", name: "Xã Vũ Bản", district_code: "352" },
  { code: "13546", name: "Xã Trung Lương", district_code: "352" },
  { code: "13552", name: "Xã An Đổ", district_code: "352" },
  { code: "13555", name: "Xã La Sơn", district_code: "352" },
  { code: "13558", name: "Xã Tiêu Động", district_code: "352" },
  { code: "13561", name: "Xã An Lão", district_code: "352" },
  { code: "13567", name: "Xã Hợp Lý", district_code: "353" },
  { code: "13570", name: "Xã Nguyên Lý", district_code: "353" },
  { code: "13573", name: "Xã Chính Lý", district_code: "353" },
  { code: "13576", name: "Xã Chân Lý", district_code: "353" },
  { code: "13579", name: "Xã Đạo Lý", district_code: "353" },
  { code: "13582", name: "Xã Công Lý", district_code: "353" },
  { code: "13585", name: "Xã Văn Lý", district_code: "353" },
  { code: "13588", name: "Xã Bắc Lý", district_code: "353" },
  { code: "13591", name: "Xã Đức Lý", district_code: "353" },
  { code: "13594", name: "Xã Trần Hưng Đạo", district_code: "353" },
  { code: "13597", name: "Thị trấn Vĩnh Trụ", district_code: "353" },
  { code: "13600", name: "Xã Nhân Thịnh", district_code: "353" },
  { code: "13606", name: "Xã Nhân Khang", district_code: "353" },
  { code: "13609", name: "Xã Nhân Mỹ", district_code: "353" },
  { code: "13612", name: "Xã Nhân Nghĩa", district_code: "353" },
  { code: "13615", name: "Xã Nhân Chính", district_code: "353" },
  { code: "13618", name: "Xã Nhân Bình", district_code: "353" },
  { code: "13621", name: "Xã Phú Phúc", district_code: "353" },
  { code: "13624", name: "Xã Xuân Khê", district_code: "353" },
  { code: "13627", name: "Xã Tiến Thắng", district_code: "353" },
  { code: "13630", name: "Xã Hòa Hậu", district_code: "353" },
  { code: "13636", name: "Phường Vị Xuyên", district_code: "356" },
  { code: "13657", name: "Phường Trường Thi", district_code: "356" },
  { code: "13666", name: "Phường Trần Hưng Đạo", district_code: "356" },
  { code: "13669", name: "Phường Cửa Bắc", district_code: "356" },
  { code: "13678", name: "Phường Năng Tĩnh", district_code: "356" },
  { code: "13681", name: "Phường Quang Trung", district_code: "356" },
  { code: "13684", name: "Phường Lộc Hạ", district_code: "356" },
  { code: "13687", name: "Phường Lộc Vượng", district_code: "356" },
  { code: "13690", name: "Phường Cửa Nam", district_code: "356" },
  { code: "13693", name: "Phường Lộc Hòa", district_code: "356" },
  { code: "13696", name: "Phường Nam Phong", district_code: "356" },
  { code: "13699", name: "Phường Mỹ Xá", district_code: "356" },
  { code: "13705", name: "Phường Nam Vân", district_code: "356" },
  { code: "13708", name: "Phường Hưng Lộc", district_code: "356" },
  { code: "13711", name: "Xã Mỹ Hà", district_code: "356" },
  { code: "13717", name: "Xã Mỹ Thắng", district_code: "356" },
  { code: "13720", name: "Xã Mỹ Trung", district_code: "356" },
  { code: "13723", name: "Xã Mỹ Tân", district_code: "356" },
  { code: "13726", name: "Xã Mỹ Phúc", district_code: "356" },
  { code: "13732", name: "Xã Mỹ Thuận", district_code: "356" },
  { code: "13735", name: "Xã Mỹ Lộc", district_code: "356" },
  { code: "13741", name: "Thị trấn Gôi", district_code: "359" },
  { code: "13747", name: "Xã Hiển Khánh", district_code: "359" },
  { code: "13750", name: "Xã Minh Tân", district_code: "359" },
  { code: "13753", name: "Xã Hợp Hưng", district_code: "359" },
  { code: "13756", name: "Xã Đại An", district_code: "359" },
  { code: "13762", name: "Xã Cộng Hòa", district_code: "359" },
  { code: "13765", name: "Xã Trung Thành", district_code: "359" },
  { code: "13768", name: "Xã Quang Trung", district_code: "359" },
  { code: "13777", name: "Xã Thành Lợi", district_code: "359" },
  { code: "13780", name: "Xã Kim Thái", district_code: "359" },
  { code: "13783", name: "Xã Liên Minh", district_code: "359" },
  { code: "13786", name: "Xã Đại Thắng", district_code: "359" },
  { code: "13789", name: "Xã Tam Thanh", district_code: "359" },
  { code: "13792", name: "Xã Vĩnh Hào", district_code: "359" },
  { code: "13795", name: "Thị trấn Lâm", district_code: "360" },
  { code: "13801", name: "Xã Trung Nghĩa", district_code: "360" },
  { code: "13807", name: "Xã Tân Minh", district_code: "360" },
  { code: "13810", name: "Xã Yên Thọ", district_code: "360" },
  { code: "13819", name: "Xã Phú Hưng", district_code: "360" },
  { code: "13822", name: "Xã Yên Chính", district_code: "360" },
  { code: "13825", name: "Xã Yên Bình", district_code: "360" },
  { code: "13831", name: "Xã Yên Mỹ", district_code: "360" },
  { code: "13834", name: "Xã Yên Dương", district_code: "360" },
  { code: "13843", name: "Xã Yên Khánh", district_code: "360" },
  { code: "13846", name: "Xã Yên Phong", district_code: "360" },
  { code: "13849", name: "Xã Yên Ninh", district_code: "360" },
  { code: "13852", name: "Xã Yên Lương", district_code: "360" },
  { code: "13861", name: "Xã Yên Tiến", district_code: "360" },
  { code: "13864", name: "Xã Yên Thắng", district_code: "360" },
  { code: "13867", name: "Xã Yên Phúc", district_code: "360" },
  { code: "13870", name: "Xã Yên Cường", district_code: "360" },
  { code: "13873", name: "Xã Yên Lộc", district_code: "360" },
  { code: "13876", name: "Xã Hồng Quang", district_code: "360" },
  { code: "13879", name: "Xã Yên Đồng", district_code: "360" },
  { code: "13882", name: "Xã Yên Khang", district_code: "360" },
  { code: "13885", name: "Xã Yên Nhân", district_code: "360" },
  { code: "13888", name: "Xã Yên Trị", district_code: "360" },
  { code: "13891", name: "Thị trấn Liễu Đề", district_code: "361" },
  { code: "13894", name: "Thị trấn Rạng Đông", district_code: "361" },
  { code: "13900", name: "Xã Đồng Thịnh", district_code: "361" },
  { code: "13906", name: "Xã Nghĩa Thái", district_code: "361" },
  { code: "13909", name: "Xã Hoàng Nam", district_code: "361" },
  { code: "13912", name: "Xã Nghĩa Châu", district_code: "361" },
  { code: "13915", name: "Xã Nghĩa Trung", district_code: "361" },
  { code: "13918", name: "Xã Nghĩa Sơn", district_code: "361" },
  { code: "13921", name: "Xã Nghĩa Lạc", district_code: "361" },
  { code: "13924", name: "Xã Nghĩa Hồng", district_code: "361" },
  { code: "13927", name: "Xã Nghĩa Phong", district_code: "361" },
  { code: "13930", name: "Xã Nghĩa Phú", district_code: "361" },
  { code: "13939", name: "Thị trấn Quỹ Nhất", district_code: "361" },
  { code: "13942", name: "Xã Nghĩa Hùng", district_code: "361" },
  { code: "13945", name: "Xã Nghĩa Lâm", district_code: "361" },
  { code: "13948", name: "Xã Nghĩa Thành", district_code: "361" },
  { code: "13951", name: "Xã Phúc Thắng", district_code: "361" },
  { code: "13954", name: "Xã Nghĩa Lợi", district_code: "361" },
  { code: "13957", name: "Xã Nghĩa Hải", district_code: "361" },
  { code: "13963", name: "Xã Nam Điền", district_code: "361" },
  { code: "13966", name: "Thị trấn Nam Giang", district_code: "362" },
  { code: "13972", name: "Xã Nam Điền", district_code: "362" },
  { code: "13975", name: "Xã Nghĩa An", district_code: "362" },
  { code: "13978", name: "Xã Nam Thắng", district_code: "362" },
  { code: "13984", name: "Xã Hồng Quang", district_code: "362" },
  { code: "13987", name: "Xã Tân Thịnh", district_code: "362" },
  { code: "13990", name: "Xã Nam Cường", district_code: "362" },
  { code: "13993", name: "Xã Nam Hồng", district_code: "362" },
  { code: "13996", name: "Xã Nam Hùng", district_code: "362" },
  { code: "13999", name: "Xã Nam Hoa", district_code: "362" },
  { code: "14002", name: "Xã Nam Dương", district_code: "362" },
  { code: "14005", name: "Xã Nam Thanh", district_code: "362" },
  { code: "14008", name: "Xã Nam Lợi", district_code: "362" },
  { code: "14011", name: "Xã Bình Minh", district_code: "362" },
  { code: "14014", name: "Xã Đồng Sơn", district_code: "362" },
  { code: "14017", name: "Xã Nam Tiến", district_code: "362" },
  { code: "14020", name: "Xã Nam Hải", district_code: "362" },
  { code: "14023", name: "Xã Nam Thái", district_code: "362" },
  { code: "14026", name: "Thị trấn Cổ Lễ", district_code: "363" },
  { code: "14029", name: "Xã Phương Định", district_code: "363" },
  { code: "14032", name: "Xã Trực Chính", district_code: "363" },
  { code: "14035", name: "Xã Trung Đông", district_code: "363" },
  { code: "14038", name: "Xã Liêm Hải", district_code: "363" },
  { code: "14041", name: "Xã Trực Tuấn", district_code: "363" },
  { code: "14044", name: "Xã Việt Hùng", district_code: "363" },
  { code: "14047", name: "Xã Trực Đạo", district_code: "363" },
  { code: "14050", name: "Xã Trực Hưng", district_code: "363" },
  { code: "14053", name: "Xã Trực Nội", district_code: "363" },
  { code: "14056", name: "Thị trấn Cát Thành", district_code: "363" },
  { code: "14059", name: "Xã Trực Thanh", district_code: "363" },
  { code: "14062", name: "Xã Trực Khang", district_code: "363" },
  { code: "14065", name: "Xã Trực Thuận", district_code: "363" },
  { code: "14068", name: "Xã Trực Mỹ", district_code: "363" },
  { code: "14071", name: "Xã Trực Đại", district_code: "363" },
  { code: "14074", name: "Xã Trực Cường", district_code: "363" },
  { code: "14077", name: "Thị trấn Ninh Cường", district_code: "363" },
  { code: "14080", name: "Xã Trực Thái", district_code: "363" },
  { code: "14083", name: "Xã Trực Hùng", district_code: "363" },
  { code: "14086", name: "Xã Trực Thắng", district_code: "363" },
  { code: "14089", name: "Thị trấn Xuân Trường", district_code: "364" },
  { code: "14092", name: "Xã Xuân Châu", district_code: "364" },
  { code: "14095", name: "Xã Xuân Hồng", district_code: "364" },
  { code: "14098", name: "Xã Xuân Thành", district_code: "364" },
  { code: "14101", name: "Xã Xuân Thượng", district_code: "364" },
  { code: "14104", name: "Xã Xuân Giang", district_code: "364" },
  { code: "14110", name: "Xã Xuân Tân", district_code: "364" },
  { code: "14116", name: "Xã Xuân Ngọc", district_code: "364" },
  { code: "14122", name: "Xã Trà Lũ", district_code: "364" },
  { code: "14125", name: "Xã Thọ Nghiệp", district_code: "364" },
  { code: "14128", name: "Xã Xuân Phú", district_code: "364" },
  { code: "14134", name: "Xã Xuân Vinh", district_code: "364" },
  { code: "14143", name: "Xã Xuân Ninh", district_code: "364" },
  { code: "14146", name: "Xã Xuân Phúc", district_code: "364" },
  { code: "14152", name: "Thị trấn Quất Lâm", district_code: "365" },
  { code: "14155", name: "Xã Giao Hương", district_code: "365" },
  { code: "14158", name: "Xã Hồng Thuận", district_code: "365" },
  { code: "14161", name: "Xã Giao Thiện", district_code: "365" },
  { code: "14164", name: "Xã Giao Thanh", district_code: "365" },
  { code: "14167", name: "Thị trấn Giao Thủy", district_code: "365" },
  { code: "14170", name: "Xã Bình Hòa", district_code: "365" },
  { code: "14176", name: "Xã Giao Hà", district_code: "365" },
  { code: "14179", name: "Xã Giao Nhân", district_code: "365" },
  { code: "14182", name: "Xã Giao An", district_code: "365" },
  { code: "14185", name: "Xã Giao Lạc", district_code: "365" },
  { code: "14188", name: "Xã Giao Châu", district_code: "365" },
  { code: "14191", name: "Xã Giao Tân", district_code: "365" },
  { code: "14194", name: "Xã Giao Yến", district_code: "365" },
  { code: "14197", name: "Xã Giao Xuân", district_code: "365" },
  { code: "14200", name: "Xã Giao Thịnh", district_code: "365" },
  { code: "14203", name: "Xã Giao Hải", district_code: "365" },
  { code: "14206", name: "Xã Bạch Long", district_code: "365" },
  { code: "14209", name: "Xã Giao Long", district_code: "365" },
  { code: "14212", name: "Xã Giao Phong", district_code: "365" },
  { code: "14215", name: "Thị trấn Yên Định", district_code: "366" },
  { code: "14218", name: "Thị trấn Cồn", district_code: "366" },
  { code: "14221", name: "Thị trấn Thịnh Long", district_code: "366" },
  { code: "14224", name: "Xã Hải Nam", district_code: "366" },
  { code: "14227", name: "Xã Hải Trung", district_code: "366" },
  { code: "14233", name: "Xã Hải Minh", district_code: "366" },
  { code: "14236", name: "Xã Hải Anh", district_code: "366" },
  { code: "14248", name: "Xã Hải Hưng", district_code: "366" },
  { code: "14254", name: "Xã Hải Long", district_code: "366" },
  { code: "14260", name: "Xã Hải Đường", district_code: "366" },
  { code: "14263", name: "Xã Hải Lộc", district_code: "366" },
  { code: "14266", name: "Xã Hải Quang", district_code: "366" },
  { code: "14269", name: "Xã Hải Đông", district_code: "366" },
  { code: "14272", name: "Xã Hải Sơn", district_code: "366" },
  { code: "14275", name: "Xã Hải Tân", district_code: "366" },
  { code: "14281", name: "Xã Hải Phong", district_code: "366" },
  { code: "14284", name: "Xã Hải An", district_code: "366" },
  { code: "14287", name: "Xã Hải Tây", district_code: "366" },
  { code: "14293", name: "Xã Hải Phú", district_code: "366" },
  { code: "14296", name: "Xã Hải Giang", district_code: "366" },
  { code: "14302", name: "Xã Hải Ninh", district_code: "366" },
  { code: "14308", name: "Xã Hải Xuân", district_code: "366" },
  { code: "14311", name: "Xã Hải Châu", district_code: "366" },
  { code: "14317", name: "Xã Hải Hòa", district_code: "366" },
  { code: "14362", name: "Phường Bắc Sơn", district_code: "370" },
  { code: "14365", name: "Phường Trung Sơn", district_code: "370" },
  { code: "14368", name: "Phường Nam Sơn", district_code: "370" },
  { code: "14369", name: "Phường Tây Sơn", district_code: "370" },
  { code: "14371", name: "Xã Yên Sơn", district_code: "370" },
  { code: "14374", name: "Phường Yên Bình", district_code: "370" },
  { code: "14375", name: "Phường Tân Bình", district_code: "370" },
  { code: "14377", name: "Xã Quang Sơn", district_code: "370" },
  { code: "14380", name: "Xã Đông Sơn", district_code: "370" },
  { code: "14386", name: "Xã Xích Thổ", district_code: "372" },
  { code: "14389", name: "Xã Gia Lâm", district_code: "372" },
  { code: "14392", name: "Xã Gia Sơn", district_code: "372" },
  { code: "14395", name: "Xã Thạch Bình", district_code: "372" },
  { code: "14398", name: "Xã Gia Thủy", district_code: "372" },
  { code: "14401", name: "Xã Gia Tường", district_code: "372" },
  { code: "14404", name: "Xã Cúc Phương", district_code: "372" },
  { code: "14407", name: "Xã Phú Sơn", district_code: "372" },
  { code: "14410", name: "Xã Đức Long", district_code: "372" },
  { code: "14413", name: "Xã Lạc Vân", district_code: "372" },
  { code: "14416", name: "Xã Đồng Phong", district_code: "372" },
  { code: "14419", name: "Xã Yên Quang", district_code: "372" },
  { code: "14425", name: "Xã Thượng Hòa", district_code: "372" },
  { code: "14428", name: "Thị trấn Nho Quan", district_code: "372" },
  { code: "14431", name: "Xã Văn Phương", district_code: "372" },
  { code: "14434", name: "Xã Thanh Sơn", district_code: "372" },
  { code: "14437", name: "Xã Phúc Sơn", district_code: "372" },
  { code: "14443", name: "Xã Văn Phú", district_code: "372" },
  { code: "14446", name: "Xã Phú Lộc", district_code: "372" },
  { code: "14449", name: "Xã Kỳ Phú", district_code: "372" },
  { code: "14452", name: "Xã Quỳnh Lưu", district_code: "372" },
  { code: "14458", name: "Xã Phú Long", district_code: "372" },
  { code: "14461", name: "Xã Quảng Lạc", district_code: "372" },
  { code: "14464", name: "Thị trấn Thịnh Vượng", district_code: "373" },
  { code: "14467", name: "Xã Gia Hòa", district_code: "373" },
  { code: "14470", name: "Xã Gia Hưng", district_code: "373" },
  { code: "14473", name: "Xã Liên Sơn", district_code: "373" },
  { code: "14476", name: "Xã Gia Thanh", district_code: "373" },
  { code: "14479", name: "Xã Gia Vân", district_code: "373" },
  { code: "14482", name: "Xã Gia Phú", district_code: "373" },
  { code: "14485", name: "Xã Gia Xuân", district_code: "373" },
  { code: "14488", name: "Xã Gia Lập", district_code: "373" },
  { code: "14494", name: "Xã Gia Trấn", district_code: "373" },
  { code: "14500", name: "Xã Gia Phương", district_code: "373" },
  { code: "14503", name: "Xã Gia Tân", district_code: "373" },
  { code: "14506", name: "Xã Tiến Thắng", district_code: "373" },
  { code: "14509", name: "Xã Gia Trung", district_code: "373" },
  { code: "14512", name: "Xã Gia Minh", district_code: "373" },
  { code: "14515", name: "Xã Gia Lạc", district_code: "373" },
  { code: "14521", name: "Xã Gia Sinh", district_code: "373" },
  { code: "14524", name: "Xã Gia Phong", district_code: "373" },
  { code: "14320", name: "Phường Đông Thành", district_code: "374" },
  { code: "14323", name: "Phường Tân Thành", district_code: "374" },
  { code: "14329", name: "Phường Vân Giang", district_code: "374" },
  { code: "14332", name: "Phường Bích Đào", district_code: "374" },
  { code: "14338", name: "Phường Nam Bình", district_code: "374" },
  { code: "14341", name: "Phường Nam Thành", district_code: "374" },
  { code: "14344", name: "Phường Ninh Khánh", district_code: "374" },
  { code: "14347", name: "Xã Ninh Nhất", district_code: "374" },
  { code: "14350", name: "Xã Ninh Tiến", district_code: "374" },
  { code: "14353", name: "Phường Ninh Phúc", district_code: "374" },
  { code: "14356", name: "Phường Ninh Sơn", district_code: "374" },
  { code: "14359", name: "Phường Ninh Phong", district_code: "374" },
  { code: "14527", name: "Phường Ninh Mỹ", district_code: "374" },
  { code: "14530", name: "Phường Ninh Giang", district_code: "374" },
  { code: "14533", name: "Xã Trường Yên", district_code: "374" },
  { code: "14536", name: "Xã Ninh Khang", district_code: "374" },
  { code: "14542", name: "Xã Ninh Hòa", district_code: "374" },
  { code: "14551", name: "Xã Ninh Hải", district_code: "374" },
  { code: "14554", name: "Xã Ninh Vân", district_code: "374" },
  { code: "14557", name: "Xã Ninh An", district_code: "374" },
  { code: "14560", name: "Thị trấn Yên Ninh", district_code: "375" },
  { code: "14563", name: "Xã Khánh Thiện", district_code: "375" },
  { code: "14566", name: "Xã Khánh Phú", district_code: "375" },
  { code: "14569", name: "Xã Khánh Hòa", district_code: "375" },
  { code: "14572", name: "Xã Khánh Lợi", district_code: "375" },
  { code: "14575", name: "Xã Khánh An", district_code: "375" },
  { code: "14578", name: "Xã Khánh Cường", district_code: "375" },
  { code: "14581", name: "Xã Khánh Cư", district_code: "375" },
  { code: "14587", name: "Xã Khánh Hải", district_code: "375" },
  { code: "14590", name: "Xã Khánh Trung", district_code: "375" },
  { code: "14593", name: "Xã Khánh Mậu", district_code: "375" },
  { code: "14596", name: "Xã Khánh Vân", district_code: "375" },
  { code: "14599", name: "Xã Khánh Hội", district_code: "375" },
  { code: "14602", name: "Xã Khánh Công", district_code: "375" },
  { code: "14608", name: "Xã Khánh Thành", district_code: "375" },
  { code: "14611", name: "Xã Khánh Nhạc", district_code: "375" },
  { code: "14614", name: "Xã Khánh Thủy", district_code: "375" },
  { code: "14617", name: "Xã Khánh Hồng", district_code: "375" },
  { code: "14620", name: "Thị trấn Phát Diệm", district_code: "376" },
  { code: "14623", name: "Thị trấn Bình Minh", district_code: "376" },
  { code: "14629", name: "Xã Hồi Ninh", district_code: "376" },
  { code: "14632", name: "Xã Xuân Chính", district_code: "376" },
  { code: "14635", name: "Xã Kim Định", district_code: "376" },
  { code: "14638", name: "Xã Ân Hòa", district_code: "376" },
  { code: "14641", name: "Xã Hùng Tiến", district_code: "376" },
  { code: "14647", name: "Xã Quang Thiện", district_code: "376" },
  { code: "14650", name: "Xã Như Hòa", district_code: "376" },
  { code: "14653", name: "Xã Chất Bình", district_code: "376" },
  { code: "14656", name: "Xã Đồng Hướng", district_code: "376" },
  { code: "14659", name: "Xã Kim Chính", district_code: "376" },
  { code: "14662", name: "Xã Thượng Kiệm", district_code: "376" },
  { code: "14668", name: "Xã Tân Thành", district_code: "376" },
  { code: "14671", name: "Xã Yên Lộc", district_code: "376" },
  { code: "14674", name: "Xã Lai Thành", district_code: "376" },
  { code: "14677", name: "Xã Định Hóa", district_code: "376" },
  { code: "14680", name: "Xã Văn Hải", district_code: "376" },
  { code: "14683", name: "Xã Kim Tân", district_code: "376" },
  { code: "14686", name: "Xã Kim Mỹ", district_code: "376" },
  { code: "14689", name: "Xã Cồn Thoi", district_code: "376" },
  { code: "14695", name: "Xã Kim Trung", district_code: "376" },
  { code: "14698", name: "Xã Kim Đông", district_code: "376" },
  { code: "14701", name: "Thị trấn Yên Thịnh", district_code: "377" },
  { code: "14704", name: "Xã Khánh Thượng", district_code: "377" },
  { code: "14707", name: "Xã Khánh Dương", district_code: "377" },
  { code: "14719", name: "Xã Yên Phong", district_code: "377" },
  { code: "14722", name: "Xã Yên Hòa", district_code: "377" },
  { code: "14725", name: "Xã Yên Thắng", district_code: "377" },
  { code: "14728", name: "Xã Yên Từ", district_code: "377" },
  { code: "14734", name: "Xã Yên Thành", district_code: "377" },
  { code: "14737", name: "Xã Yên Nhân", district_code: "377" },
  { code: "14740", name: "Xã Yên Mỹ", district_code: "377" },
  { code: "14743", name: "Xã Yên Mạc", district_code: "377" },
  { code: "14746", name: "Xã Yên Đồng", district_code: "377" },
  { code: "14749", name: "Xã Yên Thái", district_code: "377" },
  { code: "14752", name: "Xã Yên Lâm", district_code: "377" },
  { code: "14755", name: "Phường Hàm Rồng", district_code: "380" },
  { code: "14758", name: "Phường Đông Thọ", district_code: "380" },
  { code: "14761", name: "Phường Nam Ngạn", district_code: "380" },
  { code: "14764", name: "Phường Trường Thi", district_code: "380" },
  { code: "14767", name: "Phường Điện Biên", district_code: "380" },
  { code: "14770", name: "Phường Phú Sơn", district_code: "380" },
  { code: "14773", name: "Phường Lam Sơn", district_code: "380" },
  { code: "14776", name: "Phường Ba Đình", district_code: "380" },
  { code: "14779", name: "Phường Ngọc Trạo", district_code: "380" },
  { code: "14782", name: "Phường Đông Vệ", district_code: "380" },
  { code: "14785", name: "Phường Đông Sơn", district_code: "380" },
  { code: "14791", name: "Phường Đông Cương", district_code: "380" },
  { code: "14794", name: "Phường Đông Hương", district_code: "380" },
  { code: "14797", name: "Phường Đông Hải", district_code: "380" },
  { code: "14800", name: "Phường Quảng Hưng", district_code: "380" },
  { code: "14803", name: "Phường Quảng Thắng", district_code: "380" },
  { code: "14806", name: "Phường Quảng Thành", district_code: "380" },
  { code: "15850", name: "Xã Thiệu Vân", district_code: "380" },
  { code: "15856", name: "Phường Thiệu Khánh", district_code: "380" },
  { code: "15859", name: "Phường Thiệu Dương", district_code: "380" },
  { code: "15913", name: "Phường Tào Xuyên", district_code: "380" },
  { code: "15922", name: "Phường Long Anh", district_code: "380" },
  { code: "15925", name: "Phường Hoằng Quang", district_code: "380" },
  { code: "15970", name: "Phường Hoằng Đại", district_code: "380" },
  { code: "16378", name: "Phường Rừng Thông", district_code: "380" },
  { code: "16381", name: "Xã Đông Hoàng", district_code: "380" },
  { code: "16384", name: "Xã Đông Ninh", district_code: "380" },
  { code: "16387", name: "Xã Đông Khê", district_code: "380" },
  { code: "16390", name: "Xã Đông Hòa", district_code: "380" },
  { code: "16393", name: "Xã Đông Yên", district_code: "380" },
  { code: "16396", name: "Phường Đông Lĩnh", district_code: "380" },
  { code: "16399", name: "Xã Đông Minh", district_code: "380" },
  { code: "16402", name: "Xã Đông Thanh", district_code: "380" },
  { code: "16405", name: "Xã Đông Tiến", district_code: "380" },
  { code: "16408", name: "Xã Đông Khê", district_code: "380" },
  { code: "16411", name: "Xã Đông Xuân", district_code: "380" },
  { code: "16414", name: "Phường Đông Thịnh", district_code: "380" },
  { code: "16417", name: "Xã Đông Văn", district_code: "380" },
  { code: "16420", name: "Xã Đông Phú", district_code: "380" },
  { code: "16423", name: "Xã Đông Nam", district_code: "380" },
  { code: "16426", name: "Xã Đông Quang", district_code: "380" },
  { code: "16429", name: "Xã Đông Vinh", district_code: "380" },
  { code: "16432", name: "Phường Đông Tân", district_code: "380" },
  { code: "16435", name: "Phường An Hưng", district_code: "380" },
  { code: "16441", name: "Phường Quảng Thịnh", district_code: "380" },
  { code: "16459", name: "Phường Quảng Đông", district_code: "380" },
  { code: "16507", name: "Phường Quảng Cát", district_code: "380" },
  { code: "16522", name: "Phường Quảng Phú", district_code: "380" },
  { code: "16525", name: "Phường Quảng Tâm", district_code: "380" },
  { code: "14809", name: "Phường Bắc Sơn", district_code: "381" },
  { code: "14812", name: "Phường Ba Đình", district_code: "381" },
  { code: "14815", name: "Phường Lam Sơn", district_code: "381" },
  { code: "14818", name: "Phường Ngọc Trạo", district_code: "381" },
  { code: "14821", name: "Phường Đông Sơn", district_code: "381" },
  { code: "14823", name: "Phường Phú Sơn", district_code: "381" },
  { code: "14824", name: "Xã Quang Trung", district_code: "381" },
  { code: "14830", name: "Phường Trung Sơn", district_code: "382" },
  { code: "14833", name: "Phường Bắc Sơn", district_code: "382" },
  { code: "14836", name: "Phường Trường Sơn", district_code: "382" },
  { code: "14839", name: "Phường Quảng Cư", district_code: "382" },
  { code: "14842", name: "Phường Quảng Tiến", district_code: "382" },
  { code: "16513", name: "Xã Quảng Minh", district_code: "382" },
  { code: "16516", name: "Xã Đại Hùng", district_code: "382" },
  { code: "16528", name: "Phường Quảng Thọ", district_code: "382" },
  { code: "16531", name: "Phường Quảng Châu", district_code: "382" },
  { code: "16534", name: "Phường Quảng Vinh", district_code: "382" },
  { code: "14845", name: "Thị trấn Mường Lát", district_code: "384" },
  { code: "14848", name: "Xã Tam Chung", district_code: "384" },
  { code: "14854", name: "Xã Mường Lý", district_code: "384" },
  { code: "14857", name: "Xã Trung Lý", district_code: "384" },
  { code: "14860", name: "Xã Quang Chiểu", district_code: "384" },
  { code: "14863", name: "Xã Pù Nhi", district_code: "384" },
  { code: "14864", name: "Xã Nhi Sơn", district_code: "384" },
  { code: "14866", name: "Xã Mường Chanh", district_code: "384" },
  { code: "14869", name: "Thị trấn Hồi Xuân", district_code: "385" },
  { code: "14872", name: "Xã Thành Sơn", district_code: "385" },
  { code: "14875", name: "Xã Trung Sơn", district_code: "385" },
  { code: "14878", name: "Xã Phú Thanh", district_code: "385" },
  { code: "14881", name: "Xã Trung Thành", district_code: "385" },
  { code: "14884", name: "Xã Phú Lệ", district_code: "385" },
  { code: "14887", name: "Xã Phú Sơn", district_code: "385" },
  { code: "14890", name: "Xã Phú Xuân", district_code: "385" },
  { code: "14896", name: "Xã Hiền Chung", district_code: "385" },
  { code: "14899", name: "Xã Hiền Kiệt", district_code: "385" },
  { code: "14902", name: "Xã Nam Tiến", district_code: "385" },
  { code: "14908", name: "Xã Thiên Phủ", district_code: "385" },
  { code: "14911", name: "Xã Phú Nghiêm", district_code: "385" },
  { code: "14914", name: "Xã Nam Xuân", district_code: "385" },
  { code: "14917", name: "Xã Nam Động", district_code: "385" },
  { code: "14923", name: "Thị trấn Cành Nàng", district_code: "386" },
  { code: "14926", name: "Xã Điền Thượng", district_code: "386" },
  { code: "14929", name: "Xã Điền Hạ", district_code: "386" },
  { code: "14932", name: "Xã Điền Quang", district_code: "386" },
  { code: "14935", name: "Xã Điền Trung", district_code: "386" },
  { code: "14938", name: "Xã Thành Sơn", district_code: "386" },
  { code: "14941", name: "Xã Lương Ngoại", district_code: "386" },
  { code: "14944", name: "Xã Ái Thượng", district_code: "386" },
  { code: "14947", name: "Xã Lương Nội", district_code: "386" },
  { code: "14950", name: "Xã Điền Lư", district_code: "386" },
  { code: "14953", name: "Xã Lương Trung", district_code: "386" },
  { code: "14956", name: "Xã Lũng Niêm", district_code: "386" },
  { code: "14959", name: "Xã Lũng Cao", district_code: "386" },
  { code: "14962", name: "Xã Hạ Trung", district_code: "386" },
  { code: "14965", name: "Xã Cổ Lũng", district_code: "386" },
  { code: "14968", name: "Xã Thành Lâm", district_code: "386" },
  { code: "14971", name: "Xã Ban Công", district_code: "386" },
  { code: "14974", name: "Xã Kỳ Tân", district_code: "386" },
  { code: "14977", name: "Xã Văn Nho", district_code: "386" },
  { code: "14980", name: "Xã Thiết Ống", district_code: "386" },
  { code: "14986", name: "Xã Thiết Kế", district_code: "386" },
  { code: "14995", name: "Xã Trung Xuân", district_code: "387" },
  { code: "14998", name: "Xã Trung Thượng", district_code: "387" },
  { code: "14999", name: "Xã Trung Tiến", district_code: "387" },
  { code: "15001", name: "Xã Trung Hạ", district_code: "387" },
  { code: "15004", name: "Xã Sơn Hà", district_code: "387" },
  { code: "15007", name: "Xã Tam Thanh", district_code: "387" },
  { code: "15010", name: "Xã Sơn Thủy", district_code: "387" },
  { code: "15013", name: "Xã Na Mèo", district_code: "387" },
  { code: "15016", name: "Thị trấn Sơn Lư", district_code: "387" },
  { code: "15019", name: "Xã Tam Lư", district_code: "387" },
  { code: "15022", name: "Xã Sơn Điện", district_code: "387" },
  { code: "15025", name: "Xã Mường Mìn", district_code: "387" },
  { code: "15031", name: "Xã Yên Khương", district_code: "388" },
  { code: "15034", name: "Xã Yên Thắng", district_code: "388" },
  { code: "15037", name: "Xã Trí Nang", district_code: "388" },
  { code: "15040", name: "Xã Giao An", district_code: "388" },
  { code: "15043", name: "Xã Giao Thiện", district_code: "388" },
  { code: "15046", name: "Xã Tân Phúc", district_code: "388" },
  { code: "15049", name: "Xã Tam Văn", district_code: "388" },
  { code: "15052", name: "Xã Lâm Phú", district_code: "388" },
  { code: "15055", name: "Thị trấn Lang Chánh", district_code: "388" },
  { code: "15058", name: "Xã Đồng Lương", district_code: "388" },
  { code: "15061", name: "Thị trấn Ngọc Lặc", district_code: "389" },
  { code: "15064", name: "Xã Lam Sơn", district_code: "389" },
  { code: "15067", name: "Xã Mỹ Tân", district_code: "389" },
  { code: "15070", name: "Xã Thúy Sơn", district_code: "389" },
  { code: "15073", name: "Xã Thạch Lập", district_code: "389" },
  { code: "15076", name: "Xã Vân Âm", district_code: "389" },
  { code: "15079", name: "Xã Cao Ngọc", district_code: "389" },
  { code: "15085", name: "Xã Quang Trung", district_code: "389" },
  { code: "15088", name: "Xã Đồng Thịnh", district_code: "389" },
  { code: "15091", name: "Xã Ngọc Liên", district_code: "389" },
  { code: "15094", name: "Xã Ngọc Sơn", district_code: "389" },
  { code: "15097", name: "Xã Lộc Thịnh", district_code: "389" },
  { code: "15100", name: "Xã Cao Thịnh", district_code: "389" },
  { code: "15103", name: "Xã Ngọc Trung", district_code: "389" },
  { code: "15106", name: "Xã Phùng Giáo", district_code: "389" },
  { code: "15109", name: "Xã Phùng Minh", district_code: "389" },
  { code: "15112", name: "Xã Phúc Thịnh", district_code: "389" },
  { code: "15115", name: "Xã Nguyệt Ấn", district_code: "389" },
  { code: "15118", name: "Xã Kiên Thọ", district_code: "389" },
  { code: "15121", name: "Xã Minh Tiến", district_code: "389" },
  { code: "15124", name: "Xã Minh Sơn", district_code: "389" },
  { code: "15127", name: "Thị trấn Phong Sơn", district_code: "390" },
  { code: "15133", name: "Xã Cẩm Thành", district_code: "390" },
  { code: "15136", name: "Xã Cẩm Quý", district_code: "390" },
  { code: "15139", name: "Xã Cẩm Lương", district_code: "390" },
  { code: "15142", name: "Xã Cẩm Thạch", district_code: "390" },
  { code: "15145", name: "Xã Cẩm Liên", district_code: "390" },
  { code: "15148", name: "Xã Cẩm Giang", district_code: "390" },
  { code: "15151", name: "Xã Cẩm Bình", district_code: "390" },
  { code: "15154", name: "Xã Cẩm Tú", district_code: "390" },
  { code: "15160", name: "Xã Cẩm Châu", district_code: "390" },
  { code: "15163", name: "Xã Cẩm Tâm", district_code: "390" },
  { code: "15169", name: "Xã Cẩm Ngọc", district_code: "390" },
  { code: "15172", name: "Xã Cẩm Long", district_code: "390" },
  { code: "15175", name: "Xã Cẩm Yên", district_code: "390" },
  { code: "15178", name: "Xã Cẩm Tân", district_code: "390" },
  { code: "15181", name: "Xã Cẩm Phú", district_code: "390" },
  { code: "15184", name: "Xã Cẩm Vân", district_code: "390" },
  { code: "15187", name: "Thị trấn Kim Tân", district_code: "391" },
  { code: "15190", name: "Thị trấn Vân Du", district_code: "391" },
  { code: "15196", name: "Xã Thạch Lâm", district_code: "391" },
  { code: "15199", name: "Xã Thạch Quảng", district_code: "391" },
  { code: "15202", name: "Xã Thạch Tượng", district_code: "391" },
  { code: "15205", name: "Xã Thạch Cẩm", district_code: "391" },
  { code: "15208", name: "Xã Thạch Sơn", district_code: "391" },
  { code: "15211", name: "Xã Thạch Bình", district_code: "391" },
  { code: "15214", name: "Xã Thạch Định", district_code: "391" },
  { code: "15220", name: "Xã Thạch Long", district_code: "391" },
  { code: "15223", name: "Xã Thành Mỹ", district_code: "391" },
  { code: "15226", name: "Xã Thành Yên", district_code: "391" },
  { code: "15229", name: "Xã Thành Vinh", district_code: "391" },
  { code: "15232", name: "Xã Thành Minh", district_code: "391" },
  { code: "15235", name: "Xã Thành Công", district_code: "391" },
  { code: "15238", name: "Xã Thành Tân", district_code: "391" },
  { code: "15241", name: "Xã Thành Trực", district_code: "391" },
  { code: "15247", name: "Xã Thành Tâm", district_code: "391" },
  { code: "15250", name: "Xã Thành An", district_code: "391" },
  { code: "15253", name: "Xã Thành Thọ", district_code: "391" },
  { code: "15256", name: "Xã Thành Tiến", district_code: "391" },
  { code: "15259", name: "Xã Thành Long", district_code: "391" },
  { code: "15265", name: "Xã Thành Hưng", district_code: "391" },
  { code: "15268", name: "Xã Ngọc Trạo", district_code: "391" },
  { code: "15271", name: "Thị trấn Hà Trung", district_code: "392" },
  { code: "15274", name: "Thị trấn Hà Long", district_code: "392" },
  { code: "15277", name: "Xã Hà Vinh", district_code: "392" },
  { code: "15280", name: "Xã Hà Bắc", district_code: "392" },
  { code: "15283", name: "Xã Hoạt Giang", district_code: "392" },
  { code: "15286", name: "Xã Yên Dương", district_code: "392" },
  { code: "15292", name: "Xã Hà Giang", district_code: "392" },
  { code: "15298", name: "Xã Lĩnh Toại", district_code: "392" },
  { code: "15304", name: "Xã Hà Ngọc", district_code: "392" },
  { code: "15307", name: "Xã Yến Sơn", district_code: "392" },
  { code: "15313", name: "Xã Hà Sơn", district_code: "392" },
  { code: "15316", name: "Thị trấn Hà Lĩnh", district_code: "392" },
  { code: "15319", name: "Xã Hà Đông", district_code: "392" },
  { code: "15322", name: "Xã Hà Tân", district_code: "392" },
  { code: "15325", name: "Xã Hà Tiến", district_code: "392" },
  { code: "15328", name: "Xã Hà Bình", district_code: "392" },
  { code: "15331", name: "Xã Thái Lai", district_code: "392" },
  { code: "15334", name: "Xã Hà Châu", district_code: "392" },
  { code: "15343", name: "Xã Hà Hải", district_code: "392" },
  { code: "15349", name: "Thị trấn Vĩnh Lộc", district_code: "393" },
  { code: "15352", name: "Xã Vĩnh Quang", district_code: "393" },
  { code: "15355", name: "Xã Vĩnh Yên", district_code: "393" },
  { code: "15358", name: "Xã Vĩnh Tiến", district_code: "393" },
  { code: "15361", name: "Xã Vĩnh Long", district_code: "393" },
  { code: "15364", name: "Xã Vĩnh Phúc", district_code: "393" },
  { code: "15367", name: "Xã Vĩnh Hưng", district_code: "393" },
  { code: "15376", name: "Xã Vĩnh Hòa", district_code: "393" },
  { code: "15379", name: "Xã Vĩnh Hùng", district_code: "393" },
  { code: "15382", name: "Xã Minh Tân", district_code: "393" },
  { code: "15385", name: "Xã Ninh Khang", district_code: "393" },
  { code: "15388", name: "Xã Vĩnh Thịnh", district_code: "393" },
  { code: "15391", name: "Xã Vĩnh An", district_code: "393" },
  { code: "15397", name: "Thị trấn Thống Nhất", district_code: "394" },
  { code: "15403", name: "Thị trấn Yên Lâm", district_code: "394" },
  { code: "15406", name: "Xã Yên Tâm", district_code: "394" },
  { code: "15409", name: "Xã Yên Phú", district_code: "394" },
  { code: "15412", name: "Thị trấn Quý Lộc", district_code: "394" },
  { code: "15415", name: "Xã Yên Thọ", district_code: "394" },
  { code: "15418", name: "Xã Yên Trung", district_code: "394" },
  { code: "15421", name: "Xã Yên Trường", district_code: "394" },
  { code: "15427", name: "Xã Yên Phong", district_code: "394" },
  { code: "15430", name: "Xã Yên Thái", district_code: "394" },
  { code: "15433", name: "Xã Yên Hùng", district_code: "394" },
  { code: "15436", name: "Xã Yên Thịnh", district_code: "394" },
  { code: "15442", name: "Xã Yên Ninh", district_code: "394" },
  { code: "15445", name: "Xã Định Tăng", district_code: "394" },
  { code: "15448", name: "Xã Định Hòa", district_code: "394" },
  { code: "15451", name: "Xã Định Thành", district_code: "394" },
  { code: "15454", name: "Xã Định Công", district_code: "394" },
  { code: "15457", name: "Xã Định Tân", district_code: "394" },
  { code: "15460", name: "Xã Định Tiến", district_code: "394" },
  { code: "15463", name: "Xã Định Long", district_code: "394" },
  { code: "15466", name: "Xã Định Liên", district_code: "394" },
  { code: "15469", name: "Thị trấn Quán Lào", district_code: "394" },
  { code: "15472", name: "Xã Định Hưng", district_code: "394" },
  { code: "15475", name: "Xã Định Hải", district_code: "394" },
  { code: "15478", name: "Xã Định Bình", district_code: "394" },
  { code: "15493", name: "Xã Xuân Hồng", district_code: "395" },
  { code: "15499", name: "Thị trấn Thọ Xuân", district_code: "395" },
  { code: "15502", name: "Xã Bắc Lương", district_code: "395" },
  { code: "15505", name: "Xã Nam Giang", district_code: "395" },
  { code: "15508", name: "Xã Xuân Phong", district_code: "395" },
  { code: "15511", name: "Xã Thọ Lộc", district_code: "395" },
  { code: "15514", name: "Xã Xuân Trường", district_code: "395" },
  { code: "15517", name: "Xã Xuân Hòa", district_code: "395" },
  { code: "15520", name: "Xã Thọ Hải", district_code: "395" },
  { code: "15523", name: "Xã Tây Hồ", district_code: "395" },
  { code: "15526", name: "Xã Xuân Giang", district_code: "395" },
  { code: "15532", name: "Xã Xuân Sinh", district_code: "395" },
  { code: "15535", name: "Xã Xuân Hưng", district_code: "395" },
  { code: "15538", name: "Xã Thọ Diên", district_code: "395" },
  { code: "15541", name: "Xã Thọ Lâm", district_code: "395" },
  { code: "15544", name: "Xã Thọ Xương", district_code: "395" },
  { code: "15547", name: "Xã Xuân Bái", district_code: "395" },
  { code: "15550", name: "Xã Xuân Phú", district_code: "395" },
  { code: "15553", name: "Thị trấn Sao Vàng", district_code: "395" },
  { code: "15556", name: "Thị trấn Lam Sơn", district_code: "395" },
  { code: "15559", name: "Xã Xuân Thiên", district_code: "395" },
  { code: "15565", name: "Xã Thuận Minh", district_code: "395" },
  { code: "15568", name: "Xã Thọ Lập", district_code: "395" },
  { code: "15571", name: "Xã Quảng Phú", district_code: "395" },
  { code: "15574", name: "Xã Xuân Tín", district_code: "395" },
  { code: "15577", name: "Xã Phú Xuân", district_code: "395" },
  { code: "15583", name: "Xã Xuân Lai", district_code: "395" },
  { code: "15586", name: "Xã Xuân Lập", district_code: "395" },
  { code: "15592", name: "Xã Xuân Minh", district_code: "395" },
  { code: "15598", name: "Xã Trường Xuân", district_code: "395" },
  { code: "15607", name: "Xã Bát Mọt", district_code: "396" },
  { code: "15610", name: "Xã Yên Nhân", district_code: "396" },
  { code: "15619", name: "Xã Xuân Lẹ", district_code: "396" },
  { code: "15622", name: "Xã Vạn Xuân", district_code: "396" },
  { code: "15628", name: "Xã Lương Sơn", district_code: "396" },
  { code: "15631", name: "Xã Xuân Cao", district_code: "396" },
  { code: "15634", name: "Xã Luận Thành", district_code: "396" },
  { code: "15637", name: "Xã Luận Khê", district_code: "396" },
  { code: "15640", name: "Xã Xuân Thắng", district_code: "396" },
  { code: "15643", name: "Xã Xuân Lộc", district_code: "396" },
  { code: "15646", name: "Thị trấn Thường Xuân", district_code: "396" },
  { code: "15649", name: "Xã Xuân Dương", district_code: "396" },
  { code: "15652", name: "Xã Thọ Thanh", district_code: "396" },
  { code: "15655", name: "Xã Ngọc Phụng", district_code: "396" },
  { code: "15658", name: "Xã Xuân Chinh", district_code: "396" },
  { code: "15661", name: "Xã Tân Thành", district_code: "396" },
  { code: "15664", name: "Thị trấn Triệu Sơn", district_code: "397" },
  { code: "15667", name: "Xã Thọ Sơn", district_code: "397" },
  { code: "15670", name: "Xã Thọ Bình", district_code: "397" },
  { code: "15673", name: "Xã Thọ Tiến", district_code: "397" },
  { code: "15676", name: "Xã Hợp Lý", district_code: "397" },
  { code: "15679", name: "Xã Hợp Tiến", district_code: "397" },
  { code: "15682", name: "Xã Hợp Thành", district_code: "397" },
  { code: "15685", name: "Xã Triệu Thành", district_code: "397" },
  { code: "15688", name: "Xã Hợp Thắng", district_code: "397" },
  { code: "15691", name: "Xã Minh Sơn", district_code: "397" },
  { code: "15700", name: "Xã Dân Lực", district_code: "397" },
  { code: "15703", name: "Xã Dân Lý", district_code: "397" },
  { code: "15706", name: "Xã Dân Quyền", district_code: "397" },
  { code: "15709", name: "Xã An Nông", district_code: "397" },
  { code: "15712", name: "Xã Văn Sơn", district_code: "397" },
  { code: "15715", name: "Xã Thái Hòa", district_code: "397" },
  { code: "15718", name: "Thị trấn Nưa", district_code: "397" },
  { code: "15721", name: "Xã Đồng Lợi", district_code: "397" },
  { code: "15724", name: "Xã Đồng Tiến", district_code: "397" },
  { code: "15727", name: "Xã Đồng Thắng", district_code: "397" },
  { code: "15730", name: "Xã Tiến Nông", district_code: "397" },
  { code: "15733", name: "Xã Khuyến Nông", district_code: "397" },
  { code: "15736", name: "Xã Xuân Lộc", district_code: "397" },
  { code: "15742", name: "Xã Thọ Dân", district_code: "397" },
  { code: "15745", name: "Xã Xuân Thọ", district_code: "397" },
  { code: "15748", name: "Xã Thọ Tân", district_code: "397" },
  { code: "15751", name: "Xã Thọ Ngọc", district_code: "397" },
  { code: "15754", name: "Xã Thọ Cường", district_code: "397" },
  { code: "15760", name: "Xã Thọ Phú", district_code: "397" },
  { code: "15763", name: "Xã Thọ Thế", district_code: "397" },
  { code: "15766", name: "Xã Nông Trường", district_code: "397" },
  { code: "15769", name: "Xã Bình Sơn", district_code: "397" },
  { code: "15772", name: "Thị trấn Thiệu Hóa", district_code: "398" },
  { code: "15775", name: "Xã Thiệu Ngọc", district_code: "398" },
  { code: "15778", name: "Xã Thiệu Vũ", district_code: "398" },
  { code: "15781", name: "Xã Thiệu Phúc", district_code: "398" },
  { code: "15784", name: "Xã Thiệu Tiến", district_code: "398" },
  { code: "15787", name: "Xã Thiệu Công", district_code: "398" },
  { code: "15793", name: "Xã Thiệu Long", district_code: "398" },
  { code: "15796", name: "Xã Thiệu Giang", district_code: "398" },
  { code: "15799", name: "Xã Thiệu Duy", district_code: "398" },
  { code: "15802", name: "Xã Thiệu Nguyên", district_code: "398" },
  { code: "15805", name: "Xã Thiệu Hợp", district_code: "398" },
  { code: "15808", name: "Xã Thiệu Thịnh", district_code: "398" },
  { code: "15811", name: "Xã Thiệu Quang", district_code: "398" },
  { code: "15814", name: "Xã Thiệu Thành", district_code: "398" },
  { code: "15817", name: "Xã Thiệu Toán", district_code: "398" },
  { code: "15820", name: "Xã Thiệu Chính", district_code: "398" },
  { code: "15823", name: "Xã Thiệu Hòa", district_code: "398" },
  { code: "15829", name: "Thị trấn Hậu Hiền", district_code: "398" },
  { code: "15832", name: "Xã Thiệu Viên", district_code: "398" },
  { code: "15835", name: "Xã Thiệu Lý", district_code: "398" },
  { code: "15838", name: "Xã Thiệu Vận", district_code: "398" },
  { code: "15841", name: "Xã Thiệu Trung", district_code: "398" },
  { code: "15847", name: "Xã Tân Châu", district_code: "398" },
  { code: "15853", name: "Xã Thiệu Giao", district_code: "398" },
  { code: "15865", name: "Thị trấn Bút Sơn", district_code: "399" },
  { code: "15877", name: "Xã Hoằng Xuân", district_code: "399" },
  { code: "15880", name: "Xã Hoằng Giang", district_code: "399" },
  { code: "15883", name: "Xã Hoằng Phú", district_code: "399" },
  { code: "15886", name: "Xã Hoằng Quỳ", district_code: "399" },
  { code: "15889", name: "Xã Hoằng Kim", district_code: "399" },
  { code: "15892", name: "Xã Hoằng Trung", district_code: "399" },
  { code: "15895", name: "Xã Hoằng Trinh", district_code: "399" },
  { code: "15901", name: "Xã Hoằng Sơn", district_code: "399" },
  { code: "15907", name: "Xã Hoằng Cát", district_code: "399" },
  { code: "15910", name: "Xã Hoằng Xuyên", district_code: "399" },
  { code: "15916", name: "Xã Hoằng Quý", district_code: "399" },
  { code: "15919", name: "Xã Hoằng Hợp", district_code: "399" },
  { code: "15928", name: "Xã Hoằng Đức", district_code: "399" },
  { code: "15937", name: "Xã Hoằng Hà", district_code: "399" },
  { code: "15940", name: "Xã Hoằng Đạt", district_code: "399" },
  { code: "15946", name: "Xã Hoằng Đạo", district_code: "399" },
  { code: "15949", name: "Xã Hoằng Thắng", district_code: "399" },
  { code: "15952", name: "Xã Hoằng Đồng", district_code: "399" },
  { code: "15955", name: "Xã Hoằng Thái", district_code: "399" },
  { code: "15958", name: "Xã Hoằng Thịnh", district_code: "399" },
  { code: "15961", name: "Xã Hoằng Thành", district_code: "399" },
  { code: "15964", name: "Xã Hoằng Lộc", district_code: "399" },
  { code: "15967", name: "Xã Hoằng Trạch", district_code: "399" },
  { code: "15973", name: "Xã Hoằng Phong", district_code: "399" },
  { code: "15976", name: "Xã Hoằng Lưu", district_code: "399" },
  { code: "15979", name: "Xã Hoằng Châu", district_code: "399" },
  { code: "15982", name: "Xã Hoằng Tân", district_code: "399" },
  { code: "15985", name: "Xã Hoằng Yến", district_code: "399" },
  { code: "15988", name: "Xã Hoằng Tiến", district_code: "399" },
  { code: "15991", name: "Xã Hoằng Hải", district_code: "399" },
  { code: "15994", name: "Xã Hoằng Ngọc", district_code: "399" },
  { code: "15997", name: "Xã Hoằng Đông", district_code: "399" },
  { code: "16000", name: "Xã Hoằng Thanh", district_code: "399" },
  { code: "16003", name: "Xã Hoằng Phụ", district_code: "399" },
  { code: "16006", name: "Xã Hoằng Trường", district_code: "399" },
  { code: "16012", name: "Thị trấn Hậu Lộc", district_code: "400" },
  { code: "16015", name: "Xã Đồng Lộc", district_code: "400" },
  { code: "16018", name: "Xã Đại Lộc", district_code: "400" },
  { code: "16021", name: "Xã Triệu Lộc", district_code: "400" },
  { code: "16027", name: "Xã Tiến Lộc", district_code: "400" },
  { code: "16030", name: "Xã Lộc Sơn", district_code: "400" },
  { code: "16033", name: "Xã Cầu Lộc", district_code: "400" },
  { code: "16036", name: "Xã Thành Lộc", district_code: "400" },
  { code: "16042", name: "Xã Tuy Lộc", district_code: "400" },
  { code: "16045", name: "Xã Mỹ Lộc", district_code: "400" },
  { code: "16048", name: "Xã Thuần Lộc", district_code: "400" },
  { code: "16057", name: "Xã Xuân Lộc", district_code: "400" },
  { code: "16063", name: "Xã Hoa Lộc", district_code: "400" },
  { code: "16066", name: "Xã Liên Lộc", district_code: "400" },
  { code: "16069", name: "Xã Quang Lộc", district_code: "400" },
  { code: "16072", name: "Xã Phú Lộc", district_code: "400" },
  { code: "16075", name: "Xã Hòa Lộc", district_code: "400" },
  { code: "16078", name: "Xã Minh Lộc", district_code: "400" },
  { code: "16081", name: "Xã Hưng Lộc", district_code: "400" },
  { code: "16084", name: "Xã Hải Lộc", district_code: "400" },
  { code: "16087", name: "Xã Đa Lộc", district_code: "400" },
  { code: "16090", name: "Xã Ngư Lộc", district_code: "400" },
  { code: "16093", name: "Thị trấn Nga Sơn", district_code: "401" },
  { code: "16096", name: "Xã Ba Đình", district_code: "401" },
  { code: "16099", name: "Xã Nga Vịnh", district_code: "401" },
  { code: "16102", name: "Xã Nga Văn", district_code: "401" },
  { code: "16105", name: "Xã Nga Thiện", district_code: "401" },
  { code: "16108", name: "Xã Nga Tiến", district_code: "401" },
  { code: "16114", name: "Xã Nga Phượng", district_code: "401" },
  { code: "16120", name: "Xã Nga Hiệp", district_code: "401" },
  { code: "16123", name: "Xã Nga Thanh", district_code: "401" },
  { code: "16132", name: "Xã Nga Yên", district_code: "401" },
  { code: "16135", name: "Xã Nga Giáp", district_code: "401" },
  { code: "16138", name: "Xã Nga Hải", district_code: "401" },
  { code: "16141", name: "Xã Nga Thành", district_code: "401" },
  { code: "16144", name: "Xã Nga An", district_code: "401" },
  { code: "16147", name: "Xã Nga Phú", district_code: "401" },
  { code: "16150", name: "Xã Nga Điền", district_code: "401" },
  { code: "16153", name: "Xã Nga Tân", district_code: "401" },
  { code: "16156", name: "Xã Nga Thủy", district_code: "401" },
  { code: "16159", name: "Xã Nga Liên", district_code: "401" },
  { code: "16162", name: "Xã Nga Thái", district_code: "401" },
  { code: "16165", name: "Xã Nga Thạch", district_code: "401" },
  { code: "16168", name: "Xã Nga Thắng", district_code: "401" },
  { code: "16171", name: "Xã Nga Trường", district_code: "401" },
  { code: "16174", name: "Thị trấn Yên Cát", district_code: "402" },
  { code: "16177", name: "Xã Bãi Trành", district_code: "402" },
  { code: "16180", name: "Xã Xuân Hòa", district_code: "402" },
  { code: "16183", name: "Xã Xuân Bình", district_code: "402" },
  { code: "16186", name: "Xã Hóa Quỳ", district_code: "402" },
  { code: "16195", name: "Xã Cát Vân", district_code: "402" },
  { code: "16198", name: "Xã Cát Tân", district_code: "402" },
  { code: "16201", name: "Xã Tân Bình", district_code: "402" },
  { code: "16204", name: "Xã Bình Lương", district_code: "402" },
  { code: "16207", name: "Xã Thanh Quân", district_code: "402" },
  { code: "16210", name: "Xã Thanh Xuân", district_code: "402" },
  { code: "16213", name: "Xã Thanh Hòa", district_code: "402" },
  { code: "16216", name: "Xã Thanh Phong", district_code: "402" },
  { code: "16219", name: "Xã Thanh Lâm", district_code: "402" },
  { code: "16222", name: "Xã Thanh Sơn", district_code: "402" },
  { code: "16225", name: "Xã Thượng Ninh", district_code: "402" },
  { code: "16228", name: "Thị trấn Bến Sung", district_code: "403" },
  { code: "16231", name: "Xã Cán Khê", district_code: "403" },
  { code: "16234", name: "Xã Xuân Du", district_code: "403" },
  { code: "16240", name: "Xã Phượng Nghi", district_code: "403" },
  { code: "16243", name: "Xã Mậu Lâm", district_code: "403" },
  { code: "16246", name: "Xã Xuân Khang", district_code: "403" },
  { code: "16249", name: "Xã Phú Nhuận", district_code: "403" },
  { code: "16252", name: "Xã Hải Long", district_code: "403" },
  { code: "16258", name: "Xã Xuân Thái", district_code: "403" },
  { code: "16261", name: "Xã Xuân Phúc", district_code: "403" },
  { code: "16264", name: "Xã Yên Thọ", district_code: "403" },
  { code: "16267", name: "Xã Yên Lạc", district_code: "403" },
  { code: "16273", name: "Xã Thanh Tân", district_code: "403" },
  { code: "16276", name: "Xã Thanh Kỳ", district_code: "403" },
  { code: "16279", name: "Thị trấn Nông Cống", district_code: "404" },
  { code: "16282", name: "Xã Tân Phúc", district_code: "404" },
  { code: "16285", name: "Xã Tân Thọ", district_code: "404" },
  { code: "16288", name: "Xã Hoàng Sơn", district_code: "404" },
  { code: "16291", name: "Xã Tân Khang", district_code: "404" },
  { code: "16294", name: "Xã Hoàng Giang", district_code: "404" },
  { code: "16297", name: "Xã Trung Chính", district_code: "404" },
  { code: "16303", name: "Xã Trung Thành", district_code: "404" },
  { code: "16309", name: "Xã Tế Thắng", district_code: "404" },
  { code: "16315", name: "Xã Tế Lợi", district_code: "404" },
  { code: "16318", name: "Xã Tế Nông", district_code: "404" },
  { code: "16321", name: "Xã Minh Nghĩa", district_code: "404" },
  { code: "16324", name: "Xã Minh Khôi", district_code: "404" },
  { code: "16327", name: "Xã Vạn Hòa", district_code: "404" },
  { code: "16330", name: "Xã Trường Trung", district_code: "404" },
  { code: "16333", name: "Xã Vạn Thắng", district_code: "404" },
  { code: "16336", name: "Xã Trường Giang", district_code: "404" },
  { code: "16339", name: "Xã Vạn Thiện", district_code: "404" },
  { code: "16342", name: "Xã Thăng Long", district_code: "404" },
  { code: "16345", name: "Xã Trường Minh", district_code: "404" },
  { code: "16348", name: "Xã Trường Sơn", district_code: "404" },
  { code: "16351", name: "Xã Thăng Bình", district_code: "404" },
  { code: "16354", name: "Xã Công Liêm", district_code: "404" },
  { code: "16357", name: "Xã Tượng Văn", district_code: "404" },
  { code: "16360", name: "Xã Thăng Thọ", district_code: "404" },
  { code: "16363", name: "Xã Tượng Lĩnh", district_code: "404" },
  { code: "16366", name: "Xã Tượng Sơn", district_code: "404" },
  { code: "16369", name: "Xã Công Chính", district_code: "404" },
  { code: "16375", name: "Xã Yên Mỹ", district_code: "404" },
  { code: "16438", name: "Thị trấn Tân Phong", district_code: "406" },
  { code: "16447", name: "Xã Quảng Trạch", district_code: "406" },
  { code: "16453", name: "Xã Quảng Đức", district_code: "406" },
  { code: "16456", name: "Xã Quảng Định", district_code: "406" },
  { code: "16462", name: "Xã Quảng Nhân", district_code: "406" },
  { code: "16465", name: "Xã Quảng Ninh", district_code: "406" },
  { code: "16468", name: "Xã Quảng Bình", district_code: "406" },
  { code: "16471", name: "Xã Quảng Hợp", district_code: "406" },
  { code: "16474", name: "Xã Quảng Văn", district_code: "406" },
  { code: "16477", name: "Xã Quảng Long", district_code: "406" },
  { code: "16480", name: "Xã Quảng Yên", district_code: "406" },
  { code: "16483", name: "Xã Quảng Hòa", district_code: "406" },
  { code: "16489", name: "Xã Quảng Khê", district_code: "406" },
  { code: "16492", name: "Xã Quảng Trung", district_code: "406" },
  { code: "16495", name: "Xã Quảng Chính", district_code: "406" },
  { code: "16498", name: "Xã Quảng Ngọc", district_code: "406" },
  { code: "16501", name: "Xã Quảng Trường", district_code: "406" },
  { code: "16510", name: "Xã Quảng Phúc", district_code: "406" },
  { code: "16519", name: "Xã Quảng Giao", district_code: "406" },
  { code: "16540", name: "Xã Quảng Hải", district_code: "406" },
  { code: "16543", name: "Xã Quảng Lưu", district_code: "406" },
  { code: "16546", name: "Xã Quảng Lộc", district_code: "406" },
  { code: "16549", name: "Xã Tiên Trang", district_code: "406" },
  { code: "16552", name: "Xã Quảng Nham", district_code: "406" },
  { code: "16555", name: "Xã Quảng Thạch", district_code: "406" },
  { code: "16558", name: "Xã Quảng Thái", district_code: "406" },
  { code: "16561", name: "Phường Hải Hòa", district_code: "407" },
  { code: "16564", name: "Phường Hải Châu", district_code: "407" },
  { code: "16567", name: "Xã Thanh Thủy", district_code: "407" },
  { code: "16570", name: "Xã Thanh Sơn", district_code: "407" },
  { code: "16576", name: "Phường Hải Ninh", district_code: "407" },
  { code: "16579", name: "Xã Anh Sơn", district_code: "407" },
  { code: "16582", name: "Xã Ngọc Lĩnh", district_code: "407" },
  { code: "16585", name: "Phường Hải An", district_code: "407" },
  { code: "16591", name: "Xã Các Sơn", district_code: "407" },
  { code: "16594", name: "Phường Tân Dân", district_code: "407" },
  { code: "16597", name: "Phường Hải Lĩnh", district_code: "407" },
  { code: "16600", name: "Xã Định Hải", district_code: "407" },
  { code: "16603", name: "Xã Phú Sơn", district_code: "407" },
  { code: "16606", name: "Phường Ninh Hải", district_code: "407" },
  { code: "16609", name: "Phường Nguyên Bình", district_code: "407" },
  { code: "16612", name: "Xã Hải Nhân", district_code: "407" },
  { code: "16618", name: "Phường Bình Minh", district_code: "407" },
  { code: "16621", name: "Phường Hải Thanh", district_code: "407" },
  { code: "16624", name: "Xã Phú Lâm", district_code: "407" },
  { code: "16627", name: "Phường Xuân Lâm", district_code: "407" },
  { code: "16630", name: "Phường Trúc Lâm", district_code: "407" },
  { code: "16633", name: "Phường Hải Bình", district_code: "407" },
  { code: "16636", name: "Xã Tân Trường", district_code: "407" },
  { code: "16639", name: "Xã Tùng Lâm", district_code: "407" },
  { code: "16642", name: "Phường Tĩnh Hải", district_code: "407" },
  { code: "16645", name: "Phường Mai Lâm", district_code: "407" },
  { code: "16648", name: "Xã Trường Lâm", district_code: "407" },
  { code: "16654", name: "Phường Hải Thượng", district_code: "407" },
  { code: "16657", name: "Xã Nghi Sơn", district_code: "407" },
  { code: "16660", name: "Xã Hải Hà", district_code: "407" },
  { code: "16663", name: "Phường Đông Vĩnh", district_code: "412" },
  { code: "16666", name: "Phường Hà Huy Tập", district_code: "412" },
  { code: "16669", name: "Phường Lê Lợi", district_code: "412" },
  { code: "16670", name: "Phường Quán Bàu", district_code: "412" },
  { code: "16672", name: "Phường Hưng Bình", district_code: "412" },
  { code: "16673", name: "Phường Hưng Phúc", district_code: "412" },
  { code: "16675", name: "Phường Hưng Dũng", district_code: "412" },
  { code: "16678", name: "Phường Cửa Nam", district_code: "412" },
  { code: "16681", name: "Phường Quang Trung", district_code: "412" },
  { code: "16690", name: "Phường Trường Thi", district_code: "412" },
  { code: "16693", name: "Phường Bến Thủy", district_code: "412" },
  { code: "16699", name: "Phường Trung Đô", district_code: "412" },
  { code: "16702", name: "Phường Nghi Phú", district_code: "412" },
  { code: "16705", name: "Phường Hưng Đông", district_code: "412" },
  { code: "16708", name: "Phường Hưng Lộc", district_code: "412" },
  { code: "16711", name: "Xã Hưng Hòa", district_code: "412" },
  { code: "16714", name: "Phường Vinh Tân", district_code: "412" },
  { code: "16717", name: "Phường Nghi Thuỷ", district_code: "412" },
  { code: "16720", name: "Phường Nghi Tân", district_code: "412" },
  { code: "16723", name: "Phường Thu Thuỷ", district_code: "412" },
  { code: "16726", name: "Phường Nghi Hòa", district_code: "412" },
  { code: "16729", name: "Phường Nghi Hải", district_code: "412" },
  { code: "16732", name: "Phường Nghi Hương", district_code: "412" },
  { code: "16735", name: "Phường Nghi Thu", district_code: "412" },
  { code: "17902", name: "Xã Nghi Phong", district_code: "412" },
  { code: "17905", name: "Xã Nghi Xuân", district_code: "412" },
  { code: "17908", name: "Xã Nghi Liên", district_code: "412" },
  { code: "17914", name: "Xã Nghi Ân", district_code: "412" },
  { code: "17917", name: "Xã Phúc Thọ", district_code: "412" },
  { code: "17920", name: "Xã Nghi Kim", district_code: "412" },
  { code: "17923", name: "Phường Nghi Đức", district_code: "412" },
  { code: "17926", name: "Xã Nghi Thái", district_code: "412" },
  { code: "18013", name: "Xã Hưng Chính", district_code: "412" },
  { code: "16939", name: "Phường Hoà Hiếu", district_code: "414" },
  { code: "16993", name: "Phường Quang Phong", district_code: "414" },
  { code: "16994", name: "Phường Quang Tiến", district_code: "414" },
  { code: "17003", name: "Phường Long Sơn", district_code: "414" },
  { code: "17005", name: "Xã Nghĩa Tiến", district_code: "414" },
  { code: "17008", name: "Xã Nghĩa Mỹ", district_code: "414" },
  { code: "17011", name: "Xã Tây Hiếu", district_code: "414" },
  { code: "17014", name: "Xã Nghĩa Thuận", district_code: "414" },
  { code: "17017", name: "Xã Đông Hiếu", district_code: "414" },
  { code: "16738", name: "Thị trấn Kim Sơn", district_code: "415" },
  { code: "16741", name: "Xã Thông Thụ", district_code: "415" },
  { code: "16744", name: "Xã Đồng Văn", district_code: "415" },
  { code: "16747", name: "Xã Hạnh Dịch", district_code: "415" },
  { code: "16750", name: "Xã Tiền Phong", district_code: "415" },
  { code: "16753", name: "Xã Nậm Giải", district_code: "415" },
  { code: "16756", name: "Xã Tri Lễ", district_code: "415" },
  { code: "16759", name: "Xã Châu Kim", district_code: "415" },
  { code: "16763", name: "Xã Mường Nọc", district_code: "415" },
  { code: "16765", name: "Xã Châu Thôn", district_code: "415" },
  { code: "16768", name: "Xã Nậm Nhoóng", district_code: "415" },
  { code: "16771", name: "Xã Quang Phong", district_code: "415" },
  { code: "16774", name: "Xã Căm Muộn", district_code: "415" },
  { code: "16777", name: "Thị trấn Tân Lạc", district_code: "416" },
  { code: "16780", name: "Xã Châu Bính", district_code: "416" },
  { code: "16783", name: "Xã Châu Thuận", district_code: "416" },
  { code: "16786", name: "Xã Châu Hội", district_code: "416" },
  { code: "16789", name: "Xã Châu Nga", district_code: "416" },
  { code: "16792", name: "Xã Châu Tiến", district_code: "416" },
  { code: "16795", name: "Xã Châu Hạnh", district_code: "416" },
  { code: "16798", name: "Xã Châu Thắng", district_code: "416" },
  { code: "16801", name: "Xã Châu Phong", district_code: "416" },
  { code: "16804", name: "Xã Châu Bình", district_code: "416" },
  { code: "16807", name: "Xã Châu Hoàn", district_code: "416" },
  { code: "16810", name: "Xã Diên Lãm", district_code: "416" },
  { code: "16813", name: "Thị trấn Mường Xén", district_code: "417" },
  { code: "16816", name: "Xã Mỹ Lý", district_code: "417" },
  { code: "16819", name: "Xã Bắc Lý", district_code: "417" },
  { code: "16822", name: "Xã Keng Đu", district_code: "417" },
  { code: "16825", name: "Xã Đoọc Mạy", district_code: "417" },
  { code: "16828", name: "Xã Huồi Tụ", district_code: "417" },
  { code: "16831", name: "Xã Mường Lống", district_code: "417" },
  { code: "16834", name: "Xã Na Loi", district_code: "417" },
  { code: "16837", name: "Xã Nậm Cắn", district_code: "417" },
  { code: "16840", name: "Xã Bảo Nam", district_code: "417" },
  { code: "16843", name: "Xã Phà Đánh", district_code: "417" },
  { code: "16846", name: "Xã Bảo Thắng", district_code: "417" },
  { code: "16849", name: "Xã Hữu Lập", district_code: "417" },
  { code: "16852", name: "Xã Tà Cạ", district_code: "417" },
  { code: "16855", name: "Xã Chiêu Lưu", district_code: "417" },
  { code: "16858", name: "Xã Mường Típ", district_code: "417" },
  { code: "16861", name: "Xã Hữu Kiệm", district_code: "417" },
  { code: "16864", name: "Xã Tây Sơn", district_code: "417" },
  { code: "16867", name: "Xã Mường Ải", district_code: "417" },
  { code: "16870", name: "Xã Na Ngoi", district_code: "417" },
  { code: "16873", name: "Xã Nậm Càn", district_code: "417" },
  { code: "16876", name: "Thị trấn Thạch Giám", district_code: "418" },
  { code: "16879", name: "Xã Mai Sơn", district_code: "418" },
  { code: "16882", name: "Xã Nhôn Mai", district_code: "418" },
  { code: "16885", name: "Xã Hữu Khuông", district_code: "418" },
  { code: "16900", name: "Xã Yên Tĩnh", district_code: "418" },
  { code: "16903", name: "Xã Nga My", district_code: "418" },
  { code: "16904", name: "Xã Xiêng My", district_code: "418" },
  { code: "16906", name: "Xã Lưỡng Minh", district_code: "418" },
  { code: "16909", name: "Xã Yên Hòa", district_code: "418" },
  { code: "16912", name: "Xã Yên Na", district_code: "418" },
  { code: "16915", name: "Xã Lưu Kiền", district_code: "418" },
  { code: "16921", name: "Xã Xá Lượng", district_code: "418" },
  { code: "16924", name: "Xã Tam Thái", district_code: "418" },
  { code: "16927", name: "Xã Tam Đình", district_code: "418" },
  { code: "16930", name: "Xã Yên Thắng", district_code: "418" },
  { code: "16933", name: "Xã Tam Quang", district_code: "418" },
  { code: "16936", name: "Xã Tam Hợp", district_code: "418" },
  { code: "16941", name: "Thị trấn Nghĩa Đàn", district_code: "419" },
  { code: "16942", name: "Xã Nghĩa Mai", district_code: "419" },
  { code: "16945", name: "Xã Nghĩa Yên", district_code: "419" },
  { code: "16948", name: "Xã Nghĩa Lạc", district_code: "419" },
  { code: "16951", name: "Xã Nghĩa Lâm", district_code: "419" },
  { code: "16954", name: "Xã Nghĩa Sơn", district_code: "419" },
  { code: "16957", name: "Xã Nghĩa Lợi", district_code: "419" },
  { code: "16960", name: "Xã Nghĩa Bình", district_code: "419" },
  { code: "16966", name: "Xã Nghĩa Minh", district_code: "419" },
  { code: "16969", name: "Xã Nghĩa Thọ", district_code: "419" },
  { code: "16972", name: "Xã Nghĩa Hưng", district_code: "419" },
  { code: "16975", name: "Xã Nghĩa Hồng", district_code: "419" },
  { code: "16981", name: "Xã Nghĩa Trung", district_code: "419" },
  { code: "16984", name: "Xã Nghĩa Hội", district_code: "419" },
  { code: "16987", name: "Xã Nghĩa Thành", district_code: "419" },
  { code: "17020", name: "Xã Nghĩa Đức", district_code: "419" },
  { code: "17023", name: "Xã Nghĩa An", district_code: "419" },
  { code: "17026", name: "Xã Nghĩa Long", district_code: "419" },
  { code: "17029", name: "Xã Nghĩa Lộc", district_code: "419" },
  { code: "17032", name: "Xã Nghĩa Khánh", district_code: "419" },
  { code: "17035", name: "Thị trấn Quỳ Hợp", district_code: "420" },
  { code: "17038", name: "Xã Yên Hợp", district_code: "420" },
  { code: "17041", name: "Xã Châu Tiến", district_code: "420" },
  { code: "17044", name: "Xã Châu Hồng", district_code: "420" },
  { code: "17047", name: "Xã Đồng Hợp", district_code: "420" },
  { code: "17050", name: "Xã Châu Thành", district_code: "420" },
  { code: "17053", name: "Xã Liên Hợp", district_code: "420" },
  { code: "17056", name: "Xã Châu Lộc", district_code: "420" },
  { code: "17059", name: "Xã Tam Hợp", district_code: "420" },
  { code: "17062", name: "Xã Châu Cường", district_code: "420" },
  { code: "17065", name: "Xã Châu Quang", district_code: "420" },
  { code: "17068", name: "Xã Thọ Hợp", district_code: "420" },
  { code: "17071", name: "Xã Minh Hợp", district_code: "420" },
  { code: "17074", name: "Xã Nghĩa Xuân", district_code: "420" },
  { code: "17077", name: "Xã Châu Thái", district_code: "420" },
  { code: "17080", name: "Xã Châu Đình", district_code: "420" },
  { code: "17083", name: "Xã Văn Lợi", district_code: "420" },
  { code: "17086", name: "Xã Nam Sơn", district_code: "420" },
  { code: "17089", name: "Xã Châu Lý", district_code: "420" },
  { code: "17092", name: "Xã Hạ Sơn", district_code: "420" },
  { code: "17095", name: "Xã Bắc Sơn", district_code: "420" },
  { code: "17101", name: "Xã Quỳnh Thắng", district_code: "421" },
  { code: "17119", name: "Xã Quỳnh Tân", district_code: "421" },
  { code: "17122", name: "Xã Quỳnh Châu", district_code: "421" },
  { code: "17140", name: "Xã Tân Sơn", district_code: "421" },
  { code: "17143", name: "Xã Quỳnh Văn", district_code: "421" },
  { code: "17146", name: "Xã Ngọc Sơn", district_code: "421" },
  { code: "17149", name: "Xã Quỳnh Tam", district_code: "421" },
  { code: "17152", name: "Xã Quỳnh Sơn", district_code: "421" },
  { code: "17155", name: "Xã Quỳnh Thạch", district_code: "421" },
  { code: "17158", name: "Xã Quỳnh Bảng", district_code: "421" },
  { code: "17164", name: "Xã Quỳnh Thanh", district_code: "421" },
  { code: "17167", name: "Xã Quỳnh Hậu", district_code: "421" },
  { code: "17170", name: "Xã Quỳnh Lâm", district_code: "421" },
  { code: "17173", name: "Xã Quỳnh Đôi", district_code: "421" },
  { code: "17176", name: "Xã Minh Lương", district_code: "421" },
  { code: "17179", name: "Thị trấn Cầu Giát", district_code: "421" },
  { code: "17182", name: "Xã Quỳnh Yên", district_code: "421" },
  { code: "17185", name: "Xã Bình Sơn", district_code: "421" },
  { code: "17191", name: "Xã Quỳnh Diễn", district_code: "421" },
  { code: "17197", name: "Xã Quỳnh Giang", district_code: "421" },
  { code: "17206", name: "Xã An Hòa", district_code: "421" },
  { code: "17209", name: "Xã Phú Nghĩa", district_code: "421" },
  { code: "17212", name: "Xã Văn Hải", district_code: "421" },
  { code: "17218", name: "Xã Thuận Long", district_code: "421" },
  { code: "17224", name: "Xã Tân Thắng", district_code: "421" },
  { code: "17230", name: "Xã Bình Chuẩn", district_code: "422" },
  { code: "17233", name: "Xã Lạng Khê", district_code: "422" },
  { code: "17236", name: "Xã Cam Lâm", district_code: "422" },
  { code: "17239", name: "Xã Thạch Ngàn", district_code: "422" },
  { code: "17242", name: "Xã Đôn Phục", district_code: "422" },
  { code: "17245", name: "Xã Mậu Đức", district_code: "422" },
  { code: "17248", name: "Xã Châu Khê", district_code: "422" },
  { code: "17251", name: "Xã Chi Khê", district_code: "422" },
  { code: "17254", name: "Thị trấn Trà Lân", district_code: "422" },
  { code: "17257", name: "Xã Yên Khê", district_code: "422" },
  { code: "17260", name: "Xã Lục Dạ", district_code: "422" },
  { code: "17263", name: "Xã Môn Sơn", district_code: "422" },
  { code: "17266", name: "Thị trấn Tân Kỳ", district_code: "423" },
  { code: "17269", name: "Xã Tân Hợp", district_code: "423" },
  { code: "17272", name: "Xã Tân Phú", district_code: "423" },
  { code: "17275", name: "Xã Tân Xuân", district_code: "423" },
  { code: "17278", name: "Xã Giai Xuân", district_code: "423" },
  { code: "17281", name: "Xã Bình Hợp", district_code: "423" },
  { code: "17284", name: "Xã Nghĩa Đồng", district_code: "423" },
  { code: "17287", name: "Xã Đồng Văn", district_code: "423" },
  { code: "17290", name: "Xã Nghĩa Thái", district_code: "423" },
  { code: "17296", name: "Xã Hoàn Long", district_code: "423" },
  { code: "17299", name: "Xã Nghĩa Phúc", district_code: "423" },
  { code: "17302", name: "Xã Tiên Kỳ", district_code: "423" },
  { code: "17305", name: "Xã Tân An", district_code: "423" },
  { code: "17308", name: "Xã Nghĩa Dũng", district_code: "423" },
  { code: "17314", name: "Xã Kỳ Sơn", district_code: "423" },
  { code: "17317", name: "Xã Hương Sơn", district_code: "423" },
  { code: "17320", name: "Xã Kỳ Tân", district_code: "423" },
  { code: "17323", name: "Xã Phú Sơn", district_code: "423" },
  { code: "17325", name: "Xã Tân Hương", district_code: "423" },
  { code: "17326", name: "Xã Nghĩa Hành", district_code: "423" },
  { code: "17329", name: "Thị trấn Kim Nhan", district_code: "424" },
  { code: "17332", name: "Xã Thọ Sơn", district_code: "424" },
  { code: "17335", name: "Xã Thành Sơn", district_code: "424" },
  { code: "17338", name: "Xã Bình Sơn", district_code: "424" },
  { code: "17344", name: "Xã Tam Đỉnh", district_code: "424" },
  { code: "17347", name: "Xã Hùng Sơn", district_code: "424" },
  { code: "17350", name: "Xã Cẩm Sơn", district_code: "424" },
  { code: "17353", name: "Xã Đức Sơn", district_code: "424" },
  { code: "17356", name: "Xã Tường Sơn", district_code: "424" },
  { code: "17357", name: "Xã Hoa Sơn", district_code: "424" },
  { code: "17359", name: "Xã Tào Sơn", district_code: "424" },
  { code: "17362", name: "Xã Vĩnh Sơn", district_code: "424" },
  { code: "17365", name: "Xã Lạng Sơn", district_code: "424" },
  { code: "17368", name: "Xã Hội Sơn", district_code: "424" },
  { code: "17374", name: "Xã Phúc Sơn", district_code: "424" },
  { code: "17377", name: "Xã Long Sơn", district_code: "424" },
  { code: "17380", name: "Xã Khai Sơn", district_code: "424" },
  { code: "17383", name: "Xã Lĩnh Sơn", district_code: "424" },
  { code: "17386", name: "Xã Cao Sơn", district_code: "424" },
  { code: "17392", name: "Xã Diễn Lâm", district_code: "425" },
  { code: "17395", name: "Xã Diễn Đoài", district_code: "425" },
  { code: "17398", name: "Xã Diễn Trường", district_code: "425" },
  { code: "17401", name: "Xã Diễn Yên", district_code: "425" },
  { code: "17404", name: "Xã Diễn Hoàng", district_code: "425" },
  { code: "17410", name: "Xã Diễn Mỹ", district_code: "425" },
  { code: "17413", name: "Xã Diễn Hồng", district_code: "425" },
  { code: "17416", name: "Xã Diễn Phong", district_code: "425" },
  { code: "17419", name: "Xã Hùng Hải", district_code: "425" },
  { code: "17425", name: "Xã Diễn Liên", district_code: "425" },
  { code: "17428", name: "Xã Diễn Vạn", district_code: "425" },
  { code: "17431", name: "Xã Diễn Kim", district_code: "425" },
  { code: "17434", name: "Xã Diễn Kỷ", district_code: "425" },
  { code: "17437", name: "Xã Xuân Tháp", district_code: "425" },
  { code: "17440", name: "Xã Diễn Thái", district_code: "425" },
  { code: "17443", name: "Xã Diễn Đồng", district_code: "425" },
  { code: "17449", name: "Xã Hạnh Quảng", district_code: "425" },
  { code: "17452", name: "Xã Ngọc Bích", district_code: "425" },
  { code: "17458", name: "Xã Diễn Nguyên", district_code: "425" },
  { code: "17461", name: "Xã Diễn Hoa", district_code: "425" },
  { code: "17464", name: "Thị trấn Diễn Thành", district_code: "425" },
  { code: "17467", name: "Xã Diễn Phúc", district_code: "425" },
  { code: "17476", name: "Xã Diễn Cát", district_code: "425" },
  { code: "17479", name: "Xã Diễn Thịnh", district_code: "425" },
  { code: "17482", name: "Xã Diễn Tân", district_code: "425" },
  { code: "17485", name: "Xã Minh Châu", district_code: "425" },
  { code: "17488", name: "Xã Diễn Thọ", district_code: "425" },
  { code: "17491", name: "Xã Diễn Lợi", district_code: "425" },
  { code: "17494", name: "Xã Diễn Lộc", district_code: "425" },
  { code: "17497", name: "Xã Diễn Trung", district_code: "425" },
  { code: "17500", name: "Xã Diễn An", district_code: "425" },
  { code: "17503", name: "Xã Diễn Phú", district_code: "425" },
  { code: "17506", name: "Thị trấn Hoa Thành", district_code: "426" },
  { code: "17509", name: "Xã Mã Thành", district_code: "426" },
  { code: "17510", name: "Xã Tiến Thành", district_code: "426" },
  { code: "17512", name: "Xã Lăng Thành", district_code: "426" },
  { code: "17515", name: "Xã Tân Thành", district_code: "426" },
  { code: "17518", name: "Xã Đức Thành", district_code: "426" },
  { code: "17521", name: "Xã Kim Thành", district_code: "426" },
  { code: "17524", name: "Xã Hậu Thành", district_code: "426" },
  { code: "17527", name: "Xã Đô Thành", district_code: "426" },
  { code: "17530", name: "Xã Thọ Thành", district_code: "426" },
  { code: "17533", name: "Xã Quang Thành", district_code: "426" },
  { code: "17536", name: "Xã Tây Thành", district_code: "426" },
  { code: "17539", name: "Xã Phúc Thành", district_code: "426" },
  { code: "17542", name: "Xã Phú Thành", district_code: "426" },
  { code: "17545", name: "Xã Đồng Thành", district_code: "426" },
  { code: "17554", name: "Xã Tăng Thành", district_code: "426" },
  { code: "17557", name: "Xã Văn Thành", district_code: "426" },
  { code: "17560", name: "Xã Thịnh Thành", district_code: "426" },
  { code: "17566", name: "Xã Xuân Thành", district_code: "426" },
  { code: "17569", name: "Xã Bắc Thành", district_code: "426" },
  { code: "17572", name: "Xã Đông Thành", district_code: "426" },
  { code: "17575", name: "Xã Trung Thành", district_code: "426" },
  { code: "17578", name: "Xã Long Thành", district_code: "426" },
  { code: "17581", name: "Xã Minh Thành", district_code: "426" },
  { code: "17584", name: "Xã Nam Thành", district_code: "426" },
  { code: "17587", name: "Xã Vĩnh Thành", district_code: "426" },
  { code: "17596", name: "Xã Viên Thành", district_code: "426" },
  { code: "17602", name: "Xã Liên Thành", district_code: "426" },
  { code: "17605", name: "Xã Bảo Thành", district_code: "426" },
  { code: "17608", name: "Xã Mỹ Thành", district_code: "426" },
  { code: "17611", name: "Xã Vân Tụ", district_code: "426" },
  { code: "17614", name: "Xã Sơn Thành", district_code: "426" },
  { code: "17617", name: "Thị trấn Đô Lương", district_code: "427" },
  { code: "17619", name: "Xã Giang Sơn Đông", district_code: "427" },
  { code: "17620", name: "Xã Giang Sơn Tây", district_code: "427" },
  { code: "17623", name: "Xã Bạch Ngọc", district_code: "427" },
  { code: "17626", name: "Xã Bồi Sơn", district_code: "427" },
  { code: "17629", name: "Xã Hồng Sơn", district_code: "427" },
  { code: "17632", name: "Xã Bài Sơn", district_code: "427" },
  { code: "17638", name: "Xã Bắc Sơn", district_code: "427" },
  { code: "17641", name: "Xã Tràng Sơn", district_code: "427" },
  { code: "17644", name: "Xã Thượng Sơn", district_code: "427" },
  { code: "17647", name: "Xã Hòa Sơn", district_code: "427" },
  { code: "17650", name: "Xã Đặng Sơn", district_code: "427" },
  { code: "17653", name: "Xã Đông Sơn", district_code: "427" },
  { code: "17656", name: "Xã Nam Sơn", district_code: "427" },
  { code: "17659", name: "Xã Lưu Sơn", district_code: "427" },
  { code: "17662", name: "Xã Yên Sơn", district_code: "427" },
  { code: "17665", name: "Xã Văn Sơn", district_code: "427" },
  { code: "17668", name: "Xã Đà Sơn", district_code: "427" },
  { code: "17671", name: "Xã Lạc Sơn", district_code: "427" },
  { code: "17674", name: "Xã Tân Sơn", district_code: "427" },
  { code: "17677", name: "Xã Thái Sơn", district_code: "427" },
  { code: "17680", name: "Xã Quang Sơn", district_code: "427" },
  { code: "17683", name: "Xã Thịnh Sơn", district_code: "427" },
  { code: "17686", name: "Xã Trung Sơn", district_code: "427" },
  { code: "17689", name: "Xã Xuân Sơn", district_code: "427" },
  { code: "17692", name: "Xã Minh Sơn", district_code: "427" },
  { code: "17695", name: "Xã Thuận Sơn", district_code: "427" },
  { code: "17698", name: "Xã Nhân Sơn", district_code: "427" },
  { code: "17701", name: "Xã Hiến Sơn", district_code: "427" },
  { code: "17704", name: "Xã Mỹ Sơn", district_code: "427" },
  { code: "17707", name: "Xã Trù Sơn", district_code: "427" },
  { code: "17710", name: "Xã Đại Sơn", district_code: "427" },
  { code: "17713", name: "Thị trấn Dùng", district_code: "428" },
  { code: "17716", name: "Xã Cát Văn", district_code: "428" },
  { code: "17719", name: "Xã Minh Sơn", district_code: "428" },
  { code: "17722", name: "Xã Hạnh Lâm", district_code: "428" },
  { code: "17723", name: "Xã Thanh Sơn", district_code: "428" },
  { code: "17728", name: "Xã Phong Thịnh", district_code: "428" },
  { code: "17731", name: "Xã Thanh Phong", district_code: "428" },
  { code: "17734", name: "Xã Thanh Mỹ", district_code: "428" },
  { code: "17737", name: "Xã Thanh Tiên", district_code: "428" },
  { code: "17743", name: "Xã Thanh Liên", district_code: "428" },
  { code: "17749", name: "Xã Đại Đồng", district_code: "428" },
  { code: "17755", name: "Xã Thanh Ngọc", district_code: "428" },
  { code: "17758", name: "Xã Thanh Hương", district_code: "428" },
  { code: "17759", name: "Xã Ngọc Lâm", district_code: "428" },
  { code: "17764", name: "Xã Đồng Văn", district_code: "428" },
  { code: "17767", name: "Xã Ngọc Sơn", district_code: "428" },
  { code: "17770", name: "Xã Thanh Thịnh", district_code: "428" },
  { code: "17773", name: "Xã Thanh An", district_code: "428" },
  { code: "17776", name: "Xã Thanh Quả", district_code: "428" },
  { code: "17779", name: "Xã Xuân Dương", district_code: "428" },
  { code: "17785", name: "Xã Minh Tiến", district_code: "428" },
  { code: "17791", name: "Xã Kim Bảng", district_code: "428" },
  { code: "17797", name: "Xã Thanh Thủy", district_code: "428" },
  { code: "17806", name: "Xã Thanh Hà", district_code: "428" },
  { code: "17812", name: "Xã Thanh Tùng", district_code: "428" },
  { code: "17815", name: "Xã Thanh Lâm", district_code: "428" },
  { code: "17818", name: "Xã Mai Giang", district_code: "428" },
  { code: "17821", name: "Xã Thanh Xuân", district_code: "428" },
  { code: "17824", name: "Xã Thanh Đức", district_code: "428" },
  { code: "17827", name: "Thị trấn Quán Hành", district_code: "429" },
  { code: "17830", name: "Xã Nghi Văn", district_code: "429" },
  { code: "17833", name: "Xã Nghi Yên", district_code: "429" },
  { code: "17836", name: "Xã Nghi Tiến", district_code: "429" },
  { code: "17839", name: "Xã Nghi Hưng", district_code: "429" },
  { code: "17842", name: "Xã Nghi Đồng", district_code: "429" },
  { code: "17845", name: "Xã Nghi Thiết", district_code: "429" },
  { code: "17848", name: "Xã Nghi Lâm", district_code: "429" },
  { code: "17851", name: "Xã Nghi Quang", district_code: "429" },
  { code: "17854", name: "Xã Nghi Kiều", district_code: "429" },
  { code: "17857", name: "Xã Nghi Mỹ", district_code: "429" },
  { code: "17860", name: "Xã Nghi Phương", district_code: "429" },
  { code: "17863", name: "Xã Nghi Thuận", district_code: "429" },
  { code: "17866", name: "Xã Nghi Long", district_code: "429" },
  { code: "17869", name: "Xã Nghi Xá", district_code: "429" },
  { code: "17878", name: "Xã Khánh Hợp", district_code: "429" },
  { code: "17884", name: "Xã Nghi Công Bắc", district_code: "429" },
  { code: "17887", name: "Xã Nghi Công Nam", district_code: "429" },
  { code: "17890", name: "Xã Nghi Thạch", district_code: "429" },
  { code: "17893", name: "Xã Nghi Trung", district_code: "429" },
  { code: "17896", name: "Xã Thịnh Trường", district_code: "429" },
  { code: "17899", name: "Xã Diên Hoa", district_code: "429" },
  { code: "17911", name: "Xã Nghi Vạn", district_code: "429" },
  { code: "17932", name: "Xã Nam Hưng", district_code: "430" },
  { code: "17935", name: "Xã Nghĩa Thái", district_code: "430" },
  { code: "17938", name: "Xã Nam Thanh", district_code: "430" },
  { code: "17941", name: "Xã Nam Anh", district_code: "430" },
  { code: "17944", name: "Xã Nam Xuân", district_code: "430" },
  { code: "17950", name: "Thị trấn Nam Đàn", district_code: "430" },
  { code: "17953", name: "Xã Nam Lĩnh", district_code: "430" },
  { code: "17956", name: "Xã Nam Giang", district_code: "430" },
  { code: "17959", name: "Xã Xuân Hòa", district_code: "430" },
  { code: "17962", name: "Xã Hùng Tiến", district_code: "430" },
  { code: "17968", name: "Xã Thượng Tân Lộc", district_code: "430" },
  { code: "17971", name: "Xã Kim Liên", district_code: "430" },
  { code: "17980", name: "Xã Xuân Hồng", district_code: "430" },
  { code: "17983", name: "Xã Nam Cát", district_code: "430" },
  { code: "17986", name: "Xã Khánh Sơn", district_code: "430" },
  { code: "17989", name: "Xã Trung Phúc Cường", district_code: "430" },
  { code: "17998", name: "Xã Nam Kim", district_code: "430" },
  { code: "18001", name: "Thị trấn Hưng Nguyên", district_code: "431" },
  { code: "18004", name: "Xã Hưng Trung", district_code: "431" },
  { code: "18007", name: "Xã Hưng Yên", district_code: "431" },
  { code: "18008", name: "Xã Hưng Yên Bắc", district_code: "431" },
  { code: "18010", name: "Xã Hưng Tây", district_code: "431" },
  { code: "18016", name: "Xã Hưng Đạo", district_code: "431" },
  { code: "18022", name: "Xã Thịnh Mỹ", district_code: "431" },
  { code: "18025", name: "Xã Hưng Lĩnh", district_code: "431" },
  { code: "18028", name: "Xã Thông Tân", district_code: "431" },
  { code: "18037", name: "Xã Hưng Nghĩa", district_code: "431" },
  { code: "18040", name: "Xã Phúc Lợi", district_code: "431" },
  { code: "18043", name: "Xã Long Xá", district_code: "431" },
  { code: "18052", name: "Xã Châu Nhân", district_code: "431" },
  { code: "18055", name: "Xã Xuân Lam", district_code: "431" },
  { code: "18064", name: "Xã Hưng Thành", district_code: "431" },
  { code: "17104", name: "Xã Quỳnh Vinh", district_code: "432" },
  { code: "17107", name: "Xã Quỳnh Lộc", district_code: "432" },
  { code: "17110", name: "Phường Quỳnh Thiện", district_code: "432" },
  { code: "17113", name: "Xã Quỳnh Lập", district_code: "432" },
  { code: "17116", name: "Xã Quỳnh Trang", district_code: "432" },
  { code: "17125", name: "Phường Mai Hùng", district_code: "432" },
  { code: "17128", name: "Phường Quỳnh Dị", district_code: "432" },
  { code: "17131", name: "Phường Quỳnh Xuân", district_code: "432" },
  { code: "17134", name: "Phường Quỳnh Phương", district_code: "432" },
  { code: "17137", name: "Xã Quỳnh Liên", district_code: "432" },
  { code: "18073", name: "Phường Nam Hà", district_code: "436" },
  { code: "18077", name: "Phường Bắc Hà", district_code: "436" },
  { code: "18079", name: "Phường Tân Giang", district_code: "436" },
  { code: "18082", name: "Phường Đại Nài", district_code: "436" },
  { code: "18085", name: "Phường Hà Huy Tập", district_code: "436" },
  { code: "18088", name: "Phường Thạch Trung", district_code: "436" },
  { code: "18091", name: "Phường Thạch Quý", district_code: "436" },
  { code: "18094", name: "Phường Trần Phú", district_code: "436" },
  { code: "18097", name: "Phường Văn Yên", district_code: "436" },
  { code: "18100", name: "Phường Thạch Hạ", district_code: "436" },
  { code: "18103", name: "Phường Đồng Môn", district_code: "436" },
  { code: "18109", name: "Phường Thạch Hưng", district_code: "436" },
  { code: "18112", name: "Xã Thạch Bình", district_code: "436" },
  { code: "18571", name: "Xã Thạch Hải", district_code: "436" },
  { code: "18595", name: "Xã Đỉnh Bàn", district_code: "436" },
  { code: "18598", name: "Xã Hộ Độ", district_code: "436" },
  { code: "18604", name: "Xã Thạch Khê", district_code: "436" },
  { code: "18619", name: "Xã Thạch Trị", district_code: "436" },
  { code: "18622", name: "Xã Thạch Lạc", district_code: "436" },
  { code: "18628", name: "Xã Tượng Sơn", district_code: "436" },
  { code: "18631", name: "Xã Thạch Văn", district_code: "436" },
  { code: "18637", name: "Xã Thạch Thắng", district_code: "436" },
  { code: "18643", name: "Xã Thạch Đài", district_code: "436" },
  { code: "18649", name: "Xã Thạch Hội", district_code: "436" },
  { code: "18652", name: "Xã Tân Lâm Hương", district_code: "436" },
  { code: "18685", name: "Xã Cẩm Bình", district_code: "436" },
  { code: "18691", name: "Xã Cẩm Vịnh", district_code: "436" },
  { code: "18115", name: "Phường Bắc Hồng", district_code: "437" },
  { code: "18118", name: "Phường Nam Hồng", district_code: "437" },
  { code: "18121", name: "Phường Trung Lương", district_code: "437" },
  { code: "18124", name: "Phường Đức Thuận", district_code: "437" },
  { code: "18127", name: "Phường Đậu Liêu", district_code: "437" },
  { code: "18130", name: "Xã Thuận Lộc", district_code: "437" },
  { code: "18133", name: "Thị trấn Phố Châu", district_code: "439" },
  { code: "18136", name: "Thị trấn Tây Sơn", district_code: "439" },
  { code: "18139", name: "Xã Sơn Hồng", district_code: "439" },
  { code: "18142", name: "Xã Sơn Tiến", district_code: "439" },
  { code: "18145", name: "Xã Sơn Lâm", district_code: "439" },
  { code: "18148", name: "Xã Sơn Lễ", district_code: "439" },
  { code: "18157", name: "Xã Sơn Giang", district_code: "439" },
  { code: "18160", name: "Xã Sơn Lĩnh", district_code: "439" },
  { code: "18163", name: "Xã An Hòa Thịnh", district_code: "439" },
  { code: "18172", name: "Xã Sơn Tây", district_code: "439" },
  { code: "18175", name: "Xã Sơn Ninh", district_code: "439" },
  { code: "18178", name: "Xã Châu Bình", district_code: "439" },
  { code: "18181", name: "Xã Tân Mỹ Hà", district_code: "439" },
  { code: "18184", name: "Xã Quang Diệm", district_code: "439" },
  { code: "18187", name: "Xã Sơn Trung", district_code: "439" },
  { code: "18190", name: "Xã Sơn Bằng", district_code: "439" },
  { code: "18196", name: "Xã Sơn Kim 1", district_code: "439" },
  { code: "18199", name: "Xã Sơn Kim 2", district_code: "439" },
  { code: "18202", name: "Xã Mỹ Long", district_code: "439" },
  { code: "18211", name: "Xã Kim Hoa", district_code: "439" },
  { code: "18217", name: "Xã Sơn Phú", district_code: "439" },
  { code: "18223", name: "Xã Hàm Trường", district_code: "439" },
  { code: "18229", name: "Thị trấn Đức Thọ", district_code: "440" },
  { code: "18235", name: "Xã Quang Vĩnh", district_code: "440" },
  { code: "18241", name: "Xã Tùng Châu", district_code: "440" },
  { code: "18244", name: "Xã Trường Sơn", district_code: "440" },
  { code: "18247", name: "Xã Liên Minh", district_code: "440" },
  { code: "18253", name: "Xã Yên Hồ", district_code: "440" },
  { code: "18259", name: "Xã Tùng Ảnh", district_code: "440" },
  { code: "18262", name: "Xã Bùi La Nhân", district_code: "440" },
  { code: "18274", name: "Xã Thanh Bình Thịnh", district_code: "440" },
  { code: "18277", name: "Xã Lâm Trung Thủy", district_code: "440" },
  { code: "18280", name: "Xã Hòa Lạc", district_code: "440" },
  { code: "18283", name: "Xã Tân Dân", district_code: "440" },
  { code: "18298", name: "Xã An Dũng", district_code: "440" },
  { code: "18304", name: "Xã Đức Đồng", district_code: "440" },
  { code: "18307", name: "Xã Đức Lạng", district_code: "440" },
  { code: "18310", name: "Xã Tân Hương", district_code: "440" },
  { code: "18313", name: "Thị trấn Vũ Quang", district_code: "441" },
  { code: "18316", name: "Xã Ân Phú", district_code: "441" },
  { code: "18319", name: "Xã Đức Giang", district_code: "441" },
  { code: "18322", name: "Xã Đức Lĩnh", district_code: "441" },
  { code: "18325", name: "Xã Thọ Điền", district_code: "441" },
  { code: "18328", name: "Xã Đức Hương", district_code: "441" },
  { code: "18331", name: "Xã Đức Bồng", district_code: "441" },
  { code: "18334", name: "Xã Đức Liên", district_code: "441" },
  { code: "18340", name: "Xã Hương Minh", district_code: "441" },
  { code: "18343", name: "Xã Quang Thọ", district_code: "441" },
  { code: "18352", name: "Thị trấn Xuân An", district_code: "442" },
  { code: "18355", name: "Xã Xuân Hội", district_code: "442" },
  { code: "18358", name: "Xã Đan Trường", district_code: "442" },
  { code: "18364", name: "Xã Xuân Phổ", district_code: "442" },
  { code: "18367", name: "Xã Xuân Hải", district_code: "442" },
  { code: "18370", name: "Xã Xuân Giang", district_code: "442" },
  { code: "18373", name: "Thị trấn Tiên Điền", district_code: "442" },
  { code: "18376", name: "Xã Xuân Yên", district_code: "442" },
  { code: "18379", name: "Xã Xuân Mỹ", district_code: "442" },
  { code: "18382", name: "Xã Xuân Thành", district_code: "442" },
  { code: "18385", name: "Xã Xuân Viên", district_code: "442" },
  { code: "18388", name: "Xã Xuân Hồng", district_code: "442" },
  { code: "18391", name: "Xã Cỗ Đạm", district_code: "442" },
  { code: "18394", name: "Xã Xuân Liên", district_code: "442" },
  { code: "18397", name: "Xã Xuân Lĩnh", district_code: "442" },
  { code: "18400", name: "Xã Xuân Lam", district_code: "442" },
  { code: "18403", name: "Xã Cương Gián", district_code: "442" },
  { code: "18406", name: "Thị trấn Nghèn", district_code: "443" },
  { code: "18415", name: "Xã Thiên Lộc", district_code: "443" },
  { code: "18418", name: "Xã Thuần Thiện", district_code: "443" },
  { code: "18427", name: "Xã Vượng Lộc", district_code: "443" },
  { code: "18433", name: "Xã Thanh Lộc", district_code: "443" },
  { code: "18436", name: "Xã Kim Song Trường", district_code: "443" },
  { code: "18439", name: "Xã Thường Nga", district_code: "443" },
  { code: "18445", name: "Xã Tùng Lộc", district_code: "443" },
  { code: "18454", name: "Xã Phú Lộc", district_code: "443" },
  { code: "18463", name: "Xã Gia Hanh", district_code: "443" },
  { code: "18466", name: "Xã Khánh Vĩnh Yên", district_code: "443" },
  { code: "18475", name: "Xã Xuân Lộc", district_code: "443" },
  { code: "18478", name: "Xã Thượng Lộc", district_code: "443" },
  { code: "18481", name: "Xã Quang Lộc", district_code: "443" },
  { code: "18484", name: "Thị trấn Đồng Lộc", district_code: "443" },
  { code: "18487", name: "Xã Mỹ Lộc", district_code: "443" },
  { code: "18490", name: "Xã Sơn Lộc", district_code: "443" },
  { code: "18496", name: "Thị trấn Hương Khê", district_code: "444" },
  { code: "18499", name: "Xã Điền Mỹ", district_code: "444" },
  { code: "18502", name: "Xã Hà Linh", district_code: "444" },
  { code: "18505", name: "Xã Hương Thủy", district_code: "444" },
  { code: "18508", name: "Xã Hòa Hải", district_code: "444" },
  { code: "18514", name: "Xã Phúc Đồng", district_code: "444" },
  { code: "18517", name: "Xã Hương Giang", district_code: "444" },
  { code: "18520", name: "Xã Lộc Yên", district_code: "444" },
  { code: "18523", name: "Xã Hương Bình", district_code: "444" },
  { code: "18526", name: "Xã Hương Long", district_code: "444" },
  { code: "18529", name: "Xã Phú Gia", district_code: "444" },
  { code: "18532", name: "Xã Gia Phố", district_code: "444" },
  { code: "18538", name: "Xã Hương Đô", district_code: "444" },
  { code: "18541", name: "Xã Hương Vĩnh", district_code: "444" },
  { code: "18544", name: "Xã Hương Xuân", district_code: "444" },
  { code: "18547", name: "Xã Phúc Trạch", district_code: "444" },
  { code: "18550", name: "Xã Hương Trà", district_code: "444" },
  { code: "18553", name: "Xã Hương Trạch", district_code: "444" },
  { code: "18556", name: "Xã Hương Lâm", district_code: "444" },
  { code: "18559", name: "Xã Hương Liên", district_code: "444" },
  { code: "18409", name: "Xã Tân Lộc", district_code: "445" },
  { code: "18412", name: "Xã Hồng Lộc", district_code: "445" },
  { code: "18421", name: "Xã Thịnh Lộc", district_code: "445" },
  { code: "18430", name: "Xã Bình An", district_code: "445" },
  { code: "18448", name: "Xã Bình Lộc", district_code: "445" },
  { code: "18457", name: "Xã Ích Hậu", district_code: "445" },
  { code: "18493", name: "Xã Phù Lưu", district_code: "445" },
  { code: "18562", name: "Thị trấn Thạch Hà", district_code: "445" },
  { code: "18565", name: "Xã Ngọc Sơn", district_code: "445" },
  { code: "18568", name: "Thị trấn Lộc Hà", district_code: "445" },
  { code: "18577", name: "Xã Thạch Mỹ", district_code: "445" },
  { code: "18580", name: "Xã Thạch Kim", district_code: "445" },
  { code: "18583", name: "Xã Thạch Châu", district_code: "445" },
  { code: "18586", name: "Xã Thạch Kênh", district_code: "445" },
  { code: "18589", name: "Xã Thạch Sơn", district_code: "445" },
  { code: "18592", name: "Xã Thạch Liên", district_code: "445" },
  { code: "18601", name: "Xã Việt Tiến", district_code: "445" },
  { code: "18607", name: "Xã Thạch Long", district_code: "445" },
  { code: "18625", name: "Xã Thạch Ngọc", district_code: "445" },
  { code: "18634", name: "Xã Lưu Vĩnh Sơn", district_code: "445" },
  { code: "18658", name: "Xã Thạch Xuân", district_code: "445" },
  { code: "18667", name: "Xã Nam Điền", district_code: "445" },
  { code: "18670", name: "Xã Mai Phụ", district_code: "445" },
  { code: "18673", name: "Thị trấn Cẩm Xuyên", district_code: "446" },
  { code: "18676", name: "Thị trấn Thiên Cầm", district_code: "446" },
  { code: "18679", name: "Xã Yên Hòa", district_code: "446" },
  { code: "18682", name: "Xã Cẩm Dương", district_code: "446" },
  { code: "18694", name: "Xã Cẩm Thành", district_code: "446" },
  { code: "18697", name: "Xã Cẩm Quang", district_code: "446" },
  { code: "18706", name: "Xã Cẩm Thạch", district_code: "446" },
  { code: "18709", name: "Xã Cẩm Nhượng", district_code: "446" },
  { code: "18712", name: "Xã Nam Phúc Thăng", district_code: "446" },
  { code: "18715", name: "Xã Cẩm Duệ", district_code: "446" },
  { code: "18721", name: "Xã Cẩm Lĩnh", district_code: "446" },
  { code: "18724", name: "Xã Cẩm Quan", district_code: "446" },
  { code: "18727", name: "Xã Cẩm Hà", district_code: "446" },
  { code: "18730", name: "Xã Cẩm Lộc", district_code: "446" },
  { code: "18733", name: "Xã Cẩm Hưng", district_code: "446" },
  { code: "18736", name: "Xã Cẩm Thịnh", district_code: "446" },
  { code: "18739", name: "Xã Cẩm Mỹ", district_code: "446" },
  { code: "18742", name: "Xã Cẩm Trung", district_code: "446" },
  { code: "18745", name: "Xã Cẩm Sơn", district_code: "446" },
  { code: "18748", name: "Xã Cẩm Lạc", district_code: "446" },
  { code: "18751", name: "Xã Cẩm Minh", district_code: "446" },
  { code: "18757", name: "Xã Kỳ Xuân", district_code: "447" },
  { code: "18760", name: "Xã Kỳ Bắc", district_code: "447" },
  { code: "18763", name: "Xã Kỳ Phú", district_code: "447" },
  { code: "18766", name: "Xã Kỳ Phong", district_code: "447" },
  { code: "18769", name: "Xã Kỳ Tiến", district_code: "447" },
  { code: "18772", name: "Xã Kỳ Giang", district_code: "447" },
  { code: "18775", name: "Thị trấn Kỳ Đồng", district_code: "447" },
  { code: "18778", name: "Xã Kỳ Khang", district_code: "447" },
  { code: "18784", name: "Xã Kỳ Văn", district_code: "447" },
  { code: "18787", name: "Xã Kỳ Trung", district_code: "447" },
  { code: "18790", name: "Xã Kỳ Thọ", district_code: "447" },
  { code: "18793", name: "Xã Kỳ Tây", district_code: "447" },
  { code: "18799", name: "Xã Kỳ Thượng", district_code: "447" },
  { code: "18802", name: "Xã Kỳ Hải", district_code: "447" },
  { code: "18805", name: "Xã Kỳ Thư", district_code: "447" },
  { code: "18811", name: "Xã Kỳ Châu", district_code: "447" },
  { code: "18814", name: "Xã Kỳ Tân", district_code: "447" },
  { code: "18838", name: "Xã Lâm Hợp", district_code: "447" },
  { code: "18844", name: "Xã Kỳ Sơn", district_code: "447" },
  { code: "18850", name: "Xã Kỳ Lạc", district_code: "447" },
  { code: "18754", name: "Phường Hưng Trí", district_code: "449" },
  { code: "18781", name: "Phường Kỳ Ninh", district_code: "449" },
  { code: "18796", name: "Xã Kỳ Lợi", district_code: "449" },
  { code: "18808", name: "Xã Kỳ Hà", district_code: "449" },
  { code: "18820", name: "Phường Kỳ Trinh", district_code: "449" },
  { code: "18823", name: "Phường Kỳ Thịnh", district_code: "449" },
  { code: "18829", name: "Xã Kỳ Hoa", district_code: "449" },
  { code: "18832", name: "Phường Kỳ Phương", district_code: "449" },
  { code: "18835", name: "Phường Kỳ Long", district_code: "449" },
  { code: "18841", name: "Phường Kỳ Liên", district_code: "449" },
  { code: "18847", name: "Phường Kỳ Nam", district_code: "449" },
  { code: "18853", name: "Phường Hải Thành", district_code: "450" },
  { code: "18856", name: "Phường Đồng Phú", district_code: "450" },
  { code: "18859", name: "Phường Bắc Lý", district_code: "450" },
  { code: "18865", name: "Phường Nam Lý", district_code: "450" },
  { code: "18868", name: "Phường Đồng Hải", district_code: "450" },
  { code: "18871", name: "Phường Đồng Sơn", district_code: "450" },
  { code: "18874", name: "Phường Phú Hải", district_code: "450" },
  { code: "18877", name: "Phường Bắc Nghĩa", district_code: "450" },
  { code: "18880", name: "Phường Đức Ninh Đông", district_code: "450" },
  { code: "18883", name: "Xã Quang Phú", district_code: "450" },
  { code: "18886", name: "Xã Lộc Ninh", district_code: "450" },
  { code: "18889", name: "Xã Bảo Ninh", district_code: "450" },
  { code: "18892", name: "Xã Nghĩa Ninh", district_code: "450" },
  { code: "18895", name: "Xã Thuận Đức", district_code: "450" },
  { code: "18898", name: "Xã Đức Ninh", district_code: "450" },
  { code: "18901", name: "Thị trấn Quy Đạt", district_code: "452" },
  { code: "18904", name: "Xã Dân Hóa", district_code: "452" },
  { code: "18907", name: "Xã Trọng Hóa", district_code: "452" },
  { code: "18913", name: "Xã Hồng Hóa", district_code: "452" },
  { code: "18919", name: "Xã Tân Thành", district_code: "452" },
  { code: "18922", name: "Xã Hóa Hợp", district_code: "452" },
  { code: "18925", name: "Xã Xuân Hóa", district_code: "452" },
  { code: "18928", name: "Xã Yên Hóa", district_code: "452" },
  { code: "18931", name: "Xã Minh Hóa", district_code: "452" },
  { code: "18934", name: "Xã Tân Hóa", district_code: "452" },
  { code: "18937", name: "Xã Hóa Sơn", district_code: "452" },
  { code: "18943", name: "Xã Trung Hóa", district_code: "452" },
  { code: "18946", name: "Xã Thượng Hóa", district_code: "452" },
  { code: "18949", name: "Thị trấn Đồng Lê", district_code: "453" },
  { code: "18952", name: "Xã Hương Hóa", district_code: "453" },
  { code: "18955", name: "Xã Kim Hóa", district_code: "453" },
  { code: "18958", name: "Xã Thanh Hóa", district_code: "453" },
  { code: "18961", name: "Xã Thanh Thạch", district_code: "453" },
  { code: "18964", name: "Xã Thuận Hóa", district_code: "453" },
  { code: "18967", name: "Xã Lâm Hóa", district_code: "453" },
  { code: "18970", name: "Xã Lê Hóa", district_code: "453" },
  { code: "18973", name: "Xã Sơn Hóa", district_code: "453" },
  { code: "18976", name: "Xã Đồng Hóa", district_code: "453" },
  { code: "18979", name: "Xã Ngư Hóa", district_code: "453" },
  { code: "18985", name: "Xã Thạch Hóa", district_code: "453" },
  { code: "18988", name: "Xã Đức Hóa", district_code: "453" },
  { code: "18991", name: "Xã Phong Hóa", district_code: "453" },
  { code: "18994", name: "Xã Mai Hóa", district_code: "453" },
  { code: "18997", name: "Xã Tiến Hóa", district_code: "453" },
  { code: "19000", name: "Xã Châu Hóa", district_code: "453" },
  { code: "19003", name: "Xã Cao Quảng", district_code: "453" },
  { code: "19006", name: "Xã Văn Hóa", district_code: "453" },
  { code: "19012", name: "Xã Quảng Hợp", district_code: "454" },
  { code: "19015", name: "Xã Quảng Kim", district_code: "454" },
  { code: "19018", name: "Xã Quảng Đông", district_code: "454" },
  { code: "19021", name: "Xã Quảng Phú", district_code: "454" },
  { code: "19024", name: "Xã Quảng Châu", district_code: "454" },
  { code: "19027", name: "Xã Quảng Thạch", district_code: "454" },
  { code: "19030", name: "Xã Quảng Lưu", district_code: "454" },
  { code: "19033", name: "Xã Quảng Tùng", district_code: "454" },
  { code: "19036", name: "Xã Cảnh Dương", district_code: "454" },
  { code: "19039", name: "Xã Quảng Tiến", district_code: "454" },
  { code: "19042", name: "Xã Quảng Hưng", district_code: "454" },
  { code: "19045", name: "Xã Quảng Xuân", district_code: "454" },
  { code: "19051", name: "Xã Liên Trường", district_code: "454" },
  { code: "19057", name: "Xã Quảng Phương", district_code: "454" },
  { code: "19063", name: "Xã Phù Cảnh", district_code: "454" },
  { code: "19072", name: "Xã Quảng Thanh", district_code: "454" },
  { code: "19111", name: "Thị trấn Hoàn Lão", district_code: "455" },
  { code: "19114", name: "Thị trấn NT Việt Trung", district_code: "455" },
  { code: "19117", name: "Xã Xuân Trạch", district_code: "455" },
  { code: "19123", name: "Xã Hạ Mỹ", district_code: "455" },
  { code: "19126", name: "Xã Bắc Trạch", district_code: "455" },
  { code: "19129", name: "Xã Lâm Trạch", district_code: "455" },
  { code: "19132", name: "Xã Thanh Trạch", district_code: "455" },
  { code: "19135", name: "Xã Liên Trạch", district_code: "455" },
  { code: "19138", name: "Xã Phúc Trạch", district_code: "455" },
  { code: "19141", name: "Xã Cự Nẫm", district_code: "455" },
  { code: "19144", name: "Xã Hải Phú", district_code: "455" },
  { code: "19147", name: "Xã Thượng Trạch", district_code: "455" },
  { code: "19150", name: "Xã Sơn Lộc", district_code: "455" },
  { code: "19156", name: "Xã Hưng Trạch", district_code: "455" },
  { code: "19159", name: "Xã Đồng Trạch", district_code: "455" },
  { code: "19162", name: "Xã Đức Trạch", district_code: "455" },
  { code: "19165", name: "Thị trấn Phong Nha", district_code: "455" },
  { code: "19168", name: "Xã Vạn Trạch", district_code: "455" },
  { code: "19174", name: "Xã Phú Định", district_code: "455" },
  { code: "19177", name: "Xã Trung Trạch", district_code: "455" },
  { code: "19180", name: "Xã Tây Trạch", district_code: "455" },
  { code: "19183", name: "Xã Hòa Trạch", district_code: "455" },
  { code: "19186", name: "Xã Đại Trạch", district_code: "455" },
  { code: "19189", name: "Xã Nhân Trạch", district_code: "455" },
  { code: "19192", name: "Xã Tân Trạch", district_code: "455" },
  { code: "19198", name: "Xã Lý Nam", district_code: "455" },
  { code: "19204", name: "Xã Trường Sơn", district_code: "456" },
  { code: "19207", name: "Thị trấn Quán Hàu", district_code: "456" },
  { code: "19210", name: "Xã Vĩnh Ninh", district_code: "456" },
  { code: "19213", name: "Xã Võ Ninh", district_code: "456" },
  { code: "19216", name: "Xã Hải Ninh", district_code: "456" },
  { code: "19219", name: "Xã Hàm Ninh", district_code: "456" },
  { code: "19222", name: "Xã Duy Ninh", district_code: "456" },
  { code: "19225", name: "Xã Gia Ninh", district_code: "456" },
  { code: "19228", name: "Xã Trường Xuân", district_code: "456" },
  { code: "19231", name: "Xã Hiền Ninh", district_code: "456" },
  { code: "19234", name: "Xã Tân Ninh", district_code: "456" },
  { code: "19237", name: "Xã Xuân Ninh", district_code: "456" },
  { code: "19240", name: "Xã An Ninh", district_code: "456" },
  { code: "19243", name: "Xã Vạn Ninh", district_code: "456" },
  { code: "19246", name: "Thị trấn NT Lệ Ninh", district_code: "457" },
  { code: "19249", name: "Thị trấn Kiến Giang", district_code: "457" },
  { code: "19252", name: "Xã Hồng Thủy", district_code: "457" },
  { code: "19255", name: "Xã Ngư Thủy Bắc", district_code: "457" },
  { code: "19258", name: "Xã Hoa Thủy", district_code: "457" },
  { code: "19261", name: "Xã Thanh Thủy", district_code: "457" },
  { code: "19264", name: "Xã An Thủy", district_code: "457" },
  { code: "19267", name: "Xã Phong Thủy", district_code: "457" },
  { code: "19270", name: "Xã Cam Thủy", district_code: "457" },
  { code: "19273", name: "Xã Ngân Thủy", district_code: "457" },
  { code: "19276", name: "Xã Sơn Thủy", district_code: "457" },
  { code: "19279", name: "Xã Lộc Thủy", district_code: "457" },
  { code: "19285", name: "Xã Liên Thủy", district_code: "457" },
  { code: "19288", name: "Xã Hưng Thủy", district_code: "457" },
  { code: "19291", name: "Xã Dương Thủy", district_code: "457" },
  { code: "19294", name: "Xã Tân Thủy", district_code: "457" },
  { code: "19297", name: "Xã Phú Thủy", district_code: "457" },
  { code: "19300", name: "Xã Xuân Thủy", district_code: "457" },
  { code: "19303", name: "Xã Mỹ Thủy", district_code: "457" },
  { code: "19306", name: "Xã Ngư Thủy", district_code: "457" },
  { code: "19309", name: "Xã Mai Thủy", district_code: "457" },
  { code: "19312", name: "Xã Sen Thủy", district_code: "457" },
  { code: "19315", name: "Xã Thái Thủy", district_code: "457" },
  { code: "19318", name: "Xã Kim Thủy", district_code: "457" },
  { code: "19321", name: "Xã Trường Thủy", district_code: "457" },
  { code: "19327", name: "Xã Lâm Thủy", district_code: "457" },
  { code: "19009", name: "Phường Ba Đồn", district_code: "458" },
  { code: "19060", name: "Phường Quảng Long", district_code: "458" },
  { code: "19066", name: "Phường Quảng Thọ", district_code: "458" },
  { code: "19069", name: "Xã Quảng Tiên", district_code: "458" },
  { code: "19075", name: "Xã Quảng Trung", district_code: "458" },
  { code: "19078", name: "Phường Quảng Phong", district_code: "458" },
  { code: "19081", name: "Phường Quảng Thuận", district_code: "458" },
  { code: "19084", name: "Xã Quảng Tân", district_code: "458" },
  { code: "19087", name: "Xã Quảng Hải", district_code: "458" },
  { code: "19090", name: "Xã Quảng Sơn", district_code: "458" },
  { code: "19093", name: "Xã Quảng Lộc", district_code: "458" },
  { code: "19096", name: "Xã Quảng Thủy", district_code: "458" },
  { code: "19099", name: "Xã Quảng Văn", district_code: "458" },
  { code: "19102", name: "Phường Quảng Phúc", district_code: "458" },
  { code: "19105", name: "Xã Quảng Hòa", district_code: "458" },
  { code: "19108", name: "Xã Quảng Minh", district_code: "458" },
  { code: "19330", name: "Phường Đông Giang", district_code: "461" },
  { code: "19333", name: "Phường 1", district_code: "461" },
  { code: "19336", name: "Phường Đông Lễ", district_code: "461" },
  { code: "19339", name: "Phường Đông Thanh", district_code: "461" },
  { code: "19342", name: "Phường 2", district_code: "461" },
  { code: "19345", name: "Phường 4", district_code: "461" },
  { code: "19348", name: "Phường 5", district_code: "461" },
  { code: "19351", name: "Phường Đông Lương", district_code: "461" },
  { code: "19354", name: "Phường 3", district_code: "461" },
  { code: "19357", name: "Phường 1", district_code: "462" },
  { code: "19358", name: "Phường An Đôn", district_code: "462" },
  { code: "19360", name: "Phường 2", district_code: "462" },
  { code: "19361", name: "Phường 3", district_code: "462" },
  { code: "19705", name: "Xã Hải Lệ", district_code: "462" },
  { code: "19363", name: "Thị trấn Hồ Xá", district_code: "464" },
  { code: "19366", name: "Thị trấn Bến Quan", district_code: "464" },
  { code: "19369", name: "Xã Vĩnh Thái", district_code: "464" },
  { code: "19372", name: "Xã Vĩnh Tú", district_code: "464" },
  { code: "19375", name: "Xã Vĩnh Chấp", district_code: "464" },
  { code: "19378", name: "Xã Trung Nam", district_code: "464" },
  { code: "19384", name: "Xã Kim Thạch", district_code: "464" },
  { code: "19387", name: "Xã Vĩnh Long", district_code: "464" },
  { code: "19393", name: "Xã Vĩnh Khê", district_code: "464" },
  { code: "19396", name: "Xã Vĩnh Hòa", district_code: "464" },
  { code: "19402", name: "Xã Vĩnh Thủy", district_code: "464" },
  { code: "19405", name: "Xã Vĩnh Lâm", district_code: "464" },
  { code: "19408", name: "Xã Hiền Thành", district_code: "464" },
  { code: "19414", name: "Thị trấn Cửa Tùng", district_code: "464" },
  { code: "19417", name: "Xã Vĩnh Hà", district_code: "464" },
  { code: "19420", name: "Xã Vĩnh Sơn", district_code: "464" },
  { code: "19423", name: "Xã Vĩnh Giang", district_code: "464" },
  { code: "19426", name: "Xã Vĩnh Ô", district_code: "464" },
  { code: "19429", name: "Thị trấn Khe Sanh", district_code: "465" },
  { code: "19432", name: "Thị trấn Lao Bảo", district_code: "465" },
  { code: "19435", name: "Xã Hướng Lập", district_code: "465" },
  { code: "19438", name: "Xã Hướng Việt", district_code: "465" },
  { code: "19441", name: "Xã Hướng Phùng", district_code: "465" },
  { code: "19444", name: "Xã Hướng Sơn", district_code: "465" },
  { code: "19447", name: "Xã Hướng Linh", district_code: "465" },
  { code: "19450", name: "Xã Tân Hợp", district_code: "465" },
  { code: "19453", name: "Xã Hướng Tân", district_code: "465" },
  { code: "19456", name: "Xã Tân Thành", district_code: "465" },
  { code: "19459", name: "Xã Tân Long", district_code: "465" },
  { code: "19462", name: "Xã Tân Lập", district_code: "465" },
  { code: "19465", name: "Xã Tân Liên", district_code: "465" },
  { code: "19468", name: "Xã Húc", district_code: "465" },
  { code: "19471", name: "Xã Thuận", district_code: "465" },
  { code: "19474", name: "Xã Hướng Lộc", district_code: "465" },
  { code: "19477", name: "Xã Ba Tầng", district_code: "465" },
  { code: "19480", name: "Xã Thanh", district_code: "465" },
  { code: "19483", name: "Xã A Dơi", district_code: "465" },
  { code: "19489", name: "Xã Lìa", district_code: "465" },
  { code: "19492", name: "Xã Xy", district_code: "465" },
  { code: "19495", name: "Thị trấn Gio Linh", district_code: "466" },
  { code: "19496", name: "Thị trấn Cửa Việt", district_code: "466" },
  { code: "19498", name: "Xã Trung Giang", district_code: "466" },
  { code: "19501", name: "Xã Trung Hải", district_code: "466" },
  { code: "19504", name: "Xã Trung Sơn", district_code: "466" },
  { code: "19507", name: "Xã Phong Bình", district_code: "466" },
  { code: "19510", name: "Xã Gio Mỹ", district_code: "466" },
  { code: "19519", name: "Xã Gio Hải", district_code: "466" },
  { code: "19522", name: "Xã Gio An", district_code: "466" },
  { code: "19534", name: "Xã Linh Trường", district_code: "466" },
  { code: "19537", name: "Xã Gio Sơn", district_code: "466" },
  { code: "19543", name: "Xã Gio Mai", district_code: "466" },
  { code: "19546", name: "Xã Hải Thái", district_code: "466" },
  { code: "19552", name: "Xã Gio Quang", district_code: "466" },
  { code: "19555", name: "Thị trấn Krông Klang", district_code: "467" },
  { code: "19558", name: "Xã Mò Ó", district_code: "467" },
  { code: "19561", name: "Xã Hướng Hiệp", district_code: "467" },
  { code: "19564", name: "Xã Đa Krông", district_code: "467" },
  { code: "19567", name: "Xã Triệu Nguyên", district_code: "467" },
  { code: "19570", name: "Xã Ba Lòng", district_code: "467" },
  { code: "19576", name: "Xã Ba Nang", district_code: "467" },
  { code: "19579", name: "Xã Tà Long", district_code: "467" },
  { code: "19582", name: "Xã Húc Nghì", district_code: "467" },
  { code: "19585", name: "Xã A Vao", district_code: "467" },
  { code: "19588", name: "Xã Tà Rụt", district_code: "467" },
  { code: "19591", name: "Xã A Bung", district_code: "467" },
  { code: "19594", name: "Xã A Ngo", district_code: "467" },
  { code: "19597", name: "Thị trấn Cam Lộ", district_code: "468" },
  { code: "19600", name: "Xã Cam Tuyền", district_code: "468" },
  { code: "19603", name: "Xã Thanh An", district_code: "468" },
  { code: "19606", name: "Xã Cam Thủy", district_code: "468" },
  { code: "19612", name: "Xã Cam Thành", district_code: "468" },
  { code: "19615", name: "Xã Cam Hiếu", district_code: "468" },
  { code: "19618", name: "Xã Cam Chính", district_code: "468" },
  { code: "19621", name: "Xã Cam Nghĩa", district_code: "468" },
  { code: "19624", name: "Thị trấn Ái Tử", district_code: "469" },
  { code: "19627", name: "Xã Triệu Tân", district_code: "469" },
  { code: "19633", name: "Xã Triệu Phước", district_code: "469" },
  { code: "19636", name: "Xã Triệu Độ", district_code: "469" },
  { code: "19639", name: "Xã Triệu Trạch", district_code: "469" },
  { code: "19642", name: "Xã Triệu Thuận", district_code: "469" },
  { code: "19645", name: "Xã Triệu Đại", district_code: "469" },
  { code: "19648", name: "Xã Triệu Hòa", district_code: "469" },
  { code: "19654", name: "Xã Triệu Cơ", district_code: "469" },
  { code: "19657", name: "Xã Triệu Long", district_code: "469" },
  { code: "19660", name: "Xã Triệu Tài", district_code: "469" },
  { code: "19666", name: "Xã Triệu Trung", district_code: "469" },
  { code: "19669", name: "Xã Triệu Ái", district_code: "469" },
  { code: "19672", name: "Xã Triệu Thượng", district_code: "469" },
  { code: "19675", name: "Xã Triệu Giang", district_code: "469" },
  { code: "19678", name: "Xã Triệu Thành", district_code: "469" },
  { code: "19681", name: "Thị trấn Diên Sanh", district_code: "470" },
  { code: "19684", name: "Xã Hải An", district_code: "470" },
  { code: "19687", name: "Xã Hải Bình", district_code: "470" },
  { code: "19693", name: "Xã Hải Quy", district_code: "470" },
  { code: "19699", name: "Xã Hải Hưng", district_code: "470" },
  { code: "19702", name: "Xã Hải Phú", district_code: "470" },
  { code: "19708", name: "Xã Hải Thượng", district_code: "470" },
  { code: "19711", name: "Xã Hải Dương", district_code: "470" },
  { code: "19714", name: "Xã Hải Định", district_code: "470" },
  { code: "19717", name: "Xã Hải Lâm", district_code: "470" },
  { code: "19726", name: "Xã Hải Phong", district_code: "470" },
  { code: "19729", name: "Xã Hải Trường", district_code: "470" },
  { code: "19735", name: "Xã Hải Sơn", district_code: "470" },
  { code: "19738", name: "Xã Hải Chánh", district_code: "470" },
  { code: "19741", name: "Xã Hải Khê", district_code: "470" },
  { code: "19777", name: "Phường Vỹ Dạ", district_code: "474" },
  { code: "19780", name: "Phường Phường Đúc", district_code: "474" },
  { code: "19783", name: "Phường Vĩnh Ninh", district_code: "474" },
  { code: "19786", name: "Phường Phú Hội", district_code: "474" },
  { code: "19789", name: "Phường Phú Nhuận", district_code: "474" },
  { code: "19792", name: "Phường Xuân Phú", district_code: "474" },
  { code: "19795", name: "Phường Trường An", district_code: "474" },
  { code: "19798", name: "Phường Phước Vĩnh", district_code: "474" },
  { code: "19801", name: "Phường An Cựu", district_code: "474" },
  { code: "19807", name: "Phường Thuỷ Biều", district_code: "474" },
  { code: "19813", name: "Phường Thuỷ Xuân", district_code: "474" },
  { code: "19815", name: "Phường An Đông", district_code: "474" },
  { code: "19816", name: "Phường An Tây", district_code: "474" },
  { code: "19900", name: "Phường Thuận An", district_code: "474" },
  { code: "19909", name: "Phường Dương Nỗ", district_code: "474" },
  { code: "19930", name: "Phường Phú Thượng", district_code: "474" },
  { code: "19963", name: "Phường Thủy Vân", district_code: "474" },
  { code: "19981", name: "Phường Thủy Bằng", district_code: "474" },
  { code: "20002", name: "Phường Hương Phong", district_code: "474" },
  { code: "19750", name: "Phường Tây Lộc", district_code: "475" },
  { code: "19753", name: "Phường Thuận Lộc", district_code: "475" },
  { code: "19756", name: "Phường Gia Hội", district_code: "475" },
  { code: "19759", name: "Phường Phú Hậu", district_code: "475" },
  { code: "19762", name: "Phường Thuận Hòa", district_code: "475" },
  { code: "19768", name: "Phường Đông Ba", district_code: "475" },
  { code: "19774", name: "Phường Kim Long", district_code: "475" },
  { code: "19803", name: "Phường An Hòa", district_code: "475" },
  { code: "19804", name: "Phường Hương Sơ", district_code: "475" },
  { code: "19810", name: "Phường Hương Long", district_code: "475" },
  { code: "20014", name: "Phường Hương Vinh", district_code: "475" },
  { code: "20023", name: "Phường Hương An", district_code: "475" },
  { code: "20029", name: "Phường Long Hồ", district_code: "475" },
  { code: "19819", name: "Phường Phong Thu", district_code: "476" },
  { code: "19825", name: "Xã Phong Thạnh", district_code: "476" },
  { code: "19828", name: "Phường Phong Phú", district_code: "476" },
  { code: "19831", name: "Xã Phong Bình", district_code: "476" },
  { code: "19837", name: "Xã Phong Chương", district_code: "476" },
  { code: "19843", name: "Phường Phong Hải", district_code: "476" },
  { code: "19846", name: "Phường Phong Hòa", district_code: "476" },
  { code: "19852", name: "Phường Phong Hiền", district_code: "476" },
  { code: "19855", name: "Xã Phong Mỹ", district_code: "476" },
  { code: "19858", name: "Phường Phong An", district_code: "476" },
  { code: "19861", name: "Xã Phong Xuân", district_code: "476" },
  { code: "19864", name: "Xã Phong Sơn", district_code: "476" },
  { code: "19867", name: "Thị trấn Sịa", district_code: "477" },
  { code: "19870", name: "Xã Quảng Thái", district_code: "477" },
  { code: "19873", name: "Xã Quảng Ngạn", district_code: "477" },
  { code: "19876", name: "Xã Quảng Lợi", district_code: "477" },
  { code: "19879", name: "Xã Quảng Công", district_code: "477" },
  { code: "19882", name: "Xã Quảng Phước", district_code: "477" },
  { code: "19885", name: "Xã Quảng Vinh", district_code: "477" },
  { code: "19888", name: "Xã Quảng An", district_code: "477" },
  { code: "19891", name: "Xã Quảng Thành", district_code: "477" },
  { code: "19894", name: "Xã Quảng Thọ", district_code: "477" },
  { code: "19897", name: "Xã Quảng Phú", district_code: "477" },
  { code: "19903", name: "Xã Phú Thuận", district_code: "478" },
  { code: "19912", name: "Xã Phú An", district_code: "478" },
  { code: "19915", name: "Xã Phú Hải", district_code: "478" },
  { code: "19918", name: "Xã Phú Xuân", district_code: "478" },
  { code: "19921", name: "Xã Phú Diên", district_code: "478" },
  { code: "19927", name: "Xã Phú Mỹ", district_code: "478" },
  { code: "19933", name: "Xã Phú Hồ", district_code: "478" },
  { code: "19936", name: "Xã Vinh Xuân", district_code: "478" },
  { code: "19939", name: "Xã Phú Lương", district_code: "478" },
  { code: "19942", name: "Thị trấn Phú Đa", district_code: "478" },
  { code: "19945", name: "Xã Vinh Thanh", district_code: "478" },
  { code: "19948", name: "Xã Vinh An", district_code: "478" },
  { code: "19954", name: "Xã Phú Gia", district_code: "478" },
  { code: "19957", name: "Xã Vinh Hà", district_code: "478" },
  { code: "19960", name: "Phường Phú Bài", district_code: "479" },
  { code: "19966", name: "Xã Thủy Thanh", district_code: "479" },
  { code: "19969", name: "Phường Thủy Dương", district_code: "479" },
  { code: "19972", name: "Phường Thủy Phương", district_code: "479" },
  { code: "19975", name: "Phường Thủy Châu", district_code: "479" },
  { code: "19978", name: "Phường Thủy Lương", district_code: "479" },
  { code: "19984", name: "Xã Thủy Tân", district_code: "479" },
  { code: "19987", name: "Xã Thủy Phù", district_code: "479" },
  { code: "19990", name: "Xã Phú Sơn", district_code: "479" },
  { code: "19993", name: "Xã Dương Hòa", district_code: "479" },
  { code: "19996", name: "Phường Tứ Hạ", district_code: "480" },
  { code: "20005", name: "Xã Hương Toàn", district_code: "480" },
  { code: "20008", name: "Phường Hương Vân", district_code: "480" },
  { code: "20011", name: "Phường Hương Văn", district_code: "480" },
  { code: "20017", name: "Phường Hương Xuân", district_code: "480" },
  { code: "20020", name: "Phường Hương Chữ", district_code: "480" },
  { code: "20026", name: "Xã Hương Bình", district_code: "480" },
  { code: "20035", name: "Xã Bình Tiến", district_code: "480" },
  { code: "20041", name: "Xã Bình Thành", district_code: "480" },
  { code: "20044", name: "Thị trấn A Lưới", district_code: "481" },
  { code: "20047", name: "Xã Hồng Vân", district_code: "481" },
  { code: "20050", name: "Xã Hồng Hạ", district_code: "481" },
  { code: "20053", name: "Xã Hồng Kim", district_code: "481" },
  { code: "20056", name: "Xã Trung Sơn", district_code: "481" },
  { code: "20059", name: "Xã Hương Nguyên", district_code: "481" },
  { code: "20065", name: "Xã Hồng Bắc", district_code: "481" },
  { code: "20068", name: "Xã A Ngo", district_code: "481" },
  { code: "20071", name: "Xã Sơn Thủy", district_code: "481" },
  { code: "20074", name: "Xã Phú Vinh", district_code: "481" },
  { code: "20080", name: "Xã Hương Phong", district_code: "481" },
  { code: "20083", name: "Xã Quảng Nhâm", district_code: "481" },
  { code: "20086", name: "Xã Hồng Thượng", district_code: "481" },
  { code: "20089", name: "Xã Hồng Thái", district_code: "481" },
  { code: "20095", name: "Xã A Roàng", district_code: "481" },
  { code: "20098", name: "Xã Đông Sơn", district_code: "481" },
  { code: "20101", name: "Xã Lâm Đớt", district_code: "481" },
  { code: "20104", name: "Xã Hồng Thủy", district_code: "481" },
  { code: "20107", name: "Thị trấn Phú Lộc", district_code: "482" },
  { code: "20110", name: "Thị trấn Lăng Cô", district_code: "482" },
  { code: "20113", name: "Xã Vinh Mỹ", district_code: "482" },
  { code: "20116", name: "Xã Vinh Hưng", district_code: "482" },
  { code: "20122", name: "Xã Giang Hải", district_code: "482" },
  { code: "20125", name: "Xã Vinh Hiền", district_code: "482" },
  { code: "20128", name: "Xã Lộc Bổn", district_code: "482" },
  { code: "20131", name: "Thị trấn Lộc Sơn", district_code: "482" },
  { code: "20134", name: "Xã Lộc Bình", district_code: "482" },
  { code: "20137", name: "Xã Lộc Vĩnh", district_code: "482" },
  { code: "20140", name: "Xã Lộc An", district_code: "482" },
  { code: "20143", name: "Xã Lộc Điền", district_code: "482" },
  { code: "20146", name: "Xã Lộc Thủy", district_code: "482" },
  { code: "20149", name: "Xã Lộc Trì", district_code: "482" },
  { code: "20152", name: "Xã Lộc Tiến", district_code: "482" },
  { code: "20155", name: "Xã Lộc Hòa", district_code: "482" },
  { code: "20158", name: "Xã Xuân Lộc", district_code: "482" },
  { code: "20161", name: "Thị trấn Khe Tre", district_code: "482" },
  { code: "20164", name: "Xã Hương Phú", district_code: "482" },
  { code: "20167", name: "Xã Hương Sơn", district_code: "482" },
  { code: "20170", name: "Xã Hương Lộc", district_code: "482" },
  { code: "20173", name: "Xã Thượng Quảng", district_code: "482" },
  { code: "20176", name: "Xã Hương Hòa", district_code: "482" },
  { code: "20179", name: "Xã Hương Xuân", district_code: "482" },
  { code: "20182", name: "Xã Hương Hữu", district_code: "482" },
  { code: "20185", name: "Xã Thượng Lộ", district_code: "482" },
  { code: "20188", name: "Xã Thượng Long", district_code: "482" },
  { code: "20191", name: "Xã Thượng Nhật", district_code: "482" },
  { code: "20194", name: "Phường Hòa Hiệp Bắc", district_code: "490" },
  { code: "20195", name: "Phường Hòa Hiệp Nam", district_code: "490" },
  { code: "20197", name: "Phường Hòa Khánh Bắc", district_code: "490" },
  { code: "20198", name: "Phường Hòa Khánh Nam", district_code: "490" },
  { code: "20200", name: "Phường Hòa Minh", district_code: "490" },
  { code: "20206", name: "Phường Thanh Khê Tây", district_code: "491" },
  { code: "20207", name: "Phường Thanh Khê Đông", district_code: "491" },
  { code: "20209", name: "Phường Xuân Hà", district_code: "491" },
  { code: "20215", name: "Phường Chính Gián", district_code: "491" },
  { code: "20218", name: "Phường Thạc Gián", district_code: "491" },
  { code: "20224", name: "Phường An Khê", district_code: "491" },
  { code: "20227", name: "Phường Thanh Bình", district_code: "492" },
  { code: "20230", name: "Phường Thuận Phước", district_code: "492" },
  { code: "20233", name: "Phường Thạch Thang", district_code: "492" },
  { code: "20236", name: "Phường Hải Châu", district_code: "492" },
  { code: "20242", name: "Phường Phước Ninh", district_code: "492" },
  { code: "20245", name: "Phường Hòa Thuận Tây", district_code: "492" },
  { code: "20254", name: "Phường Bình Thuận", district_code: "492" },
  { code: "20257", name: "Phường Hòa Cường Bắc", district_code: "492" },
  { code: "20258", name: "Phường Hòa Cường Nam", district_code: "492" },
  { code: "20263", name: "Phường Thọ Quang", district_code: "493" },
  { code: "20266", name: "Phường Nại Hiên Đông", district_code: "493" },
  { code: "20269", name: "Phường Mân Thái", district_code: "493" },
  { code: "20272", name: "Phường An Hải Bắc", district_code: "493" },
  { code: "20275", name: "Phường Phước Mỹ", district_code: "493" },
  { code: "20278", name: "Phường An Hải Nam", district_code: "493" },
  { code: "20284", name: "Phường Mỹ An", district_code: "494" },
  { code: "20285", name: "Phường Khuê Mỹ", district_code: "494" },
  { code: "20287", name: "Phường Hoà Quý", district_code: "494" },
  { code: "20290", name: "Phường Hoà Hải", district_code: "494" },
  { code: "20260", name: "Phường Khuê Trung", district_code: "495" },
  { code: "20305", name: "Phường Hòa Phát", district_code: "495" },
  { code: "20306", name: "Phường Hòa An", district_code: "495" },
  { code: "20311", name: "Phường Hòa Thọ Tây", district_code: "495" },
  { code: "20312", name: "Phường Hòa Thọ Đông", district_code: "495" },
  { code: "20314", name: "Phường Hòa Xuân", district_code: "495" },
  { code: "20293", name: "Xã Hòa Bắc", district_code: "497" },
  { code: "20296", name: "Xã Hòa Liên", district_code: "497" },
  { code: "20299", name: "Xã Hòa Ninh", district_code: "497" },
  { code: "20302", name: "Xã Hòa Sơn", district_code: "497" },
  { code: "20308", name: "Xã Hòa Nhơn", district_code: "497" },
  { code: "20317", name: "Xã Hòa Phú", district_code: "497" },
  { code: "20320", name: "Xã Hòa Phong", district_code: "497" },
  { code: "20323", name: "Xã Hòa Châu", district_code: "497" },
  { code: "20326", name: "Xã Hòa Tiến", district_code: "497" },
  { code: "20329", name: "Xã Hòa Phước", district_code: "497" },
  { code: "20332", name: "Xã Hòa Khương", district_code: "497" },
  { code: "20335", name: "Phường Tân Thạnh", district_code: "502" },
  { code: "20341", name: "Phường An Mỹ", district_code: "502" },
  { code: "20344", name: "Phường Hòa Hương", district_code: "502" },
  { code: "20347", name: "Phường An Xuân", district_code: "502" },
  { code: "20350", name: "Phường An Sơn", district_code: "502" },
  { code: "20353", name: "Phường Trường Xuân", district_code: "502" },
  { code: "20356", name: "Phường An Phú", district_code: "502" },
  { code: "20359", name: "Xã Tam Thanh", district_code: "502" },
  { code: "20362", name: "Xã Tam Thăng", district_code: "502" },
  { code: "20371", name: "Xã Tam Phú", district_code: "502" },
  { code: "20375", name: "Phường Hoà Thuận", district_code: "502" },
  { code: "20389", name: "Xã Tam Ngọc", district_code: "502" },
  { code: "20398", name: "Phường Minh An", district_code: "503" },
  { code: "20401", name: "Phường Tân An", district_code: "503" },
  { code: "20404", name: "Phường Cẩm Phô", district_code: "503" },
  { code: "20407", name: "Phường Thanh Hà", district_code: "503" },
  { code: "20410", name: "Phường Sơn Phong", district_code: "503" },
  { code: "20413", name: "Phường Cẩm Châu", district_code: "503" },
  { code: "20416", name: "Phường Cửa Đại", district_code: "503" },
  { code: "20419", name: "Phường Cẩm An", district_code: "503" },
  { code: "20422", name: "Xã Cẩm Hà", district_code: "503" },
  { code: "20425", name: "Xã Cẩm Kim", district_code: "503" },
  { code: "20428", name: "Phường Cẩm Nam", district_code: "503" },
  { code: "20431", name: "Xã Cẩm Thanh", district_code: "503" },
  { code: "20434", name: "Xã Tân Hiệp", district_code: "503" },
  { code: "20437", name: "Xã Ch'ơm", district_code: "504" },
  { code: "20440", name: "Xã Ga Ri", district_code: "504" },
  { code: "20443", name: "Xã A Xan", district_code: "504" },
  { code: "20446", name: "Xã Tr'Hy", district_code: "504" },
  { code: "20449", name: "Xã Lăng", district_code: "504" },
  { code: "20452", name: "Xã A Nông", district_code: "504" },
  { code: "20455", name: "Xã A Tiêng", district_code: "504" },
  { code: "20458", name: "Xã Bha Lê", district_code: "504" },
  { code: "20461", name: "Xã A Vương", district_code: "504" },
  { code: "20464", name: "Xã Dang", district_code: "504" },
  { code: "20467", name: "Thị trấn P Rao", district_code: "505" },
  { code: "20470", name: "Xã Tà Lu", district_code: "505" },
  { code: "20473", name: "Xã Sông Kôn", district_code: "505" },
  { code: "20476", name: "Xã Jơ Ngây", district_code: "505" },
  { code: "20479", name: "Xã A Ting", district_code: "505" },
  { code: "20482", name: "Xã Tư", district_code: "505" },
  { code: "20485", name: "Xã Ba", district_code: "505" },
  { code: "20488", name: "Xã A Rooi", district_code: "505" },
  { code: "20491", name: "Xã Za Hung", district_code: "505" },
  { code: "20494", name: "Xã Mà Cooi", district_code: "505" },
  { code: "20497", name: "Xã Ka Dăng", district_code: "505" },
  { code: "20500", name: "Thị trấn Ái Nghĩa", district_code: "506" },
  { code: "20503", name: "Xã Đại Sơn", district_code: "506" },
  { code: "20506", name: "Xã Đại Lãnh", district_code: "506" },
  { code: "20509", name: "Xã Đại Hưng", district_code: "506" },
  { code: "20512", name: "Xã Đại Hồng", district_code: "506" },
  { code: "20515", name: "Xã Đại Đồng", district_code: "506" },
  { code: "20518", name: "Xã Đại Quang", district_code: "506" },
  { code: "20521", name: "Xã Đại Nghĩa", district_code: "506" },
  { code: "20524", name: "Xã Đại Hiệp", district_code: "506" },
  { code: "20527", name: "Xã Đại Thạnh", district_code: "506" },
  { code: "20530", name: "Xã Đại Chánh", district_code: "506" },
  { code: "20533", name: "Xã Đại Tân", district_code: "506" },
  { code: "20536", name: "Xã Đại Phong", district_code: "506" },
  { code: "20539", name: "Xã Đại Minh", district_code: "506" },
  { code: "20542", name: "Xã Đại Thắng", district_code: "506" },
  { code: "20545", name: "Xã Đại Cường", district_code: "506" },
  { code: "20547", name: "Xã Đại An", district_code: "506" },
  { code: "20548", name: "Xã Đại Hòa", district_code: "506" },
  { code: "20551", name: "Phường Vĩnh Điện", district_code: "507" },
  { code: "20554", name: "Xã Điện Tiến", district_code: "507" },
  { code: "20557", name: "Xã Điện Hòa", district_code: "507" },
  { code: "20560", name: "Phường Điện Thắng Bắc", district_code: "507" },
  { code: "20561", name: "Phường Điện Thắng Trung", district_code: "507" },
  { code: "20562", name: "Phường Điện Thắng Nam", district_code: "507" },
  { code: "20563", name: "Phường Điện Ngọc", district_code: "507" },
  { code: "20566", name: "Xã Điện Hồng", district_code: "507" },
  { code: "20569", name: "Xã Điện Thọ", district_code: "507" },
  { code: "20572", name: "Xã Điện Phước", district_code: "507" },
  { code: "20575", name: "Phường Điện An", district_code: "507" },
  { code: "20578", name: "Phường Điện Nam Bắc", district_code: "507" },
  { code: "20579", name: "Phường Điện Nam Trung", district_code: "507" },
  { code: "20580", name: "Phường Điện Nam Đông", district_code: "507" },
  { code: "20581", name: "Phường Điện Dương", district_code: "507" },
  { code: "20584", name: "Xã Điện Quang", district_code: "507" },
  { code: "20587", name: "Xã Điện Trung", district_code: "507" },
  { code: "20590", name: "Xã Điện Phong", district_code: "507" },
  { code: "20593", name: "Phường Điện Minh", district_code: "507" },
  { code: "20596", name: "Phường Điện Phương", district_code: "507" },
  { code: "20599", name: "Thị trấn Nam Phước", district_code: "508" },
  { code: "20605", name: "Xã Duy Phú", district_code: "508" },
  { code: "20608", name: "Xã Duy Tân", district_code: "508" },
  { code: "20611", name: "Xã Duy Hòa", district_code: "508" },
  { code: "20614", name: "Xã Duy Châu", district_code: "508" },
  { code: "20617", name: "Xã Duy Trinh", district_code: "508" },
  { code: "20620", name: "Xã Duy Sơn", district_code: "508" },
  { code: "20623", name: "Xã Duy Trung", district_code: "508" },
  { code: "20626", name: "Xã Duy Phước", district_code: "508" },
  { code: "20629", name: "Xã Duy Thành", district_code: "508" },
  { code: "20632", name: "Xã Duy Vinh", district_code: "508" },
  { code: "20635", name: "Xã Duy Nghĩa", district_code: "508" },
  { code: "20638", name: "Xã Duy Hải", district_code: "508" },
  { code: "20641", name: "Thị trấn Đông Phú", district_code: "509" },
  { code: "20644", name: "Xã Quế Xuân 1", district_code: "509" },
  { code: "20647", name: "Xã Quế Xuân 2", district_code: "509" },
  { code: "20650", name: "Xã Quế Phú", district_code: "509" },
  { code: "20651", name: "Thị trấn Hương An", district_code: "509" },
  { code: "20656", name: "Thị trấn Trung Phước", district_code: "509" },
  { code: "20659", name: "Xã Quế Hiệp", district_code: "509" },
  { code: "20662", name: "Xã Quế Thuận", district_code: "509" },
  { code: "20665", name: "Xã Quế Mỹ", district_code: "509" },
  { code: "20668", name: "Xã Ninh Phước", district_code: "509" },
  { code: "20669", name: "Xã Phước Ninh", district_code: "509" },
  { code: "20671", name: "Xã Quế Lộc", district_code: "509" },
  { code: "20674", name: "Xã Quế Phước", district_code: "509" },
  { code: "20677", name: "Xã Quế Long", district_code: "509" },
  { code: "20680", name: "Xã Quế Châu", district_code: "509" },
  { code: "20683", name: "Xã Quế Phong", district_code: "509" },
  { code: "20686", name: "Xã Quế An", district_code: "509" },
  { code: "20689", name: "Xã Quế Minh", district_code: "509" },
  { code: "20692", name: "Xã Quế Lâm", district_code: "509" },
  { code: "20695", name: "Thị trấn Thạnh Mỹ", district_code: "510" },
  { code: "20698", name: "Xã Laêê", district_code: "510" },
  { code: "20699", name: "Xã Chơ Chun", district_code: "510" },
  { code: "20701", name: "Xã Zuôich", district_code: "510" },
  { code: "20702", name: "Xã Tà Pơơ", district_code: "510" },
  { code: "20704", name: "Xã La Dêê", district_code: "510" },
  { code: "20705", name: "Xã Đắc Tôi", district_code: "510" },
  { code: "20707", name: "Xã Chà Vàl", district_code: "510" },
  { code: "20710", name: "Xã Tà Bhinh", district_code: "510" },
  { code: "20713", name: "Xã Cà Dy", district_code: "510" },
  { code: "20716", name: "Xã Đắc Pre", district_code: "510" },
  { code: "20719", name: "Xã Đắc Pring", district_code: "510" },
  { code: "20722", name: "Thị trấn Khâm Đức", district_code: "511" },
  { code: "20725", name: "Xã Phước Xuân", district_code: "511" },
  { code: "20728", name: "Xã Phước Hiệp", district_code: "511" },
  { code: "20729", name: "Xã Phước Hoà", district_code: "511" },
  { code: "20731", name: "Xã Phước Đức", district_code: "511" },
  { code: "20734", name: "Xã Phước Năng", district_code: "511" },
  { code: "20737", name: "Xã Phước Mỹ", district_code: "511" },
  { code: "20740", name: "Xã Phước Chánh", district_code: "511" },
  { code: "20743", name: "Xã Phước Công", district_code: "511" },
  { code: "20746", name: "Xã Phước Kim", district_code: "511" },
  { code: "20749", name: "Xã Phước Lộc", district_code: "511" },
  { code: "20752", name: "Xã Phước Thành", district_code: "511" },
  { code: "20758", name: "Xã Quế Tân", district_code: "512" },
  { code: "20764", name: "Xã Quế Thọ", district_code: "512" },
  { code: "20767", name: "Xã Bình Lâm", district_code: "512" },
  { code: "20770", name: "Xã Sông Trà", district_code: "512" },
  { code: "20773", name: "Xã Phước Trà", district_code: "512" },
  { code: "20776", name: "Xã Phước Gia", district_code: "512" },
  { code: "20779", name: "Thị trấn Tân Bình", district_code: "512" },
  { code: "20782", name: "Xã Quế Lưu", district_code: "512" },
  { code: "20785", name: "Xã Thăng Phước", district_code: "512" },
  { code: "20788", name: "Xã Bình Sơn", district_code: "512" },
  { code: "20791", name: "Thị trấn Hà Lam", district_code: "513" },
  { code: "20794", name: "Xã Bình Dương", district_code: "513" },
  { code: "20797", name: "Xã Bình Giang", district_code: "513" },
  { code: "20800", name: "Xã Bình Nguyên", district_code: "513" },
  { code: "20803", name: "Xã Bình Phục", district_code: "513" },
  { code: "20806", name: "Xã Bình Triều", district_code: "513" },
  { code: "20809", name: "Xã Bình Đào", district_code: "513" },
  { code: "20812", name: "Xã Bình Minh", district_code: "513" },
  { code: "20815", name: "Xã Bình Lãnh", district_code: "513" },
  { code: "20818", name: "Xã Bình Trị", district_code: "513" },
  { code: "20821", name: "Xã Bình Định", district_code: "513" },
  { code: "20824", name: "Xã Bình Quý", district_code: "513" },
  { code: "20827", name: "Xã Bình Phú", district_code: "513" },
  { code: "20833", name: "Xã Bình Tú", district_code: "513" },
  { code: "20836", name: "Xã Bình Sa", district_code: "513" },
  { code: "20839", name: "Xã Bình Hải", district_code: "513" },
  { code: "20842", name: "Xã Bình Quế", district_code: "513" },
  { code: "20845", name: "Xã Bình An", district_code: "513" },
  { code: "20848", name: "Xã Bình Trung", district_code: "513" },
  { code: "20851", name: "Xã Bình Nam", district_code: "513" },
  { code: "20854", name: "Thị trấn Tiên Kỳ", district_code: "514" },
  { code: "20857", name: "Xã Tiên Sơn", district_code: "514" },
  { code: "20860", name: "Xã Tiên Hà", district_code: "514" },
  { code: "20866", name: "Xã Tiên Châu", district_code: "514" },
  { code: "20869", name: "Xã Tiên Lãnh", district_code: "514" },
  { code: "20872", name: "Xã Tiên Ngọc", district_code: "514" },
  { code: "20875", name: "Xã Tiên Hiệp", district_code: "514" },
  { code: "20878", name: "Xã Tiên Cảnh", district_code: "514" },
  { code: "20881", name: "Xã Tiên Mỹ", district_code: "514" },
  { code: "20884", name: "Xã Tiên Phong", district_code: "514" },
  { code: "20887", name: "Xã Tiên Thọ", district_code: "514" },
  { code: "20890", name: "Xã Tiên An", district_code: "514" },
  { code: "20893", name: "Xã Tiên Lộc", district_code: "514" },
  { code: "20896", name: "Xã Tiên Lập", district_code: "514" },
  { code: "20899", name: "Thị trấn Trà My", district_code: "515" },
  { code: "20900", name: "Xã Trà Sơn", district_code: "515" },
  { code: "20902", name: "Xã Trà Kót", district_code: "515" },
  { code: "20905", name: "Xã Trà Nú", district_code: "515" },
  { code: "20908", name: "Xã Trà Đông", district_code: "515" },
  { code: "20911", name: "Xã Trà Dương", district_code: "515" },
  { code: "20914", name: "Xã Trà Giang", district_code: "515" },
  { code: "20917", name: "Xã Trà Bui", district_code: "515" },
  { code: "20920", name: "Xã Trà Đốc", district_code: "515" },
  { code: "20923", name: "Xã Trà Tân", district_code: "515" },
  { code: "20926", name: "Xã Trà Giác", district_code: "515" },
  { code: "20929", name: "Xã Trà Giáp", district_code: "515" },
  { code: "20932", name: "Xã Trà Ka", district_code: "515" },
  { code: "20935", name: "Xã Trà Leng", district_code: "516" },
  { code: "20938", name: "Xã Trà Dơn", district_code: "516" },
  { code: "20941", name: "Xã Trà Tập", district_code: "516" },
  { code: "20944", name: "Xã Trà Mai", district_code: "516" },
  { code: "20947", name: "Xã Trà Cang", district_code: "516" },
  { code: "20950", name: "Xã Trà Linh", district_code: "516" },
  { code: "20953", name: "Xã Trà Nam", district_code: "516" },
  { code: "20956", name: "Xã Trà Don", district_code: "516" },
  { code: "20959", name: "Xã Trà Vân", district_code: "516" },
  { code: "20962", name: "Xã Trà Vinh", district_code: "516" },
  { code: "20965", name: "Thị trấn Núi Thành", district_code: "517" },
  { code: "20968", name: "Xã Tam Xuân I", district_code: "517" },
  { code: "20971", name: "Xã Tam Xuân II", district_code: "517" },
  { code: "20974", name: "Xã Tam Tiến", district_code: "517" },
  { code: "20977", name: "Xã Tam Sơn", district_code: "517" },
  { code: "20980", name: "Xã Tam Thạnh", district_code: "517" },
  { code: "20983", name: "Xã Tam Anh Bắc", district_code: "517" },
  { code: "20984", name: "Xã Tam Anh Nam", district_code: "517" },
  { code: "20986", name: "Xã Tam Hòa", district_code: "517" },
  { code: "20989", name: "Xã Tam Hiệp", district_code: "517" },
  { code: "20992", name: "Xã Tam Hải", district_code: "517" },
  { code: "20995", name: "Xã Tam Giang", district_code: "517" },
  { code: "20998", name: "Xã Tam Quang", district_code: "517" },
  { code: "21001", name: "Xã Tam Nghĩa", district_code: "517" },
  { code: "21004", name: "Xã Tam Mỹ Tây", district_code: "517" },
  { code: "21005", name: "Xã Tam Mỹ Đông", district_code: "517" },
  { code: "21007", name: "Xã Tam Trà", district_code: "517" },
  { code: "20364", name: "Thị trấn Phú Thịnh", district_code: "518" },
  { code: "20365", name: "Xã Tam Thành", district_code: "518" },
  { code: "20368", name: "Xã Tam An", district_code: "518" },
  { code: "20374", name: "Xã Tam Đàn", district_code: "518" },
  { code: "20377", name: "Xã Tam Lộc", district_code: "518" },
  { code: "20380", name: "Xã Tam Phước", district_code: "518" },
  { code: "20386", name: "Xã Tam Thái", district_code: "518" },
  { code: "20387", name: "Xã Tam Đại", district_code: "518" },
  { code: "20392", name: "Xã Tam Dân", district_code: "518" },
  { code: "20395", name: "Xã Tam Lãnh", district_code: "518" },
  { code: "21010", name: "Phường Lê Hồng Phong", district_code: "522" },
  { code: "21013", name: "Phường Trần Phú", district_code: "522" },
  { code: "21016", name: "Phường Quảng Phú", district_code: "522" },
  { code: "21019", name: "Phường Nghĩa Chánh", district_code: "522" },
  { code: "21022", name: "Phường Trần Hưng Đạo", district_code: "522" },
  { code: "21025", name: "Phường Nguyễn Nghiêm", district_code: "522" },
  { code: "21028", name: "Phường Nghĩa Lộ", district_code: "522" },
  { code: "21031", name: "Phường Chánh Lộ", district_code: "522" },
  { code: "21034", name: "Xã Nghĩa Dũng", district_code: "522" },
  { code: "21037", name: "Xã Nghĩa Dõng", district_code: "522" },
  { code: "21172", name: "Phường Trương Quang Trọng", district_code: "522" },
  { code: "21187", name: "Xã Tịnh Hòa", district_code: "522" },
  { code: "21190", name: "Xã Tịnh Kỳ", district_code: "522" },
  { code: "21199", name: "Xã Tịnh Thiện", district_code: "522" },
  { code: "21202", name: "Xã Tịnh Ấn Đông", district_code: "522" },
  { code: "21208", name: "Xã Tịnh Châu", district_code: "522" },
  { code: "21211", name: "Xã Tịnh Khê", district_code: "522" },
  { code: "21214", name: "Xã Tịnh Long", district_code: "522" },
  { code: "21223", name: "Xã Tịnh Ấn Tây", district_code: "522" },
  { code: "21232", name: "Xã Tịnh An", district_code: "522" },
  { code: "21256", name: "Xã Nghĩa Hà", district_code: "522" },
  { code: "21262", name: "Xã An Phú", district_code: "522" },
  { code: "21040", name: "Thị trấn Châu Ổ", district_code: "524" },
  { code: "21043", name: "Xã Bình Thuận", district_code: "524" },
  { code: "21046", name: "Xã Bình Thạnh", district_code: "524" },
  { code: "21049", name: "Xã Bình Đông", district_code: "524" },
  { code: "21052", name: "Xã Bình Chánh", district_code: "524" },
  { code: "21055", name: "Xã Bình Nguyên", district_code: "524" },
  { code: "21058", name: "Xã Bình Khương", district_code: "524" },
  { code: "21061", name: "Xã Bình Trị", district_code: "524" },
  { code: "21064", name: "Xã Bình An", district_code: "524" },
  { code: "21067", name: "Xã Bình Hải", district_code: "524" },
  { code: "21070", name: "Xã Bình Dương", district_code: "524" },
  { code: "21073", name: "Xã Bình Phước", district_code: "524" },
  { code: "21079", name: "Xã Bình Hòa", district_code: "524" },
  { code: "21082", name: "Xã Bình Trung", district_code: "524" },
  { code: "21085", name: "Xã Bình Minh", district_code: "524" },
  { code: "21088", name: "Xã Bình Long", district_code: "524" },
  { code: "21091", name: "Xã Bình Thanh", district_code: "524" },
  { code: "21100", name: "Xã Bình Chương", district_code: "524" },
  { code: "21103", name: "Xã Bình Hiệp", district_code: "524" },
  { code: "21106", name: "Xã Bình Mỹ", district_code: "524" },
  { code: "21109", name: "Xã Bình Tân Phú", district_code: "524" },
  { code: "21112", name: "Xã Bình Châu", district_code: "524" },
  { code: "21115", name: "Thị trấn Trà Xuân", district_code: "525" },
  { code: "21118", name: "Xã Trà Giang", district_code: "525" },
  { code: "21121", name: "Xã Trà Thủy", district_code: "525" },
  { code: "21124", name: "Xã Trà Hiệp", district_code: "525" },
  { code: "21127", name: "Xã Trà Bình", district_code: "525" },
  { code: "21130", name: "Xã Trà Phú", district_code: "525" },
  { code: "21133", name: "Xã Trà Lâm", district_code: "525" },
  { code: "21136", name: "Xã Trà Tân", district_code: "525" },
  { code: "21139", name: "Xã Trà Sơn", district_code: "525" },
  { code: "21142", name: "Xã Trà Bùi", district_code: "525" },
  { code: "21145", name: "Xã Trà Thanh", district_code: "525" },
  { code: "21148", name: "Xã Sơn Trà", district_code: "525" },
  { code: "21154", name: "Xã Trà Phong", district_code: "525" },
  { code: "21157", name: "Xã Hương Trà", district_code: "525" },
  { code: "21163", name: "Xã Trà Xinh", district_code: "525" },
  { code: "21166", name: "Xã Trà Tây", district_code: "525" },
  { code: "21175", name: "Xã Tịnh Thọ", district_code: "527" },
  { code: "21178", name: "Xã Tịnh Trà", district_code: "527" },
  { code: "21181", name: "Xã Tịnh Phong", district_code: "527" },
  { code: "21184", name: "Xã Tịnh Hiệp", district_code: "527" },
  { code: "21193", name: "Xã Tịnh Bình", district_code: "527" },
  { code: "21196", name: "Xã Tịnh Đông", district_code: "527" },
  { code: "21205", name: "Xã Tịnh Bắc", district_code: "527" },
  { code: "21217", name: "Xã Tịnh Sơn", district_code: "527" },
  { code: "21220", name: "Thị trấn Tịnh Hà", district_code: "527" },
  { code: "21226", name: "Xã Tịnh Giang", district_code: "527" },
  { code: "21229", name: "Xã Tịnh Minh", district_code: "527" },
  { code: "21235", name: "Thị trấn La Hà", district_code: "528" },
  { code: "21238", name: "Thị trấn Sông Vệ", district_code: "528" },
  { code: "21241", name: "Xã Nghĩa Lâm", district_code: "528" },
  { code: "21244", name: "Xã Nghĩa Thắng", district_code: "528" },
  { code: "21247", name: "Xã Nghĩa Thuận", district_code: "528" },
  { code: "21250", name: "Xã Nghĩa Kỳ", district_code: "528" },
  { code: "21259", name: "Xã Nghĩa Sơn", district_code: "528" },
  { code: "21268", name: "Xã Nghĩa Hòa", district_code: "528" },
  { code: "21271", name: "Xã Nghĩa Điền", district_code: "528" },
  { code: "21274", name: "Xã Nghĩa Thương", district_code: "528" },
  { code: "21277", name: "Xã Nghĩa Trung", district_code: "528" },
  { code: "21280", name: "Xã Nghĩa Hiệp", district_code: "528" },
  { code: "21283", name: "Xã Nghĩa Phương", district_code: "528" },
  { code: "21289", name: "Thị trấn Di Lăng", district_code: "529" },
  { code: "21292", name: "Xã Sơn Hạ", district_code: "529" },
  { code: "21295", name: "Xã Sơn Thành", district_code: "529" },
  { code: "21298", name: "Xã Sơn Nham", district_code: "529" },
  { code: "21301", name: "Xã Sơn Bao", district_code: "529" },
  { code: "21304", name: "Xã Sơn Linh", district_code: "529" },
  { code: "21307", name: "Xã Sơn Giang", district_code: "529" },
  { code: "21310", name: "Xã Sơn Trung", district_code: "529" },
  { code: "21313", name: "Xã Sơn Thượng", district_code: "529" },
  { code: "21316", name: "Xã Sơn Cao", district_code: "529" },
  { code: "21319", name: "Xã Sơn Hải", district_code: "529" },
  { code: "21322", name: "Xã Sơn Thủy", district_code: "529" },
  { code: "21325", name: "Xã Sơn Kỳ", district_code: "529" },
  { code: "21328", name: "Xã Sơn Ba", district_code: "529" },
  { code: "21331", name: "Xã Sơn Bua", district_code: "530" },
  { code: "21334", name: "Xã Sơn Mùa", district_code: "530" },
  { code: "21335", name: "Xã Sơn Liên", district_code: "530" },
  { code: "21337", name: "Xã Sơn Tân", district_code: "530" },
  { code: "21338", name: "Xã Sơn Màu", district_code: "530" },
  { code: "21340", name: "Xã Sơn Dung", district_code: "530" },
  { code: "21341", name: "Xã Sơn Long", district_code: "530" },
  { code: "21343", name: "Xã Sơn Tinh", district_code: "530" },
  { code: "21346", name: "Xã Sơn Lập", district_code: "530" },
  { code: "21349", name: "Xã Long Sơn", district_code: "531" },
  { code: "21352", name: "Xã Long Mai", district_code: "531" },
  { code: "21355", name: "Xã Thanh An", district_code: "531" },
  { code: "21358", name: "Xã Long Môn", district_code: "531" },
  { code: "21361", name: "Xã Long Hiệp", district_code: "531" },
  { code: "21364", name: "Thị trấn Chợ Chùa", district_code: "532" },
  { code: "21367", name: "Xã Hành Thuận", district_code: "532" },
  { code: "21370", name: "Xã Hành Dũng", district_code: "532" },
  { code: "21373", name: "Xã Hành Trung", district_code: "532" },
  { code: "21376", name: "Xã Hành Nhân", district_code: "532" },
  { code: "21379", name: "Xã Hành Đức", district_code: "532" },
  { code: "21382", name: "Xã Hành Minh", district_code: "532" },
  { code: "21385", name: "Xã Hành Phước", district_code: "532" },
  { code: "21388", name: "Xã Hành Thiện", district_code: "532" },
  { code: "21391", name: "Xã Hành Thịnh", district_code: "532" },
  { code: "21394", name: "Xã Hành Tín Tây", district_code: "532" },
  { code: "21397", name: "Xã Hành Tín Đông", district_code: "532" },
  { code: "21400", name: "Thị trấn Mộ Đức", district_code: "533" },
  { code: "21406", name: "Xã Thắng Lợi", district_code: "533" },
  { code: "21409", name: "Xã Đức Nhuận", district_code: "533" },
  { code: "21412", name: "Xã Đức Chánh", district_code: "533" },
  { code: "21415", name: "Xã Đức Hiệp", district_code: "533" },
  { code: "21418", name: "Xã Đức Minh", district_code: "533" },
  { code: "21421", name: "Xã Đức Thạnh", district_code: "533" },
  { code: "21424", name: "Xã Đức Hòa", district_code: "533" },
  { code: "21427", name: "Xã Đức Tân", district_code: "533" },
  { code: "21430", name: "Xã Đức Phú", district_code: "533" },
  { code: "21433", name: "Xã Đức Phong", district_code: "533" },
  { code: "21436", name: "Xã Đức Lân", district_code: "533" },
  { code: "21439", name: "Phường Nguyễn Nghiêm", district_code: "534" },
  { code: "21442", name: "Xã Phổ An", district_code: "534" },
  { code: "21445", name: "Xã Phổ Phong", district_code: "534" },
  { code: "21448", name: "Xã Phổ Thuận", district_code: "534" },
  { code: "21451", name: "Phường Phổ Văn", district_code: "534" },
  { code: "21454", name: "Phường Phổ Quang", district_code: "534" },
  { code: "21457", name: "Xã Phổ Nhơn", district_code: "534" },
  { code: "21460", name: "Phường Phổ Ninh", district_code: "534" },
  { code: "21463", name: "Phường Phổ Minh", district_code: "534" },
  { code: "21466", name: "Phường Phổ Vinh", district_code: "534" },
  { code: "21469", name: "Phường Phổ Hòa", district_code: "534" },
  { code: "21472", name: "Xã Phổ Cường", district_code: "534" },
  { code: "21475", name: "Xã Phổ Khánh", district_code: "534" },
  { code: "21478", name: "Phường Phổ Thạnh", district_code: "534" },
  { code: "21481", name: "Xã Phổ Châu", district_code: "534" },
  { code: "21484", name: "Thị trấn Ba Tơ", district_code: "535" },
  { code: "21487", name: "Xã Ba Điền", district_code: "535" },
  { code: "21490", name: "Xã Ba Vinh", district_code: "535" },
  { code: "21493", name: "Xã Ba Thành", district_code: "535" },
  { code: "21496", name: "Xã Ba Động", district_code: "535" },
  { code: "21499", name: "Xã Ba Dinh", district_code: "535" },
  { code: "21500", name: "Xã Ba Giang", district_code: "535" },
  { code: "21502", name: "Xã Ba Liên", district_code: "535" },
  { code: "21505", name: "Xã Ba Ngạc", district_code: "535" },
  { code: "21508", name: "Xã Ba Khâm", district_code: "535" },
  { code: "21511", name: "Xã Ba Cung", district_code: "535" },
  { code: "21517", name: "Xã Ba Tiêu", district_code: "535" },
  { code: "21520", name: "Xã Ba Trang", district_code: "535" },
  { code: "21523", name: "Xã Ba Tô", district_code: "535" },
  { code: "21526", name: "Xã Ba Bích", district_code: "535" },
  { code: "21529", name: "Xã Ba Vì", district_code: "535" },
  { code: "21532", name: "Xã Ba Lế", district_code: "535" },
  { code: "21535", name: "Xã Ba Nam", district_code: "535" },
  { code: "21538", name: "Xã Ba Xa", district_code: "535" },
  { code: "21550", name: "Phường Nhơn Bình", district_code: "540" },
  { code: "21553", name: "Phường Nhơn Phú", district_code: "540" },
  { code: "21556", name: "Phường Đống Đa", district_code: "540" },
  { code: "21559", name: "Phường Trần Quang Diệu", district_code: "540" },
  { code: "21562", name: "Phường Hải Cảng", district_code: "540" },
  { code: "21565", name: "Phường Quang Trung", district_code: "540" },
  { code: "21577", name: "Phường Ngô Mây", district_code: "540" },
  { code: "21580", name: "Phường Trần Phú", district_code: "540" },
  { code: "21583", name: "Phường Thị Nại", district_code: "540" },
  { code: "21589", name: "Phường Bùi Thị Xuân", district_code: "540" },
  { code: "21592", name: "Phường Nguyễn Văn Cừ", district_code: "540" },
  { code: "21595", name: "Phường Ghềnh Ráng", district_code: "540" },
  { code: "21598", name: "Xã Nhơn Lý", district_code: "540" },
  { code: "21601", name: "Xã Nhơn Hội", district_code: "540" },
  { code: "21604", name: "Xã Nhơn Hải", district_code: "540" },
  { code: "21607", name: "Xã Nhơn Châu", district_code: "540" },
  { code: "21991", name: "Xã Phước Mỹ", district_code: "540" },
  { code: "21609", name: "Thị trấn An Lão", district_code: "542" },
  { code: "21610", name: "Xã An Hưng", district_code: "542" },
  { code: "21613", name: "Xã An Trung", district_code: "542" },
  { code: "21616", name: "Xã An Dũng", district_code: "542" },
  { code: "21619", name: "Xã An Vinh", district_code: "542" },
  { code: "21622", name: "Xã An Toàn", district_code: "542" },
  { code: "21625", name: "Xã An Tân", district_code: "542" },
  { code: "21628", name: "Xã An Hòa", district_code: "542" },
  { code: "21631", name: "Xã An Quang", district_code: "542" },
  { code: "21634", name: "Xã An Nghĩa", district_code: "542" },
  { code: "21637", name: "Phường Tam Quan", district_code: "543" },
  { code: "21640", name: "Phường Bồng Sơn", district_code: "543" },
  { code: "21643", name: "Xã Hoài Sơn", district_code: "543" },
  { code: "21646", name: "Xã Hoài Châu Bắc", district_code: "543" },
  { code: "21649", name: "Xã Hoài Châu", district_code: "543" },
  { code: "21652", name: "Xã Hoài Phú", district_code: "543" },
  { code: "21655", name: "Phường Tam Quan Bắc", district_code: "543" },
  { code: "21658", name: "Phường Tam Quan Nam", district_code: "543" },
  { code: "21661", name: "Phường Hoài Hảo", district_code: "543" },
  { code: "21664", name: "Phường Hoài Thanh Tây", district_code: "543" },
  { code: "21667", name: "Phường Hoài Thanh", district_code: "543" },
  { code: "21670", name: "Phường Hoài Hương", district_code: "543" },
  { code: "21673", name: "Phường Hoài Tân", district_code: "543" },
  { code: "21676", name: "Xã Hoài Hải", district_code: "543" },
  { code: "21679", name: "Phường Hoài Xuân", district_code: "543" },
  { code: "21682", name: "Xã Hoài Mỹ", district_code: "543" },
  { code: "21685", name: "Phường Hoài Đức", district_code: "543" },
  { code: "21688", name: "Thị trấn Tăng Bạt Hổ", district_code: "544" },
  { code: "21690", name: "Xã Ân Hảo Tây", district_code: "544" },
  { code: "21691", name: "Xã Ân Hảo Đông", district_code: "544" },
  { code: "21694", name: "Xã Ân Sơn", district_code: "544" },
  { code: "21697", name: "Xã Ân Mỹ", district_code: "544" },
  { code: "21700", name: "Xã Đak Mang", district_code: "544" },
  { code: "21703", name: "Xã Ân Tín", district_code: "544" },
  { code: "21706", name: "Xã Ân Thạnh", district_code: "544" },
  { code: "21709", name: "Xã Ân Phong", district_code: "544" },
  { code: "21712", name: "Xã Ân Đức", district_code: "544" },
  { code: "21715", name: "Xã Ân Hữu", district_code: "544" },
  { code: "21718", name: "Xã Bok Tới", district_code: "544" },
  { code: "21721", name: "Xã Ân Tường Tây", district_code: "544" },
  { code: "21724", name: "Xã Ân Tường Đông", district_code: "544" },
  { code: "21727", name: "Xã Ân Nghĩa", district_code: "544" },
  { code: "21730", name: "Thị trấn Phù Mỹ", district_code: "545" },
  { code: "21733", name: "Thị trấn Bình Dương", district_code: "545" },
  { code: "21736", name: "Xã Mỹ Đức", district_code: "545" },
  { code: "21739", name: "Xã Mỹ Châu", district_code: "545" },
  { code: "21742", name: "Xã Mỹ Thắng", district_code: "545" },
  { code: "21745", name: "Xã Mỹ Lộc", district_code: "545" },
  { code: "21748", name: "Xã Mỹ Lợi", district_code: "545" },
  { code: "21751", name: "Xã Mỹ An", district_code: "545" },
  { code: "21754", name: "Xã Mỹ Phong", district_code: "545" },
  { code: "21757", name: "Xã Mỹ Trinh", district_code: "545" },
  { code: "21760", name: "Xã Mỹ Thọ", district_code: "545" },
  { code: "21763", name: "Xã Mỹ Hòa", district_code: "545" },
  { code: "21766", name: "Xã Mỹ Thành", district_code: "545" },
  { code: "21769", name: "Xã Mỹ Chánh", district_code: "545" },
  { code: "21772", name: "Xã Mỹ Quang", district_code: "545" },
  { code: "21775", name: "Xã Mỹ Hiệp", district_code: "545" },
  { code: "21778", name: "Xã Mỹ Tài", district_code: "545" },
  { code: "21781", name: "Xã Mỹ Cát", district_code: "545" },
  { code: "21784", name: "Xã Mỹ Chánh Tây", district_code: "545" },
  { code: "21786", name: "Thị trấn Vĩnh Thạnh", district_code: "546" },
  { code: "21787", name: "Xã Vĩnh Sơn", district_code: "546" },
  { code: "21790", name: "Xã Vĩnh Kim", district_code: "546" },
  { code: "21796", name: "Xã Vĩnh Hiệp", district_code: "546" },
  { code: "21799", name: "Xã Vĩnh Hảo", district_code: "546" },
  { code: "21801", name: "Xã Vĩnh Hòa", district_code: "546" },
  { code: "21802", name: "Xã Vĩnh Thịnh", district_code: "546" },
  { code: "21804", name: "Xã Vĩnh Thuận", district_code: "546" },
  { code: "21805", name: "Xã Vĩnh Quang", district_code: "546" },
  { code: "21808", name: "Thị trấn Phú Phong", district_code: "547" },
  { code: "21811", name: "Xã Bình Tân", district_code: "547" },
  { code: "21814", name: "Xã Tây Thuận", district_code: "547" },
  { code: "21817", name: "Xã Bình Thuận", district_code: "547" },
  { code: "21820", name: "Xã Tây Giang", district_code: "547" },
  { code: "21823", name: "Xã Bình Thành", district_code: "547" },
  { code: "21826", name: "Xã Tây An", district_code: "547" },
  { code: "21829", name: "Xã Bình Hòa", district_code: "547" },
  { code: "21832", name: "Xã Tây Bình", district_code: "547" },
  { code: "21835", name: "Xã Bình Tường", district_code: "547" },
  { code: "21838", name: "Xã Tây Vinh", district_code: "547" },
  { code: "21841", name: "Xã Vĩnh An", district_code: "547" },
  { code: "21844", name: "Xã Tây Xuân", district_code: "547" },
  { code: "21847", name: "Xã Bình Nghi", district_code: "547" },
  { code: "21850", name: "Xã Tây Phú", district_code: "547" },
  { code: "21853", name: "Thị trấn Ngô Mây", district_code: "548" },
  { code: "21856", name: "Xã Cát Sơn", district_code: "548" },
  { code: "21859", name: "Xã Cát Minh", district_code: "548" },
  { code: "21862", name: "Thị trấn Cát Khánh", district_code: "548" },
  { code: "21865", name: "Xã Cát Tài", district_code: "548" },
  { code: "21868", name: "Xã Cát Lâm", district_code: "548" },
  { code: "21871", name: "Xã Cát Hanh", district_code: "548" },
  { code: "21874", name: "Xã Cát Thành", district_code: "548" },
  { code: "21877", name: "Xã Cát Trinh", district_code: "548" },
  { code: "21880", name: "Xã Cát Hải", district_code: "548" },
  { code: "21883", name: "Xã Cát Hiệp", district_code: "548" },
  { code: "21886", name: "Xã Cát Nhơn", district_code: "548" },
  { code: "21889", name: "Xã Cát Hưng", district_code: "548" },
  { code: "21892", name: "Xã Cát Tường", district_code: "548" },
  { code: "21895", name: "Xã Cát Tân", district_code: "548" },
  { code: "21898", name: "Thị trấn Cát Tiến", district_code: "548" },
  { code: "21901", name: "Xã Cát Thắng", district_code: "548" },
  { code: "21904", name: "Xã Cát Chánh", district_code: "548" },
  { code: "21907", name: "Phường Bình Định", district_code: "549" },
  { code: "21910", name: "Phường Đập Đá", district_code: "549" },
  { code: "21913", name: "Xã Nhơn Mỹ", district_code: "549" },
  { code: "21916", name: "Phường Nhơn Thành", district_code: "549" },
  { code: "21919", name: "Xã Nhơn Hạnh", district_code: "549" },
  { code: "21922", name: "Xã Nhơn Hậu", district_code: "549" },
  { code: "21925", name: "Xã Nhơn Phong", district_code: "549" },
  { code: "21928", name: "Xã Nhơn An", district_code: "549" },
  { code: "21931", name: "Xã Nhơn Phúc", district_code: "549" },
  { code: "21934", name: "Phường Nhơn Hưng", district_code: "549" },
  { code: "21937", name: "Xã Nhơn Khánh", district_code: "549" },
  { code: "21940", name: "Xã Nhơn Lộc", district_code: "549" },
  { code: "21943", name: "Phường Nhơn Hoà", district_code: "549" },
  { code: "21946", name: "Xã Nhơn Tân", district_code: "549" },
  { code: "21949", name: "Xã Nhơn Thọ", district_code: "549" },
  { code: "21952", name: "Thị trấn Tuy Phước", district_code: "550" },
  { code: "21955", name: "Thị trấn Diêu Trì", district_code: "550" },
  { code: "21958", name: "Xã Phước Thắng", district_code: "550" },
  { code: "21961", name: "Xã Phước Hưng", district_code: "550" },
  { code: "21964", name: "Xã Phước Quang", district_code: "550" },
  { code: "21967", name: "Xã Phước Hòa", district_code: "550" },
  { code: "21970", name: "Xã Phước Sơn", district_code: "550" },
  { code: "21973", name: "Xã Phước Hiệp", district_code: "550" },
  { code: "21976", name: "Xã Phước Lộc", district_code: "550" },
  { code: "21979", name: "Xã Phước Nghĩa", district_code: "550" },
  { code: "21982", name: "Xã Phước Thuận", district_code: "550" },
  { code: "21985", name: "Xã Phước An", district_code: "550" },
  { code: "21988", name: "Xã Phước Thành", district_code: "550" },
  { code: "21994", name: "Thị trấn Vân Canh", district_code: "551" },
  { code: "21997", name: "Xã Canh Liên", district_code: "551" },
  { code: "22000", name: "Xã Canh Hiệp", district_code: "551" },
  { code: "22003", name: "Xã Canh Vinh", district_code: "551" },
  { code: "22006", name: "Xã Canh Hiển", district_code: "551" },
  { code: "22009", name: "Xã Canh Thuận", district_code: "551" },
  { code: "22012", name: "Xã Canh Hòa", district_code: "551" },
  { code: "22015", name: "Phường 1", district_code: "555" },
  { code: "22018", name: "Phường 2", district_code: "555" },
  { code: "22024", name: "Phường 9", district_code: "555" },
  { code: "22030", name: "Phường 4", district_code: "555" },
  { code: "22033", name: "Phường 5", district_code: "555" },
  { code: "22036", name: "Phường 7", district_code: "555" },
  { code: "22040", name: "Phường Phú Thạnh", district_code: "555" },
  { code: "22041", name: "Phường Phú Đông", district_code: "555" },
  { code: "22042", name: "Xã Hòa Kiến", district_code: "555" },
  { code: "22045", name: "Xã Bình Kiến", district_code: "555" },
  { code: "22162", name: "Xã An Phú", district_code: "555" },
  { code: "22240", name: "Phường Phú Lâm", district_code: "555" },
  { code: "22051", name: "Phường Xuân Phú", district_code: "557" },
  { code: "22052", name: "Xã Xuân Lâm", district_code: "557" },
  { code: "22053", name: "Phường Xuân Thành", district_code: "557" },
  { code: "22054", name: "Xã Xuân Hải", district_code: "557" },
  { code: "22057", name: "Xã Xuân Lộc", district_code: "557" },
  { code: "22060", name: "Xã Xuân Bình", district_code: "557" },
  { code: "22066", name: "Xã Xuân Cảnh", district_code: "557" },
  { code: "22069", name: "Xã Xuân Thịnh", district_code: "557" },
  { code: "22072", name: "Xã Xuân Phương", district_code: "557" },
  { code: "22073", name: "Phường Xuân Yên", district_code: "557" },
  { code: "22075", name: "Xã Xuân Thọ 1", district_code: "557" },
  { code: "22076", name: "Phường Xuân Đài", district_code: "557" },
  { code: "22078", name: "Xã Xuân Thọ 2", district_code: "557" },
  { code: "22081", name: "Thị trấn La Hai", district_code: "558" },
  { code: "22084", name: "Xã Đa Lộc", district_code: "558" },
  { code: "22087", name: "Xã Phú Mỡ", district_code: "558" },
  { code: "22090", name: "Xã Xuân Lãnh", district_code: "558" },
  { code: "22093", name: "Xã Xuân Long", district_code: "558" },
  { code: "22096", name: "Xã Xuân Quang 1", district_code: "558" },
  { code: "22099", name: "Xã Xuân Sơn Bắc", district_code: "558" },
  { code: "22102", name: "Xã Xuân Quang 2", district_code: "558" },
  { code: "22105", name: "Xã Xuân Sơn Nam", district_code: "558" },
  { code: "22108", name: "Xã Xuân Quang 3", district_code: "558" },
  { code: "22111", name: "Xã Xuân Phước", district_code: "558" },
  { code: "22114", name: "Thị trấn Chí Thạnh", district_code: "559" },
  { code: "22117", name: "Xã An Dân", district_code: "559" },
  { code: "22120", name: "Xã An Ninh Tây", district_code: "559" },
  { code: "22123", name: "Xã An Ninh Đông", district_code: "559" },
  { code: "22126", name: "Xã An Thạch", district_code: "559" },
  { code: "22129", name: "Xã An Định", district_code: "559" },
  { code: "22132", name: "Xã An Nghiệp", district_code: "559" },
  { code: "22138", name: "Xã An Cư", district_code: "559" },
  { code: "22141", name: "Xã An Xuân", district_code: "559" },
  { code: "22144", name: "Xã An Lĩnh", district_code: "559" },
  { code: "22147", name: "Xã An Hòa Hải", district_code: "559" },
  { code: "22150", name: "Xã An Hiệp", district_code: "559" },
  { code: "22153", name: "Xã An Mỹ", district_code: "559" },
  { code: "22156", name: "Xã An Chấn", district_code: "559" },
  { code: "22159", name: "Xã An Thọ", district_code: "559" },
  { code: "22165", name: "Thị trấn Củng Sơn", district_code: "560" },
  { code: "22168", name: "Xã Phước Tân", district_code: "560" },
  { code: "22171", name: "Xã Sơn Hội", district_code: "560" },
  { code: "22174", name: "Xã Sơn Định", district_code: "560" },
  { code: "22177", name: "Xã Sơn Long", district_code: "560" },
  { code: "22180", name: "Xã Cà Lúi", district_code: "560" },
  { code: "22183", name: "Xã Sơn Phước", district_code: "560" },
  { code: "22186", name: "Xã Sơn Xuân", district_code: "560" },
  { code: "22189", name: "Xã Sơn Nguyên", district_code: "560" },
  { code: "22192", name: "Xã Eachà Rang", district_code: "560" },
  { code: "22195", name: "Xã Krông Pa", district_code: "560" },
  { code: "22198", name: "Xã Suối Bạc", district_code: "560" },
  { code: "22201", name: "Xã Sơn Hà", district_code: "560" },
  { code: "22204", name: "Xã Suối Trai", district_code: "560" },
  { code: "22207", name: "Thị trấn Hai Riêng", district_code: "561" },
  { code: "22210", name: "Xã Ea Lâm", district_code: "561" },
  { code: "22213", name: "Xã Đức Bình Tây", district_code: "561" },
  { code: "22216", name: "Xã Ea Bá", district_code: "561" },
  { code: "22219", name: "Xã Sơn Giang", district_code: "561" },
  { code: "22222", name: "Xã Đức Bình Đông", district_code: "561" },
  { code: "22225", name: "Xã EaBar", district_code: "561" },
  { code: "22228", name: "Xã EaBia", district_code: "561" },
  { code: "22231", name: "Xã EaTrol", district_code: "561" },
  { code: "22234", name: "Xã Sông Hinh", district_code: "561" },
  { code: "22237", name: "Xã Ealy", district_code: "561" },
  { code: "22249", name: "Xã Sơn Thành Tây", district_code: "562" },
  { code: "22250", name: "Xã Sơn Thành Đông", district_code: "562" },
  { code: "22252", name: "Xã Hòa Bình 1", district_code: "562" },
  { code: "22255", name: "Thị trấn Phú Thứ", district_code: "562" },
  { code: "22264", name: "Xã Hòa Phong", district_code: "562" },
  { code: "22270", name: "Xã Hòa Phú", district_code: "562" },
  { code: "22273", name: "Xã Hòa Tân Tây", district_code: "562" },
  { code: "22276", name: "Xã Hòa Đồng", district_code: "562" },
  { code: "22285", name: "Xã Hòa Mỹ Đông", district_code: "562" },
  { code: "22288", name: "Xã Hòa Mỹ Tây", district_code: "562" },
  { code: "22294", name: "Xã Hòa Thịnh", district_code: "562" },
  { code: "22303", name: "Xã Hòa Quang Bắc", district_code: "563" },
  { code: "22306", name: "Xã Hòa Quang Nam", district_code: "563" },
  { code: "22309", name: "Xã Hòa Hội", district_code: "563" },
  { code: "22312", name: "Xã Hòa Trị", district_code: "563" },
  { code: "22315", name: "Xã Hòa An", district_code: "563" },
  { code: "22318", name: "Xã Hòa Định Đông", district_code: "563" },
  { code: "22319", name: "Thị trấn Phú Hoà", district_code: "563" },
  { code: "22321", name: "Xã Hòa Định Tây", district_code: "563" },
  { code: "22324", name: "Xã Hòa Thắng", district_code: "563" },
  { code: "22243", name: "Xã Hòa Thành", district_code: "564" },
  { code: "22246", name: "Phường Hòa Hiệp Bắc", district_code: "564" },
  { code: "22258", name: "Phường Hoà Vinh", district_code: "564" },
  { code: "22261", name: "Phường Hoà Hiệp Trung", district_code: "564" },
  { code: "22267", name: "Xã Hòa Tân Đông", district_code: "564" },
  { code: "22279", name: "Phường Hòa Xuân Tây", district_code: "564" },
  { code: "22282", name: "Phường Hòa Hiệp Nam", district_code: "564" },
  { code: "22291", name: "Xã Hòa Xuân Đông", district_code: "564" },
  { code: "22297", name: "Xã Hòa Tâm", district_code: "564" },
  { code: "22300", name: "Xã Hòa Xuân Nam", district_code: "564" },
  { code: "22327", name: "Phường Vĩnh Hòa", district_code: "568" },
  { code: "22330", name: "Phường Vĩnh Hải", district_code: "568" },
  { code: "22333", name: "Phường Vĩnh Phước", district_code: "568" },
  { code: "22336", name: "Phường Ngọc Hiệp", district_code: "568" },
  { code: "22339", name: "Phường Vĩnh Thọ", district_code: "568" },
  { code: "22348", name: "Phường Vạn Thạnh", district_code: "568" },
  { code: "22351", name: "Phường Phương Sài", district_code: "568" },
  { code: "22357", name: "Phường Phước Hải", district_code: "568" },
  { code: "22363", name: "Phường Lộc Thọ", district_code: "568" },
  { code: "22366", name: "Phường Tân Tiến", district_code: "568" },
  { code: "22372", name: "Phường Phước Hòa", district_code: "568" },
  { code: "22375", name: "Phường Vĩnh Nguyên", district_code: "568" },
  { code: "22378", name: "Phường Phước Long", district_code: "568" },
  { code: "22381", name: "Phường Vĩnh Trường", district_code: "568" },
  { code: "22384", name: "Xã Vĩnh Lương", district_code: "568" },
  { code: "22387", name: "Xã Vĩnh Phương", district_code: "568" },
  { code: "22390", name: "Xã Vĩnh Ngọc", district_code: "568" },
  { code: "22393", name: "Xã Vĩnh Thạnh", district_code: "568" },
  { code: "22396", name: "Xã Vĩnh Trung", district_code: "568" },
  { code: "22399", name: "Xã Vĩnh Hiệp", district_code: "568" },
  { code: "22402", name: "Xã Vĩnh Thái", district_code: "568" },
  { code: "22405", name: "Xã Phước Đồng", district_code: "568" },
  { code: "22408", name: "Phường Cam Nghĩa", district_code: "569" },
  { code: "22411", name: "Phường Cam Phúc Bắc", district_code: "569" },
  { code: "22414", name: "Phường Cam Phúc Nam", district_code: "569" },
  { code: "22417", name: "Phường Cam Lộc", district_code: "569" },
  { code: "22420", name: "Phường Cam Phú", district_code: "569" },
  { code: "22423", name: "Phường Ba Ngòi", district_code: "569" },
  { code: "22426", name: "Phường Cam Thuận", district_code: "569" },
  { code: "22429", name: "Phường Cam Lợi", district_code: "569" },
  { code: "22432", name: "Phường Cam Linh", district_code: "569" },
  { code: "22468", name: "Xã Cam Thành Nam", district_code: "569" },
  { code: "22474", name: "Xã Cam Phước Đông", district_code: "569" },
  { code: "22477", name: "Xã Cam Thịnh Tây", district_code: "569" },
  { code: "22480", name: "Xã Cam Thịnh Đông", district_code: "569" },
  { code: "22483", name: "Xã Cam Lập", district_code: "569" },
  { code: "22486", name: "Xã Cam Bình", district_code: "569" },
  { code: "22435", name: "Xã Cam Tân", district_code: "570" },
  { code: "22438", name: "Xã Cam Hòa", district_code: "570" },
  { code: "22441", name: "Xã Cam Hải Đông", district_code: "570" },
  { code: "22444", name: "Xã Cam Hải Tây", district_code: "570" },
  { code: "22447", name: "Xã Sơn Tân", district_code: "570" },
  { code: "22450", name: "Xã Cam Hiệp Bắc", district_code: "570" },
  { code: "22453", name: "Thị trấn Cam Đức", district_code: "570" },
  { code: "22456", name: "Xã Cam Hiệp Nam", district_code: "570" },
  { code: "22459", name: "Xã Cam Phước Tây", district_code: "570" },
  { code: "22462", name: "Xã Cam Thành Bắc", district_code: "570" },
  { code: "22465", name: "Xã Cam An Bắc", district_code: "570" },
  { code: "22471", name: "Xã Cam An Nam", district_code: "570" },
  { code: "22708", name: "Xã Suối Cát", district_code: "570" },
  { code: "22711", name: "Xã Suối Tân", district_code: "570" },
  { code: "22489", name: "Thị trấn Vạn Giã", district_code: "571" },
  { code: "22492", name: "Xã Đại Lãnh", district_code: "571" },
  { code: "22495", name: "Xã Vạn Phước", district_code: "571" },
  { code: "22498", name: "Xã Vạn Long", district_code: "571" },
  { code: "22501", name: "Xã Vạn Bình", district_code: "571" },
  { code: "22504", name: "Xã Vạn Thọ", district_code: "571" },
  { code: "22507", name: "Xã Vạn Khánh", district_code: "571" },
  { code: "22510", name: "Xã Vạn Phú", district_code: "571" },
  { code: "22513", name: "Xã Vạn Lương", district_code: "571" },
  { code: "22516", name: "Xã Vạn Thắng", district_code: "571" },
  { code: "22519", name: "Xã Vạn Thạnh", district_code: "571" },
  { code: "22522", name: "Xã Xuân Sơn", district_code: "571" },
  { code: "22525", name: "Xã Vạn Hưng", district_code: "571" },
  { code: "22528", name: "Phường Ninh Hiệp", district_code: "572" },
  { code: "22531", name: "Xã Ninh Sơn", district_code: "572" },
  { code: "22534", name: "Xã Ninh Tây", district_code: "572" },
  { code: "22537", name: "Xã Ninh Thượng", district_code: "572" },
  { code: "22540", name: "Xã Ninh An", district_code: "572" },
  { code: "22543", name: "Phường Ninh Hải", district_code: "572" },
  { code: "22546", name: "Xã Ninh Thọ", district_code: "572" },
  { code: "22549", name: "Xã Ninh Trung", district_code: "572" },
  { code: "22552", name: "Xã Ninh Sim", district_code: "572" },
  { code: "22555", name: "Xã Ninh Xuân", district_code: "572" },
  { code: "22558", name: "Xã Ninh Thân", district_code: "572" },
  { code: "22561", name: "Phường Ninh Diêm", district_code: "572" },
  { code: "22564", name: "Xã Ninh Đông", district_code: "572" },
  { code: "22567", name: "Phường Ninh Thủy", district_code: "572" },
  { code: "22570", name: "Phường Ninh Đa", district_code: "572" },
  { code: "22573", name: "Xã Ninh Phụng", district_code: "572" },
  { code: "22576", name: "Xã Ninh Bình", district_code: "572" },
  { code: "22582", name: "Xã Ninh Phú", district_code: "572" },
  { code: "22585", name: "Xã Ninh Tân", district_code: "572" },
  { code: "22588", name: "Xã Ninh Quang", district_code: "572" },
  { code: "22591", name: "Phường Ninh Giang", district_code: "572" },
  { code: "22594", name: "Phường Ninh Hà", district_code: "572" },
  { code: "22597", name: "Xã Ninh Hưng", district_code: "572" },
  { code: "22600", name: "Xã Ninh Lộc", district_code: "572" },
  { code: "22603", name: "Xã Ninh Ích", district_code: "572" },
  { code: "22606", name: "Xã Ninh Phước", district_code: "572" },
  { code: "22609", name: "Thị trấn Khánh Vĩnh", district_code: "573" },
  { code: "22612", name: "Xã Khánh Hiệp", district_code: "573" },
  { code: "22615", name: "Xã Khánh Bình", district_code: "573" },
  { code: "22618", name: "Xã Khánh Trung", district_code: "573" },
  { code: "22621", name: "Xã Khánh Đông", district_code: "573" },
  { code: "22624", name: "Xã Khánh Thượng", district_code: "573" },
  { code: "22627", name: "Xã Khánh Nam", district_code: "573" },
  { code: "22630", name: "Xã Sông Cầu", district_code: "573" },
  { code: "22633", name: "Xã Giang Ly", district_code: "573" },
  { code: "22636", name: "Xã Cầu Bà", district_code: "573" },
  { code: "22639", name: "Xã Liên Sang", district_code: "573" },
  { code: "22642", name: "Xã Khánh Thành", district_code: "573" },
  { code: "22645", name: "Xã Khánh Phú", district_code: "573" },
  { code: "22648", name: "Xã Sơn Thái", district_code: "573" },
  { code: "22651", name: "Thị trấn Diên Khánh", district_code: "574" },
  { code: "22654", name: "Xã Diên Lâm", district_code: "574" },
  { code: "22657", name: "Xã Diên Điền", district_code: "574" },
  { code: "22660", name: "Xã Xuân Đồng", district_code: "574" },
  { code: "22663", name: "Xã Diên Sơn", district_code: "574" },
  { code: "22669", name: "Xã Diên Phú", district_code: "574" },
  { code: "22672", name: "Xã Diên Thọ", district_code: "574" },
  { code: "22675", name: "Xã Diên Phước", district_code: "574" },
  { code: "22678", name: "Xã Diên Lạc", district_code: "574" },
  { code: "22681", name: "Xã Diên Tân", district_code: "574" },
  { code: "22684", name: "Xã Diên Hòa", district_code: "574" },
  { code: "22687", name: "Xã Diên Thạnh", district_code: "574" },
  { code: "22690", name: "Xã Diên Toàn", district_code: "574" },
  { code: "22693", name: "Xã Diên An", district_code: "574" },
  { code: "22696", name: "Xã Bình Lộc", district_code: "574" },
  { code: "22702", name: "Xã Suối Hiệp", district_code: "574" },
  { code: "22705", name: "Xã Suối Tiên", district_code: "574" },
  { code: "22714", name: "Thị trấn Tô Hạp", district_code: "575" },
  { code: "22717", name: "Xã Thành Sơn", district_code: "575" },
  { code: "22720", name: "Xã Sơn Lâm", district_code: "575" },
  { code: "22723", name: "Xã Sơn Hiệp", district_code: "575" },
  { code: "22726", name: "Xã Sơn Bình", district_code: "575" },
  { code: "22729", name: "Xã Sơn Trung", district_code: "575" },
  { code: "22732", name: "Xã Ba Cụm Bắc", district_code: "575" },
  { code: "22735", name: "Xã Ba Cụm Nam", district_code: "575" },
  { code: "22736", name: "Thị trấn Trường Sa", district_code: "576" },
  { code: "22737", name: "Xã Song Tử Tây", district_code: "576" },
  { code: "22739", name: "Xã Sinh Tồn", district_code: "576" },
  { code: "22738", name: "Phường Đô Vinh", district_code: "582" },
  { code: "22741", name: "Phường Phước Mỹ", district_code: "582" },
  { code: "22744", name: "Phường Bảo An", district_code: "582" },
  { code: "22750", name: "Phường Phủ Hà", district_code: "582" },
  { code: "22759", name: "Phường Kinh Dinh", district_code: "582" },
  { code: "22762", name: "Phường Đạo Long", district_code: "582" },
  { code: "22765", name: "Phường Đài Sơn", district_code: "582" },
  { code: "22768", name: "Phường Đông Hải", district_code: "582" },
  { code: "22771", name: "Phường Mỹ Đông", district_code: "582" },
  { code: "22774", name: "Xã Thành Hải", district_code: "582" },
  { code: "22777", name: "Phường Văn Hải", district_code: "582" },
  { code: "22779", name: "Phường Mỹ Bình", district_code: "582" },
  { code: "22780", name: "Phường Mỹ Hải", district_code: "582" },
  { code: "22783", name: "Xã Phước Bình", district_code: "584" },
  { code: "22786", name: "Xã Phước Hòa", district_code: "584" },
  { code: "22789", name: "Xã Phước Tân", district_code: "584" },
  { code: "22792", name: "Xã Phước Tiến", district_code: "584" },
  { code: "22795", name: "Xã Phước Thắng", district_code: "584" },
  { code: "22798", name: "Xã Phước Thành", district_code: "584" },
  { code: "22801", name: "Xã Phước Đại", district_code: "584" },
  { code: "22804", name: "Xã Phước Chính", district_code: "584" },
  { code: "22807", name: "Xã Phước Trung", district_code: "584" },
  { code: "22810", name: "Thị trấn Tân Sơn", district_code: "585" },
  { code: "22813", name: "Xã Lâm Sơn", district_code: "585" },
  { code: "22816", name: "Xã Lương Sơn", district_code: "585" },
  { code: "22819", name: "Xã Quảng Sơn", district_code: "585" },
  { code: "22822", name: "Xã Mỹ Sơn", district_code: "585" },
  { code: "22825", name: "Xã Hòa Sơn", district_code: "585" },
  { code: "22828", name: "Xã Ma Nới", district_code: "585" },
  { code: "22831", name: "Xã Nhơn Sơn", district_code: "585" },
  { code: "22834", name: "Thị trấn Khánh Hải", district_code: "586" },
  { code: "22846", name: "Xã Vĩnh Hải", district_code: "586" },
  { code: "22852", name: "Xã Phương Hải", district_code: "586" },
  { code: "22855", name: "Xã Tân Hải", district_code: "586" },
  { code: "22858", name: "Xã Xuân Hải", district_code: "586" },
  { code: "22861", name: "Xã Hộ Hải", district_code: "586" },
  { code: "22864", name: "Xã Tri Hải", district_code: "586" },
  { code: "22867", name: "Xã Nhơn Hải", district_code: "586" },
  { code: "22868", name: "Xã Thanh Hải", district_code: "586" },
  { code: "22870", name: "Thị trấn Phước Dân", district_code: "587" },
  { code: "22873", name: "Xã Phước Sơn", district_code: "587" },
  { code: "22876", name: "Xã Phước Thái", district_code: "587" },
  { code: "22879", name: "Xã Phước Hậu", district_code: "587" },
  { code: "22882", name: "Xã Phước Thuận", district_code: "587" },
  { code: "22888", name: "Xã An Hải", district_code: "587" },
  { code: "22891", name: "Xã Phước Hữu", district_code: "587" },
  { code: "22894", name: "Xã Phước Hải", district_code: "587" },
  { code: "22912", name: "Xã Phước Vinh", district_code: "587" },
  { code: "22837", name: "Xã Phước Chiến", district_code: "588" },
  { code: "22840", name: "Xã Công Hải", district_code: "588" },
  { code: "22843", name: "Xã Phước Kháng", district_code: "588" },
  { code: "22849", name: "Xã Lợi Hải", district_code: "588" },
  { code: "22853", name: "Xã Bắc Sơn", district_code: "588" },
  { code: "22856", name: "Xã Bắc Phong", district_code: "588" },
  { code: "22885", name: "Xã Phước Hà", district_code: "589" },
  { code: "22897", name: "Xã Phước Nam", district_code: "589" },
  { code: "22898", name: "Xã Phước Ninh", district_code: "589" },
  { code: "22900", name: "Xã Nhị Hà", district_code: "589" },
  { code: "22903", name: "Xã Phước Dinh", district_code: "589" },
  { code: "22906", name: "Xã Phước Minh", district_code: "589" },
  { code: "22909", name: "Xã Phước Diêm", district_code: "589" },
  { code: "22910", name: "Xã Cà Ná", district_code: "589" },
  { code: "22915", name: "Phường Mũi Né", district_code: "593" },
  { code: "22918", name: "Phường Hàm Tiến", district_code: "593" },
  { code: "22921", name: "Phường Phú Hài", district_code: "593" },
  { code: "22924", name: "Phường Phú Thủy", district_code: "593" },
  { code: "22927", name: "Phường Phú Tài", district_code: "593" },
  { code: "22930", name: "Phường Phú Trinh", district_code: "593" },
  { code: "22933", name: "Phường Xuân An", district_code: "593" },
  { code: "22936", name: "Phường Thanh Hải", district_code: "593" },
  { code: "22945", name: "Phường Lạc Đạo", district_code: "593" },
  { code: "22951", name: "Phường Bình Hưng", district_code: "593" },
  { code: "22954", name: "Phường Đức Long", district_code: "593" },
  { code: "22957", name: "Xã Thiện Nghiệp", district_code: "593" },
  { code: "22960", name: "Xã Phong Nẫm", district_code: "593" },
  { code: "22963", name: "Xã Tiến Lợi", district_code: "593" },
  { code: "22966", name: "Xã Tiến Thành", district_code: "593" },
  { code: "23231", name: "Phường Phước Hội", district_code: "594" },
  { code: "23232", name: "Phường Phước Lộc", district_code: "594" },
  { code: "23234", name: "Phường Tân Thiện", district_code: "594" },
  { code: "23235", name: "Phường Tân An", district_code: "594" },
  { code: "23237", name: "Phường Bình Tân", district_code: "594" },
  { code: "23245", name: "Xã Tân Hải", district_code: "594" },
  { code: "23246", name: "Xã Tân Tiến", district_code: "594" },
  { code: "23248", name: "Xã Tân Bình", district_code: "594" },
  { code: "23268", name: "Xã Tân Phước", district_code: "594" },
  { code: "22969", name: "Thị trấn Liên Hương", district_code: "595" },
  { code: "22972", name: "Thị trấn Phan Rí Cửa", district_code: "595" },
  { code: "22975", name: "Xã Phan Dũng", district_code: "595" },
  { code: "22978", name: "Xã Phong Phú", district_code: "595" },
  { code: "22981", name: "Xã Vĩnh Hảo", district_code: "595" },
  { code: "22984", name: "Xã Vĩnh Tân", district_code: "595" },
  { code: "22987", name: "Xã Phú Lạc", district_code: "595" },
  { code: "22990", name: "Xã Phước Thể", district_code: "595" },
  { code: "22993", name: "Xã Hòa Minh", district_code: "595" },
  { code: "22996", name: "Xã Chí Công", district_code: "595" },
  { code: "22999", name: "Xã Bình Thạnh", district_code: "595" },
  { code: "23005", name: "Thị trấn Chợ Lầu", district_code: "596" },
  { code: "23008", name: "Xã Phan Sơn", district_code: "596" },
  { code: "23011", name: "Xã Phan Lâm", district_code: "596" },
  { code: "23014", name: "Xã Bình An", district_code: "596" },
  { code: "23017", name: "Xã Phan Điền", district_code: "596" },
  { code: "23020", name: "Xã Hải Ninh", district_code: "596" },
  { code: "23023", name: "Xã Sông Lũy", district_code: "596" },
  { code: "23026", name: "Xã Phan Tiến", district_code: "596" },
  { code: "23029", name: "Xã Sông Bình", district_code: "596" },
  { code: "23032", name: "Thị trấn Lương Sơn", district_code: "596" },
  { code: "23035", name: "Xã Phan Hòa", district_code: "596" },
  { code: "23038", name: "Xã Phan Thanh", district_code: "596" },
  { code: "23041", name: "Xã Hồng Thái", district_code: "596" },
  { code: "23044", name: "Xã Phan Hiệp", district_code: "596" },
  { code: "23047", name: "Xã Bình Tân", district_code: "596" },
  { code: "23050", name: "Xã Phan Rí Thành", district_code: "596" },
  { code: "23053", name: "Xã Hòa Thắng", district_code: "596" },
  { code: "23056", name: "Xã Hồng Phong", district_code: "596" },
  { code: "23059", name: "Thị trấn Ma Lâm", district_code: "597" },
  { code: "23062", name: "Thị trấn Phú Long", district_code: "597" },
  { code: "23065", name: "Xã La Dạ", district_code: "597" },
  { code: "23068", name: "Xã Đông Tiến", district_code: "597" },
  { code: "23071", name: "Xã Thuận Hòa", district_code: "597" },
  { code: "23074", name: "Xã Đông Giang", district_code: "597" },
  { code: "23077", name: "Xã Hàm Phú", district_code: "597" },
  { code: "23080", name: "Xã Hồng Liêm", district_code: "597" },
  { code: "23083", name: "Xã Thuận Minh", district_code: "597" },
  { code: "23086", name: "Xã Hồng Sơn", district_code: "597" },
  { code: "23089", name: "Xã Hàm Trí", district_code: "597" },
  { code: "23092", name: "Xã Hàm Đức", district_code: "597" },
  { code: "23095", name: "Xã Hàm Liêm", district_code: "597" },
  { code: "23098", name: "Xã Hàm Chính", district_code: "597" },
  { code: "23101", name: "Xã Hàm Hiệp", district_code: "597" },
  { code: "23104", name: "Xã Hàm Thắng", district_code: "597" },
  { code: "23107", name: "Xã Đa Mi", district_code: "597" },
  { code: "23110", name: "Thị trấn Thuận Nam", district_code: "598" },
  { code: "23113", name: "Xã Mỹ Thạnh", district_code: "598" },
  { code: "23116", name: "Xã Hàm Cần", district_code: "598" },
  { code: "23119", name: "Xã Mương Mán", district_code: "598" },
  { code: "23122", name: "Xã Hàm Thạnh", district_code: "598" },
  { code: "23125", name: "Xã Hàm Kiệm", district_code: "598" },
  { code: "23128", name: "Xã Hàm Cường", district_code: "598" },
  { code: "23131", name: "Xã Hàm Mỹ", district_code: "598" },
  { code: "23134", name: "Xã Tân Lập", district_code: "598" },
  { code: "23137", name: "Xã Hàm Minh", district_code: "598" },
  { code: "23140", name: "Xã Thuận Quí", district_code: "598" },
  { code: "23143", name: "Xã Tân Thuận", district_code: "598" },
  { code: "23146", name: "Xã Tân Thành", district_code: "598" },
  { code: "23149", name: "Thị trấn Lạc Tánh", district_code: "599" },
  { code: "23152", name: "Xã Bắc Ruộng", district_code: "599" },
  { code: "23158", name: "Xã Nghị Đức", district_code: "599" },
  { code: "23161", name: "Xã La Ngâu", district_code: "599" },
  { code: "23164", name: "Xã Huy Khiêm", district_code: "599" },
  { code: "23167", name: "Xã Măng Tố", district_code: "599" },
  { code: "23170", name: "Xã Đức Phú", district_code: "599" },
  { code: "23173", name: "Xã Đồng Kho", district_code: "599" },
  { code: "23176", name: "Xã Gia An", district_code: "599" },
  { code: "23179", name: "Xã Đức Bình", district_code: "599" },
  { code: "23182", name: "Xã Gia Huynh", district_code: "599" },
  { code: "23185", name: "Xã Đức Thuận", district_code: "599" },
  { code: "23188", name: "Xã Suối Kiết", district_code: "599" },
  { code: "23191", name: "Thị trấn Võ Xu", district_code: "600" },
  { code: "23194", name: "Thị trấn Đức Tài", district_code: "600" },
  { code: "23197", name: "Xã Đa Kai", district_code: "600" },
  { code: "23200", name: "Xã Sùng Nhơn", district_code: "600" },
  { code: "23203", name: "Xã Mê Pu", district_code: "600" },
  { code: "23206", name: "Xã Nam Chính", district_code: "600" },
  { code: "23212", name: "Xã Đức Hạnh", district_code: "600" },
  { code: "23215", name: "Xã Đức Tín", district_code: "600" },
  { code: "23218", name: "Xã Vũ Hoà", district_code: "600" },
  { code: "23221", name: "Xã Tân Hà", district_code: "600" },
  { code: "23224", name: "Xã Đông Hà", district_code: "600" },
  { code: "23227", name: "Xã Trà Tân", district_code: "600" },
  { code: "23230", name: "Thị trấn Tân Minh", district_code: "601" },
  { code: "23236", name: "Thị trấn Tân Nghĩa", district_code: "601" },
  { code: "23239", name: "Xã Sông Phan", district_code: "601" },
  { code: "23242", name: "Xã Tân Phúc", district_code: "601" },
  { code: "23251", name: "Xã Tân Đức", district_code: "601" },
  { code: "23254", name: "Xã Tân Thắng", district_code: "601" },
  { code: "23255", name: "Xã Thắng Hải", district_code: "601" },
  { code: "23257", name: "Xã Tân Hà", district_code: "601" },
  { code: "23260", name: "Xã Tân Xuân", district_code: "601" },
  { code: "23266", name: "Xã Sơn Mỹ", district_code: "601" },
  { code: "23272", name: "Xã Ngũ Phụng", district_code: "602" },
  { code: "23275", name: "Xã Long Hải", district_code: "602" },
  { code: "23278", name: "Xã Tam Thanh", district_code: "602" },
  { code: "23281", name: "Phường Quang Trung", district_code: "608" },
  { code: "23284", name: "Phường Duy Tân", district_code: "608" },
  { code: "23287", name: "Phường Quyết Thắng", district_code: "608" },
  { code: "23290", name: "Phường Trường Chinh", district_code: "608" },
  { code: "23293", name: "Phường Thắng Lợi", district_code: "608" },
  { code: "23296", name: "Phường Ngô Mây", district_code: "608" },
  { code: "23299", name: "Phường Thống Nhất", district_code: "608" },
  { code: "23302", name: "Phường Lê Lợi", district_code: "608" },
  { code: "23305", name: "Phường Nguyễn Trãi", district_code: "608" },
  { code: "23308", name: "Phường Trần Hưng Đạo", district_code: "608" },
  { code: "23311", name: "Xã Đắk Cấm", district_code: "608" },
  { code: "23314", name: "Xã Kroong", district_code: "608" },
  { code: "23317", name: "Xã Ngọk Bay", district_code: "608" },
  { code: "23320", name: "Xã Vinh Quang", district_code: "608" },
  { code: "23323", name: "Xã Đắk Blà", district_code: "608" },
  { code: "23326", name: "Xã Ia Chim", district_code: "608" },
  { code: "23327", name: "Xã Đăk Năng", district_code: "608" },
  { code: "23329", name: "Xã Đoàn Kết", district_code: "608" },
  { code: "23332", name: "Xã Chư Hreng", district_code: "608" },
  { code: "23335", name: "Xã Đắk Rơ Wa", district_code: "608" },
  { code: "23338", name: "Xã Hòa Bình", district_code: "608" },
  { code: "23341", name: "Thị trấn Đắk Glei", district_code: "610" },
  { code: "23344", name: "Xã Đắk Blô", district_code: "610" },
  { code: "23347", name: "Xã Đắk Man", district_code: "610" },
  { code: "23350", name: "Xã Đắk Nhoong", district_code: "610" },
  { code: "23353", name: "Xã Đắk Pék", district_code: "610" },
  { code: "23356", name: "Xã Đắk Choong", district_code: "610" },
  { code: "23359", name: "Xã Xốp", district_code: "610" },
  { code: "23362", name: "Xã Mường Hoong", district_code: "610" },
  { code: "23365", name: "Xã Ngọc Linh", district_code: "610" },
  { code: "23368", name: "Xã Đắk Long", district_code: "610" },
  { code: "23371", name: "Xã Đắk KRoong", district_code: "610" },
  { code: "23374", name: "Xã Đắk Môn", district_code: "610" },
  { code: "23377", name: "Thị trấn Plei Kần", district_code: "611" },
  { code: "23380", name: "Xã Đắk Ang", district_code: "611" },
  { code: "23383", name: "Xã Đắk Dục", district_code: "611" },
  { code: "23386", name: "Xã Đắk Nông", district_code: "611" },
  { code: "23389", name: "Xã Đắk Xú", district_code: "611" },
  { code: "23392", name: "Xã Đắk Kan", district_code: "611" },
  { code: "23395", name: "Xã Bờ Y", district_code: "611" },
  { code: "23398", name: "Xã Sa Loong", district_code: "611" },
  { code: "23401", name: "Thị trấn Đắk Tô", district_code: "612" },
  { code: "23427", name: "Xã Đắk Rơ Nga", district_code: "612" },
  { code: "23428", name: "Xã Ngọk Tụ", district_code: "612" },
  { code: "23430", name: "Xã Đắk Trăm", district_code: "612" },
  { code: "23431", name: "Xã Văn Lem", district_code: "612" },
  { code: "23434", name: "Xã Kon Đào", district_code: "612" },
  { code: "23437", name: "Xã Tân Cảnh", district_code: "612" },
  { code: "23440", name: "Xã Diên Bình", district_code: "612" },
  { code: "23443", name: "Xã Pô Kô", district_code: "612" },
  { code: "23452", name: "Xã Đắk Nên", district_code: "613" },
  { code: "23455", name: "Xã Đắk Ring", district_code: "613" },
  { code: "23458", name: "Xã Măng Buk", district_code: "613" },
  { code: "23461", name: "Xã Đắk Tăng", district_code: "613" },
  { code: "23464", name: "Xã Ngok Tem", district_code: "613" },
  { code: "23467", name: "Xã Pờ Ê", district_code: "613" },
  { code: "23470", name: "Xã Măng Cành", district_code: "613" },
  { code: "23473", name: "Thị trấn Măng Đen", district_code: "613" },
  { code: "23476", name: "Xã Hiếu", district_code: "613" },
  { code: "23479", name: "Thị trấn Đắk Rve", district_code: "614" },
  { code: "23482", name: "Xã Đắk Kôi", district_code: "614" },
  { code: "23485", name: "Xã Đắk Tơ Lung", district_code: "614" },
  { code: "23488", name: "Xã Đắk Ruồng", district_code: "614" },
  { code: "23491", name: "Xã Đắk Pne", district_code: "614" },
  { code: "23494", name: "Xã Đắk Tờ Re", district_code: "614" },
  { code: "23497", name: "Xã Tân Lập", district_code: "614" },
  { code: "23500", name: "Thị trấn Đắk Hà", district_code: "615" },
  { code: "23503", name: "Xã Đắk PXi", district_code: "615" },
  { code: "23504", name: "Xã Đăk Long", district_code: "615" },
  { code: "23506", name: "Xã Đắk HRing", district_code: "615" },
  { code: "23509", name: "Xã Đắk Ui", district_code: "615" },
  { code: "23510", name: "Xã Đăk Ngọk", district_code: "615" },
  { code: "23512", name: "Xã Đắk Mar", district_code: "615" },
  { code: "23515", name: "Xã Ngok Wang", district_code: "615" },
  { code: "23518", name: "Xã Ngok Réo", district_code: "615" },
  { code: "23521", name: "Xã Hà Mòn", district_code: "615" },
  { code: "23524", name: "Xã Đắk La", district_code: "615" },
  { code: "23527", name: "Thị trấn Sa Thầy", district_code: "616" },
  { code: "23530", name: "Xã Rơ Kơi", district_code: "616" },
  { code: "23533", name: "Xã Sa Nhơn", district_code: "616" },
  { code: "23534", name: "Xã Hơ Moong", district_code: "616" },
  { code: "23536", name: "Xã Mô Rai", district_code: "616" },
  { code: "23539", name: "Xã Sa Sơn", district_code: "616" },
  { code: "23542", name: "Xã Sa Nghĩa", district_code: "616" },
  { code: "23545", name: "Xã Sa Bình", district_code: "616" },
  { code: "23548", name: "Xã Ya Xiêr", district_code: "616" },
  { code: "23551", name: "Xã Ya Tăng", district_code: "616" },
  { code: "23554", name: "Xã Ya ly", district_code: "616" },
  { code: "23404", name: "Xã Ngọc Lây", district_code: "617" },
  { code: "23407", name: "Xã Đắk Na", district_code: "617" },
  { code: "23410", name: "Xã Măng Ri", district_code: "617" },
  { code: "23413", name: "Xã Ngọc Yêu", district_code: "617" },
  { code: "23416", name: "Xã Đắk Sao", district_code: "617" },
  { code: "23417", name: "Xã Đắk Rơ Ông", district_code: "617" },
  { code: "23419", name: "Xã Đắk Tờ Kan", district_code: "617" },
  { code: "23422", name: "Xã Tu Mơ Rông", district_code: "617" },
  { code: "23425", name: "Xã Đắk Hà", district_code: "617" },
  { code: "23446", name: "Xã Tê Xăng", district_code: "617" },
  { code: "23449", name: "Xã Văn Xuôi", district_code: "617" },
  { code: "23535", name: "Xã Ia Đal", district_code: "618" },
  { code: "23537", name: "Xã Ia Dom", district_code: "618" },
  { code: "23538", name: "Xã Ia Tơi", district_code: "618" },
  { code: "23557", name: "Phường Yên Đỗ", district_code: "622" },
  { code: "23560", name: "Phường Diên Hồng", district_code: "622" },
  { code: "23563", name: "Phường Ia Kring", district_code: "622" },
  { code: "23566", name: "Phường Hội Thương", district_code: "622" },
  { code: "23569", name: "Phường Hội Phú", district_code: "622" },
  { code: "23570", name: "Phường Phù Đổng", district_code: "622" },
  { code: "23572", name: "Phường Hoa Lư", district_code: "622" },
  { code: "23575", name: "Phường Tây Sơn", district_code: "622" },
  { code: "23578", name: "Phường Thống Nhất", district_code: "622" },
  { code: "23579", name: "Phường Đống Đa", district_code: "622" },
  { code: "23581", name: "Phường Trà Bá", district_code: "622" },
  { code: "23582", name: "Phường Thắng Lợi", district_code: "622" },
  { code: "23584", name: "Phường Yên Thế", district_code: "622" },
  { code: "23586", name: "Phường Chi Lăng", district_code: "622" },
  { code: "23590", name: "Xã Biển Hồ", district_code: "622" },
  { code: "23596", name: "Xã Trà Đa", district_code: "622" },
  { code: "23599", name: "Xã Chư Á", district_code: "622" },
  { code: "23602", name: "Xã An Phú", district_code: "622" },
  { code: "23605", name: "Xã Diên Phú", district_code: "622" },
  { code: "23608", name: "Xã Ia Kênh", district_code: "622" },
  { code: "23611", name: "Xã Gào", district_code: "622" },
  { code: "23614", name: "Phường An Bình", district_code: "623" },
  { code: "23617", name: "Phường Tây Sơn", district_code: "623" },
  { code: "23620", name: "Phường An Phú", district_code: "623" },
  { code: "23623", name: "Phường An Tân", district_code: "623" },
  { code: "23626", name: "Xã Tú An", district_code: "623" },
  { code: "23627", name: "Xã Xuân An", district_code: "623" },
  { code: "23629", name: "Xã Cửu An", district_code: "623" },
  { code: "23630", name: "Phường An Phước", district_code: "623" },
  { code: "23632", name: "Xã Song An", district_code: "623" },
  { code: "23633", name: "Phường Ngô Mây", district_code: "623" },
  { code: "23635", name: "Xã Thành An", district_code: "623" },
  { code: "24041", name: "Phường Cheo Reo", district_code: "624" },
  { code: "24042", name: "Phường Hòa Bình", district_code: "624" },
  { code: "24044", name: "Phường Đoàn Kết", district_code: "624" },
  { code: "24045", name: "Phường Sông Bờ", district_code: "624" },
  { code: "24064", name: "Xã Ia RBol", district_code: "624" },
  { code: "24065", name: "Xã Chư Băh", district_code: "624" },
  { code: "24070", name: "Xã Ia RTô", district_code: "624" },
  { code: "24073", name: "Xã Ia Sao", district_code: "624" },
  { code: "23638", name: "Thị trấn KBang", district_code: "625" },
  { code: "23641", name: "Xã Kon Pne", district_code: "625" },
  { code: "23644", name: "Xã Đăk Roong", district_code: "625" },
  { code: "23647", name: "Xã Sơn Lang", district_code: "625" },
  { code: "23650", name: "Xã KRong", district_code: "625" },
  { code: "23653", name: "Xã Sơ Pai", district_code: "625" },
  { code: "23656", name: "Xã Lơ Ku", district_code: "625" },
  { code: "23659", name: "Xã Đông", district_code: "625" },
  { code: "23660", name: "Xã Đak SMar", district_code: "625" },
  { code: "23662", name: "Xã Nghĩa An", district_code: "625" },
  { code: "23665", name: "Xã Tơ Tung", district_code: "625" },
  { code: "23668", name: "Xã Kông Lơng Khơng", district_code: "625" },
  { code: "23674", name: "Xã Kông Bơ La", district_code: "625" },
  { code: "23677", name: "Thị trấn Đăk Đoa", district_code: "626" },
  { code: "23680", name: "Xã Hà Đông", district_code: "626" },
  { code: "23683", name: "Xã Đăk Sơmei", district_code: "626" },
  { code: "23684", name: "Xã Đăk Krong", district_code: "626" },
  { code: "23686", name: "Xã Hải Yang", district_code: "626" },
  { code: "23689", name: "Xã Kon Gang", district_code: "626" },
  { code: "23692", name: "Xã Hà Bầu", district_code: "626" },
  { code: "23695", name: "Xã Nam Yang", district_code: "626" },
  { code: "23698", name: "Xã K' Dang", district_code: "626" },
  { code: "23701", name: "Xã H' Neng", district_code: "626" },
  { code: "23704", name: "Xã Tân Bình", district_code: "626" },
  { code: "23707", name: "Xã Glar", district_code: "626" },
  { code: "23710", name: "Xã A Dơk", district_code: "626" },
  { code: "23713", name: "Xã Trang", district_code: "626" },
  { code: "23714", name: "Xã HNol", district_code: "626" },
  { code: "23716", name: "Xã Ia Pết", district_code: "626" },
  { code: "23719", name: "Xã Ia Băng", district_code: "626" },
  { code: "23722", name: "Thị trấn Phú Hòa", district_code: "627" },
  { code: "23725", name: "Xã Hà Tây", district_code: "627" },
  { code: "23728", name: "Xã Ia Khươl", district_code: "627" },
  { code: "23731", name: "Xã Ia Phí", district_code: "627" },
  { code: "23734", name: "Thị trấn Ia Ly", district_code: "627" },
  { code: "23737", name: "Xã Ia Mơ Nông", district_code: "627" },
  { code: "23738", name: "Xã Ia Kreng", district_code: "627" },
  { code: "23740", name: "Xã Đăk Tơ Ver", district_code: "627" },
  { code: "23743", name: "Xã Hòa Phú", district_code: "627" },
  { code: "23746", name: "Xã Chư Đăng Ya", district_code: "627" },
  { code: "23749", name: "Xã Ia Ka", district_code: "627" },
  { code: "23752", name: "Xã Ia Nhin", district_code: "627" },
  { code: "23755", name: "Xã Nghĩa Hòa", district_code: "627" },
  { code: "23761", name: "Xã Nghĩa Hưng", district_code: "627" },
  { code: "23764", name: "Thị trấn Ia Kha", district_code: "628" },
  { code: "23767", name: "Xã Ia Sao", district_code: "628" },
  { code: "23768", name: "Xã Ia Yok", district_code: "628" },
  { code: "23770", name: "Xã Ia Hrung", district_code: "628" },
  { code: "23771", name: "Xã Ia Bă", district_code: "628" },
  { code: "23773", name: "Xã Ia Khai", district_code: "628" },
  { code: "23776", name: "Xã Ia KRai", district_code: "628" },
  { code: "23778", name: "Xã Ia Grăng", district_code: "628" },
  { code: "23779", name: "Xã Ia Tô", district_code: "628" },
  { code: "23782", name: "Xã Ia O", district_code: "628" },
  { code: "23785", name: "Xã Ia Dêr", district_code: "628" },
  { code: "23788", name: "Xã Ia Chia", district_code: "628" },
  { code: "23791", name: "Xã Ia Pếch", district_code: "628" },
  { code: "23794", name: "Thị trấn Kon Dơng", district_code: "629" },
  { code: "23797", name: "Xã Ayun", district_code: "629" },
  { code: "23798", name: "Xã Đak Jơ Ta", district_code: "629" },
  { code: "23799", name: "Xã Đak Ta Ley", district_code: "629" },
  { code: "23800", name: "Xã Hra", district_code: "629" },
  { code: "23803", name: "Xã Đăk Yă", district_code: "629" },
  { code: "23806", name: "Xã Đăk Djrăng", district_code: "629" },
  { code: "23809", name: "Xã Lơ Pang", district_code: "629" },
  { code: "23812", name: "Xã Kon Thụp", district_code: "629" },
  { code: "23815", name: "Xã Đê Ar", district_code: "629" },
  { code: "23818", name: "Xã Kon Chiêng", district_code: "629" },
  { code: "23821", name: "Xã Đăk Trôi", district_code: "629" },
  { code: "23824", name: "Thị trấn Kông Chro", district_code: "630" },
  { code: "23827", name: "Xã Chư Krêy", district_code: "630" },
  { code: "23830", name: "Xã An Trung", district_code: "630" },
  { code: "23833", name: "Xã Kông Yang", district_code: "630" },
  { code: "23836", name: "Xã Đăk Tơ Pang", district_code: "630" },
  { code: "23839", name: "Xã SRó", district_code: "630" },
  { code: "23840", name: "Xã Đắk Kơ Ning", district_code: "630" },
  { code: "23842", name: "Xã Đăk Song", district_code: "630" },
  { code: "23843", name: "Xã Đăk Pling", district_code: "630" },
  { code: "23845", name: "Xã Yang Trung", district_code: "630" },
  { code: "23846", name: "Xã Đăk Pơ Pho", district_code: "630" },
  { code: "23848", name: "Xã Ya Ma", district_code: "630" },
  { code: "23851", name: "Xã Chơ Long", district_code: "630" },
  { code: "23854", name: "Xã Yang Nam", district_code: "630" },
  { code: "23857", name: "Thị trấn Chư Ty", district_code: "631" },
  { code: "23860", name: "Xã Ia Dơk", district_code: "631" },
  { code: "23863", name: "Xã Ia Krêl", district_code: "631" },
  { code: "23866", name: "Xã Ia Din", district_code: "631" },
  { code: "23869", name: "Xã Ia Kla", district_code: "631" },
  { code: "23872", name: "Xã Ia Dom", district_code: "631" },
  { code: "23875", name: "Xã Ia Lang", district_code: "631" },
  { code: "23878", name: "Xã Ia Kriêng", district_code: "631" },
  { code: "23881", name: "Xã Ia Pnôn", district_code: "631" },
  { code: "23884", name: "Xã Ia Nan", district_code: "631" },
  { code: "23887", name: "Thị trấn Chư Prông", district_code: "632" },
  { code: "23888", name: "Xã Ia Kly", district_code: "632" },
  { code: "23890", name: "Xã Bình Giáo", district_code: "632" },
  { code: "23893", name: "Xã Ia Drăng", district_code: "632" },
  { code: "23896", name: "Xã Thăng Hưng", district_code: "632" },
  { code: "23899", name: "Xã Bàu Cạn", district_code: "632" },
  { code: "23902", name: "Xã Ia Phìn", district_code: "632" },
  { code: "23905", name: "Xã Ia Băng", district_code: "632" },
  { code: "23908", name: "Xã Ia Tôr", district_code: "632" },
  { code: "23911", name: "Xã Ia Boòng", district_code: "632" },
  { code: "23914", name: "Xã Ia O", district_code: "632" },
  { code: "23917", name: "Xã Ia Púch", district_code: "632" },
  { code: "23920", name: "Xã Ia Me", district_code: "632" },
  { code: "23923", name: "Xã Ia Vê", district_code: "632" },
  { code: "23924", name: "Xã Ia Bang", district_code: "632" },
  { code: "23926", name: "Xã Ia Pia", district_code: "632" },
  { code: "23929", name: "Xã Ia Ga", district_code: "632" },
  { code: "23932", name: "Xã Ia Lâu", district_code: "632" },
  { code: "23935", name: "Xã Ia Piơr", district_code: "632" },
  { code: "23938", name: "Xã Ia Mơ", district_code: "632" },
  { code: "23941", name: "Thị trấn Chư Sê", district_code: "633" },
  { code: "23944", name: "Xã Ia Tiêm", district_code: "633" },
  { code: "23945", name: "Xã Chư Pơng", district_code: "633" },
  { code: "23946", name: "Xã Bar Măih", district_code: "633" },
  { code: "23947", name: "Xã Bờ Ngoong", district_code: "633" },
  { code: "23950", name: "Xã Ia Glai", district_code: "633" },
  { code: "23953", name: "Xã AL Bá", district_code: "633" },
  { code: "23954", name: "Xã Kông HTok", district_code: "633" },
  { code: "23956", name: "Xã AYun", district_code: "633" },
  { code: "23959", name: "Xã Ia HLốp", district_code: "633" },
  { code: "23962", name: "Xã Ia Blang", district_code: "633" },
  { code: "23965", name: "Xã Dun", district_code: "633" },
  { code: "23966", name: "Xã Ia Pal", district_code: "633" },
  { code: "23968", name: "Xã H Bông", district_code: "633" },
  { code: "23977", name: "Xã Ia Ko", district_code: "633" },
  { code: "23989", name: "Xã Hà Tam", district_code: "634" },
  { code: "23992", name: "Xã An Thành", district_code: "634" },
  { code: "23995", name: "Thị trấn Đak Pơ", district_code: "634" },
  { code: "23998", name: "Xã Yang Bắc", district_code: "634" },
  { code: "24001", name: "Xã Cư An", district_code: "634" },
  { code: "24004", name: "Xã Tân An", district_code: "634" },
  { code: "24007", name: "Xã Phú An", district_code: "634" },
  { code: "24010", name: "Xã Ya Hội", district_code: "634" },
  { code: "24013", name: "Xã Pờ Tó", district_code: "635" },
  { code: "24016", name: "Xã Chư Răng", district_code: "635" },
  { code: "24019", name: "Xã Ia KDăm", district_code: "635" },
  { code: "24022", name: "Xã Kim Tân", district_code: "635" },
  { code: "24025", name: "Xã Chư Mố", district_code: "635" },
  { code: "24028", name: "Xã Ia Tul", district_code: "635" },
  { code: "24031", name: "Xã Ia Ma Rơn", district_code: "635" },
  { code: "24034", name: "Xã Ia Broăi", district_code: "635" },
  { code: "24037", name: "Xã Ia Trok", district_code: "635" },
  { code: "24076", name: "Thị trấn Phú Túc", district_code: "637" },
  { code: "24079", name: "Xã Ia RSai", district_code: "637" },
  { code: "24082", name: "Xã Ia RSươm", district_code: "637" },
  { code: "24085", name: "Xã Chư Gu", district_code: "637" },
  { code: "24088", name: "Xã Đất Bằng", district_code: "637" },
  { code: "24091", name: "Xã Ia Mláh", district_code: "637" },
  { code: "24094", name: "Xã Chư Drăng", district_code: "637" },
  { code: "24097", name: "Xã Phú Cần", district_code: "637" },
  { code: "24100", name: "Xã Ia HDreh", district_code: "637" },
  { code: "24103", name: "Xã Ia RMok", district_code: "637" },
  { code: "24106", name: "Xã Chư Ngọc", district_code: "637" },
  { code: "24109", name: "Xã Uar", district_code: "637" },
  { code: "24112", name: "Xã Chư Rcăm", district_code: "637" },
  { code: "24115", name: "Xã Krông Năng", district_code: "637" },
  { code: "24043", name: "Thị trấn Phú Thiện", district_code: "638" },
  { code: "24046", name: "Xã Chư A Thai", district_code: "638" },
  { code: "24048", name: "Xã Ayun Hạ", district_code: "638" },
  { code: "24049", name: "Xã Ia Ake", district_code: "638" },
  { code: "24052", name: "Xã Ia Sol", district_code: "638" },
  { code: "24055", name: "Xã Ia Piar", district_code: "638" },
  { code: "24058", name: "Xã Ia Peng", district_code: "638" },
  { code: "24060", name: "Xã Chrôh Pơnan", district_code: "638" },
  { code: "24061", name: "Xã Ia Hiao", district_code: "638" },
  { code: "24067", name: "Xã Ia Yeng", district_code: "638" },
  { code: "23942", name: "Thị trấn Nhơn Hoà", district_code: "639" },
  { code: "23971", name: "Xã Ia Hrú", district_code: "639" },
  { code: "23972", name: "Xã Ia Rong", district_code: "639" },
  { code: "23974", name: "Xã Ia Dreng", district_code: "639" },
  { code: "23978", name: "Xã Ia Hla", district_code: "639" },
  { code: "23980", name: "Xã Chư Don", district_code: "639" },
  { code: "23983", name: "Xã Ia Phang", district_code: "639" },
  { code: "23986", name: "Xã Ia Le", district_code: "639" },
  { code: "23987", name: "Xã Ia BLứ", district_code: "639" },
  { code: "24118", name: "Phường Tân Lập", district_code: "643" },
  { code: "24121", name: "Phường Tân Hòa", district_code: "643" },
  { code: "24124", name: "Phường Tân An", district_code: "643" },
  { code: "24130", name: "Phường Thành Nhất", district_code: "643" },
  { code: "24133", name: "Phường Thành Công", district_code: "643" },
  { code: "24136", name: "Phường Tân Lợi", district_code: "643" },
  { code: "24142", name: "Phường Tân Thành", district_code: "643" },
  { code: "24145", name: "Phường Tân Tiến", district_code: "643" },
  { code: "24148", name: "Phường Tự An", district_code: "643" },
  { code: "24151", name: "Phường Ea Tam", district_code: "643" },
  { code: "24154", name: "Phường Khánh Xuân", district_code: "643" },
  { code: "24157", name: "Xã Hòa Thuận", district_code: "643" },
  { code: "24160", name: "Xã Cư ÊBur", district_code: "643" },
  { code: "24163", name: "Xã Ea Tu", district_code: "643" },
  { code: "24166", name: "Xã Hòa Thắng", district_code: "643" },
  { code: "24169", name: "Xã Ea Kao", district_code: "643" },
  { code: "24172", name: "Xã Hòa Phú", district_code: "643" },
  { code: "24175", name: "Xã Hòa Khánh", district_code: "643" },
  { code: "24178", name: "Xã Hòa Xuân", district_code: "643" },
  { code: "24305", name: "Phường An Lạc", district_code: "644" },
  { code: "24308", name: "Phường An Bình", district_code: "644" },
  { code: "24311", name: "Phường Thiện An", district_code: "644" },
  { code: "24318", name: "Phường Đạt Hiếu", district_code: "644" },
  { code: "24322", name: "Phường Đoàn Kết", district_code: "644" },
  { code: "24328", name: "Xã Ea Drông", district_code: "644" },
  { code: "24331", name: "Phường Thống Nhất", district_code: "644" },
  { code: "24332", name: "Phường Bình Tân", district_code: "644" },
  { code: "24334", name: "Xã Ea Siên", district_code: "644" },
  { code: "24337", name: "Xã Bình Thuận", district_code: "644" },
  { code: "24340", name: "Xã Cư Bao", district_code: "644" },
  { code: "24181", name: "Thị trấn Ea Drăng", district_code: "645" },
  { code: "24184", name: "Xã Ea H'leo", district_code: "645" },
  { code: "24187", name: "Xã Ea Sol", district_code: "645" },
  { code: "24190", name: "Xã Ea Ral", district_code: "645" },
  { code: "24193", name: "Xã Ea Wy", district_code: "645" },
  { code: "24194", name: "Xã Cư A Mung", district_code: "645" },
  { code: "24196", name: "Xã Cư Mốt", district_code: "645" },
  { code: "24199", name: "Xã Ea Hiao", district_code: "645" },
  { code: "24202", name: "Xã Ea Khal", district_code: "645" },
  { code: "24205", name: "Xã Dliê Yang", district_code: "645" },
  { code: "24207", name: "Xã Ea Tir", district_code: "645" },
  { code: "24208", name: "Xã Ea Nam", district_code: "645" },
  { code: "24211", name: "Thị trấn Ea Súp", district_code: "646" },
  { code: "24214", name: "Xã Ia Lốp", district_code: "646" },
  { code: "24215", name: "Xã Ia JLơi", district_code: "646" },
  { code: "24217", name: "Xã Ea Rốk", district_code: "646" },
  { code: "24220", name: "Xã Ya Tờ Mốt", district_code: "646" },
  { code: "24221", name: "Xã Ia RVê", district_code: "646" },
  { code: "24223", name: "Xã Ea Lê", district_code: "646" },
  { code: "24226", name: "Xã Cư KBang", district_code: "646" },
  { code: "24229", name: "Xã Ea Bung", district_code: "646" },
  { code: "24232", name: "Xã Cư M'Lan", district_code: "646" },
  { code: "24235", name: "Xã Krông Na", district_code: "647" },
  { code: "24238", name: "Xã Ea Huar", district_code: "647" },
  { code: "24241", name: "Xã Ea Wer", district_code: "647" },
  { code: "24244", name: "Xã Tân Hoà", district_code: "647" },
  { code: "24247", name: "Xã Cuôr KNia", district_code: "647" },
  { code: "24250", name: "Xã Ea Bar", district_code: "647" },
  { code: "24253", name: "Xã Ea Nuôl", district_code: "647" },
  { code: "24256", name: "Thị trấn Ea Pốk", district_code: "648" },
  { code: "24259", name: "Thị trấn Quảng Phú", district_code: "648" },
  { code: "24262", name: "Xã Quảng Tiến", district_code: "648" },
  { code: "24264", name: "Xã Ea Kuêh", district_code: "648" },
  { code: "24265", name: "Xã Ea Kiết", district_code: "648" },
  { code: "24268", name: "Xã Ea Tar", district_code: "648" },
  { code: "24271", name: "Xã Cư Dliê M'nông", district_code: "648" },
  { code: "24274", name: "Xã Ea H'đinh", district_code: "648" },
  { code: "24277", name: "Xã Ea Tul", district_code: "648" },
  { code: "24280", name: "Xã Ea KPam", district_code: "648" },
  { code: "24283", name: "Xã Ea M'DRóh", district_code: "648" },
  { code: "24286", name: "Xã Quảng Hiệp", district_code: "648" },
  { code: "24289", name: "Xã Cư M'gar", district_code: "648" },
  { code: "24292", name: "Xã Ea D'Rơng", district_code: "648" },
  { code: "24295", name: "Xã Ea M'nang", district_code: "648" },
  { code: "24298", name: "Xã Cư Suê", district_code: "648" },
  { code: "24301", name: "Xã Cuor Đăng", district_code: "648" },
  { code: "24307", name: "Xã Cư Né", district_code: "649" },
  { code: "24310", name: "Xã Chư KBô", district_code: "649" },
  { code: "24313", name: "Xã Cư Pơng", district_code: "649" },
  { code: "24314", name: "Xã Ea Sin", district_code: "649" },
  { code: "24316", name: "Thị trấn Pơng Drang", district_code: "649" },
  { code: "24317", name: "Xã Tân Lập", district_code: "649" },
  { code: "24319", name: "Xã Ea Ngai", district_code: "649" },
  { code: "24343", name: "Thị trấn Krông Năng", district_code: "650" },
  { code: "24346", name: "Xã ĐLiê Ya", district_code: "650" },
  { code: "24349", name: "Xã Ea Tóh", district_code: "650" },
  { code: "24352", name: "Xã Ea Tam", district_code: "650" },
  { code: "24355", name: "Xã Phú Lộc", district_code: "650" },
  { code: "24358", name: "Xã Tam Giang", district_code: "650" },
  { code: "24359", name: "Xã Ea Puk", district_code: "650" },
  { code: "24360", name: "Xã Ea Dăh", district_code: "650" },
  { code: "24361", name: "Xã Ea Hồ", district_code: "650" },
  { code: "24364", name: "Xã Phú Xuân", district_code: "650" },
  { code: "24367", name: "Xã Cư Klông", district_code: "650" },
  { code: "24370", name: "Xã Ea Tân", district_code: "650" },
  { code: "24373", name: "Thị trấn Ea Kar", district_code: "651" },
  { code: "24376", name: "Thị trấn Ea Knốp", district_code: "651" },
  { code: "24379", name: "Xã Ea Sô", district_code: "651" },
  { code: "24380", name: "Xã Ea Sar", district_code: "651" },
  { code: "24382", name: "Xã Xuân Phú", district_code: "651" },
  { code: "24385", name: "Xã Cư Huê", district_code: "651" },
  { code: "24388", name: "Xã Ea Tih", district_code: "651" },
  { code: "24391", name: "Xã Ea Đar", district_code: "651" },
  { code: "24394", name: "Xã Ea Kmút", district_code: "651" },
  { code: "24397", name: "Xã Cư Ni", district_code: "651" },
  { code: "24400", name: "Xã Ea Păl", district_code: "651" },
  { code: "24401", name: "Xã Cư Prông", district_code: "651" },
  { code: "24403", name: "Xã Ea Ô", district_code: "651" },
  { code: "24404", name: "Xã Cư ELang", district_code: "651" },
  { code: "24406", name: "Xã Cư Bông", district_code: "651" },
  { code: "24409", name: "Xã Cư Jang", district_code: "651" },
  { code: "24412", name: "Thị trấn M'Đrắk", district_code: "652" },
  { code: "24415", name: "Xã Cư Prao", district_code: "652" },
  { code: "24418", name: "Xã Ea Pil", district_code: "652" },
  { code: "24421", name: "Xã Ea Lai", district_code: "652" },
  { code: "24424", name: "Xã Ea H'MLay", district_code: "652" },
  { code: "24427", name: "Xã Krông Jing", district_code: "652" },
  { code: "24430", name: "Xã Ea M' Doal", district_code: "652" },
  { code: "24433", name: "Xã Ea Riêng", district_code: "652" },
  { code: "24436", name: "Xã Cư M'ta", district_code: "652" },
  { code: "24439", name: "Xã Cư K Róa", district_code: "652" },
  { code: "24442", name: "Xã Krông Á", district_code: "652" },
  { code: "24444", name: "Xã Cư San", district_code: "652" },
  { code: "24445", name: "Xã Ea Trang", district_code: "652" },
  { code: "24448", name: "Thị trấn Krông Kmar", district_code: "653" },
  { code: "24451", name: "Xã Dang Kang", district_code: "653" },
  { code: "24454", name: "Xã Cư KTy", district_code: "653" },
  { code: "24457", name: "Xã Hòa Thành", district_code: "653" },
  { code: "24463", name: "Xã Hòa Phong", district_code: "653" },
  { code: "24466", name: "Xã Hòa Lễ", district_code: "653" },
  { code: "24469", name: "Xã Yang Reh", district_code: "653" },
  { code: "24472", name: "Xã Ea Trul", district_code: "653" },
  { code: "24475", name: "Xã Khuê Ngọc Điền", district_code: "653" },
  { code: "24478", name: "Xã Cư Pui", district_code: "653" },
  { code: "24481", name: "Xã Hòa Sơn", district_code: "653" },
  { code: "24484", name: "Xã Cư Drăm", district_code: "653" },
  { code: "24487", name: "Xã Yang Mao", district_code: "653" },
  { code: "24490", name: "Thị trấn Phước An", district_code: "654" },
  { code: "24493", name: "Xã KRông Búk", district_code: "654" },
  { code: "24496", name: "Xã Ea Kly", district_code: "654" },
  { code: "24499", name: "Xã Ea Kênh", district_code: "654" },
  { code: "24502", name: "Xã Ea Phê", district_code: "654" },
  { code: "24505", name: "Xã Ea KNuec", district_code: "654" },
  { code: "24508", name: "Xã Ea Yông", district_code: "654" },
  { code: "24511", name: "Xã Hòa An", district_code: "654" },
  { code: "24514", name: "Xã Ea Kuăng", district_code: "654" },
  { code: "24517", name: "Xã Hòa Đông", district_code: "654" },
  { code: "24520", name: "Xã Ea Hiu", district_code: "654" },
  { code: "24523", name: "Xã Hòa Tiến", district_code: "654" },
  { code: "24526", name: "Xã Tân Tiến", district_code: "654" },
  { code: "24529", name: "Xã Vụ Bổn", district_code: "654" },
  { code: "24532", name: "Xã Ea Uy", district_code: "654" },
  { code: "24535", name: "Xã Ea Yiêng", district_code: "654" },
  { code: "24538", name: "Thị trấn Buôn Trấp", district_code: "655" },
  { code: "24556", name: "Xã Dray Sáp", district_code: "655" },
  { code: "24559", name: "Xã Ea Na", district_code: "655" },
  { code: "24565", name: "Xã Ea Bông", district_code: "655" },
  { code: "24568", name: "Xã Băng A Drênh", district_code: "655" },
  { code: "24571", name: "Xã Dur KMăl", district_code: "655" },
  { code: "24574", name: "Xã Bình Hòa", district_code: "655" },
  { code: "24577", name: "Xã Quảng Điền", district_code: "655" },
  { code: "24580", name: "Thị trấn Liên Sơn", district_code: "656" },
  { code: "24583", name: "Xã Yang Tao", district_code: "656" },
  { code: "24586", name: "Xã Bông Krang", district_code: "656" },
  { code: "24589", name: "Xã Đắk Liêng", district_code: "656" },
  { code: "24592", name: "Xã Buôn Triết", district_code: "656" },
  { code: "24595", name: "Xã Buôn Tría", district_code: "656" },
  { code: "24598", name: "Xã Đắk Phơi", district_code: "656" },
  { code: "24601", name: "Xã Đắk Nuê", district_code: "656" },
  { code: "24604", name: "Xã Krông Nô", district_code: "656" },
  { code: "24607", name: "Xã Nam Ka", district_code: "656" },
  { code: "24610", name: "Xã Ea R'Bin", district_code: "656" },
  { code: "24540", name: "Xã Ea Ning", district_code: "657" },
  { code: "24541", name: "Xã Cư Ê Wi", district_code: "657" },
  { code: "24544", name: "Xã Ea Ktur", district_code: "657" },
  { code: "24547", name: "Xã Ea Tiêu", district_code: "657" },
  { code: "24550", name: "Xã Ea BHốk", district_code: "657" },
  { code: "24553", name: "Xã Ea Hu", district_code: "657" },
  { code: "24561", name: "Xã Dray Bhăng", district_code: "657" },
  { code: "24562", name: "Xã Hòa Hiệp", district_code: "657" },
  { code: "24611", name: "Phường Nghĩa Đức", district_code: "660" },
  { code: "24612", name: "Phường Nghĩa Thành", district_code: "660" },
  { code: "24614", name: "Phường Nghĩa Phú", district_code: "660" },
  { code: "24615", name: "Phường Nghĩa Tân", district_code: "660" },
  { code: "24617", name: "Phường Nghĩa Trung", district_code: "660" },
  { code: "24618", name: "Xã Đăk R'Moan", district_code: "660" },
  { code: "24619", name: "Phường Quảng Thành", district_code: "660" },
  { code: "24628", name: "Xã Đắk Nia", district_code: "660" },
  { code: "24616", name: "Xã Quảng Sơn", district_code: "661" },
  { code: "24620", name: "Xã Quảng Hoà", district_code: "661" },
  { code: "24622", name: "Xã Đắk Ha", district_code: "661" },
  { code: "24625", name: "Xã Đắk R'Măng", district_code: "661" },
  { code: "24631", name: "Xã Quảng Khê", district_code: "661" },
  { code: "24634", name: "Xã Đắk Plao", district_code: "661" },
  { code: "24637", name: "Xã Đắk Som", district_code: "661" },
  { code: "24640", name: "Thị trấn Ea T'Ling", district_code: "662" },
  { code: "24643", name: "Xã Đắk Wil", district_code: "662" },
  { code: "24646", name: "Xã Ea Pô", district_code: "662" },
  { code: "24649", name: "Xã Nam Dong", district_code: "662" },
  { code: "24652", name: "Xã Đắk DRông", district_code: "662" },
  { code: "24655", name: "Xã Tâm Thắng", district_code: "662" },
  { code: "24658", name: "Xã Cư Knia", district_code: "662" },
  { code: "24661", name: "Xã Trúc Sơn", district_code: "662" },
  { code: "24664", name: "Thị trấn Đắk Mil", district_code: "663" },
  { code: "24667", name: "Xã Đắk Lao", district_code: "663" },
  { code: "24670", name: "Xã Đắk R'La", district_code: "663" },
  { code: "24673", name: "Xã Đắk Gằn", district_code: "663" },
  { code: "24676", name: "Xã Đức Mạnh", district_code: "663" },
  { code: "24677", name: "Xã Đắk N'Drót", district_code: "663" },
  { code: "24678", name: "Xã Long Sơn", district_code: "663" },
  { code: "24679", name: "Xã Đắk Sắk", district_code: "663" },
  { code: "24682", name: "Xã Thuận An", district_code: "663" },
  { code: "24685", name: "Xã Đức Minh", district_code: "663" },
  { code: "24688", name: "Thị trấn Đắk Mâm", district_code: "664" },
  { code: "24691", name: "Xã Đắk Sôr", district_code: "664" },
  { code: "24692", name: "Xã Nam Xuân", district_code: "664" },
  { code: "24694", name: "Xã Buôn Choah", district_code: "664" },
  { code: "24697", name: "Xã Nam Đà", district_code: "664" },
  { code: "24699", name: "Xã Tân Thành", district_code: "664" },
  { code: "24700", name: "Xã Đắk Drô", district_code: "664" },
  { code: "24703", name: "Xã Nâm Nung", district_code: "664" },
  { code: "24706", name: "Xã Đức Xuyên", district_code: "664" },
  { code: "24709", name: "Xã Đắk Nang", district_code: "664" },
  { code: "24712", name: "Xã Quảng Phú", district_code: "664" },
  { code: "24715", name: "Xã Nâm N'Đir", district_code: "664" },
  { code: "24717", name: "Thị trấn Đức An", district_code: "665" },
  { code: "24718", name: "Xã Đắk Môl", district_code: "665" },
  { code: "24719", name: "Xã Đắk Hòa", district_code: "665" },
  { code: "24721", name: "Xã Nam Bình", district_code: "665" },
  { code: "24722", name: "Xã Thuận Hà", district_code: "665" },
  { code: "24724", name: "Xã Thuận Hạnh", district_code: "665" },
  { code: "24727", name: "Xã Đắk N'Dung", district_code: "665" },
  { code: "24728", name: "Xã Nâm N'Jang", district_code: "665" },
  { code: "24730", name: "Xã Trường Xuân", district_code: "665" },
  { code: "24733", name: "Thị trấn Kiến Đức", district_code: "666" },
  { code: "24745", name: "Xã Quảng Tín", district_code: "666" },
  { code: "24750", name: "Xã Đắk Wer", district_code: "666" },
  { code: "24751", name: "Xã Nhân Cơ", district_code: "666" },
  { code: "24754", name: "Xã Kiến Thành", district_code: "666" },
  { code: "24756", name: "Xã Nghĩa Thắng", district_code: "666" },
  { code: "24757", name: "Xã Đạo Nghĩa", district_code: "666" },
  { code: "24760", name: "Xã Đắk Sin", district_code: "666" },
  { code: "24761", name: "Xã Hưng Bình", district_code: "666" },
  { code: "24763", name: "Xã Đắk Ru", district_code: "666" },
  { code: "24766", name: "Xã Nhân Đạo", district_code: "666" },
  { code: "24736", name: "Xã Quảng Trực", district_code: "667" },
  { code: "24739", name: "Xã Đắk Búk So", district_code: "667" },
  { code: "24740", name: "Xã Quảng Tâm", district_code: "667" },
  { code: "24742", name: "Xã Đắk R'Tíh", district_code: "667" },
  { code: "24746", name: "Xã Đắk Ngo", district_code: "667" },
  { code: "24748", name: "Xã Quảng Tân", district_code: "667" },
  { code: "24769", name: "Phường 7", district_code: "672" },
  { code: "24772", name: "Phường 8", district_code: "672" },
  { code: "24775", name: "Phường 12", district_code: "672" },
  { code: "24778", name: "Phường 9", district_code: "672" },
  { code: "24781", name: "Phường 2", district_code: "672" },
  { code: "24784", name: "Phường 1", district_code: "672" },
  { code: "24787", name: "Phường 6", district_code: "672" },
  { code: "24790", name: "Phường 5", district_code: "672" },
  { code: "24793", name: "Phường 4", district_code: "672" },
  { code: "24796", name: "Phường 10", district_code: "672" },
  { code: "24799", name: "Phường 11", district_code: "672" },
  { code: "24802", name: "Phường 3", district_code: "672" },
  { code: "24805", name: "Xã Xuân Thọ", district_code: "672" },
  { code: "24808", name: "Xã Tà Nung", district_code: "672" },
  { code: "24810", name: "Xã Trạm Hành", district_code: "672" },
  { code: "24811", name: "Xã Xuân Trường", district_code: "672" },
  { code: "24814", name: "Phường Lộc Phát", district_code: "673" },
  { code: "24817", name: "Phường Lộc Tiến", district_code: "673" },
  { code: "24820", name: "Phường 2", district_code: "673" },
  { code: "24823", name: "Phường 1", district_code: "673" },
  { code: "24826", name: "Phường B'lao", district_code: "673" },
  { code: "24829", name: "Phường Lộc Sơn", district_code: "673" },
  { code: "24832", name: "Xã Đạm Bri", district_code: "673" },
  { code: "24835", name: "Xã Lộc Thanh", district_code: "673" },
  { code: "24838", name: "Xã Lộc Nga", district_code: "673" },
  { code: "24841", name: "Xã Lộc Châu", district_code: "673" },
  { code: "24844", name: "Xã Đại Lào", district_code: "673" },
  { code: "24853", name: "Xã Đạ Tông", district_code: "674" },
  { code: "24856", name: "Xã Đạ Long", district_code: "674" },
  { code: "24859", name: "Xã Đạ M' Rong", district_code: "674" },
  { code: "24874", name: "Xã Liêng Srônh", district_code: "674" },
  { code: "24875", name: "Xã Đạ Rsal", district_code: "674" },
  { code: "24877", name: "Xã Rô Men", district_code: "674" },
  { code: "24886", name: "Xã Phi Liêng", district_code: "674" },
  { code: "24889", name: "Xã Đạ K' Nàng", district_code: "674" },
  { code: "24846", name: "Thị trấn Lạc Dương", district_code: "675" },
  { code: "24847", name: "Xã Đạ Chais", district_code: "675" },
  { code: "24848", name: "Xã Đạ Nhim", district_code: "675" },
  { code: "24850", name: "Xã Đưng KNớ", district_code: "675" },
  { code: "24862", name: "Xã Lát", district_code: "675" },
  { code: "24865", name: "Xã Đạ Sar", district_code: "675" },
  { code: "24868", name: "Thị trấn Nam Ban", district_code: "676" },
  { code: "24871", name: "Thị trấn Đinh Văn", district_code: "676" },
  { code: "24880", name: "Xã Phú Sơn", district_code: "676" },
  { code: "24883", name: "Xã Phi Tô", district_code: "676" },
  { code: "24892", name: "Xã Mê Linh", district_code: "676" },
  { code: "24895", name: "Xã Đạ Đờn", district_code: "676" },
  { code: "24898", name: "Xã Phúc Thọ", district_code: "676" },
  { code: "24901", name: "Xã Đông Thanh", district_code: "676" },
  { code: "24904", name: "Xã Gia Lâm", district_code: "676" },
  { code: "24907", name: "Xã Tân Thanh", district_code: "676" },
  { code: "24910", name: "Xã Tân Văn", district_code: "676" },
  { code: "24913", name: "Xã Hoài Đức", district_code: "676" },
  { code: "24916", name: "Xã Tân Hà", district_code: "676" },
  { code: "24919", name: "Xã Liên Hà", district_code: "676" },
  { code: "24922", name: "Xã Đan Phượng", district_code: "676" },
  { code: "24925", name: "Xã Nam Hà", district_code: "676" },
  { code: "24928", name: "Thị trấn D'Ran", district_code: "677" },
  { code: "24931", name: "Thị trấn Thạnh Mỹ", district_code: "677" },
  { code: "24934", name: "Xã Lạc Xuân", district_code: "677" },
  { code: "24937", name: "Xã Đạ Ròn", district_code: "677" },
  { code: "24940", name: "Xã Lạc Lâm", district_code: "677" },
  { code: "24943", name: "Xã Ka Đô", district_code: "677" },
  { code: "24949", name: "Xã Ka Đơn", district_code: "677" },
  { code: "24952", name: "Xã Tu Tra", district_code: "677" },
  { code: "24955", name: "Xã Quảng Lập", district_code: "677" },
  { code: "24958", name: "Thị trấn Liên Nghĩa", district_code: "678" },
  { code: "24961", name: "Xã Hiệp An", district_code: "678" },
  { code: "24964", name: "Xã Liên Hiệp", district_code: "678" },
  { code: "24967", name: "Xã Hiệp Thạnh", district_code: "678" },
  { code: "24970", name: "Xã Bình Thạnh", district_code: "678" },
  { code: "24973", name: "Xã N'Thol Hạ", district_code: "678" },
  { code: "24976", name: "Xã Tân Hội", district_code: "678" },
  { code: "24979", name: "Xã Tân Thành", district_code: "678" },
  { code: "24982", name: "Xã Phú Hội", district_code: "678" },
  { code: "24985", name: "Xã Ninh Gia", district_code: "678" },
  { code: "24988", name: "Xã Tà Năng", district_code: "678" },
  { code: "24989", name: "Xã Đa Quyn", district_code: "678" },
  { code: "24991", name: "Xã Tà Hine", district_code: "678" },
  { code: "24994", name: "Xã Đà Loan", district_code: "678" },
  { code: "24997", name: "Xã Ninh Loan", district_code: "678" },
  { code: "25000", name: "Thị trấn Di Linh", district_code: "679" },
  { code: "25003", name: "Xã Đinh Trang Thượng", district_code: "679" },
  { code: "25006", name: "Xã Tân Thượng", district_code: "679" },
  { code: "25007", name: "Xã Tân Lâm", district_code: "679" },
  { code: "25009", name: "Xã Tân Châu", district_code: "679" },
  { code: "25012", name: "Xã Tân Nghĩa", district_code: "679" },
  { code: "25015", name: "Xã Gia Hiệp", district_code: "679" },
  { code: "25018", name: "Xã Đinh Lạc", district_code: "679" },
  { code: "25021", name: "Xã Tam Bố", district_code: "679" },
  { code: "25024", name: "Xã Đinh Trang Hòa", district_code: "679" },
  { code: "25027", name: "Xã Liên Đầm", district_code: "679" },
  { code: "25030", name: "Xã Gung Ré", district_code: "679" },
  { code: "25033", name: "Xã Bảo Thuận", district_code: "679" },
  { code: "25036", name: "Xã Hòa Ninh", district_code: "679" },
  { code: "25039", name: "Xã Hòa Trung", district_code: "679" },
  { code: "25042", name: "Xã Hòa Nam", district_code: "679" },
  { code: "25045", name: "Xã Hòa Bắc", district_code: "679" },
  { code: "25048", name: "Xã Sơn Điền", district_code: "679" },
  { code: "25051", name: "Xã Gia Bắc", district_code: "679" },
  { code: "25054", name: "Thị trấn Lộc Thắng", district_code: "680" },
  { code: "25057", name: "Xã Lộc Bảo", district_code: "680" },
  { code: "25060", name: "Xã Lộc Lâm", district_code: "680" },
  { code: "25063", name: "Xã Lộc Phú", district_code: "680" },
  { code: "25066", name: "Xã Lộc Bắc", district_code: "680" },
  { code: "25069", name: "Xã B' Lá", district_code: "680" },
  { code: "25072", name: "Xã Lộc Ngãi", district_code: "680" },
  { code: "25075", name: "Xã Lộc Quảng", district_code: "680" },
  { code: "25078", name: "Xã Lộc Tân", district_code: "680" },
  { code: "25081", name: "Xã Lộc Đức", district_code: "680" },
  { code: "25084", name: "Xã Lộc An", district_code: "680" },
  { code: "25087", name: "Xã Tân Lạc", district_code: "680" },
  { code: "25090", name: "Xã Lộc Thành", district_code: "680" },
  { code: "25093", name: "Xã Lộc Nam", district_code: "680" },
  { code: "25096", name: "Thị trấn Đạ M'ri", district_code: "682" },
  { code: "25099", name: "Thị trấn Ma Đa Guôi", district_code: "682" },
  { code: "25102", name: "Xã Đạ M'ri", district_code: "682" },
  { code: "25105", name: "Xã Hà Lâm", district_code: "682" },
  { code: "25111", name: "Xã Đạ Oai", district_code: "682" },
  { code: "25114", name: "Xã Bà Gia", district_code: "682" },
  { code: "25117", name: "Xã Ma Đa Guôi", district_code: "682" },
  { code: "25126", name: "Thị trấn Đạ Tẻh", district_code: "682" },
  { code: "25129", name: "Xã An Nhơn", district_code: "682" },
  { code: "25132", name: "Xã Quốc Oai", district_code: "682" },
  { code: "25135", name: "Xã Mỹ Đức", district_code: "682" },
  { code: "25138", name: "Xã Quảng Trị", district_code: "682" },
  { code: "25141", name: "Xã Đạ Lây", district_code: "682" },
  { code: "25153", name: "Xã Đạ Kho", district_code: "682" },
  { code: "25156", name: "Xã Đạ Pal", district_code: "682" },
  { code: "25159", name: "Thị trấn Cát Tiên", district_code: "682" },
  { code: "25162", name: "Xã Tiên Hoàng", district_code: "682" },
  { code: "25165", name: "Xã Phước Cát 2", district_code: "682" },
  { code: "25168", name: "Xã Gia Viễn", district_code: "682" },
  { code: "25171", name: "Xã Nam Ninh", district_code: "682" },
  { code: "25174", name: "Xã Mỹ Lâm", district_code: "682" },
  { code: "25177", name: "Xã Tư Nghĩa", district_code: "682" },
  { code: "25180", name: "Thị trấn Phước Cát", district_code: "682" },
  { code: "25183", name: "Xã Đức Phổ", district_code: "682" },
  { code: "25186", name: "Xã Phù Mỹ", district_code: "682" },
  { code: "25189", name: "Xã Quảng Ngãi", district_code: "682" },
  { code: "25192", name: "Xã Đồng Nai Thượng", district_code: "682" },
  { code: "25216", name: "Phường Thác Mơ", district_code: "688" },
  { code: "25217", name: "Phường Long Thủy", district_code: "688" },
  { code: "25219", name: "Phường Phước Bình", district_code: "688" },
  { code: "25220", name: "Phường Long Phước", district_code: "688" },
  { code: "25237", name: "Phường Sơn Giang", district_code: "688" },
  { code: "25245", name: "Xã Long Giang", district_code: "688" },
  { code: "25249", name: "Xã Phước Tín", district_code: "688" },
  { code: "25195", name: "Phường Tân Phú", district_code: "689" },
  { code: "25198", name: "Phường Tân Đồng", district_code: "689" },
  { code: "25201", name: "Phường Tân Bình", district_code: "689" },
  { code: "25204", name: "Phường Tân Xuân", district_code: "689" },
  { code: "25205", name: "Phường Tân Thiện", district_code: "689" },
  { code: "25207", name: "Xã Tân Thành", district_code: "689" },
  { code: "25210", name: "Phường Tiến Thành", district_code: "689" },
  { code: "25213", name: "Xã Tiến Hưng", district_code: "689" },
  { code: "25320", name: "Phường Hưng Chiến", district_code: "690" },
  { code: "25324", name: "Phường An Lộc", district_code: "690" },
  { code: "25325", name: "Phường Phú Thịnh", district_code: "690" },
  { code: "25326", name: "Phường Phú Đức", district_code: "690" },
  { code: "25333", name: "Xã Thanh Lương", district_code: "690" },
  { code: "25336", name: "Xã Thanh Phú", district_code: "690" },
  { code: "25222", name: "Xã Bù Gia Mập", district_code: "691" },
  { code: "25225", name: "Xã Đak Ơ", district_code: "691" },
  { code: "25228", name: "Xã Đức Hạnh", district_code: "691" },
  { code: "25229", name: "Xã Phú Văn", district_code: "691" },
  { code: "25231", name: "Xã Đa Kia", district_code: "691" },
  { code: "25232", name: "Xã Phước Minh", district_code: "691" },
  { code: "25234", name: "Xã Bình Thắng", district_code: "691" },
  { code: "25267", name: "Xã Phú Nghĩa", district_code: "691" },
  { code: "25270", name: "Thị trấn Lộc Ninh", district_code: "692" },
  { code: "25273", name: "Xã Lộc Hòa", district_code: "692" },
  { code: "25276", name: "Xã Lộc An", district_code: "692" },
  { code: "25279", name: "Xã Lộc Tấn", district_code: "692" },
  { code: "25280", name: "Xã Lộc Thạnh", district_code: "692" },
  { code: "25282", name: "Xã Lộc Hiệp", district_code: "692" },
  { code: "25285", name: "Xã Lộc Thiện", district_code: "692" },
  { code: "25288", name: "Xã Lộc Thuận", district_code: "692" },
  { code: "25291", name: "Xã Lộc Quang", district_code: "692" },
  { code: "25292", name: "Xã Lộc Phú", district_code: "692" },
  { code: "25294", name: "Xã Lộc Thành", district_code: "692" },
  { code: "25297", name: "Xã Lộc Thái", district_code: "692" },
  { code: "25300", name: "Xã Lộc Điền", district_code: "692" },
  { code: "25303", name: "Xã Lộc Hưng", district_code: "692" },
  { code: "25305", name: "Xã Lộc Thịnh", district_code: "692" },
  { code: "25306", name: "Xã Lộc Khánh", district_code: "692" },
  { code: "25308", name: "Thị trấn Thanh Bình", district_code: "693" },
  { code: "25309", name: "Xã Hưng Phước", district_code: "693" },
  { code: "25310", name: "Xã Phước Thiện", district_code: "693" },
  { code: "25312", name: "Xã Thiện Hưng", district_code: "693" },
  { code: "25315", name: "Xã Thanh Hòa", district_code: "693" },
  { code: "25318", name: "Xã Tân Thành", district_code: "693" },
  { code: "25321", name: "Xã Tân Tiến", district_code: "693" },
  { code: "25327", name: "Xã Thanh An", district_code: "694" },
  { code: "25330", name: "Xã An Khương", district_code: "694" },
  { code: "25339", name: "Xã An Phú", district_code: "694" },
  { code: "25342", name: "Xã Tân Lợi", district_code: "694" },
  { code: "25345", name: "Xã Tân Hưng", district_code: "694" },
  { code: "25348", name: "Xã Minh Đức", district_code: "694" },
  { code: "25349", name: "Xã Minh Tâm", district_code: "694" },
  { code: "25351", name: "Xã Phước An", district_code: "694" },
  { code: "25354", name: "Xã Thanh Bình", district_code: "694" },
  { code: "25357", name: "Thị trấn Tân Khai", district_code: "694" },
  { code: "25360", name: "Xã Đồng Nơ", district_code: "694" },
  { code: "25361", name: "Xã Tân Hiệp", district_code: "694" },
  { code: "25438", name: "Xã Tân Quan", district_code: "694" },
  { code: "25363", name: "Thị trấn Tân Phú", district_code: "695" },
  { code: "25366", name: "Xã Thuận Lợi", district_code: "695" },
  { code: "25369", name: "Xã Đồng Tâm", district_code: "695" },
  { code: "25372", name: "Xã Tân Phước", district_code: "695" },
  { code: "25375", name: "Xã Tân Hưng", district_code: "695" },
  { code: "25378", name: "Xã Tân Lợi", district_code: "695" },
  { code: "25381", name: "Xã Tân Lập", district_code: "695" },
  { code: "25384", name: "Xã Tân Hòa", district_code: "695" },
  { code: "25387", name: "Xã Thuận Phú", district_code: "695" },
  { code: "25390", name: "Xã Đồng Tiến", district_code: "695" },
  { code: "25393", name: "Xã Tân Tiến", district_code: "695" },
  { code: "25396", name: "Thị trấn Đức Phong", district_code: "696" },
  { code: "25398", name: "Xã Đường 10", district_code: "696" },
  { code: "25399", name: "Xã Đak Nhau", district_code: "696" },
  { code: "25400", name: "Xã Phú Sơn", district_code: "696" },
  { code: "25402", name: "Xã Thọ Sơn", district_code: "696" },
  { code: "25404", name: "Xã Bình Minh", district_code: "696" },
  { code: "25405", name: "Xã Bom Bo", district_code: "696" },
  { code: "25408", name: "Xã Minh Hưng", district_code: "696" },
  { code: "25411", name: "Xã Đoàn Kết", district_code: "696" },
  { code: "25414", name: "Xã Đồng Nai", district_code: "696" },
  { code: "25417", name: "Xã Đức Liễu", district_code: "696" },
  { code: "25420", name: "Xã Thống Nhất", district_code: "696" },
  { code: "25423", name: "Xã Nghĩa Trung", district_code: "696" },
  { code: "25424", name: "Xã Nghĩa Bình", district_code: "696" },
  { code: "25426", name: "Xã Đăng Hà", district_code: "696" },
  { code: "25429", name: "Xã Phước Sơn", district_code: "696" },
  { code: "25432", name: "Phường Hưng Long", district_code: "697" },
  { code: "25433", name: "Phường Thành Tâm", district_code: "697" },
  { code: "25435", name: "Xã Minh Lập", district_code: "697" },
  { code: "25439", name: "Xã Quang Minh", district_code: "697" },
  { code: "25441", name: "Phường Minh Hưng", district_code: "697" },
  { code: "25444", name: "Phường Minh Long", district_code: "697" },
  { code: "25447", name: "Phường Minh Thành", district_code: "697" },
  { code: "25450", name: "Xã Nha Bích", district_code: "697" },
  { code: "25453", name: "Xã Minh Thắng", district_code: "697" },
  { code: "25240", name: "Xã Long Bình", district_code: "698" },
  { code: "25243", name: "Xã Bình Tân", district_code: "698" },
  { code: "25244", name: "Xã Bình Sơn", district_code: "698" },
  { code: "25246", name: "Xã Long Hưng", district_code: "698" },
  { code: "25250", name: "Xã Phước Tân", district_code: "698" },
  { code: "25252", name: "Xã Bù Nho", district_code: "698" },
  { code: "25255", name: "Xã Long Hà", district_code: "698" },
  { code: "25258", name: "Xã Long Tân", district_code: "698" },
  { code: "25261", name: "Xã Phú Trung", district_code: "698" },
  { code: "25264", name: "Xã Phú Riềng", district_code: "698" },
  { code: "25456", name: "Phường 1", district_code: "703" },
  { code: "25459", name: "Phường 3", district_code: "703" },
  { code: "25462", name: "Phường 4", district_code: "703" },
  { code: "25465", name: "Phường Hiệp Ninh", district_code: "703" },
  { code: "25468", name: "Phường 2", district_code: "703" },
  { code: "25471", name: "Xã Thạnh Tân", district_code: "703" },
  { code: "25474", name: "Xã Tân Bình", district_code: "703" },
  { code: "25477", name: "Xã Bình Minh", district_code: "703" },
  { code: "25480", name: "Phường Ninh Sơn", district_code: "703" },
  { code: "25483", name: "Phường Ninh Thạnh", district_code: "703" },
  { code: "25486", name: "Thị trấn Tân Biên", district_code: "705" },
  { code: "25489", name: "Xã Tân Lập", district_code: "705" },
  { code: "25492", name: "Xã Thạnh Bắc", district_code: "705" },
  { code: "25495", name: "Xã Tân Bình", district_code: "705" },
  { code: "25498", name: "Xã Thạnh Bình", district_code: "705" },
  { code: "25501", name: "Xã Thạnh Tây", district_code: "705" },
  { code: "25504", name: "Xã Hòa Hiệp", district_code: "705" },
  { code: "25507", name: "Xã Tân Phong", district_code: "705" },
  { code: "25510", name: "Xã Mỏ Công", district_code: "705" },
  { code: "25513", name: "Xã Trà Vong", district_code: "705" },
  { code: "25516", name: "Thị trấn Tân Châu", district_code: "706" },
  { code: "25519", name: "Xã Tân Hà", district_code: "706" },
  { code: "25522", name: "Xã Tân Đông", district_code: "706" },
  { code: "25525", name: "Xã Tân Hội", district_code: "706" },
  { code: "25528", name: "Xã Tân Hòa", district_code: "706" },
  { code: "25531", name: "Xã Suối Ngô", district_code: "706" },
  { code: "25534", name: "Xã Suối Dây", district_code: "706" },
  { code: "25537", name: "Xã Tân Hiệp", district_code: "706" },
  { code: "25540", name: "Xã Thạnh Đông", district_code: "706" },
  { code: "25543", name: "Xã Tân Thành", district_code: "706" },
  { code: "25546", name: "Xã Tân Phú", district_code: "706" },
  { code: "25549", name: "Xã Tân Hưng", district_code: "706" },
  { code: "25552", name: "Thị trấn Dương Minh Châu", district_code: "707" },
  { code: "25555", name: "Xã Suối Đá", district_code: "707" },
  { code: "25558", name: "Xã Phan", district_code: "707" },
  { code: "25561", name: "Xã Phước Ninh", district_code: "707" },
  { code: "25564", name: "Xã Phước Minh", district_code: "707" },
  { code: "25567", name: "Xã Bàu Năng", district_code: "707" },
  { code: "25570", name: "Xã Chà Là", district_code: "707" },
  { code: "25573", name: "Xã Cầu Khởi", district_code: "707" },
  { code: "25576", name: "Xã Bến Củi", district_code: "707" },
  { code: "25579", name: "Xã Lộc Ninh", district_code: "707" },
  { code: "25582", name: "Xã Truông Mít", district_code: "707" },
  { code: "25585", name: "Thị trấn Châu Thành", district_code: "708" },
  { code: "25588", name: "Xã Hảo Đước", district_code: "708" },
  { code: "25591", name: "Xã Phước Vinh", district_code: "708" },
  { code: "25594", name: "Xã Đồng Khởi", district_code: "708" },
  { code: "25597", name: "Xã Thái Bình", district_code: "708" },
  { code: "25600", name: "Xã An Cơ", district_code: "708" },
  { code: "25603", name: "Xã Biên Giới", district_code: "708" },
  { code: "25606", name: "Xã Hòa Thạnh", district_code: "708" },
  { code: "25609", name: "Xã Trí Bình", district_code: "708" },
  { code: "25612", name: "Xã Hòa Hội", district_code: "708" },
  { code: "25615", name: "Xã An Bình", district_code: "708" },
  { code: "25618", name: "Xã Thanh Điền", district_code: "708" },
  { code: "25621", name: "Xã Thành Long", district_code: "708" },
  { code: "25624", name: "Xã Ninh Điền", district_code: "708" },
  { code: "25627", name: "Xã Long Vĩnh", district_code: "708" },
  { code: "25630", name: "Phường Long Hoa", district_code: "709" },
  { code: "25633", name: "Phường Hiệp Tân", district_code: "709" },
  { code: "25636", name: "Phường Long Thành Bắc", district_code: "709" },
  { code: "25639", name: "Xã Trường Hòa", district_code: "709" },
  { code: "25642", name: "Xã Trường Đông", district_code: "709" },
  { code: "25645", name: "Phường Long Thành Trung", district_code: "709" },
  { code: "25648", name: "Xã Trường Tây", district_code: "709" },
  { code: "25651", name: "Xã Long Thành Nam", district_code: "709" },
  { code: "25654", name: "Thị trấn Gò Dầu", district_code: "710" },
  { code: "25657", name: "Xã Thạnh Đức", district_code: "710" },
  { code: "25660", name: "Xã Cẩm Giang", district_code: "710" },
  { code: "25663", name: "Xã Hiệp Thạnh", district_code: "710" },
  { code: "25666", name: "Xã Bàu Đồn", district_code: "710" },
  { code: "25669", name: "Xã Phước Thạnh", district_code: "710" },
  { code: "25672", name: "Xã Phước Đông", district_code: "710" },
  { code: "25675", name: "Xã Phước Trạch", district_code: "710" },
  { code: "25678", name: "Xã Thanh Phước", district_code: "710" },
  { code: "25681", name: "Thị trấn Bến Cầu", district_code: "711" },
  { code: "25684", name: "Xã Long Chữ", district_code: "711" },
  { code: "25687", name: "Xã Long Phước", district_code: "711" },
  { code: "25690", name: "Xã Long Giang", district_code: "711" },
  { code: "25693", name: "Xã Tiên Thuận", district_code: "711" },
  { code: "25696", name: "Xã Long Khánh", district_code: "711" },
  { code: "25699", name: "Xã Lợi Thuận", district_code: "711" },
  { code: "25702", name: "Xã Long Thuận", district_code: "711" },
  { code: "25705", name: "Xã An Thạnh", district_code: "711" },
  { code: "25708", name: "Phường Trảng Bàng", district_code: "712" },
  { code: "25711", name: "Xã Đôn Thuận", district_code: "712" },
  { code: "25714", name: "Xã Hưng Thuận", district_code: "712" },
  { code: "25717", name: "Phường Lộc Hưng", district_code: "712" },
  { code: "25720", name: "Phường Gia Lộc", district_code: "712" },
  { code: "25723", name: "Phường Gia Bình", district_code: "712" },
  { code: "25729", name: "Xã Phước Bình", district_code: "712" },
  { code: "25732", name: "Phường An Tịnh", district_code: "712" },
  { code: "25735", name: "Phường An Hòa", district_code: "712" },
  { code: "25738", name: "Xã Phước Chỉ", district_code: "712" },
  { code: "25741", name: "Phường Hiệp Thành", district_code: "718" },
  { code: "25744", name: "Phường Phú Lợi", district_code: "718" },
  { code: "25747", name: "Phường Phú Cường", district_code: "718" },
  { code: "25750", name: "Phường Phú Hòa", district_code: "718" },
  { code: "25753", name: "Phường Phú Thọ", district_code: "718" },
  { code: "25756", name: "Phường Chánh Nghĩa", district_code: "718" },
  { code: "25759", name: "Phường Định Hoà", district_code: "718" },
  { code: "25760", name: "Phường Hoà Phú", district_code: "718" },
  { code: "25762", name: "Phường Phú Mỹ", district_code: "718" },
  { code: "25763", name: "Phường Phú Tân", district_code: "718" },
  { code: "25765", name: "Phường Tân An", district_code: "718" },
  { code: "25768", name: "Phường Hiệp An", district_code: "718" },
  { code: "25771", name: "Phường Tương Bình Hiệp", district_code: "718" },
  { code: "25774", name: "Phường Chánh Mỹ", district_code: "718" },
  { code: "25816", name: "Xã Trừ Văn Thố", district_code: "719" },
  { code: "25819", name: "Xã Cây Trường II", district_code: "719" },
  { code: "25822", name: "Thị trấn Lai Uyên", district_code: "719" },
  { code: "25825", name: "Xã Tân Hưng", district_code: "719" },
  { code: "25828", name: "Xã Long Nguyên", district_code: "719" },
  { code: "25831", name: "Xã Hưng Hòa", district_code: "719" },
  { code: "25834", name: "Xã Lai Hưng", district_code: "719" },
  { code: "25777", name: "Thị trấn Dầu Tiếng", district_code: "720" },
  { code: "25780", name: "Xã Minh Hoà", district_code: "720" },
  { code: "25783", name: "Xã Minh Thạnh", district_code: "720" },
  { code: "25786", name: "Xã Minh Tân", district_code: "720" },
  { code: "25789", name: "Xã Định An", district_code: "720" },
  { code: "25792", name: "Xã Long Hoà", district_code: "720" },
  { code: "25795", name: "Xã Định Thành", district_code: "720" },
  { code: "25798", name: "Xã Định Hiệp", district_code: "720" },
  { code: "25801", name: "Xã An Lập", district_code: "720" },
  { code: "25804", name: "Xã Long Tân", district_code: "720" },
  { code: "25807", name: "Xã Thanh An", district_code: "720" },
  { code: "25810", name: "Xã Thanh Tuyền", district_code: "720" },
  { code: "25813", name: "Phường Mỹ Phước", district_code: "721" },
  { code: "25837", name: "Phường Chánh Phú Hòa", district_code: "721" },
  { code: "25840", name: "Phường An Điền", district_code: "721" },
  { code: "25843", name: "Phường An Tây", district_code: "721" },
  { code: "25846", name: "Phường Thới Hòa", district_code: "721" },
  { code: "25849", name: "Phường Hòa Lợi", district_code: "721" },
  { code: "25852", name: "Phường Tân Định", district_code: "721" },
  { code: "25855", name: "Xã Phú An", district_code: "721" },
  { code: "25858", name: "Thị trấn Phước Vĩnh", district_code: "722" },
  { code: "25861", name: "Xã An Linh", district_code: "722" },
  { code: "25864", name: "Xã Phước Sang", district_code: "722" },
  { code: "25865", name: "Xã An Thái", district_code: "722" },
  { code: "25867", name: "Xã An Long", district_code: "722" },
  { code: "25870", name: "Xã An Bình", district_code: "722" },
  { code: "25873", name: "Xã Tân Hiệp", district_code: "722" },
  { code: "25876", name: "Xã Tam Lập", district_code: "722" },
  { code: "25879", name: "Xã Tân Long", district_code: "722" },
  { code: "25882", name: "Xã Vĩnh Hoà", district_code: "722" },
  { code: "25885", name: "Xã Phước Hoà", district_code: "722" },
  { code: "25888", name: "Phường Uyên Hưng", district_code: "723" },
  { code: "25891", name: "Phường Tân Phước Khánh", district_code: "723" },
  { code: "25912", name: "Phường Vĩnh Tân", district_code: "723" },
  { code: "25915", name: "Phường Hội Nghĩa", district_code: "723" },
  { code: "25920", name: "Phường Tân Hiệp", district_code: "723" },
  { code: "25921", name: "Phường Khánh Bình", district_code: "723" },
  { code: "25924", name: "Phường Phú Chánh", district_code: "723" },
  { code: "25930", name: "Xã Bạch Đằng", district_code: "723" },
  { code: "25933", name: "Phường Tân Vĩnh Hiệp", district_code: "723" },
  { code: "25936", name: "Phường Thạnh Phước", district_code: "723" },
  { code: "25937", name: "Xã Thạnh Hội", district_code: "723" },
  { code: "25939", name: "Phường Thái Hòa", district_code: "723" },
  { code: "25942", name: "Phường Dĩ An", district_code: "724" },
  { code: "25945", name: "Phường Tân Bình", district_code: "724" },
  { code: "25948", name: "Phường Tân Đông Hiệp", district_code: "724" },
  { code: "25951", name: "Phường Bình An", district_code: "724" },
  { code: "25954", name: "Phường Bình Thắng", district_code: "724" },
  { code: "25957", name: "Phường Đông Hòa", district_code: "724" },
  { code: "25960", name: "Phường An Bình", district_code: "724" },
  { code: "25963", name: "Phường An Thạnh", district_code: "725" },
  { code: "25966", name: "Phường Lái Thiêu", district_code: "725" },
  { code: "25969", name: "Phường Bình Chuẩn", district_code: "725" },
  { code: "25972", name: "Phường Thuận Giao", district_code: "725" },
  { code: "25975", name: "Phường An Phú", district_code: "725" },
  { code: "25978", name: "Phường Hưng Định", district_code: "725" },
  { code: "25981", name: "Xã An Sơn", district_code: "725" },
  { code: "25984", name: "Phường Bình Nhâm", district_code: "725" },
  { code: "25987", name: "Phường Bình Hòa", district_code: "725" },
  { code: "25990", name: "Phường Vĩnh Phú", district_code: "725" },
  { code: "25894", name: "Xã Tân Định", district_code: "726" },
  { code: "25897", name: "Xã Bình Mỹ", district_code: "726" },
  { code: "25900", name: "Thị trấn Tân Bình", district_code: "726" },
  { code: "25903", name: "Xã Tân Lập", district_code: "726" },
  { code: "25906", name: "Thị trấn Tân Thành", district_code: "726" },
  { code: "25907", name: "Xã Đất Cuốc", district_code: "726" },
  { code: "25908", name: "Xã Hiếu Liêm", district_code: "726" },
  { code: "25909", name: "Xã Lạc An", district_code: "726" },
  { code: "25918", name: "Xã Tân Mỹ", district_code: "726" },
  { code: "25927", name: "Xã Thường Tân", district_code: "726" },
  { code: "25993", name: "Phường Trảng Dài", district_code: "731" },
  { code: "25996", name: "Phường Tân Phong", district_code: "731" },
  { code: "25999", name: "Phường Tân Biên", district_code: "731" },
  { code: "26002", name: "Phường Hố Nai", district_code: "731" },
  { code: "26005", name: "Phường Tân Hòa", district_code: "731" },
  { code: "26008", name: "Phường Tân Hiệp", district_code: "731" },
  { code: "26011", name: "Phường Bửu Long", district_code: "731" },
  { code: "26014", name: "Phường Tân Mai", district_code: "731" },
  { code: "26017", name: "Phường Tam Hiệp", district_code: "731" },
  { code: "26020", name: "Phường Long Bình", district_code: "731" },
  { code: "26023", name: "Phường Quang Vinh", district_code: "731" },
  { code: "26029", name: "Phường Thống Nhất", district_code: "731" },
  { code: "26041", name: "Phường Trung Dũng", district_code: "731" },
  { code: "26047", name: "Phường Bình Đa", district_code: "731" },
  { code: "26050", name: "Phường An Bình", district_code: "731" },
  { code: "26053", name: "Phường Bửu Hòa", district_code: "731" },
  { code: "26056", name: "Phường Long Bình Tân", district_code: "731" },
  { code: "26059", name: "Phường Tân Vạn", district_code: "731" },
  { code: "26062", name: "Phường Tân Hạnh", district_code: "731" },
  { code: "26065", name: "Phường Hiệp Hòa", district_code: "731" },
  { code: "26068", name: "Phường Hóa An", district_code: "731" },
  { code: "26371", name: "Phường An Hòa", district_code: "731" },
  { code: "26374", name: "Phường Tam Phước", district_code: "731" },
  { code: "26377", name: "Phường Phước Tân", district_code: "731" },
  { code: "26380", name: "Xã Long Hưng", district_code: "731" },
  { code: "26077", name: "Phường Xuân Bình", district_code: "732" },
  { code: "26080", name: "Phường Xuân An", district_code: "732" },
  { code: "26083", name: "Phường Xuân Hoà", district_code: "732" },
  { code: "26086", name: "Phường Phú Bình", district_code: "732" },
  { code: "26089", name: "Xã Bình Lộc", district_code: "732" },
  { code: "26092", name: "Xã Bảo Quang", district_code: "732" },
  { code: "26095", name: "Phường Suối Tre", district_code: "732" },
  { code: "26098", name: "Phường Bảo Vinh", district_code: "732" },
  { code: "26101", name: "Phường Xuân Lập", district_code: "732" },
  { code: "26104", name: "Phường Bàu Sen", district_code: "732" },
  { code: "26107", name: "Xã Bàu Trâm", district_code: "732" },
  { code: "26110", name: "Phường Xuân Tân", district_code: "732" },
  { code: "26113", name: "Xã Hàng Gòn", district_code: "732" },
  { code: "26116", name: "Thị trấn Tân Phú", district_code: "734" },
  { code: "26119", name: "Xã Dak Lua", district_code: "734" },
  { code: "26122", name: "Xã Nam Cát Tiên", district_code: "734" },
  { code: "26125", name: "Xã Phú An", district_code: "734" },
  { code: "26131", name: "Xã Tà Lài", district_code: "734" },
  { code: "26134", name: "Xã Phú Lập", district_code: "734" },
  { code: "26140", name: "Xã Phú Thịnh", district_code: "734" },
  { code: "26143", name: "Xã Thanh Sơn", district_code: "734" },
  { code: "26146", name: "Xã Phú Sơn", district_code: "734" },
  { code: "26149", name: "Xã Phú Xuân", district_code: "734" },
  { code: "26152", name: "Xã Phú Lộc", district_code: "734" },
  { code: "26155", name: "Xã Phú Lâm", district_code: "734" },
  { code: "26158", name: "Xã Phú Bình", district_code: "734" },
  { code: "26161", name: "Xã Phú Thanh", district_code: "734" },
  { code: "26164", name: "Xã Trà Cổ", district_code: "734" },
  { code: "26167", name: "Xã Phú Điền", district_code: "734" },
  { code: "26170", name: "Thị trấn Vĩnh An", district_code: "735" },
  { code: "26173", name: "Xã Phú Lý", district_code: "735" },
  { code: "26176", name: "Xã Trị An", district_code: "735" },
  { code: "26179", name: "Xã Tân An", district_code: "735" },
  { code: "26182", name: "Xã Vĩnh Tân", district_code: "735" },
  { code: "26185", name: "Xã Bình Lợi", district_code: "735" },
  { code: "26188", name: "Xã Thạnh Phú", district_code: "735" },
  { code: "26191", name: "Xã Thiện Tân", district_code: "735" },
  { code: "26194", name: "Xã Tân Bình", district_code: "735" },
  { code: "26200", name: "Xã Mã Đà", district_code: "735" },
  { code: "26206", name: "Thị trấn Định Quán", district_code: "736" },
  { code: "26209", name: "Xã Thanh Sơn", district_code: "736" },
  { code: "26212", name: "Xã Phú Tân", district_code: "736" },
  { code: "26215", name: "Xã Phú Vinh", district_code: "736" },
  { code: "26218", name: "Xã Phú Lợi", district_code: "736" },
  { code: "26221", name: "Xã Phú Hòa", district_code: "736" },
  { code: "26224", name: "Xã Ngọc Định", district_code: "736" },
  { code: "26227", name: "Xã La Ngà", district_code: "736" },
  { code: "26230", name: "Xã Gia Canh", district_code: "736" },
  { code: "26233", name: "Xã Phú Ngọc", district_code: "736" },
  { code: "26236", name: "Xã Phú Cường", district_code: "736" },
  { code: "26239", name: "Xã Túc Trưng", district_code: "736" },
  { code: "26242", name: "Xã Phú Túc", district_code: "736" },
  { code: "26245", name: "Xã Suối Nho", district_code: "736" },
  { code: "26248", name: "Thị trấn Trảng Bom", district_code: "737" },
  { code: "26251", name: "Xã Thanh Bình", district_code: "737" },
  { code: "26254", name: "Xã Cây Gáo", district_code: "737" },
  { code: "26257", name: "Xã Bàu Hàm", district_code: "737" },
  { code: "26260", name: "Xã Sông Thao", district_code: "737" },
  { code: "26263", name: "Xã Sông Trầu", district_code: "737" },
  { code: "26266", name: "Xã Đông Hoà", district_code: "737" },
  { code: "26269", name: "Xã Bắc Sơn", district_code: "737" },
  { code: "26272", name: "Xã Hố Nai 3", district_code: "737" },
  { code: "26275", name: "Xã Tây Hoà", district_code: "737" },
  { code: "26278", name: "Xã Bình Minh", district_code: "737" },
  { code: "26281", name: "Xã Trung Hoà", district_code: "737" },
  { code: "26284", name: "Xã Đồi 61", district_code: "737" },
  { code: "26287", name: "Xã Hưng Thịnh", district_code: "737" },
  { code: "26290", name: "Xã Quảng Tiến", district_code: "737" },
  { code: "26293", name: "Xã Giang Điền", district_code: "737" },
  { code: "26296", name: "Xã An Viễn", district_code: "737" },
  { code: "26299", name: "Xã Gia Tân 1", district_code: "738" },
  { code: "26302", name: "Xã Gia Tân 2", district_code: "738" },
  { code: "26305", name: "Xã Gia Tân 3", district_code: "738" },
  { code: "26308", name: "Xã Gia Kiệm", district_code: "738" },
  { code: "26311", name: "Xã Quang Trung", district_code: "738" },
  { code: "26314", name: "Xã Bàu Hàm 2", district_code: "738" },
  { code: "26317", name: "Xã Hưng Lộc", district_code: "738" },
  { code: "26320", name: "Xã Lộ 25", district_code: "738" },
  { code: "26323", name: "Xã Xuân Thiện", district_code: "738" },
  { code: "26326", name: "Thị trấn Dầu Giây", district_code: "738" },
  { code: "26329", name: "Xã Sông Nhạn", district_code: "739" },
  { code: "26332", name: "Xã Xuân Quế", district_code: "739" },
  { code: "26335", name: "Xã Nhân Nghĩa", district_code: "739" },
  { code: "26338", name: "Xã Xuân Đường", district_code: "739" },
  { code: "26341", name: "Thị trấn Long Giao", district_code: "739" },
  { code: "26344", name: "Xã Xuân Mỹ", district_code: "739" },
  { code: "26347", name: "Xã Thừa Đức", district_code: "739" },
  { code: "26350", name: "Xã Bảo Bình", district_code: "739" },
  { code: "26353", name: "Xã Xuân Bảo", district_code: "739" },
  { code: "26356", name: "Xã Xuân Tây", district_code: "739" },
  { code: "26359", name: "Xã Xuân Đông", district_code: "739" },
  { code: "26362", name: "Xã Sông Ray", district_code: "739" },
  { code: "26365", name: "Xã Lâm San", district_code: "739" },
  { code: "26368", name: "Thị trấn Long Thành", district_code: "740" },
  { code: "26383", name: "Xã An Phước", district_code: "740" },
  { code: "26386", name: "Xã Bình An", district_code: "740" },
  { code: "26389", name: "Xã Long Đức", district_code: "740" },
  { code: "26392", name: "Xã Lộc An", district_code: "740" },
  { code: "26395", name: "Xã Bình Sơn", district_code: "740" },
  { code: "26398", name: "Xã Tam An", district_code: "740" },
  { code: "26401", name: "Xã Cẩm Đường", district_code: "740" },
  { code: "26404", name: "Xã Long An", district_code: "740" },
  { code: "26410", name: "Xã Bàu Cạn", district_code: "740" },
  { code: "26413", name: "Xã Long Phước", district_code: "740" },
  { code: "26416", name: "Xã Phước Bình", district_code: "740" },
  { code: "26419", name: "Xã Tân Hiệp", district_code: "740" },
  { code: "26422", name: "Xã Phước Thái", district_code: "740" },
  { code: "26425", name: "Thị trấn Gia Ray", district_code: "741" },
  { code: "26428", name: "Xã Xuân Bắc", district_code: "741" },
  { code: "26431", name: "Xã Suối Cao", district_code: "741" },
  { code: "26434", name: "Xã Xuân Thành", district_code: "741" },
  { code: "26437", name: "Xã Xuân Thọ", district_code: "741" },
  { code: "26440", name: "Xã Xuân Trường", district_code: "741" },
  { code: "26443", name: "Xã Xuân Hòa", district_code: "741" },
  { code: "26446", name: "Xã Xuân Hưng", district_code: "741" },
  { code: "26449", name: "Xã Xuân Tâm", district_code: "741" },
  { code: "26452", name: "Xã Suối Cát", district_code: "741" },
  { code: "26455", name: "Xã Xuân Hiệp", district_code: "741" },
  { code: "26458", name: "Xã Xuân Phú", district_code: "741" },
  { code: "26461", name: "Xã Xuân Định", district_code: "741" },
  { code: "26464", name: "Xã Bảo Hoà", district_code: "741" },
  { code: "26467", name: "Xã Lang Minh", district_code: "741" },
  { code: "26470", name: "Xã Phước Thiền", district_code: "742" },
  { code: "26473", name: "Xã Long Tân", district_code: "742" },
  { code: "26476", name: "Xã Đại Phước", district_code: "742" },
  { code: "26479", name: "Thị trấn Hiệp Phước", district_code: "742" },
  { code: "26482", name: "Xã Phú Hữu", district_code: "742" },
  { code: "26485", name: "Xã Phú Hội", district_code: "742" },
  { code: "26488", name: "Xã Phú Thạnh", district_code: "742" },
  { code: "26491", name: "Xã Phú Đông", district_code: "742" },
  { code: "26494", name: "Xã Long Thọ", district_code: "742" },
  { code: "26497", name: "Xã Vĩnh Thanh", district_code: "742" },
  { code: "26500", name: "Xã Phước Khánh", district_code: "742" },
  { code: "26503", name: "Xã Phước An", district_code: "742" },
  { code: "26506", name: "Phường 1", district_code: "747" },
  { code: "26508", name: "Phường Thắng Tam", district_code: "747" },
  { code: "26509", name: "Phường 2", district_code: "747" },
  { code: "26512", name: "Phường 3", district_code: "747" },
  { code: "26515", name: "Phường 4", district_code: "747" },
  { code: "26518", name: "Phường 5", district_code: "747" },
  { code: "26521", name: "Phường Thắng Nhì", district_code: "747" },
  { code: "26524", name: "Phường 7", district_code: "747" },
  { code: "26526", name: "Phường Nguyễn An Ninh", district_code: "747" },
  { code: "26527", name: "Phường 8", district_code: "747" },
  { code: "26530", name: "Phường 9", district_code: "747" },
  { code: "26533", name: "Phường Thắng Nhất", district_code: "747" },
  { code: "26535", name: "Phường Rạch Dừa", district_code: "747" },
  { code: "26536", name: "Phường 10", district_code: "747" },
  { code: "26539", name: "Phường 11", district_code: "747" },
  { code: "26542", name: "Phường 12", district_code: "747" },
  { code: "26545", name: "Xã Long Sơn", district_code: "747" },
  { code: "26548", name: "Phường Phước Hưng", district_code: "748" },
  { code: "26554", name: "Phường Phước Nguyên", district_code: "748" },
  { code: "26557", name: "Phường Long Toàn", district_code: "748" },
  { code: "26558", name: "Phường Long Tâm", district_code: "748" },
  { code: "26560", name: "Phường Phước Trung", district_code: "748" },
  { code: "26563", name: "Phường Long Hương", district_code: "748" },
  { code: "26566", name: "Phường Kim Dinh", district_code: "748" },
  { code: "26567", name: "Xã Tân Hưng", district_code: "748" },
  { code: "26569", name: "Xã Long Phước", district_code: "748" },
  { code: "26572", name: "Xã Hoà Long", district_code: "748" },
  { code: "26574", name: "Xã Bàu Chinh", district_code: "750" },
  { code: "26575", name: "Thị trấn Ngãi Giao", district_code: "750" },
  { code: "26578", name: "Xã Bình Ba", district_code: "750" },
  { code: "26581", name: "Xã Suối Nghệ", district_code: "750" },
  { code: "26584", name: "Xã Xuân Sơn", district_code: "750" },
  { code: "26587", name: "Xã Sơn Bình", district_code: "750" },
  { code: "26590", name: "Xã Bình Giã", district_code: "750" },
  { code: "26593", name: "Xã Bình Trung", district_code: "750" },
  { code: "26596", name: "Xã Xà Bang", district_code: "750" },
  { code: "26599", name: "Xã Cù Bị", district_code: "750" },
  { code: "26602", name: "Xã Láng Lớn", district_code: "750" },
  { code: "26605", name: "Xã Quảng Thành", district_code: "750" },
  { code: "26608", name: "Thị trấn Kim Long", district_code: "750" },
  { code: "26611", name: "Xã Suối Rao", district_code: "750" },
  { code: "26614", name: "Xã Đá Bạc", district_code: "750" },
  { code: "26617", name: "Xã Nghĩa Thành", district_code: "750" },
  { code: "26620", name: "Thị trấn Phước Bửu", district_code: "751" },
  { code: "26623", name: "Xã Phước Thuận", district_code: "751" },
  { code: "26626", name: "Xã Phước Tân", district_code: "751" },
  { code: "26629", name: "Xã Xuyên Mộc", district_code: "751" },
  { code: "26632", name: "Xã Bông Trang", district_code: "751" },
  { code: "26635", name: "Xã Tân Lâm", district_code: "751" },
  { code: "26638", name: "Xã Bàu Lâm", district_code: "751" },
  { code: "26641", name: "Xã Hòa Bình", district_code: "751" },
  { code: "26644", name: "Xã Hòa Hưng", district_code: "751" },
  { code: "26647", name: "Xã Hòa Hiệp", district_code: "751" },
  { code: "26650", name: "Xã Hòa Hội", district_code: "751" },
  { code: "26653", name: "Xã Bưng Riềng", district_code: "751" },
  { code: "26656", name: "Xã Bình Châu", district_code: "751" },
  { code: "26659", name: "Thị trấn Long Điền", district_code: "753" },
  { code: "26662", name: "Thị trấn Long Hải", district_code: "753" },
  { code: "26668", name: "Xã Tam An", district_code: "753" },
  { code: "26674", name: "Xã Phước Tỉnh", district_code: "753" },
  { code: "26677", name: "Xã Phước Hưng", district_code: "753" },
  { code: "26680", name: "Thị trấn Đất Đỏ", district_code: "753" },
  { code: "26683", name: "Xã Phước Long Thọ", district_code: "753" },
  { code: "26686", name: "Xã Phước Hội", district_code: "753" },
  { code: "26689", name: "Thị trấn Phước Hải", district_code: "753" },
  { code: "26695", name: "Xã Long Tân", district_code: "753" },
  { code: "26698", name: "Xã Láng Dài", district_code: "753" },
  { code: "26704", name: "Phường Phú Mỹ", district_code: "754" },
  { code: "26707", name: "Xã Tân Hoà", district_code: "754" },
  { code: "26710", name: "Xã Tân Hải", district_code: "754" },
  { code: "26713", name: "Phường Phước Hoà", district_code: "754" },
  { code: "26716", name: "Phường Tân Phước", district_code: "754" },
  { code: "26719", name: "Phường Mỹ Xuân", district_code: "754" },
  { code: "26722", name: "Xã Sông Xoài", district_code: "754" },
  { code: "26725", name: "Phường Hắc Dịch", district_code: "754" },
  { code: "26728", name: "Xã Châu Pha", district_code: "754" },
  { code: "26731", name: "Xã Tóc Tiên", district_code: "754" },
  { code: "26734", name: "Phường Tân Định", district_code: "760" },
  { code: "26737", name: "Phường Đa Kao", district_code: "760" },
  { code: "26740", name: "Phường Bến Nghé", district_code: "760" },
  { code: "26743", name: "Phường Bến Thành", district_code: "760" },
  { code: "26746", name: "Phường Nguyễn Thái Bình", district_code: "760" },
  { code: "26749", name: "Phường Phạm Ngũ Lão", district_code: "760" },
  { code: "26752", name: "Phường Cầu Ông Lãnh", district_code: "760" },
  { code: "26755", name: "Phường Cô Giang", district_code: "760" },
  { code: "26758", name: "Phường Nguyễn Cư Trinh", district_code: "760" },
  { code: "26761", name: "Phường Cầu Kho", district_code: "760" },
  { code: "26764", name: "Phường Thạnh Xuân", district_code: "761" },
  { code: "26767", name: "Phường Thạnh Lộc", district_code: "761" },
  { code: "26770", name: "Phường Hiệp Thành", district_code: "761" },
  { code: "26773", name: "Phường Thới An", district_code: "761" },
  { code: "26776", name: "Phường Tân Chánh Hiệp", district_code: "761" },
  { code: "26779", name: "Phường An Phú Đông", district_code: "761" },
  { code: "26782", name: "Phường Tân Thới Hiệp", district_code: "761" },
  { code: "26785", name: "Phường Trung Mỹ Tây", district_code: "761" },
  { code: "26787", name: "Phường Tân Hưng Thuận", district_code: "761" },
  { code: "26788", name: "Phường Đông Hưng Thuận", district_code: "761" },
  { code: "26791", name: "Phường Tân Thới Nhất", district_code: "761" },
  { code: "26872", name: "Phường 15", district_code: "764" },
  { code: "26875", name: "Phường 17", district_code: "764" },
  { code: "26876", name: "Phường 6", district_code: "764" },
  { code: "26878", name: "Phường 16", district_code: "764" },
  { code: "26881", name: "Phường 12", district_code: "764" },
  { code: "26882", name: "Phường 14", district_code: "764" },
  { code: "26884", name: "Phường 10", district_code: "764" },
  { code: "26887", name: "Phường 5", district_code: "764" },
  { code: "26890", name: "Phường 1", district_code: "764" },
  { code: "26898", name: "Phường 8", district_code: "764" },
  { code: "26899", name: "Phường 11", district_code: "764" },
  { code: "26902", name: "Phường 3", district_code: "764" },
  { code: "26905", name: "Phường 13", district_code: "765" },
  { code: "26908", name: "Phường 11", district_code: "765" },
  { code: "26911", name: "Phường 27", district_code: "765" },
  { code: "26914", name: "Phường 26", district_code: "765" },
  { code: "26917", name: "Phường 12", district_code: "765" },
  { code: "26920", name: "Phường 25", district_code: "765" },
  { code: "26923", name: "Phường 5", district_code: "765" },
  { code: "26926", name: "Phường 7", district_code: "765" },
  { code: "26935", name: "Phường 14", district_code: "765" },
  { code: "26941", name: "Phường 2", district_code: "765" },
  { code: "26944", name: "Phường 1", district_code: "765" },
  { code: "26950", name: "Phường 17", district_code: "765" },
  { code: "26956", name: "Phường 22", district_code: "765" },
  { code: "26959", name: "Phường 19", district_code: "765" },
  { code: "26962", name: "Phường 28", district_code: "765" },
  { code: "26965", name: "Phường 2", district_code: "766" },
  { code: "26968", name: "Phường 4", district_code: "766" },
  { code: "26971", name: "Phường 12", district_code: "766" },
  { code: "26974", name: "Phường 13", district_code: "766" },
  { code: "26977", name: "Phường 1", district_code: "766" },
  { code: "26980", name: "Phường 3", district_code: "766" },
  { code: "26983", name: "Phường 11", district_code: "766" },
  { code: "26986", name: "Phường 7", district_code: "766" },
  { code: "26989", name: "Phường 5", district_code: "766" },
  { code: "26992", name: "Phường 10", district_code: "766" },
  { code: "26995", name: "Phường 6", district_code: "766" },
  { code: "26998", name: "Phường 8", district_code: "766" },
  { code: "27001", name: "Phường 9", district_code: "766" },
  { code: "27004", name: "Phường 14", district_code: "766" },
  { code: "27007", name: "Phường 15", district_code: "766" },
  { code: "27010", name: "Phường Tân Sơn Nhì", district_code: "767" },
  { code: "27013", name: "Phường Tây Thạnh", district_code: "767" },
  { code: "27016", name: "Phường Sơn Kỳ", district_code: "767" },
  { code: "27019", name: "Phường Tân Quý", district_code: "767" },
  { code: "27022", name: "Phường Tân Thành", district_code: "767" },
  { code: "27025", name: "Phường Phú Thọ Hòa", district_code: "767" },
  { code: "27028", name: "Phường Phú Thạnh", district_code: "767" },
  { code: "27031", name: "Phường Phú Trung", district_code: "767" },
  { code: "27034", name: "Phường Hòa Thạnh", district_code: "767" },
  { code: "27037", name: "Phường Hiệp Tân", district_code: "767" },
  { code: "27040", name: "Phường Tân Thới Hòa", district_code: "767" },
  { code: "27043", name: "Phường 4", district_code: "768" },
  { code: "27046", name: "Phường 5", district_code: "768" },
  { code: "27049", name: "Phường 9", district_code: "768" },
  { code: "27052", name: "Phường 7", district_code: "768" },
  { code: "27058", name: "Phường 1", district_code: "768" },
  { code: "27061", name: "Phường 2", district_code: "768" },
  { code: "27064", name: "Phường 8", district_code: "768" },
  { code: "27067", name: "Phường 15", district_code: "768" },
  { code: "27070", name: "Phường 10", district_code: "768" },
  { code: "27073", name: "Phường 11", district_code: "768" },
  { code: "27085", name: "Phường 13", district_code: "768" },
  { code: "26794", name: "Phường Linh Xuân", district_code: "769" },
  { code: "26797", name: "Phường Bình Chiểu", district_code: "769" },
  { code: "26800", name: "Phường Linh Trung", district_code: "769" },
  { code: "26803", name: "Phường Tam Bình", district_code: "769" },
  { code: "26806", name: "Phường Tam Phú", district_code: "769" },
  { code: "26809", name: "Phường Hiệp Bình Phước", district_code: "769" },
  { code: "26812", name: "Phường Hiệp Bình Chánh", district_code: "769" },
  { code: "26815", name: "Phường Linh Chiểu", district_code: "769" },
  { code: "26818", name: "Phường Linh Tây", district_code: "769" },
  { code: "26821", name: "Phường Linh Đông", district_code: "769" },
  { code: "26824", name: "Phường Bình Thọ", district_code: "769" },
  { code: "26827", name: "Phường Trường Thọ", district_code: "769" },
  { code: "26830", name: "Phường Long Bình", district_code: "769" },
  { code: "26833", name: "Phường Long Thạnh Mỹ", district_code: "769" },
  { code: "26836", name: "Phường Tân Phú", district_code: "769" },
  { code: "26839", name: "Phường Hiệp Phú", district_code: "769" },
  { code: "26842", name: "Phường Tăng Nhơn Phú A", district_code: "769" },
  { code: "26845", name: "Phường Tăng Nhơn Phú B", district_code: "769" },
  { code: "26848", name: "Phường Phước Long B", district_code: "769" },
  { code: "26851", name: "Phường Phước Long A", district_code: "769" },
  { code: "26854", name: "Phường Trường Thạnh", district_code: "769" },
  { code: "26857", name: "Phường Long Phước", district_code: "769" },
  { code: "26860", name: "Phường Long Trường", district_code: "769" },
  { code: "26863", name: "Phường Phước Bình", district_code: "769" },
  { code: "26866", name: "Phường Phú Hữu", district_code: "769" },
  { code: "27088", name: "Phường Thảo Điền", district_code: "769" },
  { code: "27091", name: "Phường An Phú", district_code: "769" },
  { code: "27094", name: "Phường An Khánh", district_code: "769" },
  { code: "27097", name: "Phường Bình Trưng Đông", district_code: "769" },
  { code: "27100", name: "Phường Bình Trưng Tây", district_code: "769" },
  { code: "27109", name: "Phường Cát Lái", district_code: "769" },
  { code: "27112", name: "Phường Thạnh Mỹ Lợi", district_code: "769" },
  { code: "27115", name: "Phường An Lợi Đông", district_code: "769" },
  { code: "27118", name: "Phường Thủ Thiêm", district_code: "769" },
  { code: "27127", name: "Phường 14", district_code: "770" },
  { code: "27130", name: "Phường 12", district_code: "770" },
  { code: "27133", name: "Phường 11", district_code: "770" },
  { code: "27139", name: "Phường Võ Thị Sáu", district_code: "770" },
  { code: "27142", name: "Phường 9", district_code: "770" },
  { code: "27148", name: "Phường 4", district_code: "770" },
  { code: "27151", name: "Phường 5", district_code: "770" },
  { code: "27154", name: "Phường 3", district_code: "770" },
  { code: "27157", name: "Phường 2", district_code: "770" },
  { code: "27160", name: "Phường 1", district_code: "770" },
  { code: "27163", name: "Phường 15", district_code: "771" },
  { code: "27166", name: "Phường 13", district_code: "771" },
  { code: "27169", name: "Phường 14", district_code: "771" },
  { code: "27172", name: "Phường 12", district_code: "771" },
  { code: "27178", name: "Phường 10", district_code: "771" },
  { code: "27181", name: "Phường 9", district_code: "771" },
  { code: "27184", name: "Phường 1", district_code: "771" },
  { code: "27187", name: "Phường 8", district_code: "771" },
  { code: "27190", name: "Phường 2", district_code: "771" },
  { code: "27193", name: "Phường 4", district_code: "771" },
  { code: "27202", name: "Phường 6", district_code: "771" },
  { code: "27208", name: "Phường 15", district_code: "772" },
  { code: "27211", name: "Phường 5", district_code: "772" },
  { code: "27214", name: "Phường 14", district_code: "772" },
  { code: "27217", name: "Phường 11", district_code: "772" },
  { code: "27220", name: "Phường 3", district_code: "772" },
  { code: "27223", name: "Phường 10", district_code: "772" },
  { code: "27229", name: "Phường 8", district_code: "772" },
  { code: "27238", name: "Phường 7", district_code: "772" },
  { code: "27247", name: "Phường 1", district_code: "772" },
  { code: "27253", name: "Phường 16", district_code: "772" },
  { code: "27259", name: "Phường 13", district_code: "773" },
  { code: "27265", name: "Phường 9", district_code: "773" },
  { code: "27271", name: "Phường 8", district_code: "773" },
  { code: "27277", name: "Phường 18", district_code: "773" },
  { code: "27283", name: "Phường 4", district_code: "773" },
  { code: "27286", name: "Phường 3", district_code: "773" },
  { code: "27289", name: "Phường 16", district_code: "773" },
  { code: "27292", name: "Phường 2", district_code: "773" },
  { code: "27295", name: "Phường 15", district_code: "773" },
  { code: "27298", name: "Phường 1", district_code: "773" },
  { code: "27301", name: "Phường 4", district_code: "774" },
  { code: "27304", name: "Phường 9", district_code: "774" },
  { code: "27307", name: "Phường 2", district_code: "774" },
  { code: "27310", name: "Phường 12", district_code: "774" },
  { code: "27316", name: "Phường 7", district_code: "774" },
  { code: "27325", name: "Phường 1", district_code: "774" },
  { code: "27328", name: "Phường 11", district_code: "774" },
  { code: "27331", name: "Phường 14", district_code: "774" },
  { code: "27334", name: "Phường 5", district_code: "774" },
  { code: "27343", name: "Phường 13", district_code: "774" },
  { code: "27346", name: "Phường 14", district_code: "775" },
  { code: "27349", name: "Phường 13", district_code: "775" },
  { code: "27352", name: "Phường 9", district_code: "775" },
  { code: "27358", name: "Phường 12", district_code: "775" },
  { code: "27361", name: "Phường 2", district_code: "775" },
  { code: "27364", name: "Phường 11", district_code: "775" },
  { code: "27376", name: "Phường 8", district_code: "775" },
  { code: "27379", name: "Phường 1", district_code: "775" },
  { code: "27382", name: "Phường 7", district_code: "775" },
  { code: "27385", name: "Phường 10", district_code: "775" },
  { code: "27397", name: "Phường Rạch Ông", district_code: "776" },
  { code: "27403", name: "Phường Hưng Phú", district_code: "776" },
  { code: "27409", name: "Phường 4", district_code: "776" },
  { code: "27415", name: "Phường Xóm Củi", district_code: "776" },
  { code: "27418", name: "Phường 5", district_code: "776" },
  { code: "27421", name: "Phường 14", district_code: "776" },
  { code: "27424", name: "Phường 6", district_code: "776" },
  { code: "27427", name: "Phường 15", district_code: "776" },
  { code: "27430", name: "Phường 16", district_code: "776" },
  { code: "27433", name: "Phường 7", district_code: "776" },
  { code: "27436", name: "Phường Bình Hưng Hòa", district_code: "777" },
  { code: "27439", name: "Phường Bình Hưng Hoà A", district_code: "777" },
  { code: "27442", name: "Phường Bình Hưng Hoà B", district_code: "777" },
  { code: "27445", name: "Phường Bình Trị Đông", district_code: "777" },
  { code: "27448", name: "Phường Bình Trị Đông A", district_code: "777" },
  { code: "27451", name: "Phường Bình Trị Đông B", district_code: "777" },
  { code: "27454", name: "Phường Tân Tạo", district_code: "777" },
  { code: "27457", name: "Phường Tân Tạo A", district_code: "777" },
  { code: "27460", name: "Phường An Lạc", district_code: "777" },
  { code: "27463", name: "Phường An Lạc A", district_code: "777" },
  { code: "27466", name: "Phường Tân Thuận Đông", district_code: "778" },
  { code: "27469", name: "Phường Tân Thuận Tây", district_code: "778" },
  { code: "27472", name: "Phường Tân Kiểng", district_code: "778" },
  { code: "27475", name: "Phường Tân Hưng", district_code: "778" },
  { code: "27478", name: "Phường Bình Thuận", district_code: "778" },
  { code: "27481", name: "Phường Tân Quy", district_code: "778" },
  { code: "27484", name: "Phường Phú Thuận", district_code: "778" },
  { code: "27487", name: "Phường Tân Phú", district_code: "778" },
  { code: "27490", name: "Phường Tân Phong", district_code: "778" },
  { code: "27493", name: "Phường Phú Mỹ", district_code: "778" },
  { code: "27496", name: "Thị trấn Củ Chi", district_code: "783" },
  { code: "27499", name: "Xã Phú Mỹ Hưng", district_code: "783" },
  { code: "27502", name: "Xã An Phú", district_code: "783" },
  { code: "27505", name: "Xã Trung Lập Thượng", district_code: "783" },
  { code: "27508", name: "Xã An Nhơn Tây", district_code: "783" },
  { code: "27511", name: "Xã Nhuận Đức", district_code: "783" },
  { code: "27514", name: "Xã Phạm Văn Cội", district_code: "783" },
  { code: "27517", name: "Xã Phú Hòa Đông", district_code: "783" },
  { code: "27520", name: "Xã Trung Lập Hạ", district_code: "783" },
  { code: "27523", name: "Xã Trung An", district_code: "783" },
  { code: "27526", name: "Xã Phước Thạnh", district_code: "783" },
  { code: "27529", name: "Xã Phước Hiệp", district_code: "783" },
  { code: "27532", name: "Xã Tân An Hội", district_code: "783" },
  { code: "27535", name: "Xã Phước Vĩnh An", district_code: "783" },
  { code: "27538", name: "Xã Thái Mỹ", district_code: "783" },
  { code: "27541", name: "Xã Tân Thạnh Tây", district_code: "783" },
  { code: "27544", name: "Xã Hòa Phú", district_code: "783" },
  { code: "27547", name: "Xã Tân Thạnh Đông", district_code: "783" },
  { code: "27550", name: "Xã Bình Mỹ", district_code: "783" },
  { code: "27553", name: "Xã Tân Phú Trung", district_code: "783" },
  { code: "27556", name: "Xã Tân Thông Hội", district_code: "783" },
  { code: "27559", name: "Thị trấn Hóc Môn", district_code: "784" },
  { code: "27562", name: "Xã Tân Hiệp", district_code: "784" },
  { code: "27565", name: "Xã Nhị Bình", district_code: "784" },
  { code: "27568", name: "Xã Đông Thạnh", district_code: "784" },
  { code: "27571", name: "Xã Tân Thới Nhì", district_code: "784" },
  { code: "27574", name: "Xã Thới Tam Thôn", district_code: "784" },
  { code: "27577", name: "Xã Xuân Thới Sơn", district_code: "784" },
  { code: "27580", name: "Xã Tân Xuân", district_code: "784" },
  { code: "27583", name: "Xã Xuân Thới Đông", district_code: "784" },
  { code: "27586", name: "Xã Trung Chánh", district_code: "784" },
  { code: "27589", name: "Xã Xuân Thới Thượng", district_code: "784" },
  { code: "27592", name: "Xã Bà Điểm", district_code: "784" },
  { code: "27595", name: "Thị trấn Tân Túc", district_code: "785" },
  { code: "27598", name: "Xã Phạm Văn Hai", district_code: "785" },
  { code: "27601", name: "Xã Vĩnh Lộc A", district_code: "785" },
  { code: "27604", name: "Xã Vĩnh Lộc B", district_code: "785" },
  { code: "27607", name: "Xã Bình Lợi", district_code: "785" },
  { code: "27610", name: "Xã Lê Minh Xuân", district_code: "785" },
  { code: "27613", name: "Xã Tân Nhựt", district_code: "785" },
  { code: "27616", name: "Xã Tân Kiên", district_code: "785" },
  { code: "27619", name: "Xã Bình Hưng", district_code: "785" },
  { code: "27622", name: "Xã Phong Phú", district_code: "785" },
  { code: "27625", name: "Xã An Phú Tây", district_code: "785" },
  { code: "27628", name: "Xã Hưng Long", district_code: "785" },
  { code: "27631", name: "Xã Đa Phước", district_code: "785" },
  { code: "27634", name: "Xã Tân Quý Tây", district_code: "785" },
  { code: "27637", name: "Xã Bình Chánh", district_code: "785" },
  { code: "27640", name: "Xã Quy Đức", district_code: "785" },
  { code: "27643", name: "Thị trấn Nhà Bè", district_code: "786" },
  { code: "27646", name: "Xã Phước Kiển", district_code: "786" },
  { code: "27649", name: "Xã Phước Lộc", district_code: "786" },
  { code: "27652", name: "Xã Nhơn Đức", district_code: "786" },
  { code: "27655", name: "Xã Phú Xuân", district_code: "786" },
  { code: "27658", name: "Xã Long Thới", district_code: "786" },
  { code: "27661", name: "Xã Hiệp Phước", district_code: "786" },
  { code: "27664", name: "Thị trấn Cần Thạnh", district_code: "787" },
  { code: "27667", name: "Xã Bình Khánh", district_code: "787" },
  { code: "27670", name: "Xã Tam Thôn Hiệp", district_code: "787" },
  { code: "27673", name: "Xã An Thới Đông", district_code: "787" },
  { code: "27676", name: "Xã Thạnh An", district_code: "787" },
  { code: "27679", name: "Xã Long Hòa", district_code: "787" },
  { code: "27682", name: "Xã Lý Nhơn", district_code: "787" },
  { code: "27685", name: "Phường 5", district_code: "794" },
  { code: "27691", name: "Phường 4", district_code: "794" },
  { code: "27692", name: "Phường Tân Khánh", district_code: "794" },
  { code: "27694", name: "Phường 1", district_code: "794" },
  { code: "27697", name: "Phường 3", district_code: "794" },
  { code: "27698", name: "Phường 7", district_code: "794" },
  { code: "27700", name: "Phường 6", district_code: "794" },
  { code: "27703", name: "Xã Hướng Thọ Phú", district_code: "794" },
  { code: "27706", name: "Xã Nhơn Thạnh Trung", district_code: "794" },
  { code: "27709", name: "Xã Lợi Bình Nhơn", district_code: "794" },
  { code: "27712", name: "Xã Bình Tâm", district_code: "794" },
  { code: "27715", name: "Phường Khánh Hậu", district_code: "794" },
  { code: "27718", name: "Xã An Vĩnh Ngãi", district_code: "794" },
  { code: "27787", name: "Phường 1", district_code: "795" },
  { code: "27788", name: "Phường 2", district_code: "795" },
  { code: "27790", name: "Xã Thạnh Trị", district_code: "795" },
  { code: "27793", name: "Xã Bình Hiệp", district_code: "795" },
  { code: "27799", name: "Xã Bình Tân", district_code: "795" },
  { code: "27805", name: "Xã Tuyên Thạnh", district_code: "795" },
  { code: "27806", name: "Phường 3", district_code: "795" },
  { code: "27817", name: "Xã Thạnh Hưng", district_code: "795" },
  { code: "27721", name: "Thị trấn Tân Hưng", district_code: "796" },
  { code: "27724", name: "Xã Hưng Hà", district_code: "796" },
  { code: "27727", name: "Xã Hưng Điền B", district_code: "796" },
  { code: "27730", name: "Xã Hưng Điền", district_code: "796" },
  { code: "27733", name: "Xã Thạnh Hưng", district_code: "796" },
  { code: "27736", name: "Xã Hưng Thạnh", district_code: "796" },
  { code: "27739", name: "Xã Vĩnh Thạnh", district_code: "796" },
  { code: "27742", name: "Xã Vĩnh Châu B", district_code: "796" },
  { code: "27745", name: "Xã Vĩnh Lợi", district_code: "796" },
  { code: "27748", name: "Xã Vĩnh Đại", district_code: "796" },
  { code: "27751", name: "Xã Vĩnh Châu A", district_code: "796" },
  { code: "27754", name: "Xã Vĩnh Bửu", district_code: "796" },
  { code: "27757", name: "Thị trấn Vĩnh Hưng", district_code: "797" },
  { code: "27760", name: "Xã Hưng Điền A", district_code: "797" },
  { code: "27763", name: "Xã Khánh Hưng", district_code: "797" },
  { code: "27766", name: "Xã Thái Trị", district_code: "797" },
  { code: "27769", name: "Xã Vĩnh Trị", district_code: "797" },
  { code: "27772", name: "Xã Thái Bình Trung", district_code: "797" },
  { code: "27775", name: "Xã Vĩnh Bình", district_code: "797" },
  { code: "27778", name: "Xã Vĩnh Thuận", district_code: "797" },
  { code: "27781", name: "Xã Tuyên Bình", district_code: "797" },
  { code: "27784", name: "Xã Tuyên Bình Tây", district_code: "797" },
  { code: "27796", name: "Xã Bình Hòa Tây", district_code: "798" },
  { code: "27802", name: "Xã Bình Thạnh", district_code: "798" },
  { code: "27808", name: "Xã Bình Hòa Trung", district_code: "798" },
  { code: "27811", name: "Xã Bình Hòa Đông", district_code: "798" },
  { code: "27814", name: "Thị trấn Bình Phong Thạnh", district_code: "798" },
  { code: "27820", name: "Xã Tân Lập", district_code: "798" },
  { code: "27823", name: "Xã Tân Thành", district_code: "798" },
  { code: "27826", name: "Thị trấn Tân Thạnh", district_code: "799" },
  { code: "27829", name: "Xã Bắc Hòa", district_code: "799" },
  { code: "27832", name: "Xã Hậu Thạnh Tây", district_code: "799" },
  { code: "27835", name: "Xã Nhơn Hòa Lập", district_code: "799" },
  { code: "27838", name: "Xã Tân Lập", district_code: "799" },
  { code: "27841", name: "Xã Hậu Thạnh Đông", district_code: "799" },
  { code: "27844", name: "Xã Nhơn Hoà", district_code: "799" },
  { code: "27847", name: "Xã Kiến Bình", district_code: "799" },
  { code: "27850", name: "Xã Tân Thành", district_code: "799" },
  { code: "27853", name: "Xã Tân Bình", district_code: "799" },
  { code: "27856", name: "Xã Tân Ninh", district_code: "799" },
  { code: "27859", name: "Xã Nhơn Ninh", district_code: "799" },
  { code: "27862", name: "Xã Tân Hòa", district_code: "799" },
  { code: "27865", name: "Thị trấn Thạnh Hóa", district_code: "800" },
  { code: "27868", name: "Xã Tân Hiệp", district_code: "800" },
  { code: "27871", name: "Xã Thuận Bình", district_code: "800" },
  { code: "27874", name: "Xã Thạnh Phước", district_code: "800" },
  { code: "27877", name: "Xã Thạnh Phú", district_code: "800" },
  { code: "27880", name: "Xã Thuận Nghĩa Hòa", district_code: "800" },
  { code: "27883", name: "Xã Thủy Đông", district_code: "800" },
  { code: "27886", name: "Xã Thủy Tây", district_code: "800" },
  { code: "27889", name: "Xã Tân Tây", district_code: "800" },
  { code: "27892", name: "Xã Tân Đông", district_code: "800" },
  { code: "27895", name: "Xã Thạnh An", district_code: "800" },
  { code: "27898", name: "Thị trấn Đông Thành", district_code: "801" },
  { code: "27901", name: "Xã Mỹ Quý Đông", district_code: "801" },
  { code: "27904", name: "Xã Mỹ Thạnh Bắc", district_code: "801" },
  { code: "27907", name: "Xã Mỹ Quý Tây", district_code: "801" },
  { code: "27910", name: "Xã Mỹ Thạnh Tây", district_code: "801" },
  { code: "27913", name: "Xã Mỹ Thạnh Đông", district_code: "801" },
  { code: "27916", name: "Xã Bình Thành", district_code: "801" },
  { code: "27919", name: "Xã Bình Hòa Bắc", district_code: "801" },
  { code: "27922", name: "Xã Bình Hòa Hưng", district_code: "801" },
  { code: "27925", name: "Xã Bình Hòa Nam", district_code: "801" },
  { code: "27928", name: "Xã Mỹ Bình", district_code: "801" },
  { code: "27931", name: "Thị trấn Hậu Nghĩa", district_code: "802" },
  { code: "27934", name: "Thị trấn Hiệp Hòa", district_code: "802" },
  { code: "27937", name: "Thị trấn Đức Hòa", district_code: "802" },
  { code: "27940", name: "Xã Lộc Giang", district_code: "802" },
  { code: "27943", name: "Xã An Ninh Đông", district_code: "802" },
  { code: "27946", name: "Xã An Ninh Tây", district_code: "802" },
  { code: "27949", name: "Xã Tân Mỹ", district_code: "802" },
  { code: "27952", name: "Xã Hiệp Hòa", district_code: "802" },
  { code: "27955", name: "Xã Đức Lập Thượng", district_code: "802" },
  { code: "27958", name: "Xã Đức Lập Hạ", district_code: "802" },
  { code: "27961", name: "Xã Tân Phú", district_code: "802" },
  { code: "27964", name: "Xã Mỹ Hạnh Bắc", district_code: "802" },
  { code: "27967", name: "Xã Đức Hòa Thượng", district_code: "802" },
  { code: "27970", name: "Xã Hòa Khánh Tây", district_code: "802" },
  { code: "27973", name: "Xã Hòa Khánh Đông", district_code: "802" },
  { code: "27976", name: "Xã Mỹ Hạnh Nam", district_code: "802" },
  { code: "27979", name: "Xã Hòa Khánh Nam", district_code: "802" },
  { code: "27982", name: "Xã Đức Hòa Đông", district_code: "802" },
  { code: "27985", name: "Xã Đức Hòa Hạ", district_code: "802" },
  { code: "27988", name: "Xã Hựu Thạnh", district_code: "802" },
  { code: "27991", name: "Thị trấn Bến Lức", district_code: "803" },
  { code: "27994", name: "Xã Thạnh Lợi", district_code: "803" },
  { code: "27997", name: "Xã Lương Bình", district_code: "803" },
  { code: "28000", name: "Xã Thạnh Hòa", district_code: "803" },
  { code: "28003", name: "Xã Lương Hòa", district_code: "803" },
  { code: "28009", name: "Xã Tân Bửu", district_code: "803" },
  { code: "28012", name: "Xã An Thạnh", district_code: "803" },
  { code: "28015", name: "Xã Bình Đức", district_code: "803" },
  { code: "28018", name: "Xã Mỹ Yên", district_code: "803" },
  { code: "28021", name: "Xã Thanh Phú", district_code: "803" },
  { code: "28024", name: "Xã Long Hiệp", district_code: "803" },
  { code: "28027", name: "Xã Thạnh Đức", district_code: "803" },
  { code: "28030", name: "Xã Phước Lợi", district_code: "803" },
  { code: "28033", name: "Xã Nhựt Chánh", district_code: "803" },
  { code: "28036", name: "Thị trấn Thủ Thừa", district_code: "804" },
  { code: "28039", name: "Xã Long Thạnh", district_code: "804" },
  { code: "28042", name: "Xã Tân Thành", district_code: "804" },
  { code: "28045", name: "Xã Long Thuận", district_code: "804" },
  { code: "28048", name: "Xã Mỹ Lạc", district_code: "804" },
  { code: "28051", name: "Xã Mỹ Thạnh", district_code: "804" },
  { code: "28054", name: "Xã Bình An", district_code: "804" },
  { code: "28057", name: "Xã Nhị Thành", district_code: "804" },
  { code: "28060", name: "Xã Mỹ An", district_code: "804" },
  { code: "28063", name: "Xã Bình Thạnh", district_code: "804" },
  { code: "28066", name: "Xã Mỹ Phú", district_code: "804" },
  { code: "28072", name: "Xã Tân Long", district_code: "804" },
  { code: "28075", name: "Thị trấn Tân Trụ", district_code: "805" },
  { code: "28078", name: "Xã Tân Bình", district_code: "805" },
  { code: "28084", name: "Xã Quê Mỹ Thạnh", district_code: "805" },
  { code: "28087", name: "Xã Lạc Tấn", district_code: "805" },
  { code: "28090", name: "Xã Bình Trinh Đông", district_code: "805" },
  { code: "28093", name: "Xã Tân Phước Tây", district_code: "805" },
  { code: "28096", name: "Xã Bình Lãng", district_code: "805" },
  { code: "28099", name: "Xã Bình Tịnh", district_code: "805" },
  { code: "28102", name: "Xã Đức Tân", district_code: "805" },
  { code: "28105", name: "Xã Nhựt Ninh", district_code: "805" },
  { code: "28108", name: "Thị trấn Cần Đước", district_code: "806" },
  { code: "28111", name: "Xã Long Trạch", district_code: "806" },
  { code: "28114", name: "Xã Long Khê", district_code: "806" },
  { code: "28117", name: "Xã Long Định", district_code: "806" },
  { code: "28120", name: "Xã Phước Vân", district_code: "806" },
  { code: "28123", name: "Xã Long Hòa", district_code: "806" },
  { code: "28126", name: "Xã Long Cang", district_code: "806" },
  { code: "28129", name: "Xã Long Sơn", district_code: "806" },
  { code: "28132", name: "Xã Tân Trạch", district_code: "806" },
  { code: "28135", name: "Xã Mỹ Lệ", district_code: "806" },
  { code: "28138", name: "Xã Tân Lân", district_code: "806" },
  { code: "28141", name: "Xã Phước Tuy", district_code: "806" },
  { code: "28144", name: "Xã Long Hựu Đông", district_code: "806" },
  { code: "28147", name: "Xã Tân Ân", district_code: "806" },
  { code: "28150", name: "Xã Phước Đông", district_code: "806" },
  { code: "28153", name: "Xã Long Hựu Tây", district_code: "806" },
  { code: "28156", name: "Xã Tân Chánh", district_code: "806" },
  { code: "28159", name: "Thị trấn Cần Giuộc", district_code: "807" },
  { code: "28162", name: "Xã Phước Lý", district_code: "807" },
  { code: "28165", name: "Xã Long Thượng", district_code: "807" },
  { code: "28168", name: "Xã Long Hậu", district_code: "807" },
  { code: "28174", name: "Xã Phước Hậu", district_code: "807" },
  { code: "28177", name: "Xã Mỹ Lộc", district_code: "807" },
  { code: "28180", name: "Xã Phước Lại", district_code: "807" },
  { code: "28183", name: "Xã Phước Lâm", district_code: "807" },
  { code: "28189", name: "Xã Thuận Thành", district_code: "807" },
  { code: "28192", name: "Xã Phước Vĩnh Tây", district_code: "807" },
  { code: "28195", name: "Xã Phước Vĩnh Đông", district_code: "807" },
  { code: "28198", name: "Xã Long An", district_code: "807" },
  { code: "28201", name: "Xã Long Phụng", district_code: "807" },
  { code: "28204", name: "Xã Đông Thạnh", district_code: "807" },
  { code: "28207", name: "Xã Tân Tập", district_code: "807" },
  { code: "28210", name: "Thị trấn Tầm Vu", district_code: "808" },
  { code: "28213", name: "Xã Bình Quới", district_code: "808" },
  { code: "28216", name: "Xã Hòa Phú", district_code: "808" },
  { code: "28219", name: "Xã Phú Ngãi Trị", district_code: "808" },
  { code: "28222", name: "Xã Vĩnh Công", district_code: "808" },
  { code: "28225", name: "Xã Thuận Mỹ", district_code: "808" },
  { code: "28228", name: "Xã Hiệp Thạnh", district_code: "808" },
  { code: "28231", name: "Xã Phước Tân Hưng", district_code: "808" },
  { code: "28234", name: "Xã Thanh Phú Long", district_code: "808" },
  { code: "28237", name: "Xã Dương Xuân Hội", district_code: "808" },
  { code: "28240", name: "Xã An Lục Long", district_code: "808" },
  { code: "28243", name: "Xã Long Trì", district_code: "808" },
  { code: "28246", name: "Xã Thanh Vĩnh Đông", district_code: "808" },
  { code: "28249", name: "Phường 5", district_code: "815" },
  { code: "28252", name: "Phường 4", district_code: "815" },
  { code: "28261", name: "Phường 1", district_code: "815" },
  { code: "28264", name: "Phường 2", district_code: "815" },
  { code: "28270", name: "Phường 6", district_code: "815" },
  { code: "28273", name: "Phường 9", district_code: "815" },
  { code: "28276", name: "Phường 10", district_code: "815" },
  { code: "28279", name: "Phường Tân Long", district_code: "815" },
  { code: "28282", name: "Xã Đạo Thạnh", district_code: "815" },
  { code: "28285", name: "Xã Trung An", district_code: "815" },
  { code: "28288", name: "Xã Mỹ Phong", district_code: "815" },
  { code: "28291", name: "Xã Tân Mỹ Chánh", district_code: "815" },
  { code: "28567", name: "Xã Phước Thạnh", district_code: "815" },
  { code: "28591", name: "Xã Thới Sơn", district_code: "815" },
  { code: "28297", name: "Phường 2", district_code: "816" },
  { code: "28300", name: "Phường 1", district_code: "816" },
  { code: "28306", name: "Phường 5", district_code: "816" },
  { code: "28309", name: "Phường Long Hưng", district_code: "816" },
  { code: "28312", name: "Phường Long Thuận", district_code: "816" },
  { code: "28315", name: "Phường Long Chánh", district_code: "816" },
  { code: "28318", name: "Phường Long Hòa", district_code: "816" },
  { code: "28708", name: "Xã Bình Đông", district_code: "816" },
  { code: "28717", name: "Xã Bình Xuân", district_code: "816" },
  { code: "28729", name: "Xã Tân Trung", district_code: "816" },
  { code: "28435", name: "Phường 1", district_code: "817" },
  { code: "28436", name: "Phường 2", district_code: "817" },
  { code: "28437", name: "Phường 3", district_code: "817" },
  { code: "28439", name: "Phường 4", district_code: "817" },
  { code: "28440", name: "Phường 5", district_code: "817" },
  { code: "28447", name: "Xã Mỹ Phước Tây", district_code: "817" },
  { code: "28450", name: "Xã Mỹ Hạnh Đông", district_code: "817" },
  { code: "28453", name: "Xã Mỹ Hạnh Trung", district_code: "817" },
  { code: "28459", name: "Xã Tân Phú", district_code: "817" },
  { code: "28462", name: "Xã Tân Bình", district_code: "817" },
  { code: "28468", name: "Xã Tân Hội", district_code: "817" },
  { code: "28474", name: "Phường Nhị Mỹ", district_code: "817" },
  { code: "28477", name: "Xã Nhị Quý", district_code: "817" },
  { code: "28480", name: "Xã Thanh Hòa", district_code: "817" },
  { code: "28483", name: "Xã Phú Quý", district_code: "817" },
  { code: "28486", name: "Xã Long Khánh", district_code: "817" },
  { code: "28321", name: "Thị trấn Mỹ Phước", district_code: "818" },
  { code: "28324", name: "Xã Tân Hòa Đông", district_code: "818" },
  { code: "28327", name: "Xã Thạnh Tân", district_code: "818" },
  { code: "28330", name: "Xã Thạnh Mỹ", district_code: "818" },
  { code: "28333", name: "Xã Thạnh Hoà", district_code: "818" },
  { code: "28336", name: "Xã Phú Mỹ", district_code: "818" },
  { code: "28339", name: "Xã Tân Hòa Thành", district_code: "818" },
  { code: "28342", name: "Xã Hưng Thạnh", district_code: "818" },
  { code: "28345", name: "Xã Tân Lập 1", district_code: "818" },
  { code: "28348", name: "Xã Tân Hòa Tây", district_code: "818" },
  { code: "28354", name: "Xã Tân Lập 2", district_code: "818" },
  { code: "28357", name: "Xã Phước Lập", district_code: "818" },
  { code: "28360", name: "Thị trấn Cái Bè", district_code: "819" },
  { code: "28363", name: "Xã Hậu Mỹ Bắc B", district_code: "819" },
  { code: "28366", name: "Xã Hậu Mỹ Bắc A", district_code: "819" },
  { code: "28369", name: "Xã Mỹ Trung", district_code: "819" },
  { code: "28372", name: "Xã Hậu Mỹ Trinh", district_code: "819" },
  { code: "28375", name: "Xã Hậu Mỹ Phú", district_code: "819" },
  { code: "28378", name: "Xã Mỹ Tân", district_code: "819" },
  { code: "28381", name: "Xã Mỹ Lợi B", district_code: "819" },
  { code: "28384", name: "Xã Thiện Trung", district_code: "819" },
  { code: "28387", name: "Xã Mỹ Hội", district_code: "819" },
  { code: "28390", name: "Xã An Cư", district_code: "819" },
  { code: "28393", name: "Xã Hậu Thành", district_code: "819" },
  { code: "28396", name: "Xã Mỹ Lợi A", district_code: "819" },
  { code: "28399", name: "Xã Hòa Khánh", district_code: "819" },
  { code: "28402", name: "Xã Thiện Trí", district_code: "819" },
  { code: "28405", name: "Xã Mỹ Đức Đông", district_code: "819" },
  { code: "28408", name: "Xã Mỹ Đức Tây", district_code: "819" },
  { code: "28411", name: "Xã Đông Hòa Hiệp", district_code: "819" },
  { code: "28414", name: "Xã An Thái Đông", district_code: "819" },
  { code: "28417", name: "Xã Tân Hưng", district_code: "819" },
  { code: "28420", name: "Xã Mỹ Lương", district_code: "819" },
  { code: "28423", name: "Xã Tân Thanh", district_code: "819" },
  { code: "28426", name: "Xã An Thái Trung", district_code: "819" },
  { code: "28429", name: "Xã An Hữu", district_code: "819" },
  { code: "28432", name: "Xã Hòa Hưng", district_code: "819" },
  { code: "28438", name: "Xã Thạnh Lộc", district_code: "820" },
  { code: "28441", name: "Xã Mỹ Thành Bắc", district_code: "820" },
  { code: "28444", name: "Xã Phú Cường", district_code: "820" },
  { code: "28456", name: "Xã Mỹ Thành Nam", district_code: "820" },
  { code: "28465", name: "Xã Phú Nhuận", district_code: "820" },
  { code: "28471", name: "Thị trấn Bình Phú", district_code: "820" },
  { code: "28489", name: "Xã Cẩm Sơn", district_code: "820" },
  { code: "28492", name: "Xã Phú An", district_code: "820" },
  { code: "28495", name: "Xã Mỹ Long", district_code: "820" },
  { code: "28498", name: "Xã Long Tiên", district_code: "820" },
  { code: "28501", name: "Xã Hiệp Đức", district_code: "820" },
  { code: "28504", name: "Xã Long Trung", district_code: "820" },
  { code: "28507", name: "Xã Hội Xuân", district_code: "820" },
  { code: "28510", name: "Xã Tân Phong", district_code: "820" },
  { code: "28513", name: "Xã Tam Bình", district_code: "820" },
  { code: "28516", name: "Xã Ngũ Hiệp", district_code: "820" },
  { code: "28519", name: "Thị trấn Tân Hiệp", district_code: "821" },
  { code: "28522", name: "Xã Tân Hội Đông", district_code: "821" },
  { code: "28525", name: "Xã Tân Hương", district_code: "821" },
  { code: "28528", name: "Xã Tân Lý Đông", district_code: "821" },
  { code: "28534", name: "Xã Thân Cửu Nghĩa", district_code: "821" },
  { code: "28537", name: "Xã Tam Hiệp", district_code: "821" },
  { code: "28540", name: "Xã Điềm Hy", district_code: "821" },
  { code: "28543", name: "Xã Nhị Bình", district_code: "821" },
  { code: "28549", name: "Xã Đông Hòa", district_code: "821" },
  { code: "28552", name: "Xã Long Định", district_code: "821" },
  { code: "28558", name: "Xã Long An", district_code: "821" },
  { code: "28561", name: "Xã Long Hưng", district_code: "821" },
  { code: "28564", name: "Xã Bình Trưng", district_code: "821" },
  { code: "28570", name: "Xã Thạnh Phú", district_code: "821" },
  { code: "28573", name: "Xã Bàn Long", district_code: "821" },
  { code: "28576", name: "Xã Vĩnh Kim", district_code: "821" },
  { code: "28579", name: "Xã Bình Đức", district_code: "821" },
  { code: "28582", name: "Xã Song Thuận", district_code: "821" },
  { code: "28585", name: "Xã Kim Sơn", district_code: "821" },
  { code: "28588", name: "Xã Phú Phong", district_code: "821" },
  { code: "28594", name: "Thị trấn Chợ Gạo", district_code: "822" },
  { code: "28597", name: "Xã Trung Hòa", district_code: "822" },
  { code: "28600", name: "Xã Hòa Tịnh", district_code: "822" },
  { code: "28603", name: "Xã Mỹ Tịnh An", district_code: "822" },
  { code: "28606", name: "Xã Tân Bình Thạnh", district_code: "822" },
  { code: "28609", name: "Xã Phú Kiết", district_code: "822" },
  { code: "28612", name: "Xã Lương Hòa Lạc", district_code: "822" },
  { code: "28615", name: "Xã Thanh Bình", district_code: "822" },
  { code: "28618", name: "Xã Quơn Long", district_code: "822" },
  { code: "28621", name: "Xã Bình Phục Nhứt", district_code: "822" },
  { code: "28624", name: "Xã Đăng Hưng Phước", district_code: "822" },
  { code: "28627", name: "Xã Tân Thuận Bình", district_code: "822" },
  { code: "28630", name: "Xã Song Bình", district_code: "822" },
  { code: "28633", name: "Xã Bình Phan", district_code: "822" },
  { code: "28636", name: "Xã Long Bình Điền", district_code: "822" },
  { code: "28639", name: "Xã An Thạnh Thủy", district_code: "822" },
  { code: "28642", name: "Xã Xuân Đông", district_code: "822" },
  { code: "28645", name: "Xã Hòa Định", district_code: "822" },
  { code: "28648", name: "Xã Bình Ninh", district_code: "822" },
  { code: "28651", name: "Thị trấn Vĩnh Bình", district_code: "823" },
  { code: "28654", name: "Xã Đồng Sơn", district_code: "823" },
  { code: "28657", name: "Xã Bình Phú", district_code: "823" },
  { code: "28660", name: "Xã Đồng Thạnh", district_code: "823" },
  { code: "28663", name: "Xã Thành Công", district_code: "823" },
  { code: "28666", name: "Xã Bình Nhì", district_code: "823" },
  { code: "28669", name: "Xã Yên Luông", district_code: "823" },
  { code: "28672", name: "Xã Thạnh Trị", district_code: "823" },
  { code: "28675", name: "Xã Thạnh Nhựt", district_code: "823" },
  { code: "28678", name: "Xã Long Vĩnh", district_code: "823" },
  { code: "28681", name: "Xã Bình Tân", district_code: "823" },
  { code: "28684", name: "Xã Vĩnh Hựu", district_code: "823" },
  { code: "28687", name: "Xã Long Bình", district_code: "823" },
  { code: "28702", name: "Thị trấn Tân Hòa", district_code: "824" },
  { code: "28705", name: "Xã Tăng Hoà", district_code: "824" },
  { code: "28711", name: "Xã Tân Phước", district_code: "824" },
  { code: "28714", name: "Xã Gia Thuận", district_code: "824" },
  { code: "28720", name: "Thị trấn Vàm Láng", district_code: "824" },
  { code: "28723", name: "Xã Tân Tây", district_code: "824" },
  { code: "28726", name: "Xã Kiểng Phước", district_code: "824" },
  { code: "28732", name: "Xã Tân Đông", district_code: "824" },
  { code: "28735", name: "Xã Bình Ân", district_code: "824" },
  { code: "28738", name: "Xã Tân Điền", district_code: "824" },
  { code: "28741", name: "Xã Bình Nghị", district_code: "824" },
  { code: "28744", name: "Xã Phước Trung", district_code: "824" },
  { code: "28747", name: "Xã Tân Thành", district_code: "824" },
  { code: "28690", name: "Xã Tân Thới", district_code: "825" },
  { code: "28693", name: "Xã Tân Phú", district_code: "825" },
  { code: "28696", name: "Xã Phú Thạnh", district_code: "825" },
  { code: "28699", name: "Xã Tân Thạnh", district_code: "825" },
  { code: "28750", name: "Xã Phú Đông", district_code: "825" },
  { code: "28753", name: "Xã Phú Tân", district_code: "825" },
  { code: "28756", name: "Phường Phú Khương", district_code: "829" },
  { code: "28757", name: "Phường Phú Tân", district_code: "829" },
  { code: "28759", name: "Phường 8", district_code: "829" },
  { code: "28762", name: "Phường 6", district_code: "829" },
  { code: "28777", name: "Phường An Hội", district_code: "829" },
  { code: "28780", name: "Phường 7", district_code: "829" },
  { code: "28783", name: "Xã Sơn Đông", district_code: "829" },
  { code: "28786", name: "Xã Phú Hưng", district_code: "829" },
  { code: "28789", name: "Xã Bình Phú", district_code: "829" },
  { code: "28792", name: "Xã Mỹ Thạnh An", district_code: "829" },
  { code: "28795", name: "Xã Nhơn Thạnh", district_code: "829" },
  { code: "28798", name: "Xã Phú Nhuận", district_code: "829" },
  { code: "28804", name: "Xã Tân Thạch", district_code: "831" },
  { code: "28807", name: "Xã Qưới Sơn", district_code: "831" },
  { code: "28810", name: "Thị trấn Châu Thành", district_code: "831" },
  { code: "28813", name: "Xã Giao Long", district_code: "831" },
  { code: "28819", name: "Xã Phú Túc", district_code: "831" },
  { code: "28822", name: "Xã Phú Đức", district_code: "831" },
  { code: "28828", name: "Xã An Phước", district_code: "831" },
  { code: "28831", name: "Xã Tam Phước", district_code: "831" },
  { code: "28834", name: "Xã Thành Triệu", district_code: "831" },
  { code: "28840", name: "Xã Tân Phú", district_code: "831" },
  { code: "28843", name: "Xã Quới Thành", district_code: "831" },
  { code: "28846", name: "Xã Phước Thạnh", district_code: "831" },
  { code: "28852", name: "Xã Tiên Long", district_code: "831" },
  { code: "28855", name: "Xã Tường Đa", district_code: "831" },
  { code: "28858", name: "Xã Hữu Định", district_code: "831" },
  { code: "28861", name: "Thị trấn Tiên Thủy", district_code: "831" },
  { code: "28870", name: "Thị trấn Chợ Lách", district_code: "832" },
  { code: "28873", name: "Xã Phú Phụng", district_code: "832" },
  { code: "28876", name: "Xã Sơn Định", district_code: "832" },
  { code: "28879", name: "Xã Vĩnh Bình", district_code: "832" },
  { code: "28882", name: "Xã Hòa Nghĩa", district_code: "832" },
  { code: "28885", name: "Xã Long Thới", district_code: "832" },
  { code: "28888", name: "Xã Phú Sơn", district_code: "832" },
  { code: "28891", name: "Xã Tân Thiềng", district_code: "832" },
  { code: "28894", name: "Xã Vĩnh Thành", district_code: "832" },
  { code: "28897", name: "Xã Vĩnh Hòa", district_code: "832" },
  { code: "28900", name: "Xã Hưng Khánh Trung B", district_code: "832" },
  { code: "28903", name: "Thị trấn Mỏ Cày", district_code: "833" },
  { code: "28930", name: "Xã Định Thủy", district_code: "833" },
  { code: "28939", name: "Xã Đa Phước Hội", district_code: "833" },
  { code: "28940", name: "Xã Tân Hội", district_code: "833" },
  { code: "28942", name: "Xã Phước Hiệp", district_code: "833" },
  { code: "28945", name: "Xã Bình Khánh", district_code: "833" },
  { code: "28951", name: "Xã An Thạnh", district_code: "833" },
  { code: "28957", name: "Xã An Định", district_code: "833" },
  { code: "28960", name: "Xã Thành Thới B", district_code: "833" },
  { code: "28963", name: "Xã Tân Trung", district_code: "833" },
  { code: "28966", name: "Xã An Thới", district_code: "833" },
  { code: "28969", name: "Xã Thành Thới A", district_code: "833" },
  { code: "28972", name: "Xã Minh Đức", district_code: "833" },
  { code: "28975", name: "Xã Ngãi Đăng", district_code: "833" },
  { code: "28978", name: "Xã Cẩm Sơn", district_code: "833" },
  { code: "28981", name: "Xã Hương Mỹ", district_code: "833" },
  { code: "28984", name: "Thị trấn Giồng Trôm", district_code: "834" },
  { code: "28987", name: "Xã Phong Nẫm", district_code: "834" },
  { code: "28993", name: "Xã Mỹ Thạnh", district_code: "834" },
  { code: "28996", name: "Xã Châu Hòa", district_code: "834" },
  { code: "28999", name: "Xã Lương Hòa", district_code: "834" },
  { code: "29002", name: "Xã Lương Quới", district_code: "834" },
  { code: "29005", name: "Xã Lương Phú", district_code: "834" },
  { code: "29008", name: "Xã Châu Bình", district_code: "834" },
  { code: "29011", name: "Xã Thuận Điền", district_code: "834" },
  { code: "29014", name: "Xã Sơn Phú", district_code: "834" },
  { code: "29017", name: "Xã Bình Hoà", district_code: "834" },
  { code: "29020", name: "Xã Phước Long", district_code: "834" },
  { code: "29023", name: "Xã Hưng Phong", district_code: "834" },
  { code: "29026", name: "Xã Long Mỹ", district_code: "834" },
  { code: "29029", name: "Xã Tân Hào", district_code: "834" },
  { code: "29032", name: "Xã Bình Thành", district_code: "834" },
  { code: "29035", name: "Xã Tân Thanh", district_code: "834" },
  { code: "29038", name: "Xã Tân Lợi Thạnh", district_code: "834" },
  { code: "29041", name: "Xã Thạnh Phú Đông", district_code: "834" },
  { code: "29044", name: "Xã Hưng Nhượng", district_code: "834" },
  { code: "29047", name: "Xã Hưng Lễ", district_code: "834" },
  { code: "29050", name: "Thị trấn Bình Đại", district_code: "835" },
  { code: "29053", name: "Xã Tam Hiệp", district_code: "835" },
  { code: "29056", name: "Xã Long Định", district_code: "835" },
  { code: "29059", name: "Xã Long Hòa", district_code: "835" },
  { code: "29062", name: "Xã Phú Thuận", district_code: "835" },
  { code: "29065", name: "Xã Vang Quới Tây", district_code: "835" },
  { code: "29068", name: "Xã Vang Quới Đông", district_code: "835" },
  { code: "29071", name: "Xã Châu Hưng", district_code: "835" },
  { code: "29077", name: "Xã Lộc Thuận", district_code: "835" },
  { code: "29080", name: "Xã Định Trung", district_code: "835" },
  { code: "29083", name: "Xã Thới Lai", district_code: "835" },
  { code: "29086", name: "Xã Bình Thới", district_code: "835" },
  { code: "29089", name: "Xã Phú Long", district_code: "835" },
  { code: "29092", name: "Xã Bình Thắng", district_code: "835" },
  { code: "29095", name: "Xã Thạnh Trị", district_code: "835" },
  { code: "29098", name: "Xã Đại Hòa Lộc", district_code: "835" },
  { code: "29101", name: "Xã Thừa Đức", district_code: "835" },
  { code: "29104", name: "Xã Thạnh Phước", district_code: "835" },
  { code: "29107", name: "Xã Thới Thuận", district_code: "835" },
  { code: "29110", name: "Thị trấn Ba Tri", district_code: "836" },
  { code: "29116", name: "Xã Mỹ Hòa", district_code: "836" },
  { code: "29119", name: "Xã Tân Xuân", district_code: "836" },
  { code: "29122", name: "Xã Mỹ Chánh", district_code: "836" },
  { code: "29125", name: "Xã Bảo Thạnh", district_code: "836" },
  { code: "29128", name: "Xã An Phú Trung", district_code: "836" },
  { code: "29131", name: "Xã Mỹ Thạnh", district_code: "836" },
  { code: "29134", name: "Xã Mỹ Nhơn", district_code: "836" },
  { code: "29137", name: "Xã Phước Ngãi", district_code: "836" },
  { code: "29143", name: "Xã An Ngãi Trung", district_code: "836" },
  { code: "29146", name: "Xã Phú Lễ", district_code: "836" },
  { code: "29149", name: "Xã An Bình Tây", district_code: "836" },
  { code: "29152", name: "Xã Bảo Thuận", district_code: "836" },
  { code: "29155", name: "Xã Tân Hưng", district_code: "836" },
  { code: "29158", name: "Xã An Ngãi Tây", district_code: "836" },
  { code: "29161", name: "Xã An Hiệp", district_code: "836" },
  { code: "29164", name: "Xã Vĩnh Hòa", district_code: "836" },
  { code: "29167", name: "Xã Tân Thủy", district_code: "836" },
  { code: "29170", name: "Xã Vĩnh An", district_code: "836" },
  { code: "29173", name: "Xã An Đức", district_code: "836" },
  { code: "29176", name: "Xã An Hòa Tây", district_code: "836" },
  { code: "29179", name: "Thị trấn Tiệm Tôm", district_code: "836" },
  { code: "29182", name: "Thị trấn Thạnh Phú", district_code: "837" },
  { code: "29185", name: "Xã Phú Khánh", district_code: "837" },
  { code: "29188", name: "Xã Đại Điền", district_code: "837" },
  { code: "29191", name: "Xã Quới Điền", district_code: "837" },
  { code: "29194", name: "Xã Tân Phong", district_code: "837" },
  { code: "29197", name: "Xã Mỹ Hưng", district_code: "837" },
  { code: "29200", name: "Xã An Thạnh", district_code: "837" },
  { code: "29203", name: "Xã Thới Thạnh", district_code: "837" },
  { code: "29206", name: "Xã Hòa Lợi", district_code: "837" },
  { code: "29209", name: "Xã An Điền", district_code: "837" },
  { code: "29212", name: "Xã Bình Thạnh", district_code: "837" },
  { code: "29215", name: "Xã An Thuận", district_code: "837" },
  { code: "29218", name: "Xã An Quy", district_code: "837" },
  { code: "29221", name: "Xã Thạnh Hải", district_code: "837" },
  { code: "29224", name: "Xã An Nhơn", district_code: "837" },
  { code: "29227", name: "Xã Giao Thạnh", district_code: "837" },
  { code: "29230", name: "Xã Thạnh Phong", district_code: "837" },
  { code: "29233", name: "Xã Mỹ An", district_code: "837" },
  { code: "28889", name: "Xã Phú Mỹ", district_code: "838" },
  { code: "28901", name: "Xã Hưng Khánh Trung A", district_code: "838" },
  { code: "28906", name: "Xã Thanh Tân", district_code: "838" },
  { code: "28909", name: "Xã Thạnh Ngãi", district_code: "838" },
  { code: "28912", name: "Xã Tân Phú Tây", district_code: "838" },
  { code: "28915", name: "Thị trấn Phước Mỹ Trung", district_code: "838" },
  { code: "28918", name: "Xã Tân Thành Bình", district_code: "838" },
  { code: "28921", name: "Xã Thành An", district_code: "838" },
  { code: "28924", name: "Xã Hòa Lộc", district_code: "838" },
  { code: "28927", name: "Xã Tân Thanh Tây", district_code: "838" },
  { code: "28933", name: "Xã Tân Bình", district_code: "838" },
  { code: "28936", name: "Xã Nhuận Phú Tân", district_code: "838" },
  { code: "28948", name: "Xã Khánh Thạnh Tân", district_code: "838" },
  { code: "29236", name: "Phường 4", district_code: "842" },
  { code: "29239", name: "Phường 1", district_code: "842" },
  { code: "29242", name: "Phường 3", district_code: "842" },
  { code: "29248", name: "Phường 5", district_code: "842" },
  { code: "29254", name: "Phường 7", district_code: "842" },
  { code: "29257", name: "Phường 8", district_code: "842" },
  { code: "29260", name: "Phường 9", district_code: "842" },
  { code: "29263", name: "Xã Long Đức", district_code: "842" },
  { code: "29266", name: "Thị trấn Càng Long", district_code: "844" },
  { code: "29269", name: "Xã Mỹ Cẩm", district_code: "844" },
  { code: "29272", name: "Xã An Trường A", district_code: "844" },
  { code: "29275", name: "Xã An Trường", district_code: "844" },
  { code: "29278", name: "Xã Huyền Hội", district_code: "844" },
  { code: "29281", name: "Xã Tân An", district_code: "844" },
  { code: "29284", name: "Xã Tân Bình", district_code: "844" },
  { code: "29287", name: "Xã Bình Phú", district_code: "844" },
  { code: "29290", name: "Xã Phương Thạnh", district_code: "844" },
  { code: "29293", name: "Xã Đại Phúc", district_code: "844" },
  { code: "29296", name: "Xã Đại Phước", district_code: "844" },
  { code: "29299", name: "Xã Nhị Long Phú", district_code: "844" },
  { code: "29302", name: "Xã Nhị Long", district_code: "844" },
  { code: "29305", name: "Xã Đức Mỹ", district_code: "844" },
  { code: "29308", name: "Thị trấn Cầu Kè", district_code: "845" },
  { code: "29311", name: "Xã Hòa Ân", district_code: "845" },
  { code: "29314", name: "Xã Châu Điền", district_code: "845" },
  { code: "29317", name: "Xã An Phú Tân", district_code: "845" },
  { code: "29320", name: "Xã Hoà Tân", district_code: "845" },
  { code: "29323", name: "Xã Ninh Thới", district_code: "845" },
  { code: "29326", name: "Xã Phong Phú", district_code: "845" },
  { code: "29329", name: "Xã Phong Thạnh", district_code: "845" },
  { code: "29332", name: "Xã Tam Ngãi", district_code: "845" },
  { code: "29335", name: "Xã Thông Hòa", district_code: "845" },
  { code: "29338", name: "Xã Thạnh Phú", district_code: "845" },
  { code: "29341", name: "Thị trấn Tiểu Cần", district_code: "846" },
  { code: "29344", name: "Thị trấn Cầu Quan", district_code: "846" },
  { code: "29347", name: "Xã Phú Cần", district_code: "846" },
  { code: "29350", name: "Xã Hiếu Tử", district_code: "846" },
  { code: "29353", name: "Xã Hiếu Trung", district_code: "846" },
  { code: "29356", name: "Xã Long Thới", district_code: "846" },
  { code: "29359", name: "Xã Hùng Hòa", district_code: "846" },
  { code: "29362", name: "Xã Tân Hùng", district_code: "846" },
  { code: "29365", name: "Xã Tập Ngãi", district_code: "846" },
  { code: "29368", name: "Xã Ngãi Hùng", district_code: "846" },
  { code: "29371", name: "Xã Tân Hòa", district_code: "846" },
  { code: "29374", name: "Thị trấn Châu Thành", district_code: "847" },
  { code: "29377", name: "Xã Đa Lộc", district_code: "847" },
  { code: "29380", name: "Xã Mỹ Chánh", district_code: "847" },
  { code: "29383", name: "Xã Thanh Mỹ", district_code: "847" },
  { code: "29386", name: "Xã Lương Hoà A", district_code: "847" },
  { code: "29389", name: "Xã Lương Hòa", district_code: "847" },
  { code: "29392", name: "Xã Song Lộc", district_code: "847" },
  { code: "29395", name: "Xã Nguyệt Hóa", district_code: "847" },
  { code: "29398", name: "Xã Hòa Thuận", district_code: "847" },
  { code: "29401", name: "Xã Hòa Lợi", district_code: "847" },
  { code: "29404", name: "Xã Phước Hảo", district_code: "847" },
  { code: "29407", name: "Xã Hưng Mỹ", district_code: "847" },
  { code: "29410", name: "Xã Hòa Minh", district_code: "847" },
  { code: "29413", name: "Xã Long Hòa", district_code: "847" },
  { code: "29416", name: "Thị trấn Cầu Ngang", district_code: "848" },
  { code: "29419", name: "Thị trấn Mỹ Long", district_code: "848" },
  { code: "29422", name: "Xã Mỹ Long Bắc", district_code: "848" },
  { code: "29425", name: "Xã Mỹ Long Nam", district_code: "848" },
  { code: "29428", name: "Xã Mỹ Hòa", district_code: "848" },
  { code: "29431", name: "Xã Vĩnh Kim", district_code: "848" },
  { code: "29434", name: "Xã Kim Hòa", district_code: "848" },
  { code: "29437", name: "Xã Hiệp Hòa", district_code: "848" },
  { code: "29440", name: "Xã Thuận Hòa", district_code: "848" },
  { code: "29443", name: "Xã Long Sơn", district_code: "848" },
  { code: "29446", name: "Xã Nhị Trường", district_code: "848" },
  { code: "29449", name: "Xã Trường Thọ", district_code: "848" },
  { code: "29452", name: "Xã Hiệp Mỹ Đông", district_code: "848" },
  { code: "29455", name: "Xã Hiệp Mỹ Tây", district_code: "848" },
  { code: "29458", name: "Xã Thạnh Hòa Sơn", district_code: "848" },
  { code: "29461", name: "Thị trấn Trà Cú", district_code: "849" },
  { code: "29462", name: "Thị trấn Định An", district_code: "849" },
  { code: "29464", name: "Xã Phước Hưng", district_code: "849" },
  { code: "29467", name: "Xã Tập Sơn", district_code: "849" },
  { code: "29470", name: "Xã Tân Sơn", district_code: "849" },
  { code: "29473", name: "Xã An Quảng Hữu", district_code: "849" },
  { code: "29476", name: "Xã Lưu Nghiệp Anh", district_code: "849" },
  { code: "29479", name: "Xã Ngãi Xuyên", district_code: "849" },
  { code: "29482", name: "Xã Kim Sơn", district_code: "849" },
  { code: "29485", name: "Xã Thanh Sơn", district_code: "849" },
  { code: "29488", name: "Xã Hàm Giang", district_code: "849" },
  { code: "29489", name: "Xã Hàm Tân", district_code: "849" },
  { code: "29491", name: "Xã Đại An", district_code: "849" },
  { code: "29494", name: "Xã Định An", district_code: "849" },
  { code: "29503", name: "Xã Ngọc Biên", district_code: "849" },
  { code: "29506", name: "Xã Long Hiệp", district_code: "849" },
  { code: "29509", name: "Xã Tân Hiệp", district_code: "849" },
  { code: "29497", name: "Xã Đôn Xuân", district_code: "850" },
  { code: "29500", name: "Xã Đôn Châu", district_code: "850" },
  { code: "29513", name: "Thị trấn Long Thành", district_code: "850" },
  { code: "29521", name: "Xã Long Khánh", district_code: "850" },
  { code: "29530", name: "Xã Ngũ Lạc", district_code: "850" },
  { code: "29533", name: "Xã Long Vĩnh", district_code: "850" },
  { code: "29536", name: "Xã Đông Hải", district_code: "850" },
  { code: "29512", name: "Phường 1", district_code: "851" },
  { code: "29515", name: "Xã Long Toàn", district_code: "851" },
  { code: "29516", name: "Phường 2", district_code: "851" },
  { code: "29518", name: "Xã Long Hữu", district_code: "851" },
  { code: "29524", name: "Xã Dân Thành", district_code: "851" },
  { code: "29527", name: "Xã Trường Long Hòa", district_code: "851" },
  { code: "29539", name: "Xã Hiệp Thạnh", district_code: "851" },
  { code: "29542", name: "Phường 9", district_code: "855" },
  { code: "29545", name: "Phường 5", district_code: "855" },
  { code: "29551", name: "Phường 1", district_code: "855" },
  { code: "29554", name: "Phường 4", district_code: "855" },
  { code: "29557", name: "Phường 3", district_code: "855" },
  { code: "29560", name: "Phường 8", district_code: "855" },
  { code: "29563", name: "Phường Tân Ngãi", district_code: "855" },
  { code: "29566", name: "Phường Tân Hòa", district_code: "855" },
  { code: "29569", name: "Phường Tân Hội", district_code: "855" },
  { code: "29572", name: "Phường Trường An", district_code: "855" },
  { code: "29578", name: "Xã Đồng Phú", district_code: "857" },
  { code: "29581", name: "Xã Bình Hòa Phước", district_code: "857" },
  { code: "29584", name: "Xã Hòa Ninh", district_code: "857" },
  { code: "29587", name: "Xã An Bình", district_code: "857" },
  { code: "29590", name: "Xã Thanh Đức", district_code: "857" },
  { code: "29593", name: "Xã Tân Hạnh", district_code: "857" },
  { code: "29596", name: "Xã Phước Hậu", district_code: "857" },
  { code: "29599", name: "Xã Long Phước", district_code: "857" },
  { code: "29602", name: "Thị trấn Long Hồ", district_code: "857" },
  { code: "29605", name: "Xã Lộc Hòa", district_code: "857" },
  { code: "29608", name: "Xã Long An", district_code: "857" },
  { code: "29611", name: "Xã Phú Quới", district_code: "857" },
  { code: "29614", name: "Xã Thạnh Quới", district_code: "857" },
  { code: "29617", name: "Xã Hòa Phú", district_code: "857" },
  { code: "29623", name: "Xã Mỹ An", district_code: "858" },
  { code: "29626", name: "Xã Mỹ Phước", district_code: "858" },
  { code: "29629", name: "Xã An Phước", district_code: "858" },
  { code: "29632", name: "Xã Nhơn Phú", district_code: "858" },
  { code: "29635", name: "Xã Long Mỹ", district_code: "858" },
  { code: "29638", name: "Xã Hòa Tịnh", district_code: "858" },
  { code: "29641", name: "Thị trấn Cái Nhum", district_code: "858" },
  { code: "29644", name: "Xã Bình Phước", district_code: "858" },
  { code: "29647", name: "Xã Chánh An", district_code: "858" },
  { code: "29650", name: "Xã Tân An Hội", district_code: "858" },
  { code: "29653", name: "Xã Tân Long", district_code: "858" },
  { code: "29656", name: "Xã Tân Long Hội", district_code: "858" },
  { code: "29659", name: "Thị trấn Vũng Liêm", district_code: "859" },
  { code: "29662", name: "Xã Tân Quới Trung", district_code: "859" },
  { code: "29665", name: "Xã Quới Thiện", district_code: "859" },
  { code: "29668", name: "Xã Quới An", district_code: "859" },
  { code: "29671", name: "Xã Trung Chánh", district_code: "859" },
  { code: "29674", name: "Xã Tân An Luông", district_code: "859" },
  { code: "29677", name: "Xã Thanh Bình", district_code: "859" },
  { code: "29680", name: "Xã Trung Thành Tây", district_code: "859" },
  { code: "29683", name: "Xã Trung Hiệp", district_code: "859" },
  { code: "29686", name: "Xã Hiếu Phụng", district_code: "859" },
  { code: "29689", name: "Xã Trung Thành Đông", district_code: "859" },
  { code: "29692", name: "Xã Trung Thành", district_code: "859" },
  { code: "29695", name: "Xã Trung Hiếu", district_code: "859" },
  { code: "29698", name: "Xã Trung Ngãi", district_code: "859" },
  { code: "29701", name: "Xã Hiếu Thuận", district_code: "859" },
  { code: "29704", name: "Xã Trung Nghĩa", district_code: "859" },
  { code: "29707", name: "Xã Trung An", district_code: "859" },
  { code: "29710", name: "Xã Hiếu Nhơn", district_code: "859" },
  { code: "29713", name: "Xã Hiếu Thành", district_code: "859" },
  { code: "29716", name: "Xã Hiếu Nghĩa", district_code: "859" },
  { code: "29719", name: "Thị trấn Tam Bình", district_code: "860" },
  { code: "29722", name: "Xã Tân Lộc", district_code: "860" },
  { code: "29725", name: "Xã Phú Thịnh", district_code: "860" },
  { code: "29728", name: "Xã Hậu Lộc", district_code: "860" },
  { code: "29731", name: "Xã Hòa Thạnh", district_code: "860" },
  { code: "29734", name: "Xã Hoà Lộc", district_code: "860" },
  { code: "29737", name: "Xã Phú Lộc", district_code: "860" },
  { code: "29740", name: "Xã Song Phú", district_code: "860" },
  { code: "29743", name: "Xã Hòa Hiệp", district_code: "860" },
  { code: "29746", name: "Xã Mỹ Lộc", district_code: "860" },
  { code: "29749", name: "Xã Tân Phú", district_code: "860" },
  { code: "29752", name: "Xã Long Phú", district_code: "860" },
  { code: "29755", name: "Xã Mỹ Thạnh Trung", district_code: "860" },
  { code: "29761", name: "Xã Loan Mỹ", district_code: "860" },
  { code: "29764", name: "Xã Ngãi Tứ", district_code: "860" },
  { code: "29767", name: "Xã Bình Ninh", district_code: "860" },
  { code: "29770", name: "Phường Cái Vồn", district_code: "861" },
  { code: "29771", name: "Phường Thành Phước", district_code: "861" },
  { code: "29806", name: "Xã Thuận An", district_code: "861" },
  { code: "29809", name: "Xã Đông Thạnh", district_code: "861" },
  { code: "29812", name: "Xã Đông Bình", district_code: "861" },
  { code: "29813", name: "Phường Đông Thuận", district_code: "861" },
  { code: "29815", name: "Xã Mỹ Hòa", district_code: "861" },
  { code: "29818", name: "Xã Đông Thành", district_code: "861" },
  { code: "29821", name: "Thị trấn Trà Ôn", district_code: "862" },
  { code: "29824", name: "Xã Xuân Hiệp", district_code: "862" },
  { code: "29827", name: "Xã Nhơn Bình", district_code: "862" },
  { code: "29830", name: "Xã Hòa Bình", district_code: "862" },
  { code: "29833", name: "Xã Thới Hòa", district_code: "862" },
  { code: "29836", name: "Xã Trà Côn", district_code: "862" },
  { code: "29839", name: "Xã Tân Mỹ", district_code: "862" },
  { code: "29842", name: "Xã Hựu Thành", district_code: "862" },
  { code: "29845", name: "Xã Vĩnh Xuân", district_code: "862" },
  { code: "29848", name: "Xã Thuận Thới", district_code: "862" },
  { code: "29851", name: "Xã Phú Thành", district_code: "862" },
  { code: "29857", name: "Xã Lục Sỹ Thành", district_code: "862" },
  { code: "29860", name: "Xã Tích Thiện", district_code: "862" },
  { code: "29776", name: "Xã Tân Thành", district_code: "863" },
  { code: "29779", name: "Xã Thành Trung", district_code: "863" },
  { code: "29782", name: "Xã Tân An Thạnh", district_code: "863" },
  { code: "29785", name: "Xã Tân Lược", district_code: "863" },
  { code: "29788", name: "Xã Nguyễn Văn Thảnh", district_code: "863" },
  { code: "29791", name: "Xã Thành Lợi", district_code: "863" },
  { code: "29794", name: "Xã Mỹ Thuận", district_code: "863" },
  { code: "29797", name: "Xã Tân Bình", district_code: "863" },
  { code: "29800", name: "Thị trấn Tân Quới", district_code: "863" },
  { code: "29869", name: "Phường 1", district_code: "866" },
  { code: "29872", name: "Phường 4", district_code: "866" },
  { code: "29875", name: "Phường 3", district_code: "866" },
  { code: "29878", name: "Phường 6", district_code: "866" },
  { code: "29881", name: "Phường Mỹ Ngãi", district_code: "866" },
  { code: "29884", name: "Xã Mỹ Tân", district_code: "866" },
  { code: "29887", name: "Xã Mỹ Trà", district_code: "866" },
  { code: "29888", name: "Phường Mỹ Phú", district_code: "866" },
  { code: "29890", name: "Xã Tân Thuận Tây", district_code: "866" },
  { code: "29892", name: "Phường Hoà Thuận", district_code: "866" },
  { code: "29893", name: "Xã Hòa An", district_code: "866" },
  { code: "29896", name: "Xã Tân Thuận Đông", district_code: "866" },
  { code: "29899", name: "Xã Tịnh Thới", district_code: "866" },
  { code: "29902", name: "Phường 3", district_code: "867" },
  { code: "29905", name: "Phường 1", district_code: "867" },
  { code: "29908", name: "Phường 4", district_code: "867" },
  { code: "29911", name: "Phường 2", district_code: "867" },
  { code: "29914", name: "Xã Tân Khánh Đông", district_code: "867" },
  { code: "29917", name: "Phường Tân Quy Đông", district_code: "867" },
  { code: "29919", name: "Phường An Hoà", district_code: "867" },
  { code: "29920", name: "Xã Tân Quy Tây", district_code: "867" },
  { code: "29923", name: "Xã Tân Phú Đông", district_code: "867" },
  { code: "29954", name: "Phường An Lộc", district_code: "868" },
  { code: "29955", name: "Phường An Thạnh", district_code: "868" },
  { code: "29959", name: "Xã Bình Thạnh", district_code: "868" },
  { code: "29965", name: "Xã Tân Hội", district_code: "868" },
  { code: "29978", name: "Phường An Lạc", district_code: "868" },
  { code: "29986", name: "Phường An Bình B", district_code: "868" },
  { code: "29989", name: "Phường An Bình A", district_code: "868" },
  { code: "29926", name: "Thị trấn Sa Rài", district_code: "869" },
  { code: "29929", name: "Xã Tân Hộ Cơ", district_code: "869" },
  { code: "29932", name: "Xã Thông Bình", district_code: "869" },
  { code: "29935", name: "Xã Bình Phú", district_code: "869" },
  { code: "29938", name: "Xã Tân Thành A", district_code: "869" },
  { code: "29941", name: "Xã Tân Thành B", district_code: "869" },
  { code: "29944", name: "Xã Tân Phước", district_code: "869" },
  { code: "29947", name: "Xã Tân Công Chí", district_code: "869" },
  { code: "29950", name: "Xã An Phước", district_code: "869" },
  { code: "29956", name: "Xã Thường Phước 1", district_code: "870" },
  { code: "29962", name: "Xã Thường Thới Hậu A", district_code: "870" },
  { code: "29971", name: "Thị trấn Thường Thới Tiền", district_code: "870" },
  { code: "29974", name: "Xã Thường Phước 2", district_code: "870" },
  { code: "29977", name: "Xã Thường Lạc", district_code: "870" },
  { code: "29980", name: "Xã Long Khánh A", district_code: "870" },
  { code: "29983", name: "Xã Long Khánh B", district_code: "870" },
  { code: "29992", name: "Xã Long Thuận", district_code: "870" },
  { code: "29995", name: "Xã Phú Thuận B", district_code: "870" },
  { code: "29998", name: "Xã Phú Thuận A", district_code: "870" },
  { code: "30001", name: "Thị trấn Tràm Chim", district_code: "871" },
  { code: "30004", name: "Xã Hoà Bình", district_code: "871" },
  { code: "30007", name: "Xã Tân Công Sính", district_code: "871" },
  { code: "30010", name: "Xã Phú Hiệp", district_code: "871" },
  { code: "30013", name: "Xã Phú Đức", district_code: "871" },
  { code: "30016", name: "Xã Phú Thành B", district_code: "871" },
  { code: "30019", name: "Xã An Hòa", district_code: "871" },
  { code: "30022", name: "Xã An Long", district_code: "871" },
  { code: "30025", name: "Xã Phú Cường", district_code: "871" },
  { code: "30028", name: "Xã Phú Ninh", district_code: "871" },
  { code: "30031", name: "Xã Phú Thọ", district_code: "871" },
  { code: "30034", name: "Xã Phú Thành A", district_code: "871" },
  { code: "30037", name: "Thị trấn Mỹ An", district_code: "872" },
  { code: "30040", name: "Xã Thạnh Lợi", district_code: "872" },
  { code: "30043", name: "Xã Hưng Thạnh", district_code: "872" },
  { code: "30046", name: "Xã Trường Xuân", district_code: "872" },
  { code: "30049", name: "Xã Tân Kiều", district_code: "872" },
  { code: "30052", name: "Xã Mỹ Hòa", district_code: "872" },
  { code: "30055", name: "Xã Mỹ Quý", district_code: "872" },
  { code: "30058", name: "Xã Mỹ Đông", district_code: "872" },
  { code: "30061", name: "Xã Đốc Binh Kiều", district_code: "872" },
  { code: "30064", name: "Xã Mỹ An", district_code: "872" },
  { code: "30067", name: "Xã Phú Điền", district_code: "872" },
  { code: "30070", name: "Xã Láng Biển", district_code: "872" },
  { code: "30073", name: "Xã Thanh Mỹ", district_code: "872" },
  { code: "30076", name: "Thị trấn Mỹ Thọ", district_code: "873" },
  { code: "30079", name: "Xã Gáo Giồng", district_code: "873" },
  { code: "30082", name: "Xã Phương Thịnh", district_code: "873" },
  { code: "30085", name: "Xã Ba Sao", district_code: "873" },
  { code: "30088", name: "Xã Phong Mỹ", district_code: "873" },
  { code: "30091", name: "Xã Tân Nghĩa", district_code: "873" },
  { code: "30094", name: "Xã Phương Trà", district_code: "873" },
  { code: "30097", name: "Xã Nhị Mỹ", district_code: "873" },
  { code: "30100", name: "Xã Mỹ Thọ", district_code: "873" },
  { code: "30103", name: "Xã Tân Hội Trung", district_code: "873" },
  { code: "30106", name: "Xã An Bình", district_code: "873" },
  { code: "30109", name: "Xã Mỹ Hội", district_code: "873" },
  { code: "30112", name: "Xã Mỹ Hiệp", district_code: "873" },
  { code: "30115", name: "Xã Mỹ Long", district_code: "873" },
  { code: "30118", name: "Xã Bình Hàng Trung", district_code: "873" },
  { code: "30121", name: "Xã Mỹ Xương", district_code: "873" },
  { code: "30124", name: "Xã Bình Hàng Tây", district_code: "873" },
  { code: "30127", name: "Xã Bình Thạnh", district_code: "873" },
  { code: "30130", name: "Thị trấn Thanh Bình", district_code: "874" },
  { code: "30133", name: "Xã Tân Quới", district_code: "874" },
  { code: "30136", name: "Xã Tân Hòa", district_code: "874" },
  { code: "30139", name: "Xã An Phong", district_code: "874" },
  { code: "30142", name: "Xã Phú Lợi", district_code: "874" },
  { code: "30145", name: "Xã Tân Mỹ", district_code: "874" },
  { code: "30148", name: "Xã Bình Tấn", district_code: "874" },
  { code: "30151", name: "Xã Tân Huề", district_code: "874" },
  { code: "30154", name: "Xã Tân Bình", district_code: "874" },
  { code: "30157", name: "Xã Tân Thạnh", district_code: "874" },
  { code: "30160", name: "Xã Tân Phú", district_code: "874" },
  { code: "30163", name: "Xã Bình Thành", district_code: "874" },
  { code: "30166", name: "Xã Tân Long", district_code: "874" },
  { code: "30169", name: "Thị trấn Lấp Vò", district_code: "875" },
  { code: "30172", name: "Xã Mỹ An Hưng A", district_code: "875" },
  { code: "30175", name: "Xã Tân Mỹ", district_code: "875" },
  { code: "30178", name: "Xã Mỹ An Hưng B", district_code: "875" },
  { code: "30181", name: "Xã Tân Khánh Trung", district_code: "875" },
  { code: "30184", name: "Xã Long Hưng A", district_code: "875" },
  { code: "30187", name: "Xã Vĩnh Thạnh", district_code: "875" },
  { code: "30190", name: "Xã Long Hưng B", district_code: "875" },
  { code: "30193", name: "Xã Bình Thành", district_code: "875" },
  { code: "30196", name: "Xã Định An", district_code: "875" },
  { code: "30199", name: "Xã Định Yên", district_code: "875" },
  { code: "30202", name: "Xã Hội An Đông", district_code: "875" },
  { code: "30205", name: "Xã Bình Thạnh Trung", district_code: "875" },
  { code: "30208", name: "Thị trấn Lai Vung", district_code: "876" },
  { code: "30211", name: "Xã Tân Dương", district_code: "876" },
  { code: "30214", name: "Xã Hòa Thành", district_code: "876" },
  { code: "30217", name: "Xã Long Hậu", district_code: "876" },
  { code: "30220", name: "Xã Tân Phước", district_code: "876" },
  { code: "30223", name: "Xã Hòa Long", district_code: "876" },
  { code: "30226", name: "Xã Tân Thành", district_code: "876" },
  { code: "30229", name: "Xã Long Thắng", district_code: "876" },
  { code: "30232", name: "Xã Vĩnh Thới", district_code: "876" },
  { code: "30235", name: "Xã Tân Hòa", district_code: "876" },
  { code: "30238", name: "Xã Định Hòa", district_code: "876" },
  { code: "30241", name: "Xã Phong Hòa", district_code: "876" },
  { code: "30244", name: "Thị trấn Cái Tàu Hạ", district_code: "877" },
  { code: "30247", name: "Xã An Hiệp", district_code: "877" },
  { code: "30250", name: "Xã An Nhơn", district_code: "877" },
  { code: "30253", name: "Xã Tân Nhuận Đông", district_code: "877" },
  { code: "30256", name: "Xã Tân Bình", district_code: "877" },
  { code: "30259", name: "Xã Tân Phú Trung", district_code: "877" },
  { code: "30262", name: "Xã Phú Long", district_code: "877" },
  { code: "30265", name: "Xã An Phú Thuận", district_code: "877" },
  { code: "30268", name: "Xã Phú Hựu", district_code: "877" },
  { code: "30271", name: "Xã An Khánh", district_code: "877" },
  { code: "30274", name: "Xã Tân Phú", district_code: "877" },
  { code: "30277", name: "Xã Hòa Tân", district_code: "877" },
  { code: "30280", name: "Phường Mỹ Bình", district_code: "883" },
  { code: "30283", name: "Phường Mỹ Long", district_code: "883" },
  { code: "30286", name: "Phường Mỹ Xuyên", district_code: "883" },
  { code: "30289", name: "Phường Bình Đức", district_code: "883" },
  { code: "30292", name: "Phường Bình Khánh", district_code: "883" },
  { code: "30295", name: "Phường Mỹ Phước", district_code: "883" },
  { code: "30298", name: "Phường Mỹ Quý", district_code: "883" },
  { code: "30301", name: "Phường Mỹ Thới", district_code: "883" },
  { code: "30304", name: "Phường Mỹ Thạnh", district_code: "883" },
  { code: "30307", name: "Phường Mỹ Hòa", district_code: "883" },
  { code: "30310", name: "Xã Mỹ Khánh", district_code: "883" },
  { code: "30313", name: "Xã Mỹ Hoà Hưng", district_code: "883" },
  { code: "30316", name: "Phường Châu Phú B", district_code: "884" },
  { code: "30319", name: "Phường Châu Phú A", district_code: "884" },
  { code: "30322", name: "Phường Vĩnh Mỹ", district_code: "884" },
  { code: "30325", name: "Phường Núi Sam", district_code: "884" },
  { code: "30328", name: "Phường Vĩnh Ngươn", district_code: "884" },
  { code: "30331", name: "Xã Vĩnh Tế", district_code: "884" },
  { code: "30334", name: "Xã Vĩnh Châu", district_code: "884" },
  { code: "30337", name: "Thị trấn An Phú", district_code: "886" },
  { code: "30340", name: "Xã Khánh An", district_code: "886" },
  { code: "30341", name: "Thị trấn Long Bình", district_code: "886" },
  { code: "30343", name: "Xã Khánh Bình", district_code: "886" },
  { code: "30346", name: "Xã Quốc Thái", district_code: "886" },
  { code: "30349", name: "Xã Nhơn Hội", district_code: "886" },
  { code: "30352", name: "Xã Phú Hữu", district_code: "886" },
  { code: "30355", name: "Xã Phú Hội", district_code: "886" },
  { code: "30358", name: "Xã Phước Hưng", district_code: "886" },
  { code: "30361", name: "Xã Vĩnh Lộc", district_code: "886" },
  { code: "30364", name: "Xã Vĩnh Hậu", district_code: "886" },
  { code: "30367", name: "Xã Vĩnh Trường", district_code: "886" },
  { code: "30370", name: "Xã Vĩnh Hội Đông", district_code: "886" },
  { code: "30373", name: "Thị trấn Đa Phước", district_code: "886" },
  { code: "30376", name: "Phường Long Thạnh", district_code: "887" },
  { code: "30377", name: "Phường Long Hưng", district_code: "887" },
  { code: "30378", name: "Phường Long Châu", district_code: "887" },
  { code: "30379", name: "Xã Phú Lộc", district_code: "887" },
  { code: "30382", name: "Xã Vĩnh Xương", district_code: "887" },
  { code: "30385", name: "Xã Vĩnh Hòa", district_code: "887" },
  { code: "30387", name: "Xã Tân Thạnh", district_code: "887" },
  { code: "30388", name: "Xã Tân An", district_code: "887" },
  { code: "30391", name: "Xã Long An", district_code: "887" },
  { code: "30394", name: "Phường Long Phú", district_code: "887" },
  { code: "30397", name: "Xã Châu Phong", district_code: "887" },
  { code: "30400", name: "Xã Phú Vĩnh", district_code: "887" },
  { code: "30403", name: "Xã Lê Chánh", district_code: "887" },
  { code: "30412", name: "Phường Long Sơn", district_code: "887" },
  { code: "30406", name: "Thị trấn Phú Mỹ", district_code: "888" },
  { code: "30409", name: "Thị trấn Chợ Vàm", district_code: "888" },
  { code: "30415", name: "Xã Long Hoà", district_code: "888" },
  { code: "30418", name: "Xã Phú Long", district_code: "888" },
  { code: "30421", name: "Xã Phú Lâm", district_code: "888" },
  { code: "30424", name: "Xã Phú Hiệp", district_code: "888" },
  { code: "30427", name: "Xã Phú Thạnh", district_code: "888" },
  { code: "30430", name: "Xã Hoà Lạc", district_code: "888" },
  { code: "30433", name: "Xã Phú Thành", district_code: "888" },
  { code: "30436", name: "Xã Phú An", district_code: "888" },
  { code: "30439", name: "Xã Phú Xuân", district_code: "888" },
  { code: "30442", name: "Xã Hiệp Xương", district_code: "888" },
  { code: "30445", name: "Xã Phú Bình", district_code: "888" },
  { code: "30448", name: "Xã Phú Thọ", district_code: "888" },
  { code: "30451", name: "Xã Phú Hưng", district_code: "888" },
  { code: "30454", name: "Xã Bình Thạnh Đông", district_code: "888" },
  { code: "30457", name: "Xã Tân Hòa", district_code: "888" },
  { code: "30460", name: "Xã Tân Trung", district_code: "888" },
  { code: "30463", name: "Thị trấn Cái Dầu", district_code: "889" },
  { code: "30466", name: "Xã Khánh Hòa", district_code: "889" },
  { code: "30469", name: "Xã Mỹ Đức", district_code: "889" },
  { code: "30472", name: "Xã Mỹ Phú", district_code: "889" },
  { code: "30475", name: "Xã Ô Long Vỹ", district_code: "889" },
  { code: "30478", name: "Thị trấn Vĩnh Thạnh Trung", district_code: "889" },
  { code: "30481", name: "Xã Thạnh Mỹ Tây", district_code: "889" },
  { code: "30484", name: "Xã Bình Long", district_code: "889" },
  { code: "30487", name: "Xã Bình Mỹ", district_code: "889" },
  { code: "30490", name: "Xã Bình Thủy", district_code: "889" },
  { code: "30493", name: "Xã Đào Hữu Cảnh", district_code: "889" },
  { code: "30496", name: "Xã Bình Phú", district_code: "889" },
  { code: "30499", name: "Xã Bình Chánh", district_code: "889" },
  { code: "30502", name: "Phường Nhà Bàng", district_code: "890" },
  { code: "30505", name: "Phường Chi Lăng", district_code: "890" },
  { code: "30508", name: "Phường Núi Voi", district_code: "890" },
  { code: "30511", name: "Phường Nhơn Hưng", district_code: "890" },
  { code: "30514", name: "Phường An Phú", district_code: "890" },
  { code: "30517", name: "Phường Thới Sơn", district_code: "890" },
  { code: "30520", name: "Phường Tịnh Biên", district_code: "890" },
  { code: "30523", name: "Xã Văn Giáo", district_code: "890" },
  { code: "30526", name: "Xã An Cư", district_code: "890" },
  { code: "30529", name: "Xã An Nông", district_code: "890" },
  { code: "30532", name: "Xã Vĩnh Trung", district_code: "890" },
  { code: "30535", name: "Xã Tân Lợi", district_code: "890" },
  { code: "30538", name: "Xã An Hảo", district_code: "890" },
  { code: "30541", name: "Xã Tân Lập", district_code: "890" },
  { code: "30544", name: "Thị trấn Tri Tôn", district_code: "891" },
  { code: "30547", name: "Thị trấn Ba Chúc", district_code: "891" },
  { code: "30550", name: "Xã Lạc Quới", district_code: "891" },
  { code: "30553", name: "Xã Lê Trì", district_code: "891" },
  { code: "30556", name: "Xã Vĩnh Gia", district_code: "891" },
  { code: "30559", name: "Xã Vĩnh Phước", district_code: "891" },
  { code: "30562", name: "Xã Châu Lăng", district_code: "891" },
  { code: "30565", name: "Xã Lương Phi", district_code: "891" },
  { code: "30568", name: "Xã Lương An Trà", district_code: "891" },
  { code: "30571", name: "Xã Tà Đảnh", district_code: "891" },
  { code: "30574", name: "Xã Núi Tô", district_code: "891" },
  { code: "30577", name: "Xã An Tức", district_code: "891" },
  { code: "30580", name: "Thị trấn Cô Tô", district_code: "891" },
  { code: "30583", name: "Xã Tân Tuyến", district_code: "891" },
  { code: "30586", name: "Xã Ô Lâm", district_code: "891" },
  { code: "30589", name: "Thị trấn An Châu", district_code: "892" },
  { code: "30592", name: "Xã An Hòa", district_code: "892" },
  { code: "30595", name: "Xã Cần Đăng", district_code: "892" },
  { code: "30598", name: "Xã Vĩnh Hanh", district_code: "892" },
  { code: "30601", name: "Xã Bình Thạnh", district_code: "892" },
  { code: "30604", name: "Thị trấn Vĩnh Bình", district_code: "892" },
  { code: "30607", name: "Xã Bình Hòa", district_code: "892" },
  { code: "30610", name: "Xã Vĩnh An", district_code: "892" },
  { code: "30613", name: "Xã Hòa Bình Thạnh", district_code: "892" },
  { code: "30616", name: "Xã Vĩnh Lợi", district_code: "892" },
  { code: "30619", name: "Xã Vĩnh Nhuận", district_code: "892" },
  { code: "30622", name: "Xã Tân Phú", district_code: "892" },
  { code: "30625", name: "Xã Vĩnh Thành", district_code: "892" },
  { code: "30628", name: "Thị trấn Chợ Mới", district_code: "893" },
  { code: "30631", name: "Thị trấn Mỹ Luông", district_code: "893" },
  { code: "30634", name: "Xã Kiến An", district_code: "893" },
  { code: "30637", name: "Xã Mỹ Hội Đông", district_code: "893" },
  { code: "30640", name: "Xã Long Điền A", district_code: "893" },
  { code: "30643", name: "Xã Tấn Mỹ", district_code: "893" },
  { code: "30646", name: "Xã Long Điền B", district_code: "893" },
  { code: "30649", name: "Xã Kiến Thành", district_code: "893" },
  { code: "30652", name: "Xã Mỹ Hiệp", district_code: "893" },
  { code: "30655", name: "Xã Mỹ An", district_code: "893" },
  { code: "30658", name: "Xã Nhơn Mỹ", district_code: "893" },
  { code: "30661", name: "Xã Long Giang", district_code: "893" },
  { code: "30664", name: "Xã Long Kiến", district_code: "893" },
  { code: "30667", name: "Xã Bình Phước Xuân", district_code: "893" },
  { code: "30670", name: "Xã An Thạnh Trung", district_code: "893" },
  { code: "30673", name: "Thị trấn Hội An", district_code: "893" },
  { code: "30676", name: "Xã Hòa Bình", district_code: "893" },
  { code: "30679", name: "Xã Hòa An", district_code: "893" },
  { code: "30682", name: "Thị trấn Núi Sập", district_code: "894" },
  { code: "30685", name: "Thị trấn Phú Hoà", district_code: "894" },
  { code: "30688", name: "Thị trấn Óc Eo", district_code: "894" },
  { code: "30691", name: "Xã Tây Phú", district_code: "894" },
  { code: "30692", name: "Xã An Bình", district_code: "894" },
  { code: "30694", name: "Xã Vĩnh Phú", district_code: "894" },
  { code: "30697", name: "Xã Vĩnh Trạch", district_code: "894" },
  { code: "30700", name: "Xã Phú Thuận", district_code: "894" },
  { code: "30703", name: "Xã Vĩnh Chánh", district_code: "894" },
  { code: "30706", name: "Xã Định Mỹ", district_code: "894" },
  { code: "30709", name: "Xã Định Thành", district_code: "894" },
  { code: "30712", name: "Xã Mỹ Phú Đông", district_code: "894" },
  { code: "30715", name: "Xã Vọng Đông", district_code: "894" },
  { code: "30718", name: "Xã Vĩnh Khánh", district_code: "894" },
  { code: "30721", name: "Xã Thoại Giang", district_code: "894" },
  { code: "30724", name: "Xã Bình Thành", district_code: "894" },
  { code: "30727", name: "Xã Vọng Thê", district_code: "894" },
  { code: "30733", name: "Phường Vĩnh Thanh", district_code: "899" },
  { code: "30736", name: "Phường Vĩnh Quang", district_code: "899" },
  { code: "30739", name: "Phường Vĩnh Hiệp", district_code: "899" },
  { code: "30742", name: "Phường Vĩnh Thanh Vân", district_code: "899" },
  { code: "30745", name: "Phường Vĩnh Lạc", district_code: "899" },
  { code: "30748", name: "Phường An Hòa", district_code: "899" },
  { code: "30751", name: "Phường An Bình", district_code: "899" },
  { code: "30754", name: "Phường Rạch Sỏi", district_code: "899" },
  { code: "30757", name: "Phường Vĩnh Lợi", district_code: "899" },
  { code: "30760", name: "Phường Vĩnh Thông", district_code: "899" },
  { code: "30763", name: "Xã Phi Thông", district_code: "899" },
  { code: "30766", name: "Phường Tô Châu", district_code: "900" },
  { code: "30769", name: "Phường Đông Hồ", district_code: "900" },
  { code: "30772", name: "Phường Bình San", district_code: "900" },
  { code: "30775", name: "Phường Pháo Đài", district_code: "900" },
  { code: "30778", name: "Phường Mỹ Đức", district_code: "900" },
  { code: "30781", name: "Xã Tiên Hải", district_code: "900" },
  { code: "30784", name: "Xã Thuận Yên", district_code: "900" },
  { code: "30787", name: "Thị trấn Kiên Lương", district_code: "902" },
  { code: "30790", name: "Xã Kiên Bình", district_code: "902" },
  { code: "30802", name: "Xã Hòa Điền", district_code: "902" },
  { code: "30805", name: "Xã Dương Hòa", district_code: "902" },
  { code: "30808", name: "Xã Bình An", district_code: "902" },
  { code: "30809", name: "Xã Bình Trị", district_code: "902" },
  { code: "30811", name: "Xã Sơn Hải", district_code: "902" },
  { code: "30814", name: "Xã Hòn Nghệ", district_code: "902" },
  { code: "30817", name: "Thị trấn Hòn Đất", district_code: "903" },
  { code: "30820", name: "Thị trấn Sóc Sơn", district_code: "903" },
  { code: "30823", name: "Xã Bình Sơn", district_code: "903" },
  { code: "30826", name: "Xã Bình Giang", district_code: "903" },
  { code: "30828", name: "Xã Mỹ Thái", district_code: "903" },
  { code: "30829", name: "Xã Nam Thái Sơn", district_code: "903" },
  { code: "30832", name: "Xã Mỹ Hiệp Sơn", district_code: "903" },
  { code: "30835", name: "Xã Sơn Kiên", district_code: "903" },
  { code: "30836", name: "Xã Sơn Bình", district_code: "903" },
  { code: "30838", name: "Xã Mỹ Thuận", district_code: "903" },
  { code: "30840", name: "Xã Lình Huỳnh", district_code: "903" },
  { code: "30841", name: "Xã Thổ Sơn", district_code: "903" },
  { code: "30844", name: "Xã Mỹ Lâm", district_code: "903" },
  { code: "30847", name: "Xã Mỹ Phước", district_code: "903" },
  { code: "30850", name: "Thị trấn Tân Hiệp", district_code: "904" },
  { code: "30853", name: "Xã Tân Hội", district_code: "904" },
  { code: "30856", name: "Xã Tân Thành", district_code: "904" },
  { code: "30859", name: "Xã Tân Hiệp B", district_code: "904" },
  { code: "30860", name: "Xã Tân Hoà", district_code: "904" },
  { code: "30862", name: "Xã Thạnh Đông B", district_code: "904" },
  { code: "30865", name: "Xã Thạnh Đông", district_code: "904" },
  { code: "30868", name: "Xã Tân Hiệp A", district_code: "904" },
  { code: "30871", name: "Xã Tân An", district_code: "904" },
  { code: "30874", name: "Xã Thạnh Đông A", district_code: "904" },
  { code: "30877", name: "Xã Thạnh Trị", district_code: "904" },
  { code: "30880", name: "Thị trấn Minh Lương", district_code: "905" },
  { code: "30883", name: "Xã Mong Thọ A", district_code: "905" },
  { code: "30886", name: "Xã Mong Thọ B", district_code: "905" },
  { code: "30887", name: "Xã Mong Thọ", district_code: "905" },
  { code: "30889", name: "Xã Giục Tượng", district_code: "905" },
  { code: "30892", name: "Xã Vĩnh Hòa Hiệp", district_code: "905" },
  { code: "30893", name: "Xã Vĩnh Hoà Phú", district_code: "905" },
  { code: "30895", name: "Xã Minh Hòa", district_code: "905" },
  { code: "30898", name: "Xã Bình An", district_code: "905" },
  { code: "30901", name: "Xã Thạnh Lộc", district_code: "905" },
  { code: "30904", name: "Thị trấn Giồng Riềng", district_code: "906" },
  { code: "30907", name: "Xã Thạnh Hưng", district_code: "906" },
  { code: "30910", name: "Xã Thạnh Phước", district_code: "906" },
  { code: "30913", name: "Xã Thạnh Lộc", district_code: "906" },
  { code: "30916", name: "Xã Thạnh Hòa", district_code: "906" },
  { code: "30917", name: "Xã Thạnh Bình", district_code: "906" },
  { code: "30919", name: "Xã Bàn Thạch", district_code: "906" },
  { code: "30922", name: "Xã Bàn Tân Định", district_code: "906" },
  { code: "30925", name: "Xã Ngọc Thành", district_code: "906" },
  { code: "30928", name: "Xã Ngọc Chúc", district_code: "906" },
  { code: "30931", name: "Xã Ngọc Thuận", district_code: "906" },
  { code: "30934", name: "Xã Hòa Hưng", district_code: "906" },
  { code: "30937", name: "Xã Hoà Lợi", district_code: "906" },
  { code: "30940", name: "Xã Hoà An", district_code: "906" },
  { code: "30943", name: "Xã Long Thạnh", district_code: "906" },
  { code: "30946", name: "Xã Vĩnh Thạnh", district_code: "906" },
  { code: "30947", name: "Xã Vĩnh Phú", district_code: "906" },
  { code: "30949", name: "Xã Hòa Thuận", district_code: "906" },
  { code: "30950", name: "Xã Ngọc Hoà", district_code: "906" },
  { code: "30952", name: "Thị trấn Gò Quao", district_code: "907" },
  { code: "30955", name: "Xã Vĩnh Hòa Hưng Bắc", district_code: "907" },
  { code: "30958", name: "Xã Định Hòa", district_code: "907" },
  { code: "30961", name: "Xã Thới Quản", district_code: "907" },
  { code: "30964", name: "Xã Định An", district_code: "907" },
  { code: "30967", name: "Xã Thủy Liễu", district_code: "907" },
  { code: "30970", name: "Xã Vĩnh Hòa Hưng Nam", district_code: "907" },
  { code: "30973", name: "Xã Vĩnh Phước A", district_code: "907" },
  { code: "30976", name: "Xã Vĩnh Phước B", district_code: "907" },
  { code: "30979", name: "Xã Vĩnh Tuy", district_code: "907" },
  { code: "30982", name: "Xã Vĩnh Thắng", district_code: "907" },
  { code: "30985", name: "Thị trấn Thứ Ba", district_code: "908" },
  { code: "30988", name: "Xã Tây Yên", district_code: "908" },
  { code: "30991", name: "Xã Tây Yên A", district_code: "908" },
  { code: "30994", name: "Xã Nam Yên", district_code: "908" },
  { code: "30997", name: "Xã Hưng Yên", district_code: "908" },
  { code: "31000", name: "Xã Nam Thái", district_code: "908" },
  { code: "31003", name: "Xã Nam Thái A", district_code: "908" },
  { code: "31006", name: "Xã Đông Thái", district_code: "908" },
  { code: "31009", name: "Xã Đông Yên", district_code: "908" },
  { code: "31018", name: "Thị trấn Thứ Mười Một", district_code: "909" },
  { code: "31021", name: "Xã Thuận Hoà", district_code: "909" },
  { code: "31024", name: "Xã Đông Hòa", district_code: "909" },
  { code: "31030", name: "Xã Đông Thạnh", district_code: "909" },
  { code: "31031", name: "Xã Tân Thạnh", district_code: "909" },
  { code: "31033", name: "Xã Đông Hưng", district_code: "909" },
  { code: "31036", name: "Xã Đông Hưng A", district_code: "909" },
  { code: "31039", name: "Xã Đông Hưng B", district_code: "909" },
  { code: "31042", name: "Xã Vân Khánh", district_code: "909" },
  { code: "31045", name: "Xã Vân Khánh Đông", district_code: "909" },
  { code: "31048", name: "Xã Vân Khánh Tây", district_code: "909" },
  { code: "31051", name: "Thị trấn Vĩnh Thuận", district_code: "910" },
  { code: "31060", name: "Xã Vĩnh Bình Bắc", district_code: "910" },
  { code: "31063", name: "Xã Vĩnh Bình Nam", district_code: "910" },
  { code: "31064", name: "Xã Bình Minh", district_code: "910" },
  { code: "31069", name: "Xã Vĩnh Thuận", district_code: "910" },
  { code: "31072", name: "Xã Tân Thuận", district_code: "910" },
  { code: "31074", name: "Xã Phong Đông", district_code: "910" },
  { code: "31075", name: "Xã Vĩnh Phong", district_code: "910" },
  { code: "31078", name: "Phường Dương Đông", district_code: "911" },
  { code: "31081", name: "Phường An Thới", district_code: "911" },
  { code: "31084", name: "Xã Cửa Cạn", district_code: "911" },
  { code: "31087", name: "Xã Gành Dầu", district_code: "911" },
  { code: "31090", name: "Xã Cửa Dương", district_code: "911" },
  { code: "31093", name: "Xã Hàm Ninh", district_code: "911" },
  { code: "31096", name: "Xã Dương Tơ", district_code: "911" },
  { code: "31102", name: "Xã Bãi Thơm", district_code: "911" },
  { code: "31105", name: "Xã Thổ Châu", district_code: "911" },
  { code: "31108", name: "Xã Hòn Tre", district_code: "912" },
  { code: "31111", name: "Xã Lại Sơn", district_code: "912" },
  { code: "31114", name: "Xã An Sơn", district_code: "912" },
  { code: "31115", name: "Xã Nam Du", district_code: "912" },
  { code: "31012", name: "Xã Thạnh Yên", district_code: "913" },
  { code: "31015", name: "Xã Thạnh Yên A", district_code: "913" },
  { code: "31027", name: "Xã An Minh Bắc", district_code: "913" },
  { code: "31054", name: "Xã Vĩnh Hòa", district_code: "913" },
  { code: "31057", name: "Xã Hoà Chánh", district_code: "913" },
  { code: "31066", name: "Xã Minh Thuận", district_code: "913" },
  { code: "30791", name: "Xã Vĩnh Phú", district_code: "914" },
  { code: "30793", name: "Xã Vĩnh Điều", district_code: "914" },
  { code: "30796", name: "Xã Tân Khánh Hòa", district_code: "914" },
  { code: "30797", name: "Xã Phú Lợi", district_code: "914" },
  { code: "30799", name: "Xã Phú Mỹ", district_code: "914" },
  { code: "31117", name: "Phường Cái Khế", district_code: "916" },
  { code: "31120", name: "Phường An Hòa", district_code: "916" },
  { code: "31123", name: "Phường Thới Bình", district_code: "916" },
  { code: "31135", name: "Phường Tân An", district_code: "916" },
  { code: "31144", name: "Phường Xuân Khánh", district_code: "916" },
  { code: "31147", name: "Phường Hưng Lợi", district_code: "916" },
  { code: "31149", name: "Phường An Khánh", district_code: "916" },
  { code: "31150", name: "Phường An Bình", district_code: "916" },
  { code: "31153", name: "Phường Châu Văn Liêm", district_code: "917" },
  { code: "31154", name: "Phường Thới Hòa", district_code: "917" },
  { code: "31156", name: "Phường Thới Long", district_code: "917" },
  { code: "31157", name: "Phường Long Hưng", district_code: "917" },
  { code: "31159", name: "Phường Thới An", district_code: "917" },
  { code: "31162", name: "Phường Phước Thới", district_code: "917" },
  { code: "31165", name: "Phường Trường Lạc", district_code: "917" },
  { code: "31168", name: "Phường Bình Thủy", district_code: "918" },
  { code: "31169", name: "Phường Trà An", district_code: "918" },
  { code: "31171", name: "Phường Trà Nóc", district_code: "918" },
  { code: "31174", name: "Phường Thới An Đông", district_code: "918" },
  { code: "31177", name: "Phường An Thới", district_code: "918" },
  { code: "31178", name: "Phường Bùi Hữu Nghĩa", district_code: "918" },
  { code: "31180", name: "Phường Long Hòa", district_code: "918" },
  { code: "31183", name: "Phường Long Tuyền", district_code: "918" },
  { code: "31186", name: "Phường Lê Bình", district_code: "919" },
  { code: "31189", name: "Phường Hưng Phú", district_code: "919" },
  { code: "31192", name: "Phường Hưng Thạnh", district_code: "919" },
  { code: "31195", name: "Phường Ba Láng", district_code: "919" },
  { code: "31198", name: "Phường Thường Thạnh", district_code: "919" },
  { code: "31201", name: "Phường Phú Thứ", district_code: "919" },
  { code: "31204", name: "Phường Tân Phú", district_code: "919" },
  { code: "31207", name: "Phường Thốt Nốt", district_code: "923" },
  { code: "31210", name: "Phường Thới Thuận", district_code: "923" },
  { code: "31212", name: "Phường Thuận An", district_code: "923" },
  { code: "31213", name: "Phường Tân Lộc", district_code: "923" },
  { code: "31216", name: "Phường Trung Nhứt", district_code: "923" },
  { code: "31217", name: "Phường Thạnh Hoà", district_code: "923" },
  { code: "31219", name: "Phường Trung Kiên", district_code: "923" },
  { code: "31227", name: "Phường Tân Hưng", district_code: "923" },
  { code: "31228", name: "Phường Thuận Hưng", district_code: "923" },
  { code: "31211", name: "Xã Vĩnh Bình", district_code: "924" },
  { code: "31231", name: "Thị trấn Thanh An", district_code: "924" },
  { code: "31232", name: "Thị trấn Vĩnh Thạnh", district_code: "924" },
  { code: "31234", name: "Xã Thạnh Mỹ", district_code: "924" },
  { code: "31237", name: "Xã Vĩnh Trinh", district_code: "924" },
  { code: "31240", name: "Xã Thạnh An", district_code: "924" },
  { code: "31241", name: "Xã Thạnh Tiến", district_code: "924" },
  { code: "31243", name: "Xã Thạnh Thắng", district_code: "924" },
  { code: "31244", name: "Xã Thạnh Lợi", district_code: "924" },
  { code: "31246", name: "Xã Thạnh Qưới", district_code: "924" },
  { code: "31252", name: "Xã Thạnh Lộc", district_code: "924" },
  { code: "31222", name: "Xã Trung An", district_code: "925" },
  { code: "31225", name: "Xã Trung Thạnh", district_code: "925" },
  { code: "31249", name: "Xã Thạnh Phú", district_code: "925" },
  { code: "31255", name: "Xã Trung Hưng", district_code: "925" },
  { code: "31261", name: "Thị trấn Cờ Đỏ", district_code: "925" },
  { code: "31264", name: "Xã Thới Hưng", district_code: "925" },
  { code: "31273", name: "Xã Đông Hiệp", district_code: "925" },
  { code: "31274", name: "Xã Đông Thắng", district_code: "925" },
  { code: "31276", name: "Xã Thới Đông", district_code: "925" },
  { code: "31277", name: "Xã Thới Xuân", district_code: "925" },
  { code: "31299", name: "Thị trấn Phong Điền", district_code: "926" },
  { code: "31300", name: "Xã Nhơn Ái", district_code: "926" },
  { code: "31303", name: "Xã Giai Xuân", district_code: "926" },
  { code: "31306", name: "Xã Tân Thới", district_code: "926" },
  { code: "31309", name: "Xã Trường Long", district_code: "926" },
  { code: "31312", name: "Xã Mỹ Khánh", district_code: "926" },
  { code: "31315", name: "Xã Nhơn Nghĩa", district_code: "926" },
  { code: "31258", name: "Thị trấn Thới Lai", district_code: "927" },
  { code: "31267", name: "Xã Thới Thạnh", district_code: "927" },
  { code: "31268", name: "Xã Tân Thạnh", district_code: "927" },
  { code: "31270", name: "Xã Xuân Thắng", district_code: "927" },
  { code: "31279", name: "Xã Đông Bình", district_code: "927" },
  { code: "31282", name: "Xã Đông Thuận", district_code: "927" },
  { code: "31285", name: "Xã Thới Tân", district_code: "927" },
  { code: "31286", name: "Xã Trường Thắng", district_code: "927" },
  { code: "31288", name: "Xã Định Môn", district_code: "927" },
  { code: "31291", name: "Xã Trường Thành", district_code: "927" },
  { code: "31294", name: "Xã Trường Xuân", district_code: "927" },
  { code: "31297", name: "Xã Trường Xuân A", district_code: "927" },
  { code: "31298", name: "Xã Trường Xuân B", district_code: "927" },
  { code: "31318", name: "Phường I", district_code: "930" },
  { code: "31321", name: "Phường III", district_code: "930" },
  { code: "31324", name: "Phường IV", district_code: "930" },
  { code: "31327", name: "Phường V", district_code: "930" },
  { code: "31330", name: "Phường VII", district_code: "930" },
  { code: "31333", name: "Xã Vị Tân", district_code: "930" },
  { code: "31336", name: "Xã Hoả Lựu", district_code: "930" },
  { code: "31338", name: "Xã Tân Tiến", district_code: "930" },
  { code: "31339", name: "Xã Hoả Tiến", district_code: "930" },
  { code: "31340", name: "Phường Ngã Bảy", district_code: "931" },
  { code: "31341", name: "Phường Lái Hiếu", district_code: "931" },
  { code: "31343", name: "Phường Hiệp Thành", district_code: "931" },
  { code: "31344", name: "Phường Hiệp Lợi", district_code: "931" },
  { code: "31411", name: "Xã Đại Thành", district_code: "931" },
  { code: "31414", name: "Xã Tân Thành", district_code: "931" },
  { code: "31342", name: "Thị trấn Một Ngàn", district_code: "932" },
  { code: "31345", name: "Xã Tân Hoà", district_code: "932" },
  { code: "31346", name: "Thị trấn Bảy Ngàn", district_code: "932" },
  { code: "31348", name: "Xã Trường Long Tây", district_code: "932" },
  { code: "31351", name: "Xã Trường Long A", district_code: "932" },
  { code: "31357", name: "Xã Nhơn Nghĩa A", district_code: "932" },
  { code: "31359", name: "Thị trấn Rạch Gòi", district_code: "932" },
  { code: "31360", name: "Xã Thạnh Xuân", district_code: "932" },
  { code: "31362", name: "Thị trấn Cái Tắc", district_code: "932" },
  { code: "31363", name: "Xã Tân Phú Thạnh", district_code: "932" },
  { code: "31366", name: "Thị trấn Ngã Sáu", district_code: "933" },
  { code: "31369", name: "Xã Đông Thạnh", district_code: "933" },
  { code: "31375", name: "Xã Đông Phú", district_code: "933" },
  { code: "31378", name: "Xã Phú Hữu", district_code: "933" },
  { code: "31379", name: "Xã Phú Tân", district_code: "933" },
  { code: "31381", name: "Thị trấn Mái Dầm", district_code: "933" },
  { code: "31384", name: "Xã Đông Phước", district_code: "933" },
  { code: "31387", name: "Xã Đông Phước A", district_code: "933" },
  { code: "31393", name: "Thị trấn Kinh Cùng", district_code: "934" },
  { code: "31396", name: "Thị trấn Cây Dương", district_code: "934" },
  { code: "31399", name: "Xã Tân Bình", district_code: "934" },
  { code: "31402", name: "Xã Bình Thành", district_code: "934" },
  { code: "31405", name: "Xã Thạnh Hòa", district_code: "934" },
  { code: "31408", name: "Xã Long Thạnh", district_code: "934" },
  { code: "31417", name: "Xã Phụng Hiệp", district_code: "934" },
  { code: "31420", name: "Xã Hòa Mỹ", district_code: "934" },
  { code: "31423", name: "Xã Hòa An", district_code: "934" },
  { code: "31426", name: "Xã Phương Bình", district_code: "934" },
  { code: "31429", name: "Xã Hiệp Hưng", district_code: "934" },
  { code: "31432", name: "Xã Tân Phước Hưng", district_code: "934" },
  { code: "31433", name: "Thị trấn Búng Tàu", district_code: "934" },
  { code: "31435", name: "Xã Phương Phú", district_code: "934" },
  { code: "31438", name: "Xã Tân Long", district_code: "934" },
  { code: "31441", name: "Thị trấn Nàng Mau", district_code: "935" },
  { code: "31444", name: "Xã Vị Trung", district_code: "935" },
  { code: "31447", name: "Xã Vị Thuỷ", district_code: "935" },
  { code: "31450", name: "Xã Vị Thắng", district_code: "935" },
  { code: "31453", name: "Xã Vĩnh Thuận Tây", district_code: "935" },
  { code: "31456", name: "Xã Vĩnh Trung", district_code: "935" },
  { code: "31459", name: "Xã Vĩnh Tường", district_code: "935" },
  { code: "31462", name: "Xã Vị Đông", district_code: "935" },
  { code: "31465", name: "Xã Vị Thanh", district_code: "935" },
  { code: "31468", name: "Xã Vị Bình", district_code: "935" },
  { code: "31483", name: "Xã Thuận Hưng", district_code: "936" },
  { code: "31484", name: "Xã Thuận Hòa", district_code: "936" },
  { code: "31486", name: "Xã Vĩnh Thuận Đông", district_code: "936" },
  { code: "31489", name: "Thị trấn Vĩnh Viễn", district_code: "936" },
  { code: "31490", name: "Xã Vĩnh Viễn A", district_code: "936" },
  { code: "31492", name: "Xã Lương Tâm", district_code: "936" },
  { code: "31493", name: "Xã Lương Nghĩa", district_code: "936" },
  { code: "31495", name: "Xã Xà Phiên", district_code: "936" },
  { code: "31471", name: "Phường Thuận An", district_code: "937" },
  { code: "31472", name: "Phường Trà Lồng", district_code: "937" },
  { code: "31473", name: "Phường Bình Thạnh", district_code: "937" },
  { code: "31474", name: "Xã Long Bình", district_code: "937" },
  { code: "31475", name: "Phường Vĩnh Tường", district_code: "937" },
  { code: "31477", name: "Xã Long Trị", district_code: "937" },
  { code: "31478", name: "Xã Long Trị A", district_code: "937" },
  { code: "31480", name: "Xã Long Phú", district_code: "937" },
  { code: "31481", name: "Xã Tân Phú", district_code: "937" },
  { code: "31498", name: "Phường 5", district_code: "941" },
  { code: "31501", name: "Phường 7", district_code: "941" },
  { code: "31504", name: "Phường 8", district_code: "941" },
  { code: "31507", name: "Phường 6", district_code: "941" },
  { code: "31510", name: "Phường 2", district_code: "941" },
  { code: "31516", name: "Phường 4", district_code: "941" },
  { code: "31519", name: "Phường 3", district_code: "941" },
  { code: "31522", name: "Phường 1", district_code: "941" },
  { code: "31525", name: "Phường 10", district_code: "941" },
  { code: "31569", name: "Thị trấn Châu Thành", district_code: "942" },
  { code: "31570", name: "Xã Hồ Đắc Kiện", district_code: "942" },
  { code: "31573", name: "Xã Phú Tâm", district_code: "942" },
  { code: "31576", name: "Xã Thuận Hòa", district_code: "942" },
  { code: "31582", name: "Xã Phú Tân", district_code: "942" },
  { code: "31585", name: "Xã Thiện Mỹ", district_code: "942" },
  { code: "31594", name: "Xã An Hiệp", district_code: "942" },
  { code: "31600", name: "Xã An Ninh", district_code: "942" },
  { code: "31528", name: "Thị trấn Kế Sách", district_code: "943" },
  { code: "31531", name: "Thị trấn An Lạc Thôn", district_code: "943" },
  { code: "31534", name: "Xã Xuân Hòa", district_code: "943" },
  { code: "31537", name: "Xã Phong Nẫm", district_code: "943" },
  { code: "31540", name: "Xã An Lạc Tây", district_code: "943" },
  { code: "31543", name: "Xã Trinh Phú", district_code: "943" },
  { code: "31546", name: "Xã Ba Trinh", district_code: "943" },
  { code: "31549", name: "Xã Thới An Hội", district_code: "943" },
  { code: "31552", name: "Xã Nhơn Mỹ", district_code: "943" },
  { code: "31555", name: "Xã Kế Thành", district_code: "943" },
  { code: "31558", name: "Xã Kế An", district_code: "943" },
  { code: "31561", name: "Xã Đại Hải", district_code: "943" },
  { code: "31564", name: "Xã An Mỹ", district_code: "943" },
  { code: "31567", name: "Thị trấn Huỳnh Hữu Nghĩa", district_code: "944" },
  { code: "31579", name: "Xã Long Hưng", district_code: "944" },
  { code: "31588", name: "Xã Hưng Phú", district_code: "944" },
  { code: "31591", name: "Xã Mỹ Hương", district_code: "944" },
  { code: "31597", name: "Xã Mỹ Tú", district_code: "944" },
  { code: "31603", name: "Xã Mỹ Phước", district_code: "944" },
  { code: "31606", name: "Xã Thuận Hưng", district_code: "944" },
  { code: "31609", name: "Xã Mỹ Thuận", district_code: "944" },
  { code: "31612", name: "Xã Phú Mỹ", district_code: "944" },
  { code: "31615", name: "Thị trấn Cù Lao Dung", district_code: "945" },
  { code: "31618", name: "Xã An Thạnh 1", district_code: "945" },
  { code: "31621", name: "Xã An Thạnh Tây", district_code: "945" },
  { code: "31624", name: "Xã An Thạnh Đông", district_code: "945" },
  { code: "31627", name: "Xã Đại Ân 1", district_code: "945" },
  { code: "31630", name: "Xã An Thạnh 2", district_code: "945" },
  { code: "31633", name: "Xã An Thạnh 3", district_code: "945" },
  { code: "31636", name: "Xã An Thạnh Nam", district_code: "945" },
  { code: "31639", name: "Thị trấn Long Phú", district_code: "946" },
  { code: "31642", name: "Xã Song Phụng", district_code: "946" },
  { code: "31645", name: "Thị trấn Đại Ngãi", district_code: "946" },
  { code: "31648", name: "Xã Hậu Thạnh", district_code: "946" },
  { code: "31651", name: "Xã Long Đức", district_code: "946" },
  { code: "31654", name: "Xã Trường Khánh", district_code: "946" },
  { code: "31657", name: "Xã Phú Hữu", district_code: "946" },
  { code: "31660", name: "Xã Tân Hưng", district_code: "946" },
  { code: "31663", name: "Xã Châu Khánh", district_code: "946" },
  { code: "31666", name: "Xã Tân Thạnh", district_code: "946" },
  { code: "31669", name: "Xã Long Phú", district_code: "946" },
  { code: "31684", name: "Thị trấn Mỹ Xuyên", district_code: "947" },
  { code: "31690", name: "Xã Đại Tâm", district_code: "947" },
  { code: "31693", name: "Xã Tham Đôn", district_code: "947" },
  { code: "31708", name: "Xã Thạnh Phú", district_code: "947" },
  { code: "31711", name: "Xã Ngọc Đông", district_code: "947" },
  { code: "31714", name: "Xã Thạnh Quới", district_code: "947" },
  { code: "31717", name: "Xã Hòa Tú 1", district_code: "947" },
  { code: "31720", name: "Xã Gia Hòa 1", district_code: "947" },
  { code: "31723", name: "Xã Ngọc Tố", district_code: "947" },
  { code: "31726", name: "Xã Gia Hòa 2", district_code: "947" },
  { code: "31729", name: "Xã Hòa Tú II", district_code: "947" },
  { code: "31732", name: "Phường 1", district_code: "948" },
  { code: "31735", name: "Phường 2", district_code: "948" },
  { code: "31738", name: "Xã Vĩnh Quới", district_code: "948" },
  { code: "31741", name: "Xã Tân Long", district_code: "948" },
  { code: "31744", name: "Xã Long Bình", district_code: "948" },
  { code: "31747", name: "Phường 3", district_code: "948" },
  { code: "31750", name: "Xã Mỹ Bình", district_code: "948" },
  { code: "31753", name: "Xã Mỹ Quới", district_code: "948" },
  { code: "31756", name: "Thị trấn Phú Lộc", district_code: "949" },
  { code: "31757", name: "Thị trấn Hưng Lợi", district_code: "949" },
  { code: "31759", name: "Xã Lâm Tân", district_code: "949" },
  { code: "31762", name: "Xã Thạnh Tân", district_code: "949" },
  { code: "31765", name: "Xã Lâm Kiết", district_code: "949" },
  { code: "31768", name: "Xã Tuân Tức", district_code: "949" },
  { code: "31771", name: "Xã Vĩnh Thành", district_code: "949" },
  { code: "31774", name: "Xã Thạnh Trị", district_code: "949" },
  { code: "31777", name: "Xã Vĩnh Lợi", district_code: "949" },
  { code: "31780", name: "Xã Châu Hưng", district_code: "949" },
  { code: "31783", name: "Phường 1", district_code: "950" },
  { code: "31786", name: "Xã Hòa Đông", district_code: "950" },
  { code: "31789", name: "Phường Khánh Hòa", district_code: "950" },
  { code: "31792", name: "Xã Vĩnh Hiệp", district_code: "950" },
  { code: "31795", name: "Xã Vĩnh Hải", district_code: "950" },
  { code: "31798", name: "Xã Lạc Hòa", district_code: "950" },
  { code: "31801", name: "Phường 2", district_code: "950" },
  { code: "31804", name: "Phường Vĩnh Phước", district_code: "950" },
  { code: "31807", name: "Xã Vĩnh Tân", district_code: "950" },
  { code: "31810", name: "Xã Lai Hòa", district_code: "950" },
  { code: "31672", name: "Xã Đại Ân 2", district_code: "951" },
  { code: "31673", name: "Thị trấn Trần Đề", district_code: "951" },
  { code: "31675", name: "Xã Liêu Tú", district_code: "951" },
  { code: "31678", name: "Xã Lịch Hội Thượng", district_code: "951" },
  { code: "31679", name: "Thị trấn Lịch Hội Thượng", district_code: "951" },
  { code: "31681", name: "Xã Trung Bình", district_code: "951" },
  { code: "31687", name: "Xã Tài Văn", district_code: "951" },
  { code: "31696", name: "Xã Viên An", district_code: "951" },
  { code: "31699", name: "Xã Thạnh Thới An", district_code: "951" },
  { code: "31702", name: "Xã Thạnh Thới Thuận", district_code: "951" },
  { code: "31705", name: "Xã Viên Bình", district_code: "951" },
  { code: "31813", name: "Phường 2", district_code: "954" },
  { code: "31816", name: "Phường 3", district_code: "954" },
  { code: "31819", name: "Phường 5", district_code: "954" },
  { code: "31822", name: "Phường 7", district_code: "954" },
  { code: "31825", name: "Phường 1", district_code: "954" },
  { code: "31828", name: "Phường 8", district_code: "954" },
  { code: "31831", name: "Phường Nhà Mát", district_code: "954" },
  { code: "31834", name: "Xã Vĩnh Trạch", district_code: "954" },
  { code: "31837", name: "Xã Vĩnh Trạch Đông", district_code: "954" },
  { code: "31840", name: "Xã Hiệp Thành", district_code: "954" },
  { code: "31843", name: "Thị trấn Ngan Dừa", district_code: "956" },
  { code: "31846", name: "Xã Ninh Quới", district_code: "956" },
  { code: "31849", name: "Xã Ninh Quới A", district_code: "956" },
  { code: "31852", name: "Xã Ninh Hòa", district_code: "956" },
  { code: "31855", name: "Xã Lộc Ninh", district_code: "956" },
  { code: "31858", name: "Xã Vĩnh Lộc", district_code: "956" },
  { code: "31861", name: "Xã Vĩnh Lộc A", district_code: "956" },
  { code: "31863", name: "Xã Ninh Thạnh Lợi A", district_code: "956" },
  { code: "31864", name: "Xã Ninh Thạnh Lợi", district_code: "956" },
  { code: "31867", name: "Thị trấn Phước Long", district_code: "957" },
  { code: "31870", name: "Xã Vĩnh Phú Đông", district_code: "957" },
  { code: "31873", name: "Xã Vĩnh Phú Tây", district_code: "957" },
  { code: "31876", name: "Xã Phước Long", district_code: "957" },
  { code: "31879", name: "Xã Hưng Phú", district_code: "957" },
  { code: "31882", name: "Xã Vĩnh Thanh", district_code: "957" },
  { code: "31885", name: "Xã Phong Thạnh Tây A", district_code: "957" },
  { code: "31888", name: "Xã Phong Thạnh Tây B", district_code: "957" },
  { code: "31894", name: "Xã Vĩnh Hưng", district_code: "958" },
  { code: "31897", name: "Xã Vĩnh Hưng A", district_code: "958" },
  { code: "31900", name: "Thị trấn Châu Hưng", district_code: "958" },
  { code: "31903", name: "Xã Châu Hưng A", district_code: "958" },
  { code: "31906", name: "Xã Hưng Thành", district_code: "958" },
  { code: "31909", name: "Xã Hưng Hội", district_code: "958" },
  { code: "31912", name: "Xã Châu Thới", district_code: "958" },
  { code: "31921", name: "Xã Long Thạnh", district_code: "958" },
  { code: "31942", name: "Phường 1", district_code: "959" },
  { code: "31945", name: "Phường Hộ Phòng", district_code: "959" },
  { code: "31948", name: "Xã Phong Thạnh Đông", district_code: "959" },
  { code: "31951", name: "Phường Láng Tròn", district_code: "959" },
  { code: "31954", name: "Xã Phong Tân", district_code: "959" },
  { code: "31957", name: "Xã Tân Phong", district_code: "959" },
  { code: "31960", name: "Xã Phong Thạnh", district_code: "959" },
  { code: "31963", name: "Xã Phong Thạnh A", district_code: "959" },
  { code: "31966", name: "Xã Phong Thạnh Tây", district_code: "959" },
  { code: "31969", name: "Xã Tân Thạnh", district_code: "959" },
  { code: "31972", name: "Thị trấn Gành Hào", district_code: "960" },
  { code: "31975", name: "Xã Long Điền Đông", district_code: "960" },
  { code: "31978", name: "Xã Long Điền Đông A", district_code: "960" },
  { code: "31981", name: "Xã Long Điền", district_code: "960" },
  { code: "31984", name: "Xã Long Điền Tây", district_code: "960" },
  { code: "31985", name: "Xã Điền Hải", district_code: "960" },
  { code: "31987", name: "Xã An Trạch", district_code: "960" },
  { code: "31988", name: "Xã An Trạch A", district_code: "960" },
  { code: "31990", name: "Xã An Phúc", district_code: "960" },
  { code: "31993", name: "Xã Định Thành", district_code: "960" },
  { code: "31996", name: "Xã Định Thành A", district_code: "960" },
  { code: "31891", name: "Thị trấn Hòa Bình", district_code: "961" },
  { code: "31915", name: "Xã Minh Diệu", district_code: "961" },
  { code: "31918", name: "Xã Vĩnh Bình", district_code: "961" },
  { code: "31924", name: "Xã Vĩnh Mỹ B", district_code: "961" },
  { code: "31927", name: "Xã Vĩnh Hậu", district_code: "961" },
  { code: "31930", name: "Xã Vĩnh Hậu A", district_code: "961" },
  { code: "31933", name: "Xã Vĩnh Mỹ A", district_code: "961" },
  { code: "31936", name: "Xã Vĩnh Thịnh", district_code: "961" },
  { code: "31999", name: "Phường 9", district_code: "964" },
  { code: "32002", name: "Phường 2", district_code: "964" },
  { code: "32005", name: "Phường 1", district_code: "964" },
  { code: "32008", name: "Phường 5", district_code: "964" },
  { code: "32014", name: "Phường 8", district_code: "964" },
  { code: "32017", name: "Phường 6", district_code: "964" },
  { code: "32020", name: "Phường 7", district_code: "964" },
  { code: "32022", name: "Phường Tân Xuyên", district_code: "964" },
  { code: "32023", name: "Xã An Xuyên", district_code: "964" },
  { code: "32025", name: "Phường Tân Thành", district_code: "964" },
  { code: "32026", name: "Xã Tân Thành", district_code: "964" },
  { code: "32029", name: "Xã Tắc Vân", district_code: "964" },
  { code: "32032", name: "Xã Lý Văn Lâm", district_code: "964" },
  { code: "32035", name: "Xã Định Bình", district_code: "964" },
  { code: "32038", name: "Xã Hòa Thành", district_code: "964" },
  { code: "32041", name: "Xã Hòa Tân", district_code: "964" },
  { code: "32044", name: "Thị trấn U Minh", district_code: "966" },
  { code: "32047", name: "Xã Khánh Hòa", district_code: "966" },
  { code: "32048", name: "Xã Khánh Thuận", district_code: "966" },
  { code: "32050", name: "Xã Khánh Tiến", district_code: "966" },
  { code: "32053", name: "Xã Nguyễn Phích", district_code: "966" },
  { code: "32056", name: "Xã Khánh Lâm", district_code: "966" },
  { code: "32059", name: "Xã Khánh An", district_code: "966" },
  { code: "32062", name: "Xã Khánh Hội", district_code: "966" },
  { code: "32065", name: "Thị trấn Thới Bình", district_code: "967" },
  { code: "32068", name: "Xã Biển Bạch", district_code: "967" },
  { code: "32069", name: "Xã Tân Bằng", district_code: "967" },
  { code: "32071", name: "Xã Trí Phải", district_code: "967" },
  { code: "32072", name: "Xã Trí Lực", district_code: "967" },
  { code: "32074", name: "Xã Biển Bạch Đông", district_code: "967" },
  { code: "32077", name: "Xã Thới Bình", district_code: "967" },
  { code: "32080", name: "Xã Tân Phú", district_code: "967" },
  { code: "32083", name: "Xã Tân Lộc Bắc", district_code: "967" },
  { code: "32086", name: "Xã Tân Lộc", district_code: "967" },
  { code: "32089", name: "Xã Tân Lộc Đông", district_code: "967" },
  { code: "32092", name: "Xã Hồ Thị Kỷ", district_code: "967" },
  { code: "32095", name: "Thị trấn Trần Văn Thời", district_code: "968" },
  { code: "32098", name: "Thị trấn Sông Đốc", district_code: "968" },
  { code: "32101", name: "Xã Khánh Bình Tây Bắc", district_code: "968" },
  { code: "32104", name: "Xã Khánh Bình Tây", district_code: "968" },
  { code: "32107", name: "Xã Trần Hợi", district_code: "968" },
  { code: "32108", name: "Xã Khánh Lộc", district_code: "968" },
  { code: "32110", name: "Xã Khánh Bình", district_code: "968" },
  { code: "32113", name: "Xã Khánh Hưng", district_code: "968" },
  { code: "32116", name: "Xã Khánh Bình Đông", district_code: "968" },
  { code: "32119", name: "Xã Khánh Hải", district_code: "968" },
  { code: "32122", name: "Xã Lợi An", district_code: "968" },
  { code: "32124", name: "Xã Phong Điền", district_code: "968" },
  { code: "32125", name: "Xã Phong Lạc", district_code: "968" },
  { code: "32128", name: "Thị trấn Cái Nước", district_code: "969" },
  { code: "32130", name: "Xã Thạnh Phú", district_code: "969" },
  { code: "32131", name: "Xã Lương Thế Trân", district_code: "969" },
  { code: "32134", name: "Xã Phú Hưng", district_code: "969" },
  { code: "32137", name: "Xã Tân Hưng", district_code: "969" },
  { code: "32140", name: "Xã Hưng Mỹ", district_code: "969" },
  { code: "32141", name: "Xã Hoà Mỹ", district_code: "969" },
  { code: "32142", name: "Xã Đông Hưng", district_code: "969" },
  { code: "32143", name: "Xã Đông Thới", district_code: "969" },
  { code: "32146", name: "Xã Tân Hưng Đông", district_code: "969" },
  { code: "32149", name: "Xã Trần Thới", district_code: "969" },
  { code: "32152", name: "Thị trấn Đầm Dơi", district_code: "970" },
  { code: "32155", name: "Xã Tạ An Khương", district_code: "970" },
  { code: "32158", name: "Xã Tạ An Khương Đông", district_code: "970" },
  { code: "32161", name: "Xã Trần Phán", district_code: "970" },
  { code: "32162", name: "Xã Tân Trung", district_code: "970" },
  { code: "32164", name: "Xã Tân Đức", district_code: "970" },
  { code: "32167", name: "Xã Tân Thuận", district_code: "970" },
  { code: "32170", name: "Xã Tạ An Khương Nam", district_code: "970" },
  { code: "32173", name: "Xã Tân Duyệt", district_code: "970" },
  { code: "32174", name: "Xã Tân Dân", district_code: "970" },
  { code: "32176", name: "Xã Tân Tiến", district_code: "970" },
  { code: "32179", name: "Xã Quách Phẩm Bắc", district_code: "970" },
  { code: "32182", name: "Xã Quách Phẩm", district_code: "970" },
  { code: "32185", name: "Xã Thanh Tùng", district_code: "970" },
  { code: "32186", name: "Xã Ngọc Chánh", district_code: "970" },
  { code: "32188", name: "Xã Nguyễn Huân", district_code: "970" },
  { code: "32191", name: "Thị trấn Năm Căn", district_code: "971" },
  { code: "32194", name: "Xã Hàm Rồng", district_code: "971" },
  { code: "32197", name: "Xã Hiệp Tùng", district_code: "971" },
  { code: "32200", name: "Xã Đất Mới", district_code: "971" },
  { code: "32201", name: "Xã Lâm Hải", district_code: "971" },
  { code: "32203", name: "Xã Hàng Vịnh", district_code: "971" },
  { code: "32206", name: "Xã Tam Giang", district_code: "971" },
  { code: "32209", name: "Xã Tam Giang Đông", district_code: "971" },
  { code: "32212", name: "Thị trấn Cái Đôi Vàm", district_code: "972" },
  { code: "32214", name: "Xã Phú Thuận", district_code: "972" },
  { code: "32215", name: "Xã Phú Mỹ", district_code: "972" },
  { code: "32218", name: "Xã Phú Tân", district_code: "972" },
  { code: "32221", name: "Xã Tân Hải", district_code: "972" },
  { code: "32224", name: "Xã Việt Thắng", district_code: "972" },
  { code: "32227", name: "Xã Tân Hưng Tây", district_code: "972" },
  { code: "32228", name: "Xã Rạch Chèo", district_code: "972" },
  { code: "32230", name: "Xã Nguyễn Việt Khái", district_code: "972" },
  { code: "32233", name: "Xã Tam Giang Tây", district_code: "973" },
  { code: "32236", name: "Xã Tân Ân Tây", district_code: "973" },
  { code: "32239", name: "Xã Viên An Đông", district_code: "973" },
  { code: "32242", name: "Xã Viên An", district_code: "973" },
  { code: "32244", name: "Thị trấn Rạch Gốc", district_code: "973" },
  { code: "32245", name: "Xã Tân Ân", district_code: "973" },
  { code: "32248", name: "Xã Đất Mũi", district_code: "973" },
];
